export * from '@simpl/element-ng/translate-types';
import * as i2 from '@simpl/element-ng/auto-collapsable-list';
import { SiAutoCollapsableListDirective, SiAutoCollapsableListModule } from '@simpl/element-ng/auto-collapsable-list';
export * from '@simpl/element-ng/auto-collapsable-list';
import * as i2$1 from '@simpl/element-ng/split';
import { SiSplitModule } from '@simpl/element-ng/split';
export * from '@simpl/element-ng/split';
import * as i1 from '@angular/common';
import { CommonModule, isPlatformBrowser, getLocaleDayPeriods, FormStyle, TranslationWidth, getLocaleId, getLocaleDateTimeFormat, FormatWidth, getLocaleTimeFormat, getLocaleDateFormat, formatDate, getLocaleFirstDayOfWeek, WeekDay, getLocaleMonthNames } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, Component, Input, ViewChild, ChangeDetectionStrategy, ApplicationRef, Injector, EnvironmentInjector, PLATFORM_ID, runInInjectionContext, createComponent, Injectable, EventEmitter, Directive, HostBinding, Output, ChangeDetectorRef, ContentChildren, NgModule, LOCALE_ID, ElementRef, Renderer2, HostListener, ViewEncapsulation, ViewChildren, SimpleChange, NgZone, ContentChild, DestroyRef, Pipe, forwardRef, TemplateRef } from '@angular/core';
import * as i2$7 from '@simpl/element-ng/translate';
import { SiTranslateModule, SiTranslateService, SiNoTranslateService } from '@simpl/element-ng/translate';
export * from '@simpl/element-ng/translate';
import { Subject, merge, Observable, of, timer, asyncScheduler, BehaviorSubject, EMPTY } from 'rxjs';
import { AnimationBuilder, style, animate, trigger, transition } from '@angular/animations';
import { STATUS_ICON, areAnimationsDisabled, isRTL, positionBottomStart, positionBottomCenter, positionBottomEnd, positionTopStart, positionTopCenter, positionTopEnd, getOverlay, correctKeyRTL, listenGlobal, BlinkService, buildTrackByIdentity, WebComponentContentChildren, positions, getPositionStrategy } from '@simpl/element-ng/common';
export * from '@simpl/element-ng/common';
import * as i2$5 from '@simpl/element-ng/icon';
import { SiIconModule } from '@simpl/element-ng/icon';
export * from '@simpl/element-ng/icon';
import * as i3$5 from '@simpl/element-ng/link';
import { SiLinkModule } from '@simpl/element-ng/link';
export * from '@simpl/element-ng/link';
import * as i2$a from '@angular/forms';
import { NG_VALIDATORS, FormsModule, Validators, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpEventType, HttpParams } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import * as i2$2 from '@simpl/element-ng/accordion';
import { SiAccordionModule, SiAccordionHCollapseService } from '@simpl/element-ng/accordion';
export * from '@simpl/element-ng/accordion';
import * as i3$4 from '@simpl/element-ng/copyright-notice';
import { SiCopyrightNoticeModule } from '@simpl/element-ng/copyright-notice';
export * from '@simpl/element-ng/copyright-notice';
import { SiBreadcrumbModule } from '@simpl/element-ng/breadcrumb';
export * from '@simpl/element-ng/breadcrumb';
import { SiBreadcrumbRouterModule } from '@simpl/element-ng/breadcrumb-router';
export * from '@simpl/element-ng/breadcrumb-router';
import * as i2$3 from '@simpl/element-ng/content-action-bar';
import { SiContentActionBarModule } from '@simpl/element-ng/content-action-bar';
export * from '@simpl/element-ng/content-action-bar';
export * from '@simpl/element-ng/menu-next';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { debounceTime, takeUntil, mapTo, filter, map, first, retry, withLatestFrom } from 'rxjs/operators';
import * as i1$1 from '@angular/cdk/a11y';
import { A11yModule, FocusMonitor, LiveAnnouncer } from '@angular/cdk/a11y';
import { Overlay, OverlayModule, CdkOverlayOrigin } from '@angular/cdk/overlay';
import * as i1$3 from '@angular/cdk/portal';
import { ComponentPortal, CdkPortalOutlet, PortalModule } from '@angular/cdk/portal';
import { BidiModule } from '@angular/cdk/bidi';
import * as i1$2 from '@angular/cdk/listbox';
import { CdkListboxModule, CdkOption } from '@angular/cdk/listbox';
import * as i5 from '@simpl/element-ng/search-bar';
import { SiSearchBarModule } from '@simpl/element-ng/search-bar';
export * from '@simpl/element-ng/search-bar';
import * as i2$6 from '@simpl/element-ng/number-input';
import { SiNumberInputModule } from '@simpl/element-ng/number-input';
export * from '@simpl/element-ng/number-input';
import * as i3$3 from '@simpl/element-ng/select';
import { SiSelectModule } from '@simpl/element-ng/select';
export * from '@simpl/element-ng/select';
import * as i2$4 from '@simpl/element-ng/dropdown';
import { SiDropdownModule } from '@simpl/element-ng/dropdown';
export * from '@simpl/element-ng/dropdown';
import * as i3$2 from '@simpl/element-ng/menu';
import { SiMenuModule } from '@simpl/element-ng/menu';
export * from '@simpl/element-ng/menu';
import * as i4 from '@simpl/element-ng/progressbar';
import { SiProgressbarModule } from '@simpl/element-ng/progressbar';
export * from '@simpl/element-ng/progressbar';
import { RouterModule } from '@angular/router';
import * as i3 from '@simpl/element-ng/inline-notification';
import { SiInlineNotificationModule } from '@simpl/element-ng/inline-notification';
export * from '@simpl/element-ng/inline-notification';
import * as i4$1 from '@simpl/element-ng/language-switcher';
import { SiLanguageSwitcherModule } from '@simpl/element-ng/language-switcher';
export * from '@simpl/element-ng/language-switcher';
import * as i3$1 from '@simpl/element-ng/loading-spinner';
import { SiLoadingSpinnerModule } from '@simpl/element-ng/loading-spinner';
export * from '@simpl/element-ng/loading-spinner';
import { ModalRef, SiModalService, createModalConfig, SiModalModule } from '@simpl/element-ng/modal';
export * from '@simpl/element-ng/modal';
import * as i3$6 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule, CDK_DRAG_CONFIG } from '@angular/cdk/drag-drop';
import * as i2$8 from '@simpl/element-ng/resize-observer';
import { ResizeObserverService, BOOTSTRAP_BREAKPOINTS, SiResizeObserverModule } from '@simpl/element-ng/resize-observer';
export * from '@simpl/element-ng/resize-observer';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SiNavbarModule } from '@simpl/element-ng/navbar';
export * from '@simpl/element-ng/navbar';
import { SiNavbarSecondaryModule } from '@simpl/element-ng/navbar-secondary';
export * from '@simpl/element-ng/navbar-secondary';
import { SiNavbarVerticalModule } from '@simpl/element-ng/navbar-vertical';
export * from '@simpl/element-ng/navbar-vertical';
import * as i4$2 from '@simpl/element-ng/typeahead';
import { SiTypeaheadModule } from '@simpl/element-ng/typeahead';
export * from '@simpl/element-ng/typeahead';
import { SiFormModule } from '@simpl/element-ng/form';
export * from '@simpl/element-ng/form';
import { SiStatusBarModule } from '@simpl/element-ng/status-bar';
export * from '@simpl/element-ng/status-bar';
import * as i2$9 from '@simpl/element-ng/list-interaction';
import { SiListInteractionModule } from '@simpl/element-ng/list-interaction';
export * from '@simpl/element-ng/list-interaction';
import { __decorate } from 'tslib';
import { SiCardModule } from '@simpl/element-ng/card';
export * from '@simpl/element-ng/card';
import { SiLocalizationModule } from '@simpl/element-ng/localization';
export * from '@simpl/element-ng/localization';
import { SiTabsModule } from '@simpl/element-ng/tabs';
export * from '@simpl/element-ng/tabs';
export * from '@simpl/element-ng/theme';
import { BreakpointObserver } from '@angular/cdk/layout';
export * from '@simpl/element-ng/aria-current';
import { SiPopoverModule } from '@simpl/element-ng/popover';
export * from '@simpl/element-ng/popover';

const SI_TOAST_AUTO_HIDE_DELAY = 6000;

class SiToastNotificationComponent {
    toast;
    closeAriaLabel = $localize `:@@SI_TOAST.CLOSE:Close`;
    statusIcon = STATUS_ICON.info;
    autoCloseBar;
    animationBuilder = inject(AnimationBuilder);
    ngOnChanges(changes) {
        if (changes?.toast.currentValue) {
            if (this.toast.state === 'connection') {
                this.statusIcon = STATUS_ICON.danger;
            }
            else {
                this.statusIcon = STATUS_ICON[this.toast.state];
            }
            if (!this.toast.disableAutoClose && this.toast.timeout) {
                const animation = this.animationBuilder.build([
                    style({ width: '100%' }),
                    animate(this.toast.timeout, style({ width: '0%' }))
                ]);
                animation.create(this.autoCloseBar.nativeElement).play();
            }
            this.closeAriaLabel = this.toast.closeAriaLabel ?? this.closeAriaLabel;
        }
    }
    close() {
        this.toast.close();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiToastNotificationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiToastNotificationComponent, isStandalone: true, selector: "si-toast-notification", inputs: { toast: "toast" }, viewQueries: [{ propertyName: "autoCloseBar", first: true, predicate: ["autoCloseBar"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"si-toast elevation-2\" [class.si-toast-auto-close]=\"!toast.disableAutoClose\">\n  <div #autoCloseBar class=\"si-toast-timer-bar cy-ignore\"></div>\n  <div class=\"bar\" [ngClass]=\"statusIcon.color\"></div>\n  <si-icon\n    alt=\"\"\n    [icon]=\"statusIcon.icon\"\n    [color]=\"statusIcon.color\"\n    [stackedIcon]=\"statusIcon.stacked\"\n    [stackedColor]=\"statusIcon.stackedColor\"\n  ></si-icon>\n  <div class=\"toast-content px-4\">\n    <p class=\"toast-title\"\n      ><b>{{ toast.title | translate : toast.translationParams }}</b></p\n    >\n    <p *ngIf=\"toast.message\" class=\"mt-3\">{{\n      toast.message | translate : toast.translationParams\n    }}</p>\n    <p *ngIf=\"toast.action\" [class.mt-3]=\"toast.message\" [class.mt-4]=\"!toast.message\">\n      <a [siLink]=\"toast.action\">{{ toast.action.title! | translate : toast.translationParams }}</a>\n    </p>\n  </div>\n  <button\n    *ngIf=\"!toast.disableManualClose\"\n    type=\"button\"\n    tabindex=\"0\"\n    class=\"btn btn-circle btn-sm btn-ghost mt-n2 me-n2 element-cancel\"\n    [attr.aria-label]=\"closeAriaLabel | translate\"\n    (keydown.enter)=\"close()\"\n    (click)=\"close()\"\n  ></button>\n</div>\n", styles: [".si-toast-timer-bar,.si-toast.si-toast-auto-close:before{position:absolute;inset-block-end:0;inset-inline-start:0;block-size:2px}:host{display:block}.si-toast{block-size:auto;position:relative;display:flex;align-items:flex-start;color:var(--element-text-primary);background:var(--element-base-3);border-radius:var(--element-radius-2);padding:12px;margin-block-end:20px;font-size:1rem;pointer-events:all;overflow:hidden;min-inline-size:250px;max-inline-size:calc(100vw - 40px)}@media (min-width: 768px){.si-toast{max-inline-size:400px}}.si-toast.si-toast-auto-close{padding-block-end:14px}.si-toast.si-toast-auto-close:before{content:\"\";background:var(--element-ui-4);inset-inline-end:0}.bar{inset-block-start:0;inset-inline-start:0;position:absolute;inline-size:4px;block-size:100%;background:currentColor}.si-toast-timer-bar{background-color:var(--element-ui-0)}.toast-content{flex:1;overflow:hidden;white-space:nowrap}.toast-content p{margin-block:0;line-height:1.125rem;white-space:pre-line;overflow-wrap:break-word;word-wrap:break-word}.toast-content .toast-title{line-height:1.5rem}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: SiIconModule }, { kind: "component", type: i2$5.SiIconComponent, selector: "si-icon", inputs: ["icon", "color", "stackedIcon", "stackedColor", "alt", "size"] }, { kind: "ngmodule", type: SiLinkModule }, { kind: "directive", type: i3$5.SiLinkDirective, selector: "[siLink]", inputs: ["siLink", "siLinkDefaultTarget", "actionParam", "activeClass", "exactMatch", "ariaCurrent"], outputs: ["activeChange"], exportAs: ["siLink"] }, { kind: "ngmodule", type: SiTranslateModule }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiToastNotificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-toast-notification', imports: [CommonModule, SiIconModule, SiLinkModule, SiTranslateModule], standalone: true, template: "<div class=\"si-toast elevation-2\" [class.si-toast-auto-close]=\"!toast.disableAutoClose\">\n  <div #autoCloseBar class=\"si-toast-timer-bar cy-ignore\"></div>\n  <div class=\"bar\" [ngClass]=\"statusIcon.color\"></div>\n  <si-icon\n    alt=\"\"\n    [icon]=\"statusIcon.icon\"\n    [color]=\"statusIcon.color\"\n    [stackedIcon]=\"statusIcon.stacked\"\n    [stackedColor]=\"statusIcon.stackedColor\"\n  ></si-icon>\n  <div class=\"toast-content px-4\">\n    <p class=\"toast-title\"\n      ><b>{{ toast.title | translate : toast.translationParams }}</b></p\n    >\n    <p *ngIf=\"toast.message\" class=\"mt-3\">{{\n      toast.message | translate : toast.translationParams\n    }}</p>\n    <p *ngIf=\"toast.action\" [class.mt-3]=\"toast.message\" [class.mt-4]=\"!toast.message\">\n      <a [siLink]=\"toast.action\">{{ toast.action.title! | translate : toast.translationParams }}</a>\n    </p>\n  </div>\n  <button\n    *ngIf=\"!toast.disableManualClose\"\n    type=\"button\"\n    tabindex=\"0\"\n    class=\"btn btn-circle btn-sm btn-ghost mt-n2 me-n2 element-cancel\"\n    [attr.aria-label]=\"closeAriaLabel | translate\"\n    (keydown.enter)=\"close()\"\n    (click)=\"close()\"\n  ></button>\n</div>\n", styles: [".si-toast-timer-bar,.si-toast.si-toast-auto-close:before{position:absolute;inset-block-end:0;inset-inline-start:0;block-size:2px}:host{display:block}.si-toast{block-size:auto;position:relative;display:flex;align-items:flex-start;color:var(--element-text-primary);background:var(--element-base-3);border-radius:var(--element-radius-2);padding:12px;margin-block-end:20px;font-size:1rem;pointer-events:all;overflow:hidden;min-inline-size:250px;max-inline-size:calc(100vw - 40px)}@media (min-width: 768px){.si-toast{max-inline-size:400px}}.si-toast.si-toast-auto-close{padding-block-end:14px}.si-toast.si-toast-auto-close:before{content:\"\";background:var(--element-ui-4);inset-inline-end:0}.bar{inset-block-start:0;inset-inline-start:0;position:absolute;inline-size:4px;block-size:100%;background:currentColor}.si-toast-timer-bar{background-color:var(--element-ui-0)}.toast-content{flex:1;overflow:hidden;white-space:nowrap}.toast-content p{margin-block:0;line-height:1.125rem;white-space:pre-line;overflow-wrap:break-word;word-wrap:break-word}.toast-content .toast-title{line-height:1.5rem}\n"] }]
        }], propDecorators: { toast: [{
                type: Input
            }], autoCloseBar: [{
                type: ViewChild,
                args: ['autoCloseBar', { static: true }]
            }] } });

class SiToastNotificationDrawerComponent {
    toasts;
    animationsDisabled = areAnimationsDisabled();
    trackByItem = (index, item) => item;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiToastNotificationDrawerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiToastNotificationDrawerComponent, isStandalone: true, selector: "si-toast-notification-drawer", inputs: { toasts: "toasts" }, ngImport: i0, template: "<div class=\"si-toast-drawer\" aria-live=\"polite\">\n  <si-toast-notification\n    *ngFor=\"let toast of toasts | async; trackBy: trackByItem\"\n    class=\"position-relative\"\n    [toast]=\"toast\"\n    @toastTrigger\n    [@.disabled]=\"animationsDisabled\"\n  ></si-toast-notification>\n</div>\n", styles: [".si-toast-drawer{position:fixed;inset-block-end:0;inset-inline-end:0;padding-block:32px 0;padding-inline:32px 20px;z-index:2000;overflow:hidden;pointer-events:none}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "component", type: SiToastNotificationComponent, selector: "si-toast-notification", inputs: ["toast"] }], animations: [
            trigger('toastTrigger', [
                transition(':enter', [
                    style({ opacity: 0, transform: 'translateY(100%)' }),
                    animate('500ms cubic-bezier(0.175, 0.885, 0.32, 1.275)', style({ opacity: 1, transform: 'translateY(0%)' }))
                ]),
                transition(':leave', [
                    style({ 'opacity': 1, 'inset-inline-end': '0%' }),
                    animate('300ms', style({ 'opacity': 0, 'inset-inline-end': '-100%' }))
                ])
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiToastNotificationDrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-toast-notification-drawer', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('toastTrigger', [
                            transition(':enter', [
                                style({ opacity: 0, transform: 'translateY(100%)' }),
                                animate('500ms cubic-bezier(0.175, 0.885, 0.32, 1.275)', style({ opacity: 1, transform: 'translateY(0%)' }))
                            ]),
                            transition(':leave', [
                                style({ 'opacity': 1, 'inset-inline-end': '0%' }),
                                animate('300ms', style({ 'opacity': 0, 'inset-inline-end': '-100%' }))
                            ])
                        ])
                    ], imports: [CommonModule, SiToastNotificationComponent], standalone: true, template: "<div class=\"si-toast-drawer\" aria-live=\"polite\">\n  <si-toast-notification\n    *ngFor=\"let toast of toasts | async; trackBy: trackByItem\"\n    class=\"position-relative\"\n    [toast]=\"toast\"\n    @toastTrigger\n    [@.disabled]=\"animationsDisabled\"\n  ></si-toast-notification>\n</div>\n", styles: [".si-toast-drawer{position:fixed;inset-block-end:0;inset-inline-end:0;padding-block:32px 0;padding-inline:32px 20px;z-index:2000;overflow:hidden;pointer-events:none}\n"] }]
        }], propDecorators: { toasts: [{
                type: Input
            }] } });

class SiToastNotificationService {
    /**
     * List of currently active toasts to see details or close them.
     */
    activeToasts = [];
    activeToastsSubject = new Subject();
    queuedToastSubject = new Subject();
    maxToasts = 3;
    componentRef;
    appRef = inject(ApplicationRef);
    injector = inject(Injector);
    environmentInjector = inject(EnvironmentInjector);
    constructor() {
        const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
        this.queuedToastSubject.subscribe((toast) => {
            this.activeToasts.push(toast);
            if (this.activeToasts.length > this.maxToasts) {
                this.hideToastNotification(this.activeToasts[0]);
            }
            this.activeToastsSubject.next(this.activeToasts);
            if (!toast.disableAutoClose && toast.timeout) {
                setTimeout(() => this.hideToastNotification(toast), toast.timeout);
            }
        });
        if (isBrowser) {
            this.addToastDrawer();
        }
    }
    ngOnDestroy() {
        this.componentRef?.destroy();
    }
    /**
     * Queue a new toast to be shown.
     * @param action Passing a Link object will optionally add a clickable link to the toast which can contain an action.
     * @returns the toast object
     */
    queueToastNotification(state, title, message, disableAutoClose, disableManualClose, action) {
        const toast = {
            state,
            title,
            message,
            disableAutoClose,
            disableManualClose,
            action,
            hidden: new Subject()
        };
        return this.showToastNotification(toast);
    }
    /**
     * Show a toast notification
     * @param toast The toast object of the toast to be shown, can also be constructed while calling this.
     */
    showToastNotification(toast) {
        toast.timeout ??= SI_TOAST_AUTO_HIDE_DELAY;
        toast.close = () => this.hideToastNotification(toast);
        this.queuedToastSubject.next(toast);
        return toast;
    }
    /**
     * Hide a toast notification
     * @param toast The toast object of the toast to be hidden, can be retrieved from {@link activeToasts} and is returned by {@link queueToastNotification}.
     */
    hideToastNotification(toast) {
        const hiddenToasts = [];
        const activeToasts = [];
        this.activeToasts.forEach(item => {
            if (!toast || item === toast) {
                hiddenToasts.push(item);
            }
            else {
                activeToasts.push(item);
            }
        });
        this.activeToasts = activeToasts;
        this.activeToastsSubject.next(this.activeToasts);
        hiddenToasts.forEach(item => {
            item.hidden?.next();
            item.hidden?.complete();
        });
    }
    addToastDrawer() {
        runInInjectionContext(this.injector, () => {
            this.componentRef = createComponent(SiToastNotificationDrawerComponent, {
                environmentInjector: this.environmentInjector,
                elementInjector: this.buildInjector()
            });
            this.componentRef.instance.toasts = this.activeToastsSubject;
            this.appRef.attachView(this.componentRef.hostView);
            document.body.appendChild(this.componentRef.location.nativeElement);
        });
    }
    // TODO remove once translation must be defined at application start
    // Notification service is provided in 'root'. If no translation is defined, SiNoTranslateService is not provided
    buildInjector() {
        let injector = this.injector;
        if (!injector.get(SiTranslateService, null)) {
            injector = Injector.create({
                providers: [{ provide: SiTranslateService, useClass: SiNoTranslateService, deps: [] }],
                parent: this.injector
            });
        }
        return injector;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiToastNotificationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiToastNotificationService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiToastNotificationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

const RE_UPPER_CASE = /[A-Z]/;
const RE_LOWER_CASE = /[a-z]/;
const RE_DIGITS = /[0-9]/;
const RE_SPECIAL_CHARS = /[\x21-\x2F|\x3A-\x40|\x5B-\x60]/;
const RE_WHITESPACES = /\s/;
class SiPasswordStrengthDirective {
    maxStrength = 1;
    noValidation = false;
    /**
     * Define Siemens password strength.
     */
    siPasswordStrength = {
        minLength: 8,
        uppercase: true,
        lowercase: true,
        digits: true,
        special: true
    };
    /**
     * Output callback event called when the password changes. The number
     * indicated the number of rules which still can be met. (`-2` --> 2 rules are
     * still unmet, `0` --> all met)
     */
    passwordStrengthChanged = new EventEmitter();
    ngOnChanges() {
        this.maxStrength = 1;
        this.maxStrength += this.siPasswordStrength.uppercase ? 1 : 0;
        this.maxStrength += this.siPasswordStrength.lowercase ? 1 : 0;
        this.maxStrength += this.siPasswordStrength.digits ? 1 : 0;
        this.maxStrength += this.siPasswordStrength.special ? 1 : 0;
    }
    /** @internal */
    validate(control) {
        if (this.getStrength(control.value) >= this.maxStrength) {
            return {};
        }
        return { siPasswordStrength: true };
    }
    getStrength(password) {
        let strength = 0;
        if (password && password !== '') {
            // Strength check
            strength += password.length >= this.siPasswordStrength.minLength ? 1 : 0;
            strength += this.siPasswordStrength.uppercase && password.match(RE_UPPER_CASE) ? 1 : 0;
            strength += this.siPasswordStrength.lowercase && password.match(RE_LOWER_CASE) ? 1 : 0;
            strength += this.siPasswordStrength.digits && password.match(RE_DIGITS) ? 1 : 0;
            strength += this.siPasswordStrength.special && password.match(RE_SPECIAL_CHARS) ? 1 : 0;
            // Hard limit check
            strength = password.match(RE_WHITESPACES) ? 0 : strength;
            this.noValidation = true;
            // Notify listeners
            this.passwordStrengthChanged.emit(strength - this.maxStrength);
            return strength;
        }
        this.noValidation = false;
        this.passwordStrengthChanged.emit();
        return strength;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiPasswordStrengthDirective, selector: "[siPasswordStrength]", inputs: { siPasswordStrength: "siPasswordStrength" }, outputs: { passwordStrengthChanged: "passwordStrengthChanged" }, host: { properties: { "class.no-validation": "this.noValidation" } }, providers: [{ provide: NG_VALIDATORS, useExisting: SiPasswordStrengthDirective, multi: true }], usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siPasswordStrength]',
                    providers: [{ provide: NG_VALIDATORS, useExisting: SiPasswordStrengthDirective, multi: true }]
                }]
        }], propDecorators: { noValidation: [{
                type: HostBinding,
                args: ['class.no-validation']
            }], siPasswordStrength: [{
                type: Input
            }], passwordStrengthChanged: [{
                type: Output
            }] } });
class SiPasswordStrengthComponent {
    passwordStrengthDirective;
    cdRef = inject(ChangeDetectorRef);
    bad = false;
    weak = false;
    medium = false;
    good = false;
    strong = false;
    ngAfterViewInit() {
        this.passwordStrengthDirective.forEach(directive => {
            directive.passwordStrengthChanged.subscribe((strength) => {
                this.strong = strength === 0;
                this.good = strength === -1;
                this.medium = strength === -2;
                this.weak = strength === -3;
                this.bad = strength === -4;
                this.cdRef.markForCheck();
            });
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiPasswordStrengthComponent, selector: "si-password-strength", host: { properties: { "class.bad": "this.bad", "class.weak": "this.weak", "class.medium": "this.medium", "class.good": "this.good", "class.strong": "this.strong" } }, queries: [{ propertyName: "passwordStrengthDirective", predicate: SiPasswordStrengthDirective }], ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{--strength-border-radius: 0 var(--element-radius-1) var(--element-radius-1) 1px;display:block;position:relative}:host:before{background:var(--strength-background);inset-block-end:1px;content:\"\";block-size:3px;inset-inline-start:1px;position:absolute;transition:inline-size calc(.15s * var(--element-animations-enabled, 1)),background calc(.15s * var(--element-animations-enabled, 1)) ease-in-out;inline-size:calc(var(--strength-width) - 2px);border-radius:var(--strength-border-radius)}:host.bad{--strength-background: var(--element-color-bad);--strength-width: 20%}:host.weak{--strength-background: var(--element-color-poor);--strength-width: 40%}:host.medium{--strength-background: var(--element-color-average);--strength-width: 60%}:host.good{--strength-background: var(--element-color-good);--strength-width: 80%}:host.strong{--strength-background: var(--element-color-excellent);--strength-width: 100%;--strength-border-radius: 0 0 1px 1px}\n"] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-password-strength', template: '<ng-content></ng-content>', styles: [":host{--strength-border-radius: 0 var(--element-radius-1) var(--element-radius-1) 1px;display:block;position:relative}:host:before{background:var(--strength-background);inset-block-end:1px;content:\"\";block-size:3px;inset-inline-start:1px;position:absolute;transition:inline-size calc(.15s * var(--element-animations-enabled, 1)),background calc(.15s * var(--element-animations-enabled, 1)) ease-in-out;inline-size:calc(var(--strength-width) - 2px);border-radius:var(--strength-border-radius)}:host.bad{--strength-background: var(--element-color-bad);--strength-width: 20%}:host.weak{--strength-background: var(--element-color-poor);--strength-width: 40%}:host.medium{--strength-background: var(--element-color-average);--strength-width: 60%}:host.good{--strength-background: var(--element-color-good);--strength-width: 80%}:host.strong{--strength-background: var(--element-color-excellent);--strength-width: 100%;--strength-border-radius: 0 0 1px 1px}\n"] }]
        }], propDecorators: { passwordStrengthDirective: [{
                type: ContentChildren,
                args: [SiPasswordStrengthDirective]
            }], bad: [{
                type: HostBinding,
                args: ['class.bad']
            }], weak: [{
                type: HostBinding,
                args: ['class.weak']
            }], medium: [{
                type: HostBinding,
                args: ['class.medium']
            }], good: [{
                type: HostBinding,
                args: ['class.good']
            }], strong: [{
                type: HostBinding,
                args: ['class.strong']
            }] } });

class SiPasswordStrengthModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthModule, declarations: [SiPasswordStrengthComponent, SiPasswordStrengthDirective], imports: [CommonModule, FormsModule], exports: [SiPasswordStrengthComponent, SiPasswordStrengthDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthModule, imports: [CommonModule, FormsModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPasswordStrengthModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [SiPasswordStrengthComponent, SiPasswordStrengthDirective],
                    exports: [SiPasswordStrengthComponent, SiPasswordStrengthDirective]
                }]
        }] });

class SiAboutComponent {
    http = inject(HttpClient);
    sanitizer = inject(DomSanitizer);
    cdRef = inject(ChangeDetectorRef);
    /**
     * Title shown above the about information.
     */
    aboutTitle;
    /**
     * Define mode to display the licenses. See {@link LicenseInfo}
     */
    licenseInfo;
    /**
     * Path to the application logo. Use for image
     */
    icon;
    /**
     * Name of element icon. Use as alternative to image
     */
    iconName;
    /**
     * Title of this application.
     */
    appName;
    /**
     * Sub titles of the application. Shown as a list below the application name. (Optional)
     */
    subheading;
    /**
     * Link to `Acceptable Use Policy`.
     */
    acceptableUsePolicyLink;
    /**
     * Link to `Corporate Information`.
     */
    imprintLink;
    /**
     * Link to `Privacy Notice`.
     */
    privacyLink;
    /**
     * Link to `Cookie Notice`.
     */
    cookieNoticeLink;
    /**
     * Link to `Terms of Use`.
     */
    termsLink;
    /**
     * Additional links listed in the about section.
     */
    links = [];
    sanitizedUrl;
    licenseApi = [];
    /**
     * Copyright information to be displayed. Alternatively, you can use the {@link SI_COPYRIGHT_DETAILS} global inject.
     */
    copyrightDetails;
    ngOnInit() {
        if (this.licenseInfo.api) {
            this.http.get(this.licenseInfo.api, { responseType: 'json' }).subscribe(data => {
                this.licenseApi = data;
                if (this.licenseApi.length === 1) {
                    const apiInfo = this.licenseApi[0];
                    apiInfo.isOpen = false;
                    this.toggleLoadLicenseApi(apiInfo);
                }
                this.cdRef.markForCheck();
            });
        }
    }
    ngOnChanges() {
        if (this.licenseInfo.iframe != null) {
            this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.licenseInfo.iframe);
        }
    }
    trackByIndex = (index) => index;
    toggleLoadLicenseApi(apiInfo) {
        if (!apiInfo.isOpen && !apiInfo.files) {
            this.http.get(apiInfo.href, { responseType: 'json' }).subscribe(files => {
                apiInfo.files = files;
                this.cdRef.markForCheck();
            });
        }
        apiInfo.isOpen = !apiInfo.isOpen;
        this.cdRef.markForCheck();
    }
    toggleLoadLicenseContent(apiInfo) {
        apiInfo.isOpen = !apiInfo.isOpen;
        if (!apiInfo.content) {
            this.http.get(apiInfo.href, { responseType: 'text' }).subscribe((content) => {
                apiInfo.content = content;
                this.cdRef.markForCheck();
            });
        }
        this.cdRef.markForCheck();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAboutComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiAboutComponent, selector: "si-about", inputs: { aboutTitle: "aboutTitle", licenseInfo: "licenseInfo", icon: "icon", iconName: "iconName", appName: "appName", subheading: "subheading", acceptableUsePolicyLink: "acceptableUsePolicyLink", imprintLink: "imprintLink", privacyLink: "privacyLink", cookieNoticeLink: "cookieNoticeLink", termsLink: "termsLink", links: "links", copyrightDetails: "copyrightDetails" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"row mx-6 mt-6\">\n  <div class=\"col-md-6 mb-6\">\n    <div class=\"card elevation-1 overflow-hidden\">\n      <div class=\"card-header text-truncate\">\n        {{ aboutTitle }}\n      </div>\n\n      <div>\n        <div class=\"list-group-item text-center\">\n          <img\n            *ngIf=\"icon\"\n            class=\"rounded-circle\"\n            height=\"150\"\n            [src]=\"icon\"\n            [alt]=\"appName + '\\'s Logo'\"\n          />\n          <i\n            *ngIf=\"!icon && iconName\"\n            class=\"app-icon\"\n            role=\"presentation\"\n            [ngClass]=\"iconName\"\n          ></i>\n          <h3>{{ appName }}</h3>\n          <p *ngFor=\"let item of subheading; trackBy: trackByIndex\">{{ item }}</p>\n          <si-copyright-notice [copyright]=\"copyrightDetails\"></si-copyright-notice>\n        </div>\n\n        <ng-container\n          *ngIf=\"imprintLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: imprintLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"privacyLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: privacyLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"cookieNoticeLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: cookieNoticeLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"termsLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: termsLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"acceptableUsePolicyLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: acceptableUsePolicyLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngFor=\"let item of links; trackBy: trackByIndex\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: item }\"\n        >\n        </ng-container>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-6 mb-6\">\n    <div class=\"card elevation-1 overflow-hidden\" [class.h-100]=\"licenseInfo.iframe\">\n      <div class=\"card-header text-truncate\">\n        {{ licenseInfo.title }}\n      </div>\n\n      <div class=\"h-100\">\n        <pre *ngIf=\"licenseInfo.text\" class=\"list-group-item\">{{ licenseInfo.text }}</pre>\n\n        <iframe\n          *ngIf=\"licenseInfo.iframe\"\n          class=\"w-100 h-100\"\n          [src]=\"sanitizedUrl\"\n          [title]=\"licenseInfo.title\"\n        ></iframe>\n\n        <ng-container *ngIf=\"licenseInfo.api\">\n          <ng-container *ngFor=\"let api of licenseApi; trackBy: trackByIndex\">\n            <si-collapsible-panel\n              colorVariant=\"base-0\"\n              class=\"license-api\"\n              [heading]=\"api.name\"\n              (toggle)=\"toggleLoadLicenseApi(api)\"\n            >\n              <si-collapsible-panel\n                *ngFor=\"let file of api.files; trackBy: trackByIndex\"\n                colorVariant=\"base-0\"\n                class=\"license-api-file\"\n                [icon]=\"licenseInfo.icon ? licenseInfo.icon : 'element-document'\"\n                [heading]=\"file.name\"\n                (toggle)=\"toggleLoadLicenseContent(file)\"\n              >\n                <pre class=\"license-api-file-content px-6 pt-6\">{{ file.content }}</pre>\n              </si-collapsible-panel>\n            </si-collapsible-panel>\n          </ng-container>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-template #linkTemplate let-link=\"link\">\n  <a\n    class=\"list-group-item si-title-2 text-body focus-inside\"\n    siLinkDefaultTarget=\"_blank\"\n    [siLink]=\"link\"\n  >\n    {{ link.title ?? '' | translate }}\n  </a>\n</ng-template>\n", styles: [".list-group-item{border-width:0 0 1px;padding-inline:16px}.list-group-item.with-border:first-child{border-block-start-width:1px}.list-group-item:last-child{border-block-end-width:0}.app-icon{font-size:150px}iframe{border-style:none;min-block-size:500px;margin-block-end:-5px}pre{word-break:break-word;white-space:pre-wrap}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$2.SiCollapsiblePanelComponent, selector: "si-collapsible-panel", inputs: ["heading", "headerCssClasses", "contentBgClasses", "contentCssClasses", "opened", "icon", "disabled", "colorVariant", "badge", "badgeColor"], outputs: ["toggle"] }, { kind: "component", type: i3$4.SiCopyrightNoticeComponent, selector: "si-copyright-notice", inputs: ["copyright"] }, { kind: "directive", type: i3$5.SiLinkDirective, selector: "[siLink]", inputs: ["siLink", "siLinkDefaultTarget", "actionParam", "activeClass", "exactMatch", "ariaCurrent"], outputs: ["activeChange"], exportAs: ["siLink"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAboutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-about', template: "<div class=\"row mx-6 mt-6\">\n  <div class=\"col-md-6 mb-6\">\n    <div class=\"card elevation-1 overflow-hidden\">\n      <div class=\"card-header text-truncate\">\n        {{ aboutTitle }}\n      </div>\n\n      <div>\n        <div class=\"list-group-item text-center\">\n          <img\n            *ngIf=\"icon\"\n            class=\"rounded-circle\"\n            height=\"150\"\n            [src]=\"icon\"\n            [alt]=\"appName + '\\'s Logo'\"\n          />\n          <i\n            *ngIf=\"!icon && iconName\"\n            class=\"app-icon\"\n            role=\"presentation\"\n            [ngClass]=\"iconName\"\n          ></i>\n          <h3>{{ appName }}</h3>\n          <p *ngFor=\"let item of subheading; trackBy: trackByIndex\">{{ item }}</p>\n          <si-copyright-notice [copyright]=\"copyrightDetails\"></si-copyright-notice>\n        </div>\n\n        <ng-container\n          *ngIf=\"imprintLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: imprintLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"privacyLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: privacyLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"cookieNoticeLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: cookieNoticeLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"termsLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: termsLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngIf=\"acceptableUsePolicyLink\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: acceptableUsePolicyLink }\"\n        >\n        </ng-container>\n        <ng-container\n          *ngFor=\"let item of links; trackBy: trackByIndex\"\n          [ngTemplateOutlet]=\"linkTemplate\"\n          [ngTemplateOutletContext]=\"{ link: item }\"\n        >\n        </ng-container>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"col-md-6 mb-6\">\n    <div class=\"card elevation-1 overflow-hidden\" [class.h-100]=\"licenseInfo.iframe\">\n      <div class=\"card-header text-truncate\">\n        {{ licenseInfo.title }}\n      </div>\n\n      <div class=\"h-100\">\n        <pre *ngIf=\"licenseInfo.text\" class=\"list-group-item\">{{ licenseInfo.text }}</pre>\n\n        <iframe\n          *ngIf=\"licenseInfo.iframe\"\n          class=\"w-100 h-100\"\n          [src]=\"sanitizedUrl\"\n          [title]=\"licenseInfo.title\"\n        ></iframe>\n\n        <ng-container *ngIf=\"licenseInfo.api\">\n          <ng-container *ngFor=\"let api of licenseApi; trackBy: trackByIndex\">\n            <si-collapsible-panel\n              colorVariant=\"base-0\"\n              class=\"license-api\"\n              [heading]=\"api.name\"\n              (toggle)=\"toggleLoadLicenseApi(api)\"\n            >\n              <si-collapsible-panel\n                *ngFor=\"let file of api.files; trackBy: trackByIndex\"\n                colorVariant=\"base-0\"\n                class=\"license-api-file\"\n                [icon]=\"licenseInfo.icon ? licenseInfo.icon : 'element-document'\"\n                [heading]=\"file.name\"\n                (toggle)=\"toggleLoadLicenseContent(file)\"\n              >\n                <pre class=\"license-api-file-content px-6 pt-6\">{{ file.content }}</pre>\n              </si-collapsible-panel>\n            </si-collapsible-panel>\n          </ng-container>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-template #linkTemplate let-link=\"link\">\n  <a\n    class=\"list-group-item si-title-2 text-body focus-inside\"\n    siLinkDefaultTarget=\"_blank\"\n    [siLink]=\"link\"\n  >\n    {{ link.title ?? '' | translate }}\n  </a>\n</ng-template>\n", styles: [".list-group-item{border-width:0 0 1px;padding-inline:16px}.list-group-item.with-border:first-child{border-block-start-width:1px}.list-group-item:last-child{border-block-end-width:0}.app-icon{font-size:150px}iframe{border-style:none;min-block-size:500px;margin-block-end:-5px}pre{word-break:break-word;white-space:pre-wrap}\n"] }]
        }], propDecorators: { aboutTitle: [{
                type: Input,
                args: [{ required: true }]
            }], licenseInfo: [{
                type: Input,
                args: [{ required: true }]
            }], icon: [{
                type: Input
            }], iconName: [{
                type: Input
            }], appName: [{
                type: Input,
                args: [{ required: true }]
            }], subheading: [{
                type: Input
            }], acceptableUsePolicyLink: [{
                type: Input
            }], imprintLink: [{
                type: Input
            }], privacyLink: [{
                type: Input
            }], cookieNoticeLink: [{
                type: Input
            }], termsLink: [{
                type: Input
            }], links: [{
                type: Input
            }], copyrightDetails: [{
                type: Input
            }] } });

class SiAboutModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAboutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiAboutModule, declarations: [SiAboutComponent], imports: [CommonModule,
            SiAccordionModule,
            SiCopyrightNoticeModule,
            SiLinkModule,
            SiTranslateModule], exports: [SiAboutComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAboutModule, imports: [CommonModule,
            SiAccordionModule,
            SiCopyrightNoticeModule,
            SiLinkModule,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAboutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SiAccordionModule,
                        SiCopyrightNoticeModule,
                        SiLinkModule,
                        SiTranslateModule
                    ],
                    declarations: [SiAboutComponent],
                    exports: [SiAboutComponent]
                }]
        }] });

class SiComfortScoreStatusComponent {
    item;
    size = 'medium';
    get sizeClass() {
        return 'size-' + this.size;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreStatusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiComfortScoreStatusComponent, selector: "si-comfort-score-status", inputs: { item: "item", size: "size" }, host: { properties: { "class": "this.sizeClass" } }, ngImport: i0, template: "<i\n  *ngIf=\"item.icon\"\n  class=\"me-4\"\n  role=\"presentation\"\n  [ngClass]=\"[item.icon, 'status-' + item.status, item.selected ? item.icon + '-filled' : '']\"\n  [class.item-disabled]=\"item.disabled\"\n></i>\n<div\n  class=\"flex-fill d-flex flex-column\"\n  [class.text-muted]=\"item.disabled\"\n  [attr.aria-disabled]=\"item.disabled\"\n>\n  <div class=\"score-title d-flex mb-3\">\n    {{ item.title | translate }}\n    <div\n      *ngIf=\"size !== 'large'\"\n      class=\"score si-caption mt-2\"\n      [class.text-secondary]=\"!item.disabled\"\n      [class.text-muted]=\"item.disabled\"\n    >\n      {{ item.value }}{{ item.unit ?? ' / 100' }}\n    </div>\n  </div>\n  <div *ngIf=\"size !== 'small' && item.description\" class=\"score-description\">\n    {{ item.description | translate }}\n  </div>\n</div>\n", styles: [":host{display:flex;max-inline-size:192px}:host.size-small{--title-weight: normal;--icon-size: 1.25rem;--score-dir: column;align-items:center}:host.size-medium{--title-weight: bold;--icon-size: 2rem;--title-order: 1;--score-dir: row}:host.size-large{--title-weight: bold;--title-size: 1.75rem;--icon-size: 2rem;--title-order: 0}i{font-size:var(--icon-size)}.score-title{flex-direction:var(--score-dir);align-items:baseline;justify-content:space-between;font-weight:var(--title-weight);font-size:var(--title-size);order:var(--title-order);line-height:1}.item-disabled{color:var(--element-ui-3)!important}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreStatusComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-comfort-score-status', template: "<i\n  *ngIf=\"item.icon\"\n  class=\"me-4\"\n  role=\"presentation\"\n  [ngClass]=\"[item.icon, 'status-' + item.status, item.selected ? item.icon + '-filled' : '']\"\n  [class.item-disabled]=\"item.disabled\"\n></i>\n<div\n  class=\"flex-fill d-flex flex-column\"\n  [class.text-muted]=\"item.disabled\"\n  [attr.aria-disabled]=\"item.disabled\"\n>\n  <div class=\"score-title d-flex mb-3\">\n    {{ item.title | translate }}\n    <div\n      *ngIf=\"size !== 'large'\"\n      class=\"score si-caption mt-2\"\n      [class.text-secondary]=\"!item.disabled\"\n      [class.text-muted]=\"item.disabled\"\n    >\n      {{ item.value }}{{ item.unit ?? ' / 100' }}\n    </div>\n  </div>\n  <div *ngIf=\"size !== 'small' && item.description\" class=\"score-description\">\n    {{ item.description | translate }}\n  </div>\n</div>\n", styles: [":host{display:flex;max-inline-size:192px}:host.size-small{--title-weight: normal;--icon-size: 1.25rem;--score-dir: column;align-items:center}:host.size-medium{--title-weight: bold;--icon-size: 2rem;--title-order: 1;--score-dir: row}:host.size-large{--title-weight: bold;--title-size: 1.75rem;--icon-size: 2rem;--title-order: 0}i{font-size:var(--icon-size)}.score-title{flex-direction:var(--score-dir);align-items:baseline;justify-content:space-between;font-weight:var(--title-weight);font-size:var(--title-size);order:var(--title-order);line-height:1}.item-disabled{color:var(--element-ui-3)!important}\n"] }]
        }], propDecorators: { item: [{
                type: Input,
                args: [{ required: true }]
            }], size: [{
                type: Input
            }], sizeClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class SiComfortScoreComponent {
    items = [];
    showValues = true;
    labelOnly = false;
    gridParts = 2;
    selected = new EventEmitter();
    trackByItem = (index, item) => item;
    trackByIndex = (index) => index;
    gridPartArray = new Array(this.gridParts);
    ngOnChanges(changes) {
        if (changes.gridParts) {
            this.gridPartArray = new Array(this.gridParts);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiComfortScoreComponent, selector: "si-comfort-score", inputs: { items: "items", showValues: "showValues", labelOnly: "labelOnly", gridParts: "gridParts" }, outputs: { selected: "selected" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"wrapper\" [class.labels]=\"showValues\">\n  <div\n    class=\"grid d-flex flex-column position-relative text-secondary small\"\n    [style.grid-column-end]=\"items.length + 1\"\n  >\n    <div *ngFor=\"let p of gridPartArray; trackBy: trackByIndex\" class=\"border-top flex-fill\"></div>\n    <ng-container *ngIf=\"showValues\">\n      <div class=\"axis-label position-absolute text-end label-100\">100</div>\n      <div class=\"axis-label position-absolute text-end label-0\">0</div>\n    </ng-container>\n  </div>\n  <ng-container *ngFor=\"let item of items; trackBy: trackByItem; index as i\">\n    <div class=\"bar-outer position-relative\" [style.grid-column]=\"i + 1\">\n      <div\n        class=\"bar position-absolute d-flex flex-column text-center\"\n        [class.detail]=\"!labelOnly\"\n        [style.height.%]=\"item.value\"\n        (click)=\"selected.emit(item)\"\n      >\n        <div\n          class=\"bar-inner flex-fill\"\n          [class.selected]=\"item.selected\"\n          [class.disabled]=\"item.disabled\"\n          [ngClass]=\"'status-' + item.status\"\n        >\n          <div *ngIf=\"showValues && !item.disabled\" class=\"value text-body small\">\n            {{ item.value }}{{ item.unit ?? '' }}\n          </div>\n        </div>\n      </div>\n    </div>\n    <div\n      class=\"status\"\n      tabindex=\"0\"\n      [attr.aria-disabled]=\"item.disabled\"\n      (click)=\"selected.emit(item)\"\n      (keydown.enter)=\"selected.emit(item)\"\n    >\n      <si-comfort-score-status\n        *ngIf=\"!labelOnly\"\n        size=\"large\"\n        [item]=\"item\"\n      ></si-comfort-score-status>\n      <div *ngIf=\"labelOnly\" class=\"small text-center\" [class.text-muted]=\"item.disabled\">{{\n        item.title | translate\n      }}</div>\n    </div>\n  </ng-container>\n</div>\n", styles: [":host{display:block}.wrapper{block-size:100%;display:grid;grid-row-gap:16px;grid-template-rows:1fr;margin-block:2rem 8px}.wrapper.labels{margin-inline-start:40px}.bar-outer{grid-row:1;min-block-size:100px}.bar,.status{cursor:pointer}.status{grid-row:2}.bar{inset-block-end:0;transition:block-size calc(.5s * var(--element-animations-enabled, 1))}.bar.detail{margin-inline-start:40px}.bar:not(.detail){inset-inline-start:calc(50% - 24px)}.bar-inner{inline-size:48px;background:var(--element-base-0);border-block-start:2px solid currentColor;margin-block-end:1px}.bar-inner.selected{background:currentColor}.bar-inner.disabled{border-block-start-color:var(--element-base-0);background:var(--element-base-0)}.value{margin-block-start:-1.25rem;line-height:1}.grid{grid-row:1;grid-column-start:1;border-block-end:1px solid var(--element-ui-1)}.axis-label{inset-inline-start:-40px;inline-size:40px;line-height:1;padding-inline-end:12px}.label-0{inset-block-end:-.5em}.label-100{inset-block-start:-.5em}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SiComfortScoreStatusComponent, selector: "si-comfort-score-status", inputs: ["item", "size"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-comfort-score', template: "<div class=\"wrapper\" [class.labels]=\"showValues\">\n  <div\n    class=\"grid d-flex flex-column position-relative text-secondary small\"\n    [style.grid-column-end]=\"items.length + 1\"\n  >\n    <div *ngFor=\"let p of gridPartArray; trackBy: trackByIndex\" class=\"border-top flex-fill\"></div>\n    <ng-container *ngIf=\"showValues\">\n      <div class=\"axis-label position-absolute text-end label-100\">100</div>\n      <div class=\"axis-label position-absolute text-end label-0\">0</div>\n    </ng-container>\n  </div>\n  <ng-container *ngFor=\"let item of items; trackBy: trackByItem; index as i\">\n    <div class=\"bar-outer position-relative\" [style.grid-column]=\"i + 1\">\n      <div\n        class=\"bar position-absolute d-flex flex-column text-center\"\n        [class.detail]=\"!labelOnly\"\n        [style.height.%]=\"item.value\"\n        (click)=\"selected.emit(item)\"\n      >\n        <div\n          class=\"bar-inner flex-fill\"\n          [class.selected]=\"item.selected\"\n          [class.disabled]=\"item.disabled\"\n          [ngClass]=\"'status-' + item.status\"\n        >\n          <div *ngIf=\"showValues && !item.disabled\" class=\"value text-body small\">\n            {{ item.value }}{{ item.unit ?? '' }}\n          </div>\n        </div>\n      </div>\n    </div>\n    <div\n      class=\"status\"\n      tabindex=\"0\"\n      [attr.aria-disabled]=\"item.disabled\"\n      (click)=\"selected.emit(item)\"\n      (keydown.enter)=\"selected.emit(item)\"\n    >\n      <si-comfort-score-status\n        *ngIf=\"!labelOnly\"\n        size=\"large\"\n        [item]=\"item\"\n      ></si-comfort-score-status>\n      <div *ngIf=\"labelOnly\" class=\"small text-center\" [class.text-muted]=\"item.disabled\">{{\n        item.title | translate\n      }}</div>\n    </div>\n  </ng-container>\n</div>\n", styles: [":host{display:block}.wrapper{block-size:100%;display:grid;grid-row-gap:16px;grid-template-rows:1fr;margin-block:2rem 8px}.wrapper.labels{margin-inline-start:40px}.bar-outer{grid-row:1;min-block-size:100px}.bar,.status{cursor:pointer}.status{grid-row:2}.bar{inset-block-end:0;transition:block-size calc(.5s * var(--element-animations-enabled, 1))}.bar.detail{margin-inline-start:40px}.bar:not(.detail){inset-inline-start:calc(50% - 24px)}.bar-inner{inline-size:48px;background:var(--element-base-0);border-block-start:2px solid currentColor;margin-block-end:1px}.bar-inner.selected{background:currentColor}.bar-inner.disabled{border-block-start-color:var(--element-base-0);background:var(--element-base-0)}.value{margin-block-start:-1.25rem;line-height:1}.grid{grid-row:1;grid-column-start:1;border-block-end:1px solid var(--element-ui-1)}.axis-label{inset-inline-start:-40px;inline-size:40px;line-height:1;padding-inline-end:12px}.label-0{inset-block-end:-.5em}.label-100{inset-block-start:-.5em}\n"] }]
        }], propDecorators: { items: [{
                type: Input
            }], showValues: [{
                type: Input
            }], labelOnly: [{
                type: Input
            }], gridParts: [{
                type: Input
            }], selected: [{
                type: Output
            }] } });

class SiComfortScoreModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreModule, declarations: [SiComfortScoreComponent, SiComfortScoreStatusComponent], imports: [CommonModule, SiTranslateModule], exports: [SiComfortScoreComponent, SiComfortScoreStatusComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiComfortScoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiComfortScoreComponent, SiComfortScoreStatusComponent],
                    exports: [SiComfortScoreComponent, SiComfortScoreStatusComponent],
                    imports: [CommonModule, SiTranslateModule]
                }]
        }] });

const CONNECTION_STRENGTH_MAP = { 'none': 0, 'low': 1, 'medium': 2, 'strong': 3 };
class SiConnectionStrengthComponent {
    /**
     * Shows the signal representation in an alternative *WLAN* format
     */
    wlan = false;
    /**
     * Main value representing the current connection strength.
     */
    value = 'none';
    get numberValue() {
        return CONNECTION_STRENGTH_MAP[this.value] ?? 0;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiConnectionStrengthComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiConnectionStrengthComponent, selector: "si-connection-strength", inputs: { wlan: "wlan", value: "value" }, ngImport: i0, template: "<svg\n  *ngIf=\"wlan\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  viewBox=\"0 0 512 512\"\n  [class.none]=\"numberValue < 1\"\n>\n  <path\n    d=\"M318.63,304a108.1,108.1,0,0,0-125.1,0,12,12,0,0,0,13.9,19.56,84.09,84.09,0,0,1,97.3,0A12,12,0,1,0,318.63,304Z\"\n  />\n  <path\n    d=\"M377,247.56a188,188,0,0,0-240.64,0A12,12,0,1,0,151.68,266a164,164,0,0,1,209.92,0A12,12,0,0,0,377,247.56Z\"\n    [class.inactive]=\"numberValue < 2\"\n  />\n  <path\n    d=\"M433.21,191a268,268,0,0,0-354.42,0,12,12,0,1,0,15.86,18,244,244,0,0,1,322.7,0,12,12,0,0,0,15.86-18Z\"\n    [class.inactive]=\"numberValue < 3\"\n  />\n  <circle cx=\"256\" cy=\"372.22\" r=\"16\" />\n  <g *ngIf=\"numberValue < 1\">\n    <path d=\"M412,352a12,12,0,0,0,12-12V263.78a12,12,0,0,0-24,0V340A12,12,0,0,0,412,352Z\" />\n    <path d=\"M412.18,400H412a12,12,0,0,0,0,24h.18a12,12,0,1,0,0-24Z\" />\n  </g>\n</svg>\n\n<svg\n  *ngIf=\"!wlan\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  viewBox=\"0 0 512 512\"\n  [class.none]=\"numberValue < 1\"\n>\n  <path\n    d=\"M128,228a12,12,0,0,0,0,24A132.14,132.14,0,0,1,260,384a12,12,0,0,0,24,0C284,298,214,228,128,228Z\"\n    [class.inactive]=\"numberValue < 2\"\n  />\n  <path\n    d=\"M128,116a12,12,0,0,0,0,24A244,244,0,0,1,372,384a12,12,0,0,0,24,0A268,268,0,0,0,128,116Z\"\n    [class.inactive]=\"numberValue < 3\"\n  />\n  <circle cx=\"144\" cy=\"368\" r=\"28\" />\n  <g *ngIf=\"numberValue < 1\">\n    <path d=\"M412,188.11a12,12,0,0,0,12-12V99.89a12,12,0,1,0-24,0v76.22A12,12,0,0,0,412,188.11Z\" />\n    <path d=\"M412.18,236.11H412a12,12,0,0,0,0,24h.18a12,12,0,0,0,0-24Z\" />\n  </g>\n</svg>\n", styles: ["svg{inline-size:1em;block-size:1em;fill:var(--element-ui-1)}svg.none,svg.none .inactive{fill:var(--element-status-danger)}svg .inactive{fill:var(--element-ui-3)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiConnectionStrengthComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-connection-strength', changeDetection: ChangeDetectionStrategy.OnPush, template: "<svg\n  *ngIf=\"wlan\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  viewBox=\"0 0 512 512\"\n  [class.none]=\"numberValue < 1\"\n>\n  <path\n    d=\"M318.63,304a108.1,108.1,0,0,0-125.1,0,12,12,0,0,0,13.9,19.56,84.09,84.09,0,0,1,97.3,0A12,12,0,1,0,318.63,304Z\"\n  />\n  <path\n    d=\"M377,247.56a188,188,0,0,0-240.64,0A12,12,0,1,0,151.68,266a164,164,0,0,1,209.92,0A12,12,0,0,0,377,247.56Z\"\n    [class.inactive]=\"numberValue < 2\"\n  />\n  <path\n    d=\"M433.21,191a268,268,0,0,0-354.42,0,12,12,0,1,0,15.86,18,244,244,0,0,1,322.7,0,12,12,0,0,0,15.86-18Z\"\n    [class.inactive]=\"numberValue < 3\"\n  />\n  <circle cx=\"256\" cy=\"372.22\" r=\"16\" />\n  <g *ngIf=\"numberValue < 1\">\n    <path d=\"M412,352a12,12,0,0,0,12-12V263.78a12,12,0,0,0-24,0V340A12,12,0,0,0,412,352Z\" />\n    <path d=\"M412.18,400H412a12,12,0,0,0,0,24h.18a12,12,0,1,0,0-24Z\" />\n  </g>\n</svg>\n\n<svg\n  *ngIf=\"!wlan\"\n  xmlns=\"http://www.w3.org/2000/svg\"\n  viewBox=\"0 0 512 512\"\n  [class.none]=\"numberValue < 1\"\n>\n  <path\n    d=\"M128,228a12,12,0,0,0,0,24A132.14,132.14,0,0,1,260,384a12,12,0,0,0,24,0C284,298,214,228,128,228Z\"\n    [class.inactive]=\"numberValue < 2\"\n  />\n  <path\n    d=\"M128,116a12,12,0,0,0,0,24A244,244,0,0,1,372,384a12,12,0,0,0,24,0A268,268,0,0,0,128,116Z\"\n    [class.inactive]=\"numberValue < 3\"\n  />\n  <circle cx=\"144\" cy=\"368\" r=\"28\" />\n  <g *ngIf=\"numberValue < 1\">\n    <path d=\"M412,188.11a12,12,0,0,0,12-12V99.89a12,12,0,1,0-24,0v76.22A12,12,0,0,0,412,188.11Z\" />\n    <path d=\"M412.18,236.11H412a12,12,0,0,0,0,24h.18a12,12,0,0,0,0-24Z\" />\n  </g>\n</svg>\n", styles: ["svg{inline-size:1em;block-size:1em;fill:var(--element-ui-1)}svg.none,svg.none .inactive{fill:var(--element-status-danger)}svg .inactive{fill:var(--element-ui-3)}\n"] }]
        }], propDecorators: { wlan: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class SiConnectionStrengthModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiConnectionStrengthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiConnectionStrengthModule, declarations: [SiConnectionStrengthComponent], imports: [CommonModule], exports: [SiConnectionStrengthComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiConnectionStrengthModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiConnectionStrengthModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SiConnectionStrengthComponent],
                    exports: [SiConnectionStrengthComponent]
                }]
        }] });

const WEEK_ISO = [
    { id: 'monday', index: 1, offset: 0, isWeekend: false },
    { id: 'tuesday', index: 2, offset: 1, isWeekend: false },
    { id: 'wednesday', index: 3, offset: 2, isWeekend: false },
    { id: 'thursday', index: 4, offset: 3, isWeekend: false },
    { id: 'friday', index: 5, offset: 4, isWeekend: false },
    { id: 'saturday', index: 6, offset: 5, isWeekend: true },
    { id: 'sunday', index: 7, offset: 6, isWeekend: true }
];
const WEEK_START_OFFSET = {
    'monday': 0,
    'saturday': 5,
    'sunday': 6
};
const UNITS = {
    millisecondsPerDay: 86400000,
    daysPerWeek: 7,
    thursday: 4
};
const dayOfWeekMap = {};
const getDaysOfWeek = (weekStart) => {
    weekStart = weekStart ?? 'monday';
    let weekdays = dayOfWeekMap[weekStart];
    if (!weekdays) {
        dayOfWeekMap[weekStart] = weekdays = [];
        const offset = WEEK_START_OFFSET[weekStart];
        for (let i = 0; i < 7; i++) {
            weekdays.push({ ...WEEK_ISO[(i + offset) % 7], offset: i });
        }
    }
    return weekdays;
};
/**
 * Get local specific weekdays as string using DateTimeFormat.
 * @param locale current local
 * @param weekStart start of the week
 * @param format display format
 * @returns array of week days.
 */
const getDayStrings = (locale, weekStart = 'monday', format = 'short') => {
    const dateFormatter = new Intl.DateTimeFormat(locale, { weekday: format, timeZone: 'utc' });
    const days = [];
    // Get local specific day strings from sunday (0) .. saturady (6)
    for (let index = 1; index <= 7; index++) {
        const day = new Date(Date.UTC(2023, 0, index));
        days.push(dateFormatter.format(day));
    }
    const map = { 'sunday': 0, 'monday': 1, 'saturday': 6 };
    const index = map[weekStart];
    return days.slice(index).concat(days.slice(0, index));
};
/**
 * Gets the first day in the specified month.
 * Expects the month as a value between 1 and 12.
 * The year is required to handle leap years.
 *
 * @returns The first day of the month as a Date.
 */
const getFirstDayInMonth = (year, month) => new Date(year, month - 1, 1);
/**
 * Gets the week number of the specified date.
 * Week number according to the ISO-8601 standard, weeks starting on Monday.
 * The first week of a year is the week that contains the first Thursday of the year (='First 4-day week').
 * The highest week number in a year is either 52 or 53.
 *
 * @param date The JavaScript date object.
 * @param weekStart Name of the first day of the week
 * @returns The number of the Week
 */
const getWeekOfYear = (date, weekStart) => {
    // Algorithm rewritten from C# example given at http://en.wikipedia.org/wiki/Talk:ISO_week_date
    const dayOfWeek = getWeekDayOffset(date, weekStart) + 1;
    const nearestThu = new Date(date);
    nearestThu.setDate(date.getDate() + (UNITS.thursday - dayOfWeek)); // get nearest Thursday (-3..+3 days)
    const year = nearestThu.getFullYear();
    const janfirst = getFirstDayInMonth(year, 1);
    const days = Math.floor((nearestThu - janfirst) / UNITS.millisecondsPerDay);
    const week = 1 + Math.floor(days / UNITS.daysPerWeek); // Count of Thursdays
    return week;
};
const getWeekDayOffset = (date, weekStart) => {
    const offset = WEEK_START_OFFSET[weekStart ?? 'monday'];
    return (date.getDay() + 6 - offset) % 7;
};
/** returns the date string in format YYYY-MM-DD for given date */
const getStringforDate = (date) => {
    let month = '' + (date.getMonth() + 1);
    let day = '' + date.getDate();
    const year = date.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    return `${year}-${month}-${day}`;
};
/**
 * Create a new date without time.
 * @param value date object
 * @param hours numeric value of the hours.
 * @param minutes numeric value of the minutes.
 * @param seconds numeric value of the seconds.
 * @param milliseconds numeric value of the milliseconds.
 * @returns
 */
const createDate = (value, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) => {
    const newDate = new Date(value.getFullYear(), value.getMonth(), value.getDate(), hours, minutes, seconds, milliseconds);
    // Seems redundant, but makes sure that increasing
    // the hours does no change the date when switching
    // from 11pm up.
    newDate.setFullYear(value.getFullYear());
    newDate.setMonth(value.getMonth());
    newDate.setDate(value.getDate());
    return newDate;
};
/** Creates a date but allows the month and date to overflow. */
const createDateInternal = (year, month, date) => {
    const d = new Date();
    d.setFullYear(year, month, date);
    d.setHours(0, 0, 0, 0);
    return d;
};
const NAMED_FORMATS = {};
/**
 * @param input String containing a date or dateTime value (Ex. "05/15/2020"
 * @param format Format of the input value (Ex. "M/d/YYYY")
 * @param locale Locale of the input value
 * @returns A JS Date in accordance of the three parameters
 */
const parseDate = (input, format, locale) => {
    if (!input) {
        return undefined;
    }
    const splitFormat = format.split(/[^MydhHmsSa]+/);
    const splitDate = input.toUpperCase().match(/\d+|\w+/g);
    if (!splitDate) {
        return undefined;
    }
    // in case of some locales where meridian is with special chars
    const dateAndMeridian = input.split(/ +/);
    if (splitDate.length > 0 && dateAndMeridian.length > 0) {
        const parsedMeridian = dateAndMeridian[dateAndMeridian.length - 1].toUpperCase();
        if (splitDate[splitDate.length - 1] !== parsedMeridian &&
            getMeridian(parsedMeridian, locale)) {
            splitDate?.push(parsedMeridian);
        }
    }
    let year = 0;
    let month = 0;
    let day = 0;
    let hour = 0;
    let minute = 0;
    let second = 0;
    let milliseconds = 0;
    // check if date is invalid and return if it is invalid
    for (let i = 0; i < splitDate.length; i++) {
        if (i === splitDate.length - 1) {
            const parsedMeridian = splitDate[splitDate.length - 1];
            // skip if its meridian
            if (getMeridian(parsedMeridian, locale)) {
                continue;
            }
        }
        const parsedDateVal = parseInt(splitDate[i], 10);
        if (isNaN(parsedDateVal)) {
            return undefined;
        }
    }
    for (let i = 0; i < splitFormat.length; i++) {
        const f = splitFormat[i];
        let parsedNumber = parseInt(splitDate[i], 10);
        if (f !== 'a' && isNaN(parsedNumber)) {
            // auto fill seconds and milliseconds if not passed by user
            if (f === 'ss' || f === 'SSS') {
                parsedNumber = 0;
            }
            else {
                return undefined;
            }
        }
        if (f === 'M' || f === 'MM') {
            month = parsedNumber;
        }
        else if (f === 'd' || f === 'dd') {
            day = parsedNumber;
        }
        else if (f === 'y' || f === 'yy' || f === 'yyyy') {
            // JS adds 1900 for numbers between 0 and 99. Adjust to be more user-friendly
            year =
                parsedNumber < 50
                    ? parsedNumber + 2000
                    : parsedNumber < 100
                        ? parsedNumber + 1900
                        : parsedNumber;
        }
        else if (f === 'h' || f === 'HH') {
            hour = parsedNumber;
        }
        else if (f === 'mm') {
            minute = parsedNumber;
        }
        else if (f === 'ss') {
            second = parsedNumber;
        }
        else if (f === 'SSS') {
            milliseconds = parsedNumber;
        }
        else if (f === 'a') {
            if (!isNaN(parseInt(splitDate[splitDate.length - 1], 10))) {
                continue;
            }
            const parsedMeridian = splitDate[splitDate.length - 1];
            const meridian = getMeridian(parsedMeridian, locale);
            if (hour === 12 && meridian === 'AM') {
                hour = 0;
            }
            else if (meridian === 'PM') {
                hour = (hour % 12) + 12;
            }
            else if (!meridian) {
                return;
            }
        }
    }
    if (month > 12 || day > 31 || day > new Date(year, month, 0).getDate()) {
        return undefined;
    }
    return new Date(year, month - 1, day, hour, minute, second, milliseconds);
};
const getMeridian = (parsedMeridian, locale) => {
    const meridian = getLocaleDayPeriods(locale, FormStyle.Format, TranslationWidth.Short);
    const usingAM = parsedMeridian === meridian[0].toUpperCase();
    if (usingAM) {
        return 'AM';
    }
    else {
        const usingPM = parsedMeridian === meridian[1].toUpperCase();
        return usingPM ? 'PM' : undefined;
    }
};
// Adapted from: https://github.com/angular/angular/blob/91954cf20e17a386d71cc8ea25d1d17b9ae1e31c/packages/common/src/i18n/format_date.ts
// unfortunately it is not exported there
const getNamedFormat = (locale, format) => {
    const localeId = getLocaleId(locale);
    NAMED_FORMATS[localeId] = NAMED_FORMATS[localeId] || {};
    if (NAMED_FORMATS[localeId][format]) {
        return NAMED_FORMATS[localeId][format];
    }
    let formatValue = '';
    switch (format) {
        case 'shortDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Short);
            break;
        case 'shortTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Short);
            break;
        case 'mediumTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Medium);
            break;
        case 'longTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Long);
            break;
        case 'fullTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Full);
            break;
        case 'short':
        case 'medium':
            const shortTime = getNamedFormat(locale, format === 'short' ? 'shortTime' : 'mediumTime');
            const shortDate = getNamedFormat(locale, 'shortDate');
            formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Short), [
                shortTime,
                shortDate
            ]);
            break;
    }
    if (formatValue) {
        NAMED_FORMATS[localeId][format] = formatValue;
    }
    return formatValue;
};
const formatDateTime = (str, optVals) => {
    if (optVals) {
        str = str.replace(/\{([^}]+)}/g, (match, key) => optVals != null && key in optVals ? optVals[key] : match);
    }
    return str;
};
const getDateWithoutTime = (date) => createDate(date, 0, 0, 0, 0);
/**
 * Get today
 * @returns date of today
 */
const today = () => new Date();
/**
 * Calculate a new date based on the offset while considering the min and max date.
 * @param current input date.
 * @param offsetDays numeric offset of days.
 * @returns new date if the range is valid or original date
 */
const addDaysInRange = (current, daysOffset, minDate, maxDate) => {
    const newDate = addDays(current, daysOffset);
    // Make sure the new date is within the specified limits
    // MinDate < new data < MaxDate
    if (isSameOrBetween(newDate, minDate, maxDate)) {
        return newDate;
    }
    return getDateSameOrBetween(newDate, minDate, maxDate);
};
/**
 * Get date delta based on the offset.
 * @param date source date object.
 * @param days numeric offset of days.
 * @returns new date.
 */
const addDays = (date, days) => {
    const d = createDate(date);
    d.setDate(d.getDate() + days);
    return d;
};
/**
 * Update date/day of give date without changing the month.
 * In case the day exceed the number of days in the current month the last day in month will be assigned.
 * @param date the date object to update the day.
 * @param day the day which shall be set.
 * @returns the updated date object.
 */
const changeDay = (date, day) => {
    const lastDay = daysInMonth(date.getMonth(), date.getFullYear());
    date.setDate(lastDay <= day ? lastDay : day);
    return date;
};
/**
 * Get date delta specifically for months based on the offset.
 * @param current starting date.
 * @param monthsOffset numeric offset of months.
 * @param minDate optional minimum allowed date.
 * @param maxDate optional maximum allowed date.
 * @returns a new date object with the updated month.
 */
const addMonthsInRange = (current, monthsOffset, minDate, maxDate) => {
    let newDate = createDateInternal(current.getFullYear(), current.getMonth() + monthsOffset, 1);
    newDate = changeDay(newDate, current.getDate());
    if (isSameOrBetween(newDate, minDate, maxDate)) {
        return newDate;
    }
    return getDateSameOrBetween(newDate, minDate, maxDate);
};
/**
 * Get date delta specifically for years based on the offset.
 * @param current starting date.
 * @param yearsOffset numeric offset of years.
 * @param minDate optional minimum allowed date.
 * @param maxDate optional maximum allowed date.
 * @returns a new date object with the updated year.
 */
const addYearsInRange = (current, yearsOffset, minDate, maxDate) => {
    const newDate = createDateInternal(current.getFullYear() + yearsOffset, current.getMonth(), current.getDate());
    if (isSameOrBetween(newDate, minDate, maxDate)) {
        return newDate;
    }
    return getDateSameOrBetween(newDate, minDate, maxDate);
};
/**
 * Get number of days for the given month and year.
 * @param month month as number (0..11).
 * @param year year as number.
 * @returns the number of days for the given month.
 */
const daysInMonth = (month, year) => 
// By using 0 as the day it will give us the last day of the prior
// month. So passing in 1 as the month number will return the last day
new Date(year, month + 1, 0).getDate();
/**
 * Get the first date of the week based on the input date.
 * @param current a date object from where the last date of a week is derived.
 * @param weekStartDay optional when a week shall start.
 * @returns a new date object which is the start of the current week.
 */
const getWeekStartDate = (current, weekStartDay = 'monday') => {
    const weekStartDate = createDate(current);
    const diff = current.getDate() - getWeekDayOffset(current, weekStartDay);
    weekStartDate.setDate(diff);
    return weekStartDate;
};
/**
 * Get the last date of the week based on the input date.
 * @param current a date object from where the last date of a week is derived.
 * @param weekStartDay optional when a week shall start.
 * @returns the last date within the week.
 */
const getWeekEndDate = (current, weekStartDay = 'monday') => {
    const weekStartDate = createDate(current);
    weekStartDate.setDate(current.getDate() + 6 - getWeekDayOffset(current, weekStartDay));
    return weekStartDate;
};
/**
 * Get the beginning of the month.
 * @param current a date object from where the first date in a month is derived.
 * @returns a new date object which starts a the first.
 */
const getFirstDateInMonth = (current) => new Date(current.getFullYear(), current.getMonth(), 1);
/**
 * Get the last date of the month.
 * @param current a date object from where we derive the last date in a month.
 * @returns a new date object which is the last day in the current month.
 */
const getLastDateInMonth = (current) => new Date(current.getFullYear(), current.getMonth() + 1, 0);
/**
 * Get the beginning of the year.
 * @param current a date object from where the first date in a year is derived.
 * @returns a new date object which starts a the first.
 */
const getFirstDateInYear = (current) => new Date(current.getFullYear(), 0, 1);
/**
 * Are the two dates identical without considering time.
 */
const isSameDate = (current, compareTo) => {
    if (!compareTo) {
        return false;
    }
    return (current.getFullYear() === compareTo.getFullYear() &&
        current.getMonth() === compareTo.getMonth() &&
        current.getDate() === compareTo.getDate());
};
/**
 * Are the two months identical without considering time.
 */
const isSameMonth = (current, compareTo) => {
    if (!compareTo) {
        return false;
    }
    return isSameYear(current, compareTo) && current.getMonth() === compareTo.getMonth();
};
/**
 * Are the two years identical.
 */
const isSameYear = (current, compareTo) => {
    if (!compareTo) {
        return false;
    }
    return current.getFullYear() === compareTo.getFullYear();
};
/**
 * Compares two dates.
 * @param first The first date to compare.
 * @param second The second date to compare.
 * @returns 0 if the dates are equal, a number less than 0 if the first date is earlier,
 * a number greater than 0 if the first date is later.
 */
const compareDate = (first, second) => compareMonth(first, second) || first.getDate() - second.getDate();
/**
 * Compares two months.
 * @param first The first month to compare.
 * @param second The second month to compare.
 * @returns 0 if the months are equal, a number less than 0 if the first month is earlier,
 * a number greater than 0 if the first month is later.
 */
const compareMonth = (first, second) => compareYear(first, second) || first.getMonth() - second.getMonth();
/**
 * Compares two years.
 * @param first The first year to compare.
 * @param second The second year to compare.
 * @returns 0 if the years are equal, a number less than 0 if the first year is earlier,
 * a number greater than 0 if the first year is later.
 */
const compareYear = (first, second) => first.getFullYear() - second.getFullYear();
/**
 * Compare the current date is the same date or between start and end date.
 * @param d the date object.
 * @param minDate optional min date, if no value is provided we assume true for the min value.
 * @param maxDate optional max date, if no value is provided we assume true for the max value.
 * @returns true if the date is in the provided range.
 */
const isSameOrBetween = (current, from, to) => {
    // from <= d
    const isInMinRange = from ? compareDate(from, current) <= 0 : true;
    // d <= to
    const isInMaxRange = to ? compareDate(current, to) <= 0 : true;
    return isInMinRange && isInMaxRange;
};
/**
 * Compare the current month is the same month or between start and end month.
 * @param d the month object.
 * @param minDate optional min month, if no value is provided we assume true for the min value.
 * @param maxDate optional max month, if no value is provided we assume true for the max value.
 * @returns true if the date is in the provided range.
 */
const isSameOrBetweenMonth = (current, from, to) => {
    // from <= d
    const isInMinRange = from ? compareMonth(from, current) <= 0 : true;
    // d <= to
    const isInMaxRange = to ? compareMonth(current, to) <= 0 : true;
    return isInMinRange && isInMaxRange;
};
/**
 * Compare the current year is the same year or between start and end year.
 * @param d the year object.
 * @param minDate optional min year, if no value is provided we assume true for the min value.
 * @param maxDate optional max year, if no value is provided we assume true for the max value.
 * @returns true if the date is in the provided range.
 */
const isSameOrBetweenYears = (current, from, to) => {
    // from <= d
    const isInMinRange = from ? compareYear(from, current) <= 0 : true;
    // d <= to
    const isInMaxRange = to ? compareYear(current, to) <= 0 : true;
    return isInMinRange && isInMaxRange;
};
/**
 * Compare the current date is between start and end date.
 * from < current < to
 */
const isBetween = (current, from, to) => {
    const isInMinRange = from ? compareDate(current, from) > 0 : true;
    const isInMaxRange = to ? compareDate(current, to) < 0 : true;
    return isInMinRange && isInMaxRange;
};
/**
 * Compare the current month is between start and end month.
 * from < current < to
 */
const isBetweenMonth = (current, from, to) => {
    const isInMinRange = from ? compareMonth(current, from) > 0 : true;
    const isInMaxRange = to ? compareMonth(current, to) < 0 : true;
    return isInMinRange && isInMaxRange;
};
/**
 * Compare the current year is between start and end year.
 * from < current < to
 */
const isBetweenYears = (current, from, to) => {
    const isInMinRange = from ? compareYear(current, from) > 0 : true;
    const isInMaxRange = to ? compareYear(current, to) < 0 : true;
    return isInMinRange && isInMaxRange;
};
/**
 * Is first date after the second date (without considering the time).
 * current > compareTo
 */
const isAfter = (current, compareTo) => compareDate(current, compareTo) > 0;
/**
 * Is first month after the second month (without considering the time).
 * current > compareTo
 */
const isAfterMonth = (current, compareTo) => compareMonth(current, compareTo) > 0;
/**
 * Is first year after the second year.
 * current > compareTo
 */
const isAfterYear = (current, compareTo) => compareYear(current, compareTo) > 0;
/**
 * Is first date equal or before the second date (without considering the time).
 * current >= compareTo
 */
const isSameOrBefore = (current, compareTo) => compareDate(current, compareTo) <= 0;
/**
 * Is first month equal or before the second month.
 * current >= compareTo
 */
const isSameOrBeforeMonth = (current, compareTo) => compareMonth(current, compareTo) <= 0;
/**
 * Is first year equal or before the second year.
 * current >= compareTo
 */
const isSameOrBeforeYear = (current, compareTo) => compareMonth(current, compareTo) <= 0;
/**
 * Are the two dates in different months.
 */
const isAnotherMonth = (current, compareTo) => current.getMonth() !== compareTo.getMonth();
/**
 * Are the two dates in different years.
 */
const isAnotherYear = (current, compareTo) => current.getFullYear() !== compareTo.getFullYear();
/**
 * Are the two dates either in different months or years.
 */
const isAnotherMonthOrYear = (current, compareTo) => isAnotherMonth(current, compareTo) || isAnotherYear(current, compareTo);
/**
 * Get a date which is in within the range and the close to current.
 */
const getDateSameOrBetween = (current, minDate, maxDate) => {
    if (isSameOrBetween(current, minDate, maxDate)) {
        return current;
    }
    const minDistance = minDate
        ? Math.ceil(Math.abs(current.getTime() - minDate.getTime()))
        : Number.MAX_VALUE;
    const maxDistance = maxDate
        ? Math.ceil(Math.abs(current.getTime() - maxDate.getTime()))
        : Number.MAX_VALUE;
    return minDistance < maxDistance ? createDate(minDate) : createDate(maxDate);
};
/**
 * Get date or absolute min date.
 * @param date input date.
 * @returns date or date of 1.1.1900
 */
const getMinDate = (date) => date && !isNaN(date.getTime()) ? date : new Date(Date.UTC(1900, 0, 1));
/**
 * Get date or absolute max date.
 * @param date input date.
 * @returns date or date of 31.12.2154
 */
const getMaxDate = (date) => date && !isNaN(date.getTime()) ? date : new Date(Date.UTC(2154, 11, 31));
/**
 * Is valid date object.
 */
const isValid = (date) => !!date && !isNaN(date.getTime());

/**
 * Returns date / datetime format to be used for rendering a date object as text
 * to an Html input element, which has the `SiDatepickerDirective`.
 *
 * @see https://angular.io/api/common/DatePipe#pre-defined-format-options
 * @param locale The locale for which the format is returned.
 * @param config The config object of the datepicker.
 * @param timeWhenDisabled If `true`, a format with time (medium or short) is returned, even if the `disabledTime` config is `true`.
 * @returns Either
 *   - a custom format provided by the config,
 *   - the localized `medium` format when time and seconds included
 *   - the localized `short` format when time and no seconds included
 */
const getDatepickerFormat = (locale, config, timeWhenDisabled = false) => {
    // try format from consumer
    let dateFormat = config?.showTime && !config.disabledTime ? config.dateTimeFormat : config?.dateFormat;
    if (!dateFormat) {
        // no format from consumer - use default depending on configuration
        let named;
        if (config?.showTime && (!config.disabledTime || timeWhenDisabled)) {
            named = config.showSeconds ? 'medium' : 'short';
        }
        else {
            named = 'shortDate';
        }
        dateFormat = getNamedFormat(locale, named);
    }
    // patch 2-digit year to 4-digit year
    if (!dateFormat.includes('yyyy')) {
        dateFormat = dateFormat.replace('yy', 'yyyy');
    }
    return dateFormat;
};

/**
 * Base directive for date input fields.
 */
class SiDateInputDirective {
    /**
     * Configuration object for the datepicker.
     */
    siDatepickerConfig = {};
    dateRange;
    /**
     * Indicate whether the input represent the start or the end of a range.
     */
    rangeType;
    /**
     * The debounce time for the date input changes.
     */
    dateInputDebounceTime = 200;
    /**
     * Emits an event to notify about disabling the time from the datepicker.
     * When time is disable, we construct a pure date object in UTC 00:00:00 time.
     */
    siDatepickerDisabledTime = new EventEmitter();
    /**
     * Emits an event on state changes e.g. readonly, disable, ... .
     */
    stateChange = new EventEmitter();
    _disabled = false;
    get disabled() {
        return this._disabled;
    }
    /**
     * Whether the date range input is disabled.
     * @defaultref {@link _disabled}
     */
    set disabled(value) {
        this.setDisabledState(value !== false);
    }
    /**
     * Whether the date range input is readonly.
     * @defaultref {@link _readonly}
     */
    set readonly(value) {
        this._readonly = coerceBooleanProperty(value);
        this.stateChange.next();
    }
    get readonly() {
        return this._readonly;
    }
    get readOnlyState() {
        return this._readonly ? true : null;
    }
    _readonly = false;
    /** @internal */
    validatorOnChange = () => { };
    /**
     * Date form input validator function, validating text format, min and max value.
     */
    validator = Validators.compose([
        c => this.formatValidator(c),
        () => this.minValidator(),
        () => this.maxValidator()
    ]);
    date;
    /**
     * Emits a new `date` value on input field value changes.
     */
    dateChange = new EventEmitter();
    onTouched = () => { };
    onModelChange = () => { };
    destroyer$ = new Subject();
    cdRef = inject(ChangeDetectorRef);
    locale = inject(LOCALE_ID);
    elementRef = inject(ElementRef);
    renderer = inject(Renderer2);
    inputChange$ = new Subject();
    format = '';
    ngOnChanges(changes) {
        if (changes.siDatepickerConfig && !changes.siDatepickerConfig.currentValue) {
            this.siDatepickerConfig = {};
        }
        if (changes.siDatepickerConfig) {
            // reflect possible change is date/time format
            this.format = '';
            const formatChanged = changes.siDatepickerConfig.previousValue?.dateFormat !==
                this.siDatepickerConfig?.dateFormat ||
                changes.siDatepickerConfig.previousValue?.dateTimeFormat !==
                    this.siDatepickerConfig?.dateTimeFormat ||
                this.siDatepickerConfig?.dateFormat;
            if (this.date && formatChanged) {
                this.updateNativeValue();
            }
        }
    }
    ngOnInit() {
        this.inputChange$
            .pipe(debounceTime(this.dateInputDebounceTime), takeUntil(this.destroyer$))
            .subscribe((value) => this.processInput(value));
    }
    ngOnDestroy() {
        this.destroyer$.next();
        this.destroyer$.complete();
    }
    validate(c) {
        return this.validator(c);
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    registerOnValidatorChange(fn) {
        this.validatorOnChange = fn;
    }
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
        this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
        this.stateChange.next();
        this.cdRef.markForCheck();
    }
    writeValue(value) {
        // remove date when user input is empty
        let emptyString = false;
        // Flag to define invalid string
        let invalidDate = false;
        if (typeof value === 'string') {
            emptyString = value.trim().length === 0;
            value = parseDate(value, this.getFormat(), this.locale);
            invalidDate = !value;
        }
        this.date = value;
        this.dateChange.next(this.date);
        // We should not change the content of the input field when the user typed
        // a wrong input. Otherwise the typed content changes and the user cannot
        // correct the content.
        if (!invalidDate || emptyString) {
            this.updateNativeValue();
        }
        this.cdRef.markForCheck();
    }
    updateNativeValue() {
        let dtStr = '';
        if (this.date) {
            dtStr = formatDate(this.date, this.getFormat(), this.locale);
        }
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', dtStr);
    }
    onChange(event) {
        this.writeValue(event.target.value);
        this.onModelChange(this.date);
        this.onTouched();
    }
    /**
     * Handles `input` events on the input element.
     * @param value current input value.
     */
    onInput(value) {
        this.inputChange$.next(value);
    }
    processInput(value) {
        const parsedDate = parseDate(value, this.getFormat(), this.locale);
        // Ensure the string is a valid date and ignore years which aren't between 1900..2154.
        // The use user could remove the last char from 12.03.2022 which leads to
        // 12.03.202 which isn't we should ignore.
        const valid = value.trim() === '' ||
            (isValid(parsedDate) && isBetweenYears(parsedDate, getMinDate(), getMaxDate()));
        if (!valid) {
            return;
        }
        // Is same date
        const hasChanged = !(parsedDate === this.date);
        if (hasChanged) {
            this.date = parsedDate;
            this.onModelChange(this.date);
            this.validatorOnChange();
            this.dateChange.next(this.date);
        }
    }
    getFormat() {
        if (!this.format) {
            this.format = getDatepickerFormat(this.locale, this.siDatepickerConfig);
        }
        return this.format;
    }
    /**
     * Callback when the datepicker changes his value.
     * @param date updated date
     */
    onDateChanged(date) {
        // update input element
        this.writeValue(date);
        // update the Forms ngModel
        this.onModelChange(this.date);
        // trigger validation on date selection
        this.onTouched();
        this.cdRef.markForCheck();
    }
    /**
     * Datepicker consider time / ignore time changed.
     * @param disabled disable time
     */
    onDisabledTime(disabledTime) {
        this.siDatepickerConfig.disabledTime = disabledTime;
        // Ensure the time format will be removed
        this.onDateChanged(this.date);
        this.siDatepickerDisabledTime.next(disabledTime);
    }
    /** The form control validator for date format */
    formatValidator(control) {
        const invalidFormat = !!(!control?.value && this.elementRef.nativeElement.value);
        return invalidFormat ? { invalidFormat: { format: this.getFormat() } } : null;
    }
    /** The form control validator for the min date. */
    minValidator() {
        const controlValue = this.date;
        const min = getMinDate(this.siDatepickerConfig?.minDate);
        const withTime = this.siDatepickerConfig?.showTime;
        return !min ||
            !controlValue ||
            (withTime ? controlValue >= min : compareDate(controlValue, min) >= 0)
            ? null
            : { invalidMinDate: { min, actual: controlValue } };
    }
    /** The form control validator for the min date. */
    maxValidator() {
        const controlValue = this.date;
        const max = getMaxDate(this.siDatepickerConfig?.maxDate);
        const withTime = this.siDatepickerConfig?.showTime;
        return !max ||
            !controlValue ||
            (withTime ? controlValue <= max : compareDate(controlValue, max) <= 0)
            ? null
            : { invalidMaxDate: { max, actual: controlValue } };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateInputDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiDateInputDirective, selector: "[siDateInput]", inputs: { siDatepickerConfig: "siDatepickerConfig", dateRange: "dateRange", rangeType: "rangeType", dateInputDebounceTime: "dateInputDebounceTime", disabled: "disabled", readonly: "readonly" }, outputs: { siDatepickerDisabledTime: "siDatepickerDisabledTime", stateChange: "stateChange" }, host: { listeners: { "change": "onChange($event)", "input": "onInput($event.target.value)" }, properties: { "attr.readonly": "this.readOnlyState", "class.readonly": "this._readonly" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: SiDateInputDirective,
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: SiDateInputDirective,
                multi: true
            }
        ], exportAs: ["siDateInput"], usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siDateInput]',
                    exportAs: 'siDateInput',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SiDateInputDirective,
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: SiDateInputDirective,
                            multi: true
                        }
                    ]
                }]
        }], propDecorators: { siDatepickerConfig: [{
                type: Input
            }], dateRange: [{
                type: Input
            }], rangeType: [{
                type: Input
            }], dateInputDebounceTime: [{
                type: Input
            }], siDatepickerDisabledTime: [{
                type: Output
            }], stateChange: [{
                type: Output
            }], disabled: [{
                type: Input
            }], readonly: [{
                type: Input
            }], readOnlyState: [{
                type: HostBinding,
                args: ['attr.readonly']
            }], _readonly: [{
                type: HostBinding,
                args: ['class.readonly']
            }], onChange: [{
                type: HostListener,
                args: ['change', ['$event']]
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }] } });

/**
 * Compare dates in the month view.
 */
class DayCompareAdapter {
    isAfter(current, start) {
        return isAfter(current, start);
    }
    isBetween(current, from, to) {
        return isBetween(current, from, to);
    }
    isEqual(current, other) {
        return isSameDate(current, other);
    }
    isEqualOrBefore(current, other) {
        return isSameOrBefore(current, other);
    }
    isEqualOrBetween(current, from, to) {
        return isSameOrBetween(current, from, to);
    }
}
/**
 * Compare dates in the year view.
 */
class MonthCompareAdapter {
    isAfter(current, start) {
        return isAfterMonth(current, start);
    }
    isBetween(current, from, to) {
        return isBetweenMonth(current, from, to);
    }
    isEqual(current, other) {
        return isSameMonth(current, other);
    }
    isEqualOrBefore(current, other) {
        return isSameOrBeforeMonth(current, other);
    }
    isEqualOrBetween(current, from, to) {
        return isSameOrBetweenMonth(current, from, to);
    }
}
class YearCompareAdapter {
    isAfter(current, other) {
        return isAfterYear(current, other);
    }
    isBetween(current, from, to) {
        return isBetweenYears(current, from, to);
    }
    isEqual(current, other) {
        return isSameYear(current, other);
    }
    isEqualOrBefore(current, other) {
        if (!other) {
            return false;
        }
        return isSameOrBeforeYear(current, other);
    }
    isEqualOrBetween(current, from, to) {
        return isSameOrBetweenYears(current, from, to);
    }
}

class SiCalendarDateCellDirective {
    cell;
    compareAdapter;
    ref = inject(ElementRef);
    get disabled() {
        return this.cell.disabled;
    }
    get ariaLabel() {
        return this.cell.ariaLabel;
    }
    get today() {
        return this.cell.isToday;
    }
    get ariaToday() {
        return this.cell.isToday ? 'date' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarDateCellDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiCalendarDateCellDirective, isStandalone: true, selector: "[siCalendarDateCell]", inputs: { cell: "cell", compareAdapter: "compareAdapter" }, host: { properties: { "attr.aria-disabled": "this.disabled", "class.disabled": "this.disabled", "attr.aria-label": "this.ariaLabel", "class.today": "this.today", "attr.aria-current": "this.ariaToday" }, classAttribute: "si-calendar-date-cell" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarDateCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siCalendarDateCell]',
                    standalone: true,
                    host: {
                        class: 'si-calendar-date-cell'
                    }
                }]
        }], propDecorators: { cell: [{
                type: Input
            }], compareAdapter: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['attr.aria-disabled']
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }], ariaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }], today: [{
                type: HostBinding,
                args: ['class.today']
            }], ariaToday: [{
                type: HostBinding,
                args: ['attr.aria-current']
            }] } });

/**
 * Base interface for selections.
 */
class SelectionStrategy {
    compare;
    constructor(compare) {
        this.compare = compare;
    }
}
/**
 * Strategy the handle single selection within the {@link SiCalendarBodyComponent}.
 */
class SingleSelectionStrategy extends SelectionStrategy {
    isSelected(cell, start, end) {
        return this.compare.isEqual(cell.valueRaw, start);
    }
    inRange(cell, start, end) {
        return false;
    }
    isRangeSelected(cell, start, end) {
        return false;
    }
    previewRangeHover(cell, hoverCell, start, end) {
        return false;
    }
}
/**
 * Strategy the handle range selection within the {@link SiCalendarBodyComponent}.
 */
class RangeSelectionStrategy extends SelectionStrategy {
    isSelected(cell, start, end) {
        return this.compare.isEqual(cell.valueRaw, start) || this.compare.isEqual(cell.valueRaw, end);
    }
    inRange(c, start, end) {
        if (!start || !end) {
            return false;
        }
        return this.compare.isBetween(c.valueRaw, start, end);
    }
    isRangeSelected(cell, start, end) {
        return this.compare.isEqual(cell.valueRaw, start) || this.compare.isEqual(cell.valueRaw, end);
    }
    previewRangeHover(cell, hoverCell, start, end) {
        if (!hoverCell || cell.disabled || !start) {
            return false;
        }
        return (this.compare.isAfter(cell.valueRaw, start) &&
            this.compare.isEqualOrBefore(cell.valueRaw, hoverCell.valueRaw));
    }
}
class SiCalendarBodyComponent {
    /** The active date, the cell which will receive the focus. */
    focusedDate;
    /** The date which shall be indicated as currently selected. */
    startDate;
    /** Selected end value which is only considered with enableRangeSelection. */
    endDate;
    /** The cells to display in the table. */
    rows = [];
    /** Labels for each row, which can be used to display the week number. */
    rowLabels;
    /** Additional row label CSS class(es). */
    rowLabelCssClasses = [];
    /**
     * Choose the selection strategy between single or range selection.
     * @default `false`
     */
    set enableRangeSelection(isRangeSelection) {
        this.selection = isRangeSelection
            ? new RangeSelectionStrategy(this.compareAdapter)
            : new SingleSelectionStrategy(this.compareAdapter);
    }
    /**
     * Indicate whether a range preview shall be displayed.
     * It's necessary since to display a preview also datepicker has a valid endDate.
     */
    previewRange = true;
    /** The cell which which has the mouse hover. */
    activeHover;
    /** Compare date functions which are necessary to compare a the dates according the current view. */
    compareAdapter = new DayCompareAdapter();
    /** Required to establish a two way binding of activeHover. The event emits on mouseover or focus changes. */
    activeHoverChange = new EventEmitter();
    /** Emits when a user select a cell via click, space or enter. */
    selectedValueChange = new EventEmitter();
    /** Emits when a cell in the body is focused. */
    focusedDateChange = new EventEmitter();
    calendarDateCells;
    selection = new SingleSelectionStrategy(this.compareAdapter);
    trackByIndex = (index) => index;
    /**
     * Focus calendar cell which is marked as active cell.
     */
    focusActiveCell() {
        setTimeout(() => {
            const focusedDateCells = this.calendarDateCells.filter(dateCell => this.compareAdapter.isEqual(this.focusedDate, dateCell.cell.valueRaw));
            if (focusedDateCells.length > 0) {
                focusedDateCells[0].ref.nativeElement.focus();
            }
        });
    }
    isActive(cell) {
        return this.compareAdapter.isEqual(this.focusedDate, cell.valueRaw);
    }
    cellCss(cell) {
        return cell.cssClasses;
    }
    emitActiveHover(cell) {
        this.activeHover = cell;
        this.activeHoverChange.emit(this.activeHover);
    }
    emitSelectCell(selection) {
        if (selection.disabled) {
            return;
        }
        this.selectedValueChange.emit(selection.valueRaw);
    }
    emitActiveDateChange(cell) {
        if (!cell.disabled) {
            // To provide a date-range preview it is necessary to maintain hoverCell also in case of keyboard usage
            this.emitActiveHover(cell);
            this.focusedDateChange.emit(cell.valueRaw);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiCalendarBodyComponent, isStandalone: true, selector: "[si-calendar-body]", inputs: { focusedDate: "focusedDate", startDate: "startDate", endDate: "endDate", rows: "rows", rowLabels: "rowLabels", rowLabelCssClasses: "rowLabelCssClasses", enableRangeSelection: "enableRangeSelection", previewRange: "previewRange", activeHover: "activeHover", compareAdapter: "compareAdapter" }, outputs: { activeHoverChange: "activeHoverChange", selectedValueChange: "selectedValueChange", focusedDateChange: "focusedDateChange" }, host: { classAttribute: "si-calendar-body" }, viewQueries: [{ propertyName: "calendarDateCells", predicate: SiCalendarDateCellDirective, descendants: true }], exportAs: ["siCalendarBody"], ngImport: i0, template: "<tr *ngFor=\"let row of rows; let rowIndex = index; trackBy: trackByIndex\" role=\"row\">\n  <!-- Typically used for week numbers -->\n  <td\n    *ngIf=\"rowLabels\"\n    class=\"si-calendar-row-label\"\n    [attr.data-row]=\"rowIndex\"\n    [ngClass]=\"rowLabelCssClasses\"\n  >\n    {{ rowLabels[rowIndex] }}\n  </td>\n  <td\n    *ngFor=\"let col of row; let colIndex = index; trackBy: trackByIndex\"\n    role=\"gridcell\"\n    class=\"si-calendar-cell\"\n    [attr.data-row]=\"rowIndex\"\n    [attr.data-col]=\"colIndex\"\n    [class.range-hover]=\"\n      previewRange && selection.previewRangeHover(col, activeHover, startDate, endDate)\n    \"\n    [class.range]=\"selection.inRange(col, startDate, endDate)\"\n    [class.range-start-end]=\"selection.isRangeSelected(col, startDate, endDate)\"\n  >\n    <div\n      siCalendarDateCell\n      [cell]=\"col\"\n      [compareAdapter]=\"compareAdapter\"\n      [ngClass]=\"cellCss(col)\"\n      [attr.cdkFocusInitial]=\"isActive(col) ? '' : null\"\n      [class.selected]=\"selection.isSelected(col, startDate, endDate)\"\n      [class.text-secondary]=\"\n        col.isPreview && !col.disabled && !selection.isRangeSelected(col, startDate, endDate)\n      \"\n      [tabindex]=\"isActive(col) ? '0' : '-1'\"\n      (mouseover)=\"emitActiveHover(col)\"\n      (click)=\"emitSelectCell(col)\"\n      (focus)=\"emitActiveDateChange(col)\"\n      (keydown.enter)=\"emitSelectCell(col)\"\n      (keydown.space)=\"emitSelectCell(col)\"\n    >\n      {{ col.displayValue }}\n    </div>\n  </td>\n</tr>\n", styles: [".selection .month:not(.disabled):hover,.selection .year:not(.disabled):hover,.year:not(.disabled):not(.selected):hover,.month:not(.disabled):not(.selected):hover,.day:not(.disabled):not(.selected):hover{background:var(--element-base-1-hover);color:var(--element-ui-0)}.year,.month,.day{block-size:32px;line-height:32px}.day{inline-size:32px}.year,.month,.day{margin-inline:auto;position:relative;cursor:pointer}:host{background:var(--element-base-1);border-radius:var(--element-radius-2);display:block;inline-size:348px}.header,.footer{display:flex;align-items:center}.header{padding-block-start:12px;padding-block-end:16px;padding-inline:32px;border-block-end:1px solid var(--element-ui-4)}.header a{text-decoration:none;cursor:pointer}.footer{margin-block-start:4px;text-align:center}table{inline-size:100%;border-collapse:separate;border-spacing:0 3px;table-layout:fixed;margin-block-end:-3px}.day.selected,.month.selected,.year.selected{background:var(--element-ui-0);color:var(--element-base-1)}td[role=gridcell]{text-align:center}th{font-weight:400;text-align:center;block-size:32px}.week-num,th{font-size:.75rem;color:var(--element-text-secondary);inline-size:32px;cursor:default}.today.selected:before{border-color:var(--element-ui-5)}.today:before{position:absolute;content:\"\";inset:1px;border:1px solid var(--element-ui-1);border-radius:var(--element-radius-2);display:inline-block}.selection .month,.selection .year{block-size:30px;line-height:30px;cursor:pointer}.selection .month{inline-size:50%}.selection .year{inline-size:33.3%}.disabled{color:var(--element-text-disabled);font-weight:400!important;cursor:default!important}.range{background-color:var(--element-ui-4)}.range:hover{background:var(--element-base-1-hover)}.range:hover div.si-title-1:hover{background:transparent}.range-hover{background-color:var(--element-base-1-hover)}td.range-start-end{background:var(--element-ui-0);color:var(--element-base-1)}td.range-start-end div.si-title-1:hover,td.range-start-end div.si-body-1:hover{background:transparent;color:var(--element-base-1)}td.range-start-end .today:before{border-color:var(--element-ui-5)}.calendar-button{font-weight:700;font-size:.875rem;line-height:1.143;color:var(--element-text-active);min-inline-size:0!important}\n"], dependencies: [{ kind: "ngmodule", type: A11yModule }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: SiCalendarDateCellDirective, selector: "[siCalendarDateCell]", inputs: ["cell", "compareAdapter"] }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: '[si-calendar-body]', exportAs: 'siCalendarBody', encapsulation: ViewEncapsulation.None, standalone: true, imports: [A11yModule, CommonModule, SiCalendarDateCellDirective], host: {
                        class: 'si-calendar-body'
                    }, template: "<tr *ngFor=\"let row of rows; let rowIndex = index; trackBy: trackByIndex\" role=\"row\">\n  <!-- Typically used for week numbers -->\n  <td\n    *ngIf=\"rowLabels\"\n    class=\"si-calendar-row-label\"\n    [attr.data-row]=\"rowIndex\"\n    [ngClass]=\"rowLabelCssClasses\"\n  >\n    {{ rowLabels[rowIndex] }}\n  </td>\n  <td\n    *ngFor=\"let col of row; let colIndex = index; trackBy: trackByIndex\"\n    role=\"gridcell\"\n    class=\"si-calendar-cell\"\n    [attr.data-row]=\"rowIndex\"\n    [attr.data-col]=\"colIndex\"\n    [class.range-hover]=\"\n      previewRange && selection.previewRangeHover(col, activeHover, startDate, endDate)\n    \"\n    [class.range]=\"selection.inRange(col, startDate, endDate)\"\n    [class.range-start-end]=\"selection.isRangeSelected(col, startDate, endDate)\"\n  >\n    <div\n      siCalendarDateCell\n      [cell]=\"col\"\n      [compareAdapter]=\"compareAdapter\"\n      [ngClass]=\"cellCss(col)\"\n      [attr.cdkFocusInitial]=\"isActive(col) ? '' : null\"\n      [class.selected]=\"selection.isSelected(col, startDate, endDate)\"\n      [class.text-secondary]=\"\n        col.isPreview && !col.disabled && !selection.isRangeSelected(col, startDate, endDate)\n      \"\n      [tabindex]=\"isActive(col) ? '0' : '-1'\"\n      (mouseover)=\"emitActiveHover(col)\"\n      (click)=\"emitSelectCell(col)\"\n      (focus)=\"emitActiveDateChange(col)\"\n      (keydown.enter)=\"emitSelectCell(col)\"\n      (keydown.space)=\"emitSelectCell(col)\"\n    >\n      {{ col.displayValue }}\n    </div>\n  </td>\n</tr>\n", styles: [".selection .month:not(.disabled):hover,.selection .year:not(.disabled):hover,.year:not(.disabled):not(.selected):hover,.month:not(.disabled):not(.selected):hover,.day:not(.disabled):not(.selected):hover{background:var(--element-base-1-hover);color:var(--element-ui-0)}.year,.month,.day{block-size:32px;line-height:32px}.day{inline-size:32px}.year,.month,.day{margin-inline:auto;position:relative;cursor:pointer}:host{background:var(--element-base-1);border-radius:var(--element-radius-2);display:block;inline-size:348px}.header,.footer{display:flex;align-items:center}.header{padding-block-start:12px;padding-block-end:16px;padding-inline:32px;border-block-end:1px solid var(--element-ui-4)}.header a{text-decoration:none;cursor:pointer}.footer{margin-block-start:4px;text-align:center}table{inline-size:100%;border-collapse:separate;border-spacing:0 3px;table-layout:fixed;margin-block-end:-3px}.day.selected,.month.selected,.year.selected{background:var(--element-ui-0);color:var(--element-base-1)}td[role=gridcell]{text-align:center}th{font-weight:400;text-align:center;block-size:32px}.week-num,th{font-size:.75rem;color:var(--element-text-secondary);inline-size:32px;cursor:default}.today.selected:before{border-color:var(--element-ui-5)}.today:before{position:absolute;content:\"\";inset:1px;border:1px solid var(--element-ui-1);border-radius:var(--element-radius-2);display:inline-block}.selection .month,.selection .year{block-size:30px;line-height:30px;cursor:pointer}.selection .month{inline-size:50%}.selection .year{inline-size:33.3%}.disabled{color:var(--element-text-disabled);font-weight:400!important;cursor:default!important}.range{background-color:var(--element-ui-4)}.range:hover{background:var(--element-base-1-hover)}.range:hover div.si-title-1:hover{background:transparent}.range-hover{background-color:var(--element-base-1-hover)}td.range-start-end{background:var(--element-ui-0);color:var(--element-base-1)}td.range-start-end div.si-title-1:hover,td.range-start-end div.si-body-1:hover{background:transparent;color:var(--element-base-1)}td.range-start-end .today:before{border-color:var(--element-ui-5)}.calendar-button{font-weight:700;font-size:.875rem;line-height:1.143;color:var(--element-text-active);min-inline-size:0!important}\n"] }]
        }], propDecorators: { focusedDate: [{
                type: Input
            }], startDate: [{
                type: Input
            }], endDate: [{
                type: Input
            }], rows: [{
                type: Input
            }], rowLabels: [{
                type: Input
            }], rowLabelCssClasses: [{
                type: Input
            }], enableRangeSelection: [{
                type: Input
            }], previewRange: [{
                type: Input
            }], activeHover: [{
                type: Input
            }], compareAdapter: [{
                type: Input
            }], activeHoverChange: [{
                type: Output
            }], selectedValueChange: [{
                type: Output
            }], focusedDateChange: [{
                type: Output
            }], calendarDateCells: [{
                type: ViewChildren,
                args: [SiCalendarDateCellDirective]
            }] } });

/**
 * Helper directive to set the initial focus to the calendar body cell.
 */
class SiInitialFocusComponent {
    /** Guard to set the focus during ngAfterViewInit, we just set the focus after we first initialized the view */
    initialFocus = true;
    /** The body of calendar table */
    calendarBody;
    ngAfterViewInit() {
        if (this.initialFocus) {
            this.initialFocus = false;
            this.focusActiveCell();
        }
    }
    /**
     * Focus calendar cell which is marked as active cell.
     */
    focusActiveCell() {
        this.calendarBody.focusActiveCell();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiInitialFocusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiInitialFocusComponent, isStandalone: true, selector: "ng-component", inputs: { initialFocus: "initialFocus" }, viewQueries: [{ propertyName: "calendarBody", first: true, predicate: SiCalendarBodyComponent, descendants: true }], ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiInitialFocusComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    standalone: true
                }]
        }], propDecorators: { initialFocus: [{
                type: Input
            }], calendarBody: [{
                type: ViewChild,
                args: [SiCalendarBodyComponent]
            }] } });

class SiCalendarDirectionButtonComponent {
    ariaLabel = '';
    disabled = false;
    set direction(v) {
        switch (v) {
            case 'left':
                this.icon = 'element-left-2';
                this.buttonClass = 'previous-button';
                break;
            case 'right':
                this.icon = 'element-right-2';
                this.buttonClass = 'next-button';
                break;
        }
    }
    /**
     * Emit on button click.
     */
    clicked = new EventEmitter();
    onClick() {
        this.clicked.emit();
    }
    icon;
    buttonClass;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarDirectionButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiCalendarDirectionButtonComponent, isStandalone: true, selector: "si-calendar-direction-button", inputs: { ariaLabel: "ariaLabel", disabled: "disabled", direction: "direction" }, outputs: { clicked: "clicked" }, ngImport: i0, template: `<button
    role="button"
    type="button"
    class="btn btn-circle btn-sm btn-tertiary"
    [ngClass]="buttonClass"
    [disabled]="disabled || null"
    [attr.aria-label]="ariaLabel"
    (click)="onClick()"
  >
    <i class="icon flip-rtl" [ngClass]="icon"></i>
  </button>`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarDirectionButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'si-calendar-direction-button',
                    template: `<button
    role="button"
    type="button"
    class="btn btn-circle btn-sm btn-tertiary"
    [ngClass]="buttonClass"
    [disabled]="disabled || null"
    [attr.aria-label]="ariaLabel"
    (click)="onClick()"
  >
    <i class="icon flip-rtl" [ngClass]="icon"></i>
  </button>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    imports: [CommonModule]
                }]
        }], propDecorators: { ariaLabel: [{
                type: Input
            }], disabled: [{
                type: Input
            }], direction: [{
                type: Input
            }], clicked: [{
                type: Output
            }] } });

/**
 * Show dates of a single month as table and handles the keyboard interactions.
 * The focusedDate is handled according the keyboard interactions.
 */
class SiDaySelectionComponent extends SiInitialFocusComponent {
    /** Indicate whether or not the week numbers shall be hidden. */
    hideWeekNumbers = false;
    /** Defines the starting day of the week. Default is `monday`. */
    weekStartDay = 'monday';
    /** The minimum selectable date. */
    minDate;
    /** The maximum selectable date. */
    maxDate;
    /** The date which is displayed as selected. */
    startDate;
    /** The date which is displayed as selected end. The value is only considered with enableRangeSelection. */
    endDate;
    /** Is range selection enabled */
    isRangeSelection = false;
    /**
     * Indicate whether a range preview shall be displayed.
     * It's necessary since to display a preview also datepicker has a valid endDate.
     */
    previewRange = true;
    /** The list of translated month labels. */
    months;
    /** The active date, the cell which will receive the focus. */
    set focusedDate(v) {
        const oldActiveDate = this._focusedDate;
        this._focusedDate = v;
        if (isAnotherMonthOrYear(this._focusedDate, oldActiveDate)) {
            // Re-calc month view
            this.initView();
            this.activeMonthChange.emit(v);
        }
    }
    get focusedDate() {
        return this._focusedDate;
    }
    /** Aria label for the previous button. Needed for a11y. */
    previousLabel;
    /** Aria label for the next button. Needed for a11y. */
    nextLabel;
    /** Today button text */
    todayLabel;
    /** Aria label for calendar week column */
    calenderWeekLabel;
    /** Emits when a new value is selected. */
    selectedValueChange = new EventEmitter();
    /** Emits when the active focused date changed, typically during keyboard navigation */
    focusedDateChange = new EventEmitter();
    /** Emits when the active focused date changed to another month / year, typically during keyboard navigation */
    activeMonthChange = new EventEmitter();
    /** Emits when the user requests a different to show a different view */
    viewChange = new EventEmitter();
    /** The translated list of week days. */
    days = [];
    /** The week numbers which are shown as row label */
    weekNumbers = [];
    /**
     * The current visible list of calendar days.
     * Every time the focusedDate changes to either another month or year the list will be rebuild.
     */
    weeks = [];
    /** Compare date based on the current view */
    compareAdapter = new DayCompareAdapter();
    trackByIndex = (index) => index;
    isTodayButtonDisabled = false;
    /** The currently focused date */
    _focusedDate = today();
    locale = inject(LOCALE_ID);
    cdRef = inject(ChangeDetectorRef);
    ngOnChanges(changes) {
        if (changes.maxDate || changes.minDate || changes.weekStartDay) {
            this.initView();
        }
    }
    calendarBodyKeyDown(event) {
        const isRtl = isRTL();
        const oldActiveDate = this.focusedDate;
        switch (event.key) {
            case 'ArrowLeft':
                this.focusedDate = addDaysInRange(this._focusedDate, isRtl ? 1 : -1, this.minDate, this.maxDate);
                break;
            case 'ArrowRight':
                this.focusedDate = addDaysInRange(this._focusedDate, isRtl ? -1 : 1, this.minDate, this.maxDate);
                break;
            case 'ArrowUp':
                this.focusedDate = addDaysInRange(this._focusedDate, -7, this.minDate, this.maxDate);
                break;
            case 'ArrowDown':
                this.focusedDate = addDaysInRange(this._focusedDate, 7, this.minDate, this.maxDate);
                break;
            case 'Home':
                this.focusedDate = getWeekStartDate(this._focusedDate, this.weekStartDay);
                break;
            case 'End':
                this.focusedDate = getWeekEndDate(this._focusedDate, this.weekStartDay);
                break;
            case 'PageDown':
                this.focusedDate = addMonthsInRange(this._focusedDate, 1, this.minDate, this.maxDate);
                break;
            case 'PageUp':
                this.focusedDate = addMonthsInRange(this._focusedDate, -1, this.minDate, this.maxDate);
                break;
            case 'Enter':
            case 'Space':
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        if (!isSameDate(oldActiveDate, this.focusedDate)) {
            this.focusedDateChange.emit(this.focusedDate);
            this.focusActiveCell();
        }
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    }
    /**
     * Update month of focusedDate.
     * @param offset 1 or -1.
     */
    setMonthOffset(offset) {
        this.focusedDate = addMonthsInRange(this.focusedDate, offset, this.minDate, this.maxDate);
    }
    /** Change the focusedDate to today */
    goToToday() {
        this.focusedDate = today();
        this.focusedDateChange.emit(this.focusedDate);
        this.focusActiveCell();
    }
    /**
     * Indicate the previous button shall be disabled.
     * This happens when the focusedDate is equal or before the minDate.
     */
    isPreviousButtonDisabled() {
        if (!this.minDate) {
            return false;
        }
        return (isSameMonth(this.focusedDate, this.minDate) ||
            isAfterMonth(this.minDate, this.focusedDate));
    }
    /**
     * Indicate the next button shall be disabled.
     * This happens when the focusedDate is equal or after the maxDate.
     */
    isNextButtonDisabled() {
        if (!this.maxDate) {
            return false;
        }
        return (isSameMonth(this.focusedDate, this.maxDate) ||
            isAfterMonth(this.focusedDate, this.maxDate));
    }
    emitSelectedValue(selected) {
        if (selected !== this.startDate || selected !== this.endDate) {
            this.selectedValueChange.emit(selected);
        }
        this.cdRef.markForCheck();
    }
    emitActiveDate(active) {
        this.focusedDateChange.emit(active);
    }
    emitViewChange(view) {
        this.viewChange.emit(view);
    }
    /**
     * Initialize weekday labels.
     */
    initWeekdays() {
        // Convert local to string otherwise DateTimeFormat will always go with the default.
        const localString = this.locale.toString();
        this.days = getDayStrings(localString, this.weekStartDay);
    }
    /**
     * Initialize view based on the focusedDate.
     */
    initView() {
        this.initWeekdays();
        // Disable today button if it is the same month
        this.isTodayButtonDisabled = isSameMonth(today(), this.focusedDate);
        const monthStart = getFirstDateInMonth(this._focusedDate);
        const monthEnd = getLastDateInMonth(this._focusedDate);
        /**
         * We start the month with the first day in the week which has the effect that dates are
         * visible which aren't in the active month.
         */
        const startDate = getWeekStartDate(monthStart, this.weekStartDay);
        this.weeks = [[], [], [], [], [], []];
        let weekIndex = 0;
        this.weekNumbers = [];
        for (let i = 0, date = new Date(startDate); this.weeks[this.weeks.length - 1].length < 7; i++, date.setDate(date.getDate() + 1)) {
            if (i > 0 && i % 7 === 0) {
                weekIndex++;
            }
            const activeMonth = isSameOrBetween(date, monthStart, monthEnd);
            const isToday = isSameDate(date, today());
            const outOfRange = !isSameOrBetween(date, this.minDate, this.maxDate);
            this.weeks.at(weekIndex)?.push({
                value: date.getDate(),
                disabled: !activeMonth || outOfRange,
                ariaLabel: date.toDateString(),
                displayValue: date.getDate().toString(),
                isPreview: !activeMonth,
                isToday,
                valueRaw: createDate(date),
                cssClasses: ['day', activeMonth ? 'si-title-1' : 'si-body-1']
            });
        }
        this.initWeekNumbers();
    }
    /**
     * Initialize calendar week numbers cells based on the weeks array.
     */
    initWeekNumbers() {
        this.weeks.forEach(w => {
            const weekNumber = getWeekOfYear(w[0].valueRaw, this.weekStartDay);
            this.weekNumbers.push(weekNumber.toString());
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDaySelectionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiDaySelectionComponent, selector: "si-day-selection", inputs: { hideWeekNumbers: "hideWeekNumbers", weekStartDay: "weekStartDay", minDate: "minDate", maxDate: "maxDate", startDate: "startDate", endDate: "endDate", isRangeSelection: "isRangeSelection", previewRange: "previewRange", months: "months", focusedDate: "focusedDate", previousLabel: "previousLabel", nextLabel: "nextLabel", todayLabel: "todayLabel", calenderWeekLabel: "calenderWeekLabel" }, outputs: { selectedValueChange: "selectedValueChange", focusedDateChange: "focusedDateChange", activeMonthChange: "activeMonthChange", viewChange: "viewChange" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"header\">\n  <si-calendar-direction-button\n    direction=\"left\"\n    [ariaLabel]=\"previousLabel | translate\"\n    [disabled]=\"isPreviousButtonDisabled()\"\n    (clicked)=\"setMonthOffset(-1)\"\n  />\n  <div class=\"flex-fill\">\n    <button\n      type=\"button\"\n      class=\"open-month-view flex-fill text-end px-2 btn btn-tertiary calendar-button\"\n      tabindex=\"0\"\n      (click)=\"emitViewChange('month')\"\n    >\n      {{ focusedDate | date : 'MMMM' }}\n    </button>\n    <button\n      type=\"button\"\n      class=\"open-year-view flex-fill text-start px-2 btn btn-tertiary calendar-button\"\n      tabindex=\"0\"\n      (click)=\"emitViewChange('year')\"\n    >\n      {{ focusedDate | date : 'YYYY' }}\n    </button>\n  </div>\n  <si-calendar-direction-button\n    direction=\"right\"\n    [ariaLabel]=\"nextLabel | translate\"\n    [disabled]=\"isNextButtonDisabled()\"\n    (clicked)=\"setMonthOffset(1)\"\n  />\n</div>\n<table class=\"px-9 mt-6\" role=\"grid\">\n  <thead class=\"si-calendar-table-header\">\n    <tr>\n      <th *ngIf=\"!hideWeekNumbers\" scope=\"col\" class=\"week-num\">\n        <span class=\"visually-hidden\">{{ calenderWeekLabel ?? '' | translate }}</span>\n      </th>\n      <th *ngFor=\"let day of days; trackBy: trackByIndex\" scope=\"col\">\n        <span class=\"si-hidden-xs si-hidden-sm\">{{ day }}</span>\n      </th>\n    </tr>\n  </thead>\n  <tbody\n    si-calendar-body\n    [focusedDate]=\"focusedDate\"\n    [compareAdapter]=\"compareAdapter\"\n    [startDate]=\"startDate\"\n    [endDate]=\"endDate\"\n    [enableRangeSelection]=\"isRangeSelection\"\n    [previewRange]=\"previewRange\"\n    [rows]=\"weeks\"\n    [rowLabels]=\"hideWeekNumbers ? undefined : weekNumbers\"\n    [rowLabelCssClasses]=\"'week-num'\"\n    (selectedValueChange)=\"emitSelectedValue($event)\"\n    (focusedDateChange)=\"emitActiveDate($event)\"\n    (keydown)=\"calendarBodyKeyDown($event)\"\n  >\n  </tbody>\n</table>\n<div class=\"footer pt-2 ps-8 pe-8\">\n  <button\n    type=\"button\"\n    class=\"today-button btn btn-tertiary flex-fill\"\n    [disabled]=\"isTodayButtonDisabled\"\n    (click)=\"goToToday()\"\n  >\n    {{ todayLabel ?? 'Today' | translate }}\n  </button>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SiCalendarBodyComponent, selector: "[si-calendar-body]", inputs: ["focusedDate", "startDate", "endDate", "rows", "rowLabels", "rowLabelCssClasses", "enableRangeSelection", "previewRange", "activeHover", "compareAdapter"], outputs: ["activeHoverChange", "selectedValueChange", "focusedDateChange"], exportAs: ["siCalendarBody"] }, { kind: "component", type: SiCalendarDirectionButtonComponent, selector: "si-calendar-direction-button", inputs: ["ariaLabel", "disabled", "direction"], outputs: ["clicked"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDaySelectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-day-selection', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"header\">\n  <si-calendar-direction-button\n    direction=\"left\"\n    [ariaLabel]=\"previousLabel | translate\"\n    [disabled]=\"isPreviousButtonDisabled()\"\n    (clicked)=\"setMonthOffset(-1)\"\n  />\n  <div class=\"flex-fill\">\n    <button\n      type=\"button\"\n      class=\"open-month-view flex-fill text-end px-2 btn btn-tertiary calendar-button\"\n      tabindex=\"0\"\n      (click)=\"emitViewChange('month')\"\n    >\n      {{ focusedDate | date : 'MMMM' }}\n    </button>\n    <button\n      type=\"button\"\n      class=\"open-year-view flex-fill text-start px-2 btn btn-tertiary calendar-button\"\n      tabindex=\"0\"\n      (click)=\"emitViewChange('year')\"\n    >\n      {{ focusedDate | date : 'YYYY' }}\n    </button>\n  </div>\n  <si-calendar-direction-button\n    direction=\"right\"\n    [ariaLabel]=\"nextLabel | translate\"\n    [disabled]=\"isNextButtonDisabled()\"\n    (clicked)=\"setMonthOffset(1)\"\n  />\n</div>\n<table class=\"px-9 mt-6\" role=\"grid\">\n  <thead class=\"si-calendar-table-header\">\n    <tr>\n      <th *ngIf=\"!hideWeekNumbers\" scope=\"col\" class=\"week-num\">\n        <span class=\"visually-hidden\">{{ calenderWeekLabel ?? '' | translate }}</span>\n      </th>\n      <th *ngFor=\"let day of days; trackBy: trackByIndex\" scope=\"col\">\n        <span class=\"si-hidden-xs si-hidden-sm\">{{ day }}</span>\n      </th>\n    </tr>\n  </thead>\n  <tbody\n    si-calendar-body\n    [focusedDate]=\"focusedDate\"\n    [compareAdapter]=\"compareAdapter\"\n    [startDate]=\"startDate\"\n    [endDate]=\"endDate\"\n    [enableRangeSelection]=\"isRangeSelection\"\n    [previewRange]=\"previewRange\"\n    [rows]=\"weeks\"\n    [rowLabels]=\"hideWeekNumbers ? undefined : weekNumbers\"\n    [rowLabelCssClasses]=\"'week-num'\"\n    (selectedValueChange)=\"emitSelectedValue($event)\"\n    (focusedDateChange)=\"emitActiveDate($event)\"\n    (keydown)=\"calendarBodyKeyDown($event)\"\n  >\n  </tbody>\n</table>\n<div class=\"footer pt-2 ps-8 pe-8\">\n  <button\n    type=\"button\"\n    class=\"today-button btn btn-tertiary flex-fill\"\n    [disabled]=\"isTodayButtonDisabled\"\n    (click)=\"goToToday()\"\n  >\n    {{ todayLabel ?? 'Today' | translate }}\n  </button>\n</div>\n" }]
        }], propDecorators: { hideWeekNumbers: [{
                type: Input
            }], weekStartDay: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], startDate: [{
                type: Input
            }], endDate: [{
                type: Input
            }], isRangeSelection: [{
                type: Input
            }], previewRange: [{
                type: Input
            }], months: [{
                type: Input
            }], focusedDate: [{
                type: Input
            }], previousLabel: [{
                type: Input
            }], nextLabel: [{
                type: Input
            }], todayLabel: [{
                type: Input
            }], calenderWeekLabel: [{
                type: Input
            }], selectedValueChange: [{
                type: Output
            }], focusedDateChange: [{
                type: Output
            }], activeMonthChange: [{
                type: Output
            }], viewChange: [{
                type: Output
            }] } });

/**
 * Show months of a single year as table and handles the keyboard interactions.
 * The focus and focusedDate is handled according the keyboard interactions.
 */
class SiMonthSelectionComponent extends SiInitialFocusComponent {
    /** The translated list of months. */
    months = [];
    /** The minimum selectable date. */
    minDate;
    /** The maximum selectable date. */
    maxDate;
    /** The date which is displayed as selected. */
    startDate;
    /** The active date, the cell which will receive the focus. */
    set focusedDate(v) {
        const oldFocusedDate = this._focusedDate;
        this._focusedDate = v;
        if (isAnotherYear(this._focusedDate, oldFocusedDate)) {
            // Re-calc month view
            this.initView();
            this.activeMonthChange.emit(v);
        }
    }
    get focusedDate() {
        return this._focusedDate;
    }
    /** Aria label for the previous button. Needed for a11y. */
    previousLabel;
    /** Aria label for the next button. Needed for a11y. */
    nextLabel;
    /**
     * Emits when a new value is selected. In case where the value is null to
     * user aborted the selection by Escape.
     */
    selectedValueChange = new EventEmitter();
    /** Emits when the active focused date changed, typically during keyboard navigation. */
    focusedDateChange = new EventEmitter();
    /** Emits when the active focused date is changed to another month / year, typically during keyboard navigation. */
    activeMonthChange = new EventEmitter();
    /** Emits when the user requests a different to show a different view. */
    viewChange = new EventEmitter();
    /** Listen Escape event to switch view back */
    triggerEsc(event) {
        this.selectedValueChange.emit(null);
        event.preventDefault();
        event.stopPropagation(); // Prevents the overlay from closing.
    }
    /**
     * The current visible list of calendar months.
     * Every time the focusedDate changes to another year the list will be rebuild.
     */
    monthCells = [];
    /**
     * Is previous year button disabled based on the minDate,
     * true when the focusedDate is equal or before the minDate.
     */
    disablePreviousButton = false;
    /**
     * Is next year button disabled based on the maxDate,
     * true when the focusedDate is equal or after the maxDate.
     */
    disableNextButton = false;
    compareAdapter = new MonthCompareAdapter();
    trackByIndex = (index) => index;
    /** The currently focused date */
    _focusedDate = today();
    /** Number of column before the row is wrapped */
    columnCount = 2;
    cdRef = inject(ChangeDetectorRef);
    ngOnChanges(changes) {
        if (changes.maxDate || changes.minDate) {
            this.initView();
        }
    }
    calendarBodyKeyDown(event) {
        const isRtl = isRTL();
        const oldActiveDate = this.focusedDate;
        let newActiveDate = this.focusedDate;
        switch (event.key) {
            case 'ArrowLeft':
                newActiveDate = addMonthsInRange(this.focusedDate, isRtl ? 1 : -1, this.minDate, this.maxDate);
                break;
            case 'ArrowRight':
                newActiveDate = addMonthsInRange(this.focusedDate, isRtl ? -1 : 1, this.minDate, this.maxDate);
                break;
            case 'ArrowUp':
                newActiveDate = addMonthsInRange(this._focusedDate, -1 * this.columnCount, this.minDate, this.maxDate);
                break;
            case 'ArrowDown':
                newActiveDate = addMonthsInRange(this._focusedDate, this.columnCount, this.minDate, this.maxDate);
                break;
            case 'Escape':
                this.selectedValueChange.emit(null);
                event.preventDefault();
                event.stopPropagation(); // Prevents the overlay from closing.
                return;
            case 'Enter':
            case 'Space':
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        this.focusedDate = newActiveDate;
        if (!this.compareAdapter.isEqual(oldActiveDate, this.focusedDate)) {
            // Synchronize focusedDate with year view
            this.focusedDateChange.emit(this.focusedDate);
            this.focusActiveCell();
        }
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    }
    /**
     * Add offset to year and update focusedDate.
     */
    setYearOffset(offset) {
        const newActive = createDate(this.focusedDate);
        newActive.setFullYear(newActive.getFullYear() + offset);
        this.focusedDate = newActive;
        this.emitActiveDate(this.focusedDate);
    }
    /**
     * Indicate the previous button shall be disabled.
     * This happens when the focusedDate is equal or before the minDate.
     */
    isPreviousButtonDisabled() {
        if (!this.minDate) {
            return false;
        }
        return (isSameYear(this.focusedDate, this.minDate) ||
            isAfterYear(this.minDate, this.focusedDate));
    }
    /**
     * Indicate the next button shall be disabled.
     * This happens when the focusedDate is equal or after the maxDate.
     */
    isNextButtonDisabled() {
        if (!this.maxDate) {
            return false;
        }
        return (isSameYear(this.focusedDate, this.maxDate) ||
            isAfterYear(this.focusedDate, this.maxDate));
    }
    emitSelectedValue(selected) {
        this.selectedValueChange.emit(selected);
        this.cdRef.markForCheck();
    }
    emitActiveDate(active) {
        active.setDate(this.focusedDate.getDate());
        this.focusedDateChange.emit(active);
    }
    emitViewChange() {
        this.viewChange.emit('year');
    }
    /**
     * Initialize view based on the focusedDate.
     */
    initView() {
        this.monthCells = [];
        let row = [];
        // The cell date object needs to be the first to prevent that we jump to the next month when
        // setting the month. For example the focusedDate is 31. setting february would result in the
        // 3. March.
        const startDate = getFirstDateInYear(this.focusedDate);
        const today$1 = today();
        for (let i = 0; i <= 11; i++) {
            if (i > 0 && i % this.columnCount === 0) {
                this.monthCells.push(row);
                row = [];
            }
            const date = new Date(startDate);
            date.setMonth(i);
            const isToday = this.compareAdapter.isEqual(date, today$1);
            const isDisabled = !this.compareAdapter.isEqualOrBetween(date, this.minDate, this.maxDate);
            row.push({
                value: date.getDate(),
                disabled: isDisabled,
                ariaLabel: `${this.months[date.getMonth()]} ${this.focusedDate.getFullYear()}`,
                displayValue: this.months[date.getMonth()],
                isPreview: false,
                isToday,
                valueRaw: createDate(date),
                cssClasses: ['month', 'si-title-1', 'text-truncate']
            });
        }
        this.monthCells.push(row);
        this.disablePreviousButton = this.isPreviousButtonDisabled();
        this.disableNextButton = this.isNextButtonDisabled();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMonthSelectionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiMonthSelectionComponent, selector: "si-month-selection", inputs: { months: "months", minDate: "minDate", maxDate: "maxDate", startDate: "startDate", focusedDate: "focusedDate", previousLabel: "previousLabel", nextLabel: "nextLabel" }, outputs: { selectedValueChange: "selectedValueChange", focusedDateChange: "focusedDateChange", activeMonthChange: "activeMonthChange", viewChange: "viewChange" }, host: { listeners: { "keydown.Escape": "triggerEsc($event)" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"header\">\n  <si-calendar-direction-button\n    direction=\"left\"\n    [ariaLabel]=\"previousLabel\"\n    [disabled]=\"disablePreviousButton\"\n    (clicked)=\"setYearOffset(-1)\"\n  />\n  <button\n    type=\"button\"\n    class=\"open-year-view flex-fill mx-4 btn btn-tertiary calendar-button\"\n    tabindex=\"0\"\n    (click)=\"emitViewChange()\"\n  >\n    {{ focusedDate | date : 'YYYY' }}\n  </button>\n  <si-calendar-direction-button\n    direction=\"right\"\n    [ariaLabel]=\"nextLabel\"\n    [disabled]=\"disableNextButton\"\n    (clicked)=\"setYearOffset(1)\"\n  />\n</div>\n<table class=\"px-9 mt-6\" role=\"grid\">\n  <tbody\n    si-calendar-body\n    [focusedDate]=\"focusedDate\"\n    [compareAdapter]=\"compareAdapter\"\n    [startDate]=\"startDate\"\n    [enableRangeSelection]=\"false\"\n    [rows]=\"monthCells\"\n    (selectedValueChange)=\"emitSelectedValue($event)\"\n    (focusedDateChange)=\"emitActiveDate($event)\"\n    (keydown)=\"calendarBodyKeyDown($event)\"\n  >\n  </tbody>\n</table>\n", dependencies: [{ kind: "component", type: SiCalendarBodyComponent, selector: "[si-calendar-body]", inputs: ["focusedDate", "startDate", "endDate", "rows", "rowLabels", "rowLabelCssClasses", "enableRangeSelection", "previewRange", "activeHover", "compareAdapter"], outputs: ["activeHoverChange", "selectedValueChange", "focusedDateChange"], exportAs: ["siCalendarBody"] }, { kind: "component", type: SiCalendarDirectionButtonComponent, selector: "si-calendar-direction-button", inputs: ["ariaLabel", "disabled", "direction"], outputs: ["clicked"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMonthSelectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-month-selection', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"header\">\n  <si-calendar-direction-button\n    direction=\"left\"\n    [ariaLabel]=\"previousLabel\"\n    [disabled]=\"disablePreviousButton\"\n    (clicked)=\"setYearOffset(-1)\"\n  />\n  <button\n    type=\"button\"\n    class=\"open-year-view flex-fill mx-4 btn btn-tertiary calendar-button\"\n    tabindex=\"0\"\n    (click)=\"emitViewChange()\"\n  >\n    {{ focusedDate | date : 'YYYY' }}\n  </button>\n  <si-calendar-direction-button\n    direction=\"right\"\n    [ariaLabel]=\"nextLabel\"\n    [disabled]=\"disableNextButton\"\n    (clicked)=\"setYearOffset(1)\"\n  />\n</div>\n<table class=\"px-9 mt-6\" role=\"grid\">\n  <tbody\n    si-calendar-body\n    [focusedDate]=\"focusedDate\"\n    [compareAdapter]=\"compareAdapter\"\n    [startDate]=\"startDate\"\n    [enableRangeSelection]=\"false\"\n    [rows]=\"monthCells\"\n    (selectedValueChange)=\"emitSelectedValue($event)\"\n    (focusedDateChange)=\"emitActiveDate($event)\"\n    (keydown)=\"calendarBodyKeyDown($event)\"\n  >\n  </tbody>\n</table>\n" }]
        }], propDecorators: { months: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], startDate: [{
                type: Input
            }], focusedDate: [{
                type: Input
            }], previousLabel: [{
                type: Input
            }], nextLabel: [{
                type: Input
            }], selectedValueChange: [{
                type: Output
            }], focusedDateChange: [{
                type: Output
            }], activeMonthChange: [{
                type: Output
            }], viewChange: [{
                type: Output
            }], triggerEsc: [{
                type: HostListener,
                args: ['keydown.Escape', ['$event']]
            }] } });

/**
 * Show months of a single year as table and handles the keyboard interactions.
 * The focus and focusedDate is handled according the keyboard interactions.
 */
class SiYearSelectionComponent extends SiInitialFocusComponent {
    /** The minimum selectable date. */
    minDate;
    /** The maximum selectable date. */
    maxDate;
    /** The date which is displayed as selected. */
    selectedDate;
    /** The active date, the cell which will receive the focus. */
    focusedDate = today();
    /** Aria label for the previous button. Needed for a11y. */
    previousLabel;
    /** Aria label for the next button. Needed for a11y. */
    nextLabel;
    /**
     * Emits when a new value is selected. In case where the value is null to
     * user aborted the selection by Escape.
     */
    selectedValueChange = new EventEmitter();
    /** Emits when the active focused date changed to another month / year, typically during keyboard navigation. */
    yearRangeChange = new EventEmitter();
    /** Listen Escape event to switch view back */
    triggerEsc(event) {
        this.selectedValueChange.emit(null);
        event.preventDefault();
        event.stopPropagation(); // Prevents the overlay from closing.
    }
    /** Number of column before the row is wrapped */
    columnCount = 3;
    /** The number of years which shall be displayed, this number should be even and dividable by columnCount */
    yearsToDisplay = 18;
    /** Lower windows bound for displayed year range */
    fromYear;
    /** Upper windows bound for displayed year range */
    toYear;
    /**
     * The current visible list of calendar years.
     * Every time the focusedDate changes to another year the list will be rebuilt.
     */
    yearCells = [];
    /** Is previous button disabled based on the minDate */
    disablePreviousButton = false;
    /** Is next button  disabled  based on the maxDate */
    disableNextButton = false;
    compareAdapter = new YearCompareAdapter();
    trackByIndex = (index) => index;
    cdRef = inject(ChangeDetectorRef);
    ngOnChanges(changes) {
        if (changes.selectedDate || changes.focusedDate || changes.maxDate || changes.minDate) {
            this.initView();
        }
    }
    calendarBodyKeyDown(event) {
        const isRtl = isRTL();
        const oldActiveDate = this.focusedDate;
        switch (event.key) {
            case 'ArrowLeft':
                this.setYearOffset(isRtl ? 1 : -1);
                break;
            case 'ArrowRight':
                this.setYearOffset(isRtl ? -1 : 1);
                break;
            case 'ArrowUp':
                this.setYearOffset(-1 * this.columnCount);
                break;
            case 'ArrowDown':
                this.setYearOffset(this.columnCount);
                break;
            case 'PageUp':
                this.setYearOffset(-1 * (this.focusedDate.getFullYear() - this.fromYear.getFullYear()));
                break;
            case 'PageDown':
                this.setYearOffset(this.toYear.getFullYear() - this.focusedDate.getFullYear());
                break;
            case 'Escape':
                this.selectedValueChange.emit(null);
                event.preventDefault();
                event.stopPropagation(); // Prevents the overlay from closing.
                return;
            case 'Enter':
            case 'Space':
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        if (!this.compareAdapter.isEqual(oldActiveDate, this.focusedDate)) {
            this.focusActiveCell();
        }
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    }
    /**
     * Change the active date and the range of displayed years.
     * The windowOffset control the amount of ranges the view shall move forward or backward.
     * The number of displayed years ia controlled by yearsToDisplay.
     */
    changeVisibleYearRange(windowOffset) {
        const offset = windowOffset * this.yearsToDisplay;
        this.setYearOffset(offset);
    }
    emitSelectedValue(selected) {
        this.selectedValueChange.emit(selected);
        this.cdRef.markForCheck();
    }
    /**
     * Determine the year range start and end year.
     * - Based on the active date this function will find the start and
     * ending year of the current displayed range.
     * - In case the focusedDate is either before or after the current range the
     * start and end year will move the entire window (yearsToDisplay)
     */
    initYearRange() {
        // Did we exceed the display current displayed year range
        let changed = false;
        if (!this.fromYear) {
            const start = this.focusedDate.getFullYear() - this.yearsToDisplay / 2;
            this.fromYear = new Date(start, 0, 1);
            this.toYear = new Date(start + this.yearsToDisplay - 1, 0, 1);
            changed = true;
        }
        else if (this.compareAdapter.isAfter(this.focusedDate, this.toYear)) {
            // Change window forward
            const rangeDistance = Math.floor(Math.abs(this.focusedDate.getFullYear() - this.fromYear.getFullYear()) / this.yearsToDisplay);
            const newFromYear = this.fromYear.getFullYear() + rangeDistance * this.yearsToDisplay;
            this.fromYear = new Date(newFromYear, 0, 1);
            this.toYear = new Date(newFromYear + this.yearsToDisplay - 1, 0, 1);
            changed = true;
        }
        else if (this.compareAdapter.isAfter(this.fromYear, this.focusedDate)) {
            // Change window backwards
            const rangeDistance = Math.ceil(Math.abs(this.focusedDate.getFullYear() - this.fromYear.getFullYear()) / this.yearsToDisplay);
            const newFromYear = this.fromYear.getFullYear() - rangeDistance * this.yearsToDisplay;
            this.fromYear = new Date(newFromYear, 0, 1);
            this.toYear = new Date(newFromYear + this.yearsToDisplay - 1, 0, 1);
            changed = true;
        }
        this.disablePreviousButton = this.isPreviousButtonDisabled();
        this.disableNextButton = this.isNextButtonDisabled();
        if (changed) {
            this.yearRangeChange.emit([this.fromYear, this.toYear]);
        }
    }
    /**
     * Initialize view based on the focusedDate.
     */
    initView() {
        // Initial year limits
        this.initYearRange();
        this.yearCells = [];
        let row = [];
        // The cell date object needs to be the first to prevent that we jump to the next month when
        // setting the month. For example the focusedDate is 31. setting february would result in the
        // 3. March.
        const startDate = getFirstDateInYear(this.fromYear);
        const today$1 = today();
        for (let i = 0; i < this.yearsToDisplay; i++) {
            if (i > 0 && i % this.columnCount === 0) {
                this.yearCells.push(row);
                row = [];
            }
            const date = createDate(startDate);
            date.setFullYear(date.getFullYear() + i);
            const isToday = this.compareAdapter.isEqual(date, today$1);
            const isDisabled = !this.compareAdapter.isEqualOrBetween(date, this.minDate, this.maxDate);
            const year = date.getFullYear().toString();
            row.push({
                value: date.getDate(),
                disabled: isDisabled,
                ariaLabel: year,
                displayValue: year,
                isPreview: false,
                isToday,
                valueRaw: createDate(date),
                cssClasses: ['year', 'si-title-1']
            });
        }
        this.yearCells.push(row);
    }
    /**
     * Add offset to year and update focusedDate.
     * If the new year is outside min/max date the year will set to the closest year in range.
     */
    setYearOffset(offset) {
        const newActive = addYearsInRange(this.focusedDate, offset, this.minDate, this.maxDate);
        this.focusedDate = newActive;
        if (!this.fromYear || !isBetween(this.focusedDate, this.fromYear, this.toYear)) {
            // Re-calc years view
            this.initView();
        }
        this.cdRef.markForCheck();
    }
    /**
     * Indicate the previous button shall be disabled.
     * This happens when the lower window bound is equal or before the minDate.
     */
    isPreviousButtonDisabled() {
        if (!this.minDate) {
            return false;
        }
        return (this.compareAdapter.isEqual(this.fromYear, this.minDate) ||
            this.compareAdapter.isAfter(this.minDate, this.fromYear));
    }
    /**
     * Indicate the next button shall be disabled.
     * This happens when the upper window bound is equal or after the maxDate.
     */
    isNextButtonDisabled() {
        if (!this.maxDate) {
            return false;
        }
        return (this.compareAdapter.isEqual(this.toYear, this.maxDate) ||
            this.compareAdapter.isAfter(this.toYear, this.maxDate));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiYearSelectionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiYearSelectionComponent, selector: "si-year-selection", inputs: { minDate: "minDate", maxDate: "maxDate", selectedDate: "selectedDate", focusedDate: "focusedDate", previousLabel: "previousLabel", nextLabel: "nextLabel" }, outputs: { selectedValueChange: "selectedValueChange", yearRangeChange: "yearRangeChange" }, host: { listeners: { "keydown.Escape": "triggerEsc($event)" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"header\">\n  <si-calendar-direction-button\n    direction=\"left\"\n    [ariaLabel]=\"previousLabel\"\n    [disabled]=\"disablePreviousButton\"\n    (clicked)=\"changeVisibleYearRange(-1)\"\n  />\n  <span class=\"year-range-label flex-fill mx-4 si-title-1 text-secondary calendar-button\">\n    {{ fromYear! | date : 'YYYY' }} - {{ toYear! | date : 'YYYY' }}\n  </span>\n  <si-calendar-direction-button\n    direction=\"right\"\n    [ariaLabel]=\"nextLabel\"\n    [disabled]=\"disableNextButton\"\n    (clicked)=\"changeVisibleYearRange(1)\"\n  />\n</div>\n<table class=\"px-9 mt-6\" role=\"grid\">\n  <tbody\n    si-calendar-body\n    [focusedDate]=\"focusedDate\"\n    [compareAdapter]=\"compareAdapter\"\n    [startDate]=\"selectedDate\"\n    [enableRangeSelection]=\"false\"\n    [rows]=\"yearCells\"\n    (selectedValueChange)=\"emitSelectedValue($event)\"\n    (keydown)=\"calendarBodyKeyDown($event)\"\n  >\n  </tbody>\n</table>\n", dependencies: [{ kind: "component", type: SiCalendarBodyComponent, selector: "[si-calendar-body]", inputs: ["focusedDate", "startDate", "endDate", "rows", "rowLabels", "rowLabelCssClasses", "enableRangeSelection", "previewRange", "activeHover", "compareAdapter"], outputs: ["activeHoverChange", "selectedValueChange", "focusedDateChange"], exportAs: ["siCalendarBody"] }, { kind: "component", type: SiCalendarDirectionButtonComponent, selector: "si-calendar-direction-button", inputs: ["ariaLabel", "disabled", "direction"], outputs: ["clicked"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiYearSelectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-year-selection', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"header\">\n  <si-calendar-direction-button\n    direction=\"left\"\n    [ariaLabel]=\"previousLabel\"\n    [disabled]=\"disablePreviousButton\"\n    (clicked)=\"changeVisibleYearRange(-1)\"\n  />\n  <span class=\"year-range-label flex-fill mx-4 si-title-1 text-secondary calendar-button\">\n    {{ fromYear! | date : 'YYYY' }} - {{ toYear! | date : 'YYYY' }}\n  </span>\n  <si-calendar-direction-button\n    direction=\"right\"\n    [ariaLabel]=\"nextLabel\"\n    [disabled]=\"disableNextButton\"\n    (clicked)=\"changeVisibleYearRange(1)\"\n  />\n</div>\n<table class=\"px-9 mt-6\" role=\"grid\">\n  <tbody\n    si-calendar-body\n    [focusedDate]=\"focusedDate\"\n    [compareAdapter]=\"compareAdapter\"\n    [startDate]=\"selectedDate\"\n    [enableRangeSelection]=\"false\"\n    [rows]=\"yearCells\"\n    (selectedValueChange)=\"emitSelectedValue($event)\"\n    (keydown)=\"calendarBodyKeyDown($event)\"\n  >\n  </tbody>\n</table>\n" }]
        }], propDecorators: { minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], selectedDate: [{
                type: Input
            }], focusedDate: [{
                type: Input
            }], previousLabel: [{
                type: Input
            }], nextLabel: [{
                type: Input
            }], selectedValueChange: [{
                type: Output
            }], yearRangeChange: [{
                type: Output
            }], triggerEsc: [{
                type: HostListener,
                args: ['keydown.Escape', ['$event']]
            }] } });

class SiTimepickerComponent {
    /** @internal */
    invalidHours = false;
    /** @internal */
    invalidMinutes = false;
    /** @internal */
    invalidSeconds = false;
    /** @internal */
    invalidMilliseconds = false;
    /**
     * All input fields will be disabled if set to true.
     */
    disabled = false;
    hoursLabel = 'hh';
    minutesLabel = 'mm';
    secondsLabel = 'ss';
    millisecondsLabel = 'ms';
    hideLabels = false;
    hoursAriaLabel = $localize `:@@SI_DATEPICKER.HOURS:Hours`;
    minutesAriaLabel = $localize `:@@SI_DATEPICKER.MINUTES:Minutes`;
    secondsAriaLabel = $localize `:@@SI_DATEPICKER.SECONDS:Seconds`;
    millisecondsAriaLabel = $localize `:@@SI_DATEPICKER.MILLISECONDS:Milliseconds`;
    hoursPlaceholder = 'hh';
    minutesPlaceholder = 'mm';
    secondsPlaceholder = 'ss';
    millisecondsPlaceholder = 'ms';
    meridians;
    meridiansLabel = 'am/pm';
    meridiansAriaLabel = $localize `:@@SI_DATEPICKER.PERIOD:Period`;
    showMinutes = true;
    showSeconds = false;
    showMilliseconds = false;
    _showMeridian;
    get showMeridian() {
        if (this._showMeridian === undefined) {
            return !this.is24HoursLocale;
        }
        else {
            return this._showMeridian;
        }
    }
    set showMeridian(showMeridian) {
        this._showMeridian = showMeridian;
    }
    /**
     * A minimum time limit. The date part of the date object will be ignored.
     */
    min;
    /**
     * A maximum time limit. The date part of the date object will be ignored.
     */
    max;
    _readonly = false;
    get readonly() {
        return this._readonly;
    }
    /**
     * @defaultref {@link _readonly}
     */
    set readonly(value) {
        this._readonly = coerceBooleanProperty(value);
    }
    isValid = new EventEmitter();
    meridianChange = new EventEmitter();
    inputCompleted = new EventEmitter();
    inputParts;
    onChange = () => { };
    onTouched = () => { };
    // The following are the time values for the ui.
    hours = '';
    minutes = '';
    seconds = '';
    milliseconds = '';
    meridian = '';
    locale = inject(LOCALE_ID);
    cdRef = inject(ChangeDetectorRef);
    /**
     * Holds the time as date object that is presented by this control.
     */
    time;
    is24HoursLocale;
    periodDefaults;
    get periods() {
        return this.meridians?.length ? this.meridians : this.periodDefaults;
    }
    constructor() {
        const timeFormat = getLocaleTimeFormat(this.locale, FormatWidth.Full);
        this.is24HoursLocale = !timeFormat.includes('a');
        this.periodDefaults = getLocaleDayPeriods(this.locale, FormStyle.Format, TranslationWidth.Short).slice();
    }
    writeValue(obj) {
        if (this.isValidDate(obj)) {
            this.setTime(this.parseTime(obj));
        }
        else if (obj == null) {
            this.setTime();
        }
        if (obj) {
            this.isInputValid(this.hours, this.minutes, this.seconds, this.milliseconds, this.isPM());
        }
        this.cdRef.markForCheck();
    }
    /** @internal */
    isPM() {
        return !!this.showMeridian && this.meridian === 'pm';
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onTouch() {
        this.onTouched();
    }
    upDown(event) {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
            const key = event.target.name;
            this.changeTimeComponent(key, event.key === 'ArrowUp');
        }
    }
    trackByIndex = (index) => index;
    toHtmlInputElement = (target) => target;
    updateHours(value) {
        value = value.toString();
        if (this.hours !== value) {
            this.hours = value;
            const isValid = this.isHourInputValid(this.hours, this.isPM()) && this.isValidLimit();
            if (!isValid) {
                this.invalidHours = true;
                this.isValid.emit(false);
                this.onChange(null);
            }
            else {
                this.invalidHours = false;
                this.updateTime();
            }
        }
    }
    updateMinutes(value) {
        value = value.toString();
        if (this.minutes !== value) {
            this.minutes = value;
            const isValid = this.isMinuteInputValid(this.minutes) && this.isValidLimit();
            if (!isValid) {
                this.invalidMinutes = true;
                this.isValid.emit(false);
                this.onChange(null);
            }
            else {
                this.invalidMinutes = false;
                this.updateTime();
            }
        }
    }
    updateSeconds(value) {
        value = value.toString();
        if (this.seconds !== value) {
            this.seconds = value.toString();
            const isValid = this.isSecondInputValid(this.seconds) && this.isValidLimit();
            if (!isValid) {
                this.invalidSeconds = true;
                this.isValid.emit(false);
                this.onChange(null);
            }
            else {
                this.invalidSeconds = false;
                this.updateTime();
            }
        }
    }
    updateMilliseconds(value) {
        value = value.toString();
        if (this.milliseconds !== value) {
            this.milliseconds = value.toString();
            const isValid = this.isMillisecondInputValid(this.milliseconds) && this.isValidLimit();
            if (!isValid) {
                this.invalidMilliseconds = true;
                this.isValid.emit(false);
                this.onChange(null);
            }
            else {
                this.invalidMilliseconds = false;
                this.updateTime();
            }
        }
    }
    toggleMeridian() {
        if (!this.showMeridian) {
            return;
        }
        const time = this.changeTime(this.time, { hour: 12 });
        this.setTime(time);
    }
    /**
     * Takes the current UI values and updates the time object value
     * accordingly, if they UI input values are valid.
     */
    updateTime() {
        const minutes = this.showMinutes ? this.minutes : undefined;
        const seconds = this.showSeconds ? this.seconds : undefined;
        const milliseconds = this.showMilliseconds ? this.milliseconds : undefined;
        if (!this.isInputValid(this.hours, minutes, seconds, milliseconds, this.isPM())) {
            this.isValid.emit(false);
            this.onChange(null);
            return;
        }
        const time = this.createDateUpdate(this.time, {
            hour: this.hours,
            minute: this.minutes,
            seconds: this.seconds,
            milliseconds: this.milliseconds,
            isPM: this.isPM()
        });
        this.setTime(time);
    }
    /**
     * Sets a new time object as model value, updates the user interface
     * and invokes onChange to let timepicker clients know about the update.
     * @param time The new time to be set.
     */
    setTime(time) {
        if (this.time !== time) {
            this.time = time;
            this.updateUI(this.time);
            this.onChange(this.time);
        }
    }
    /**
     * Updates the user interface by filling the time components
     * into the time input fields. Sets empty values if the date
     * is undefined or invalid.
     *
     * @param value The date object or string from with the time components are taken.
     */
    updateUI(value) {
        if (!value || !this.isValidDate(value)) {
            this.hours = '';
            this.minutes = '';
            this.seconds = '';
            this.milliseconds = '';
            this.meridian = 'am';
            this.meridianChange.emit(this.meridian);
        }
        else {
            const time = this.parseTime(value);
            if (!time) {
                return;
            }
            let hours = time.getHours();
            if (this.showMeridian) {
                this.meridian = hours >= 12 ? 'pm' : 'am';
                this.meridianChange.emit(this.meridian);
                hours = hours % 12;
                if (hours === 0) {
                    hours = 12;
                }
            }
            this.hours = hours.toString().padStart(2, '0');
            this.minutes = time.getMinutes().toString().padStart(2, '0');
            this.seconds = time.getUTCSeconds().toString().padStart(2, '0');
            this.milliseconds = time.getUTCMilliseconds().toString().padStart(3, '0');
        }
    }
    isValidDate(value) {
        if (!value) {
            return false;
        }
        if (typeof value === 'string') {
            return this.isValidDate(new Date(value));
        }
        if (value instanceof Date && isNaN(value.getHours())) {
            return false;
        }
        return true;
    }
    parseTime(value) {
        if (typeof value === 'string') {
            return new Date(value);
        }
        return value;
    }
    parseHours(value, isPM = false) {
        const hour = this.toNumber(value);
        if (isNaN(hour) || hour < 0 || hour > (isPM ? 12 : 24)) {
            return NaN;
        }
        return hour;
    }
    parseMinutes(value) {
        const minute = this.toNumber(value);
        if (isNaN(minute) || minute < 0 || minute > 60) {
            return NaN;
        }
        return minute;
    }
    parseSeconds(value) {
        const seconds = this.toNumber(value);
        if (isNaN(seconds) || seconds < 0 || seconds > 60) {
            return NaN;
        }
        return seconds;
    }
    parseMilliseconds(value) {
        const milliseconds = this.toNumber(value);
        if (isNaN(milliseconds) || milliseconds < 0 || milliseconds > 1000) {
            return NaN;
        }
        return milliseconds;
    }
    createDateUpdate(date, time) {
        let hour = this.parseHours(time.hour);
        const minute = this.parseMinutes(time.minute);
        const seconds = this.parseSeconds(time.seconds) || 0;
        const milliseconds = this.parseMilliseconds(time.milliseconds) || 0;
        if (time.isPM && hour !== 12) {
            hour += 12;
        }
        if (!date) {
            if (!isNaN(hour) && !isNaN(minute)) {
                return createDate(new Date(), hour, minute, seconds, milliseconds);
            }
            else {
                return date;
            }
        }
        else if (isNaN(hour) || isNaN(minute)) {
            return date;
        }
        else {
            return createDate(date, hour, minute, seconds, milliseconds);
        }
    }
    toNumber(value) {
        if (typeof value === 'undefined') {
            return NaN;
        }
        else if (typeof value === 'number') {
            return value;
        }
        return parseInt(value, 10);
    }
    isInputValid(hours, minutes = '0', seconds = '0', milliseconds = '0', isPM) {
        if (!this.isValidLimit()) {
            this.invalidHours = true;
            this.invalidMinutes = true;
            this.invalidSeconds = true;
            this.invalidMilliseconds = true;
        }
        else {
            this.invalidHours = !this.isHourInputValid(hours, isPM);
            this.invalidMinutes = !this.isMinuteInputValid(minutes);
            this.invalidSeconds = !this.isSecondInputValid(seconds);
            this.invalidMilliseconds = !this.isMillisecondInputValid(milliseconds);
        }
        return (!this.invalidHours &&
            !this.invalidMinutes &&
            !this.invalidSeconds &&
            !this.invalidMilliseconds);
    }
    isHourInputValid(hours, isPM) {
        return !isNaN(this.parseHours(hours, isPM));
    }
    isMinuteInputValid(minutes) {
        return !isNaN(this.parseMinutes(minutes));
    }
    isSecondInputValid(seconds) {
        return !isNaN(this.parseSeconds(seconds));
    }
    isMillisecondInputValid(milliseconds) {
        return !isNaN(this.parseMilliseconds(milliseconds));
    }
    isValidLimit() {
        const refDate = new Date();
        const newDate = this.createDateUpdate(refDate, {
            hour: this.hours,
            minute: this.minutes,
            seconds: this.seconds,
            milliseconds: this.milliseconds,
            isPM: this.isPM()
        });
        if (!newDate) {
            return false;
        }
        let refMax;
        if (this.max) {
            refMax = new Date(refDate);
            refMax.setHours(this.max.getHours());
            refMax.setMinutes(this.max.getMinutes());
            refMax.setSeconds(this.max.getSeconds());
            refMax.setMilliseconds(this.max.getMilliseconds());
        }
        let refMin;
        if (this.min) {
            refMin = new Date(refDate);
            refMin.setHours(this.min.getHours());
            refMin.setMinutes(this.min.getMinutes());
            refMin.setSeconds(this.min.getSeconds());
            refMin.setMilliseconds(this.min.getMilliseconds());
        }
        if (refMax && newDate > refMax) {
            return false;
        }
        else if (refMin && newDate < refMin) {
            return false;
        }
        return true;
    }
    changeTimeComponent(key, up) {
        const change = up ? 1 : -1;
        const date = this.createDateUpdate(new Date(), {
            hour: this.hours,
            minute: this.minutes,
            seconds: this.seconds,
            milliseconds: this.milliseconds,
            isPM: this.isPM()
        });
        switch (key) {
            case 'hours': {
                const newTime = this.changeTime(date, { hour: change });
                let hour = newTime.getHours();
                if (this.showMeridian) {
                    hour = hour % 12;
                    if (hour === 0 && !this.isPM()) {
                        hour = 12;
                    }
                    else if (hour === 0 && this.isPM()) {
                        this.toggleMeridian();
                    }
                }
                this.updateHours(hour);
                break;
            }
            case 'minutes': {
                const newTime = this.changeTime(date, { minute: change });
                this.updateMinutes(newTime.getMinutes());
                break;
            }
            case 'seconds': {
                const newTime = this.changeTime(date, { seconds: change });
                this.updateSeconds(newTime.getSeconds());
                break;
            }
            case 'milliseconds': {
                const newTime = this.changeTime(date, { milliseconds: change });
                this.updateMilliseconds(newTime.getMilliseconds());
                break;
            }
            default:
                break;
        }
    }
    changeTime(value, diff) {
        if (!value) {
            return this.changeTime(createDate(new Date(), 0, 0, 0, 0), diff);
        }
        if (!diff) {
            return value;
        }
        let hour = value.getHours();
        let minutes = value.getMinutes();
        let seconds = value.getSeconds();
        let milliseconds = value.getMilliseconds();
        if (diff.hour) {
            hour = hour + this.toNumber(diff.hour);
        }
        if (diff.minute) {
            minutes = minutes + this.toNumber(diff.minute);
        }
        if (diff.seconds) {
            seconds = seconds + this.toNumber(diff.seconds);
        }
        if (diff.milliseconds) {
            milliseconds = milliseconds + this.toNumber(diff.milliseconds);
        }
        return createDate(value, hour, minutes, seconds, milliseconds);
    }
    /**
     * Focuses the next available input/select field or emit inputCompleted event.
     */
    focusNext(event) {
        const target = event.target;
        if (!target) {
            return;
        }
        const targets = this.inputParts?.toArray();
        const position = targets?.findIndex(t => t.nativeElement === target);
        if (position === undefined || position === -1) {
            return;
        }
        if (position < targets.length - 1) {
            targets[position + 1].nativeElement.focus();
        }
        else {
            this.inputCompleted.emit();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTimepickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiTimepickerComponent, selector: "si-timepicker", inputs: { disabled: "disabled", hoursLabel: "hoursLabel", minutesLabel: "minutesLabel", secondsLabel: "secondsLabel", millisecondsLabel: "millisecondsLabel", hideLabels: "hideLabels", hoursAriaLabel: "hoursAriaLabel", minutesAriaLabel: "minutesAriaLabel", secondsAriaLabel: "secondsAriaLabel", millisecondsAriaLabel: "millisecondsAriaLabel", hoursPlaceholder: "hoursPlaceholder", minutesPlaceholder: "minutesPlaceholder", secondsPlaceholder: "secondsPlaceholder", millisecondsPlaceholder: "millisecondsPlaceholder", meridians: "meridians", meridiansLabel: "meridiansLabel", meridiansAriaLabel: "meridiansAriaLabel", showMinutes: "showMinutes", showSeconds: "showSeconds", showMilliseconds: "showMilliseconds", showMeridian: "showMeridian", min: "min", max: "max", readonly: "readonly" }, outputs: { isValid: "isValid", meridianChange: "meridianChange", inputCompleted: "inputCompleted" }, host: { listeners: { "blur": "onTouch()" }, properties: { "class.readonly": "this._readonly" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: SiTimepickerComponent,
                multi: true
            }
        ], viewQueries: [{ propertyName: "inputParts", predicate: ["inputPart"], descendants: true }], ngImport: i0, template: "<div class=\"d-flex flex-row flex-wrap\">\n  <label class=\"min-width\">\n    <span *ngIf=\"!hideLabels\" class=\"form-label\">{{ (hoursLabel | translate) || '&nbsp;' }}</span>\n    <input\n      #inputPart\n      type=\"text\"\n      inputmode=\"numeric\"\n      pattern=\"2[0-4]|[01]?[0-9]\"\n      class=\"form-control\"\n      name=\"hours\"\n      maxlength=\"2\"\n      autocomplete=\"off\"\n      [attr.aria-label]=\"hoursAriaLabel | translate\"\n      [class.is-invalid]=\"invalidHours\"\n      [disabled]=\"disabled\"\n      [readonly]=\"readonly\"\n      [placeholder]=\"hoursPlaceholder\"\n      [value]=\"hours\"\n      (change)=\"updateHours(toHtmlInputElement($event.target).value)\"\n      (blur)=\"updateHours(toHtmlInputElement($event.target).value)\"\n      (keydown)=\"upDown($event)\"\n      (keydown.enter)=\"focusNext($event)\"\n    />\n  </label>\n\n  <ng-container *ngIf=\"showMinutes\">\n    <ng-container *ngTemplateOutlet=\"separator\"></ng-container>\n    <label class=\"min-width\">\n      <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n        (minutesLabel | translate) || '&nbsp;'\n      }}</span>\n      <input\n        #inputPart\n        type=\"text\"\n        inputmode=\"numeric\"\n        pattern=\"[0-5]?[0-9]\"\n        class=\"form-control\"\n        name=\"minutes\"\n        maxlength=\"2\"\n        autocomplete=\"off\"\n        [attr.aria-label]=\"minutesAriaLabel | translate\"\n        [class.is-invalid]=\"invalidMinutes\"\n        [disabled]=\"disabled\"\n        [readonly]=\"readonly\"\n        [placeholder]=\"minutesPlaceholder\"\n        [value]=\"minutes\"\n        (change)=\"updateMinutes(toHtmlInputElement($event.target).value)\"\n        (blur)=\"updateMinutes(toHtmlInputElement($event.target).value)\"\n        (keydown)=\"upDown($event)\"\n        (keydown.enter)=\"focusNext($event)\"\n      />\n    </label>\n  </ng-container>\n\n  <ng-container *ngIf=\"showSeconds\">\n    <ng-container *ngTemplateOutlet=\"separator\"></ng-container>\n    <label class=\"min-width\">\n      <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n        (secondsLabel | translate) || '&nbsp;'\n      }}</span>\n      <input\n        #inputPart\n        type=\"text\"\n        inputmode=\"numeric\"\n        pattern=\"[0-5]?[0-9]\"\n        class=\"form-control\"\n        name=\"seconds\"\n        maxlength=\"2\"\n        autocomplete=\"off\"\n        [attr.aria-label]=\"secondsAriaLabel | translate\"\n        [class.is-invalid]=\"invalidSeconds\"\n        [disabled]=\"disabled\"\n        [readonly]=\"readonly\"\n        [placeholder]=\"secondsPlaceholder\"\n        [value]=\"seconds\"\n        (change)=\"updateSeconds(toHtmlInputElement($event.target).value)\"\n        (blur)=\"updateSeconds(toHtmlInputElement($event.target).value)\"\n        (keydown)=\"upDown($event)\"\n        (keydown.enter)=\"focusNext($event)\"\n      />\n    </label>\n  </ng-container>\n\n  <ng-container *ngIf=\"showMilliseconds\">\n    <ng-container *ngTemplateOutlet=\"separator; context: { separator: '.' }\"></ng-container>\n    <label class=\"min-width\">\n      <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n        (millisecondsLabel | translate) || '&nbsp;'\n      }}</span>\n      <input\n        #inputPart\n        type=\"text\"\n        inputmode=\"numeric\"\n        pattern=\"[0-9]{1,3}\"\n        class=\"form-control\"\n        name=\"milliseconds\"\n        maxlength=\"3\"\n        autocomplete=\"off\"\n        [attr.aria-label]=\"millisecondsAriaLabel | translate\"\n        [class.is-invalid]=\"invalidMilliseconds\"\n        [disabled]=\"disabled\"\n        [readonly]=\"readonly\"\n        [placeholder]=\"millisecondsPlaceholder\"\n        [value]=\"milliseconds\"\n        (change)=\"updateMilliseconds(toHtmlInputElement($event.target).value)\"\n        (blur)=\"updateMilliseconds(toHtmlInputElement($event.target).value)\"\n        (keydown)=\"upDown($event)\"\n        (keydown.enter)=\"focusNext($event)\"\n      />\n    </label>\n  </ng-container>\n\n  <label *ngIf=\"showMeridian\" class=\"ms-2\">\n    <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n      (meridiansLabel | translate) || '&nbsp;'\n    }}</span>\n    <select\n      #inputPart\n      class=\"form-control\"\n      [attr.aria-label]=\"meridiansAriaLabel | translate\"\n      [disabled]=\"disabled || readonly\"\n      (change)=\"toggleMeridian()\"\n      (keydown.enter)=\"focusNext($event)\"\n    >\n      <option value=\"am\" [selected]=\"meridian === 'am'\">{{ periods[0] }}</option>\n      <option value=\"pm\" [selected]=\"meridian === 'pm'\">{{ periods[1] }}</option>\n    </select>\n  </label>\n</div>\n\n<ng-template #separator let-separator=\"separator\">\n  <div class=\"align-self-end pb-3 px-1\" aria-hidden=\"true\">{{ separator ? separator : ':' }}</div>\n</ng-template>\n", styles: [":host{display:block}.min-width{inline-size:100%;max-inline-size:45px;min-inline-size:35px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$a.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2$a.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTimepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-timepicker', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SiTimepickerComponent,
                            multi: true
                        }
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex flex-row flex-wrap\">\n  <label class=\"min-width\">\n    <span *ngIf=\"!hideLabels\" class=\"form-label\">{{ (hoursLabel | translate) || '&nbsp;' }}</span>\n    <input\n      #inputPart\n      type=\"text\"\n      inputmode=\"numeric\"\n      pattern=\"2[0-4]|[01]?[0-9]\"\n      class=\"form-control\"\n      name=\"hours\"\n      maxlength=\"2\"\n      autocomplete=\"off\"\n      [attr.aria-label]=\"hoursAriaLabel | translate\"\n      [class.is-invalid]=\"invalidHours\"\n      [disabled]=\"disabled\"\n      [readonly]=\"readonly\"\n      [placeholder]=\"hoursPlaceholder\"\n      [value]=\"hours\"\n      (change)=\"updateHours(toHtmlInputElement($event.target).value)\"\n      (blur)=\"updateHours(toHtmlInputElement($event.target).value)\"\n      (keydown)=\"upDown($event)\"\n      (keydown.enter)=\"focusNext($event)\"\n    />\n  </label>\n\n  <ng-container *ngIf=\"showMinutes\">\n    <ng-container *ngTemplateOutlet=\"separator\"></ng-container>\n    <label class=\"min-width\">\n      <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n        (minutesLabel | translate) || '&nbsp;'\n      }}</span>\n      <input\n        #inputPart\n        type=\"text\"\n        inputmode=\"numeric\"\n        pattern=\"[0-5]?[0-9]\"\n        class=\"form-control\"\n        name=\"minutes\"\n        maxlength=\"2\"\n        autocomplete=\"off\"\n        [attr.aria-label]=\"minutesAriaLabel | translate\"\n        [class.is-invalid]=\"invalidMinutes\"\n        [disabled]=\"disabled\"\n        [readonly]=\"readonly\"\n        [placeholder]=\"minutesPlaceholder\"\n        [value]=\"minutes\"\n        (change)=\"updateMinutes(toHtmlInputElement($event.target).value)\"\n        (blur)=\"updateMinutes(toHtmlInputElement($event.target).value)\"\n        (keydown)=\"upDown($event)\"\n        (keydown.enter)=\"focusNext($event)\"\n      />\n    </label>\n  </ng-container>\n\n  <ng-container *ngIf=\"showSeconds\">\n    <ng-container *ngTemplateOutlet=\"separator\"></ng-container>\n    <label class=\"min-width\">\n      <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n        (secondsLabel | translate) || '&nbsp;'\n      }}</span>\n      <input\n        #inputPart\n        type=\"text\"\n        inputmode=\"numeric\"\n        pattern=\"[0-5]?[0-9]\"\n        class=\"form-control\"\n        name=\"seconds\"\n        maxlength=\"2\"\n        autocomplete=\"off\"\n        [attr.aria-label]=\"secondsAriaLabel | translate\"\n        [class.is-invalid]=\"invalidSeconds\"\n        [disabled]=\"disabled\"\n        [readonly]=\"readonly\"\n        [placeholder]=\"secondsPlaceholder\"\n        [value]=\"seconds\"\n        (change)=\"updateSeconds(toHtmlInputElement($event.target).value)\"\n        (blur)=\"updateSeconds(toHtmlInputElement($event.target).value)\"\n        (keydown)=\"upDown($event)\"\n        (keydown.enter)=\"focusNext($event)\"\n      />\n    </label>\n  </ng-container>\n\n  <ng-container *ngIf=\"showMilliseconds\">\n    <ng-container *ngTemplateOutlet=\"separator; context: { separator: '.' }\"></ng-container>\n    <label class=\"min-width\">\n      <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n        (millisecondsLabel | translate) || '&nbsp;'\n      }}</span>\n      <input\n        #inputPart\n        type=\"text\"\n        inputmode=\"numeric\"\n        pattern=\"[0-9]{1,3}\"\n        class=\"form-control\"\n        name=\"milliseconds\"\n        maxlength=\"3\"\n        autocomplete=\"off\"\n        [attr.aria-label]=\"millisecondsAriaLabel | translate\"\n        [class.is-invalid]=\"invalidMilliseconds\"\n        [disabled]=\"disabled\"\n        [readonly]=\"readonly\"\n        [placeholder]=\"millisecondsPlaceholder\"\n        [value]=\"milliseconds\"\n        (change)=\"updateMilliseconds(toHtmlInputElement($event.target).value)\"\n        (blur)=\"updateMilliseconds(toHtmlInputElement($event.target).value)\"\n        (keydown)=\"upDown($event)\"\n        (keydown.enter)=\"focusNext($event)\"\n      />\n    </label>\n  </ng-container>\n\n  <label *ngIf=\"showMeridian\" class=\"ms-2\">\n    <span *ngIf=\"!hideLabels\" class=\"form-label\">{{\n      (meridiansLabel | translate) || '&nbsp;'\n    }}</span>\n    <select\n      #inputPart\n      class=\"form-control\"\n      [attr.aria-label]=\"meridiansAriaLabel | translate\"\n      [disabled]=\"disabled || readonly\"\n      (change)=\"toggleMeridian()\"\n      (keydown.enter)=\"focusNext($event)\"\n    >\n      <option value=\"am\" [selected]=\"meridian === 'am'\">{{ periods[0] }}</option>\n      <option value=\"pm\" [selected]=\"meridian === 'pm'\">{{ periods[1] }}</option>\n    </select>\n  </label>\n</div>\n\n<ng-template #separator let-separator=\"separator\">\n  <div class=\"align-self-end pb-3 px-1\" aria-hidden=\"true\">{{ separator ? separator : ':' }}</div>\n</ng-template>\n", styles: [":host{display:block}.min-width{inline-size:100%;max-inline-size:45px;min-inline-size:35px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { disabled: [{
                type: Input
            }], hoursLabel: [{
                type: Input
            }], minutesLabel: [{
                type: Input
            }], secondsLabel: [{
                type: Input
            }], millisecondsLabel: [{
                type: Input
            }], hideLabels: [{
                type: Input
            }], hoursAriaLabel: [{
                type: Input
            }], minutesAriaLabel: [{
                type: Input
            }], secondsAriaLabel: [{
                type: Input
            }], millisecondsAriaLabel: [{
                type: Input
            }], hoursPlaceholder: [{
                type: Input
            }], minutesPlaceholder: [{
                type: Input
            }], secondsPlaceholder: [{
                type: Input
            }], millisecondsPlaceholder: [{
                type: Input
            }], meridians: [{
                type: Input
            }], meridiansLabel: [{
                type: Input
            }], meridiansAriaLabel: [{
                type: Input
            }], showMinutes: [{
                type: Input
            }], showSeconds: [{
                type: Input
            }], showMilliseconds: [{
                type: Input
            }], showMeridian: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], _readonly: [{
                type: HostBinding,
                args: ['class.readonly']
            }], readonly: [{
                type: Input
            }], isValid: [{
                type: Output
            }], meridianChange: [{
                type: Output
            }], inputCompleted: [{
                type: Output
            }], inputParts: [{
                type: ViewChildren,
                args: ['inputPart']
            }], onTouch: [{
                type: HostListener,
                args: ['blur']
            }] } });

let idCounter$1 = 1;
class SiDatepickerComponent {
    /**
     * The date which is currently focused
     * Compare to the selected date or range the calendar requires to have one element to focus.
     */
    focusedDate;
    /**
     * The selected date of the datepicker. Use for
     * initialization and for bidirectional binding.
     */
    date;
    /**
     * The selected date range of the datepicker. Use for
     * initialization and for bidirectional binding.
     */
    dateRange;
    /** Set initial focus to calendar body. */
    initialFocus = false;
    /**
     * Emits the new value of `date` whenever its value changes.
     */
    dateChange = new EventEmitter();
    /**
     * Emits the new value of `dateRange` whenever its value changes.
     */
    dateRangeChange = new EventEmitter();
    /**
     * Emits an event to notify about disabling the time from the datepicker.
     * When time is disable, we construct a pure date object in UTC 00:00:00 time.
     */
    disabledTimeChange = new EventEmitter();
    /**
     * Object to configure the datepicker.
     */
    config = {};
    /**
     * Aria label for the previous button. Needed for a11y.
     */
    previousLabel = $localize `:@@SI_DATEPICKER.PREVIOUS:Previous`;
    /**
     * Aria label for the next button. Needed for a11y.
     */
    nextLabel = $localize `:@@SI_DATEPICKER.NEXT:Next`;
    /** Aria label for week number column */
    calenderWeekLabel = $localize `:@@SI_DATEPICKER.CALENDAR_WEEK_LABEL:Calendar week`;
    /**
     * Enable/disable 12H mode in timepicker. Defaults to locale
     */
    time12h;
    /**
     * Use this to force date range operation to select either start date or end date.
     */
    rangeType = 'START';
    get startDate() {
        return this.config.enableDateRange ? this.dateRange?.start : this.date;
    }
    defaultDisabledTimeText = $localize `:@@SI_DATEPICKER.DISABLED_TIME_TEXT:Ignore time`;
    defaultEnableTimeText = $localize `:@@SI_DATEPICKER.ENABLED_TIME_TEXT:Consider time`;
    get includeTimeLabel() {
        return this.disabledTime
            ? this.config.disabledTimeText ?? this.defaultDisabledTimeText
            : this.config.enabledTimeText ?? this.defaultEnableTimeText;
    }
    get weekStartDay() {
        return this.config.weekStartDay ?? this.localeWeekStart;
    }
    get hideWeekNumbers() {
        return this.config.hideWeekNumbers ?? false;
    }
    get disabledTime() {
        return this.config.disabledTime ?? false;
    }
    /**
     * The active view
     */
    view = 'week';
    months = [];
    switchId = `__si-datepicker-switch-id-${idCounter$1++}`;
    locale = inject(LOCALE_ID);
    cdRef = inject(ChangeDetectorRef);
    localeWeekStart;
    /**
     * Date object to track and change the time. Keeping time and date
     * in separate objects to not change the date when flipping time.
     * After change, a new date object is created with an adapted time.
     */
    time;
    /**
     * Used to hold the last time when setting the time to disabled.
     * Value will be reset on enabling the time again.
     */
    previousTime;
    timePicker;
    /** Reference to the current day selection component. Shown when view === 'week' */
    daySelection;
    /** Reference to the current month selection component. Shown when view === 'month' */
    monthSelection;
    /** Reference to the current year selection component. Shown when view === 'year' */
    yearSelection;
    constructor() {
        this.initCalendarLabels();
        this.focusedDate = today();
        const weekStart = getLocaleFirstDayOfWeek(this.locale);
        this.localeWeekStart =
            weekStart === WeekDay.Sunday
                ? 'sunday'
                : weekStart === WeekDay.Saturday
                    ? 'saturday'
                    : 'monday';
    }
    ngAfterViewInit() {
        // After the view is created the first time we want that the children components set
        // the focus to the calendarBody. Means when we select a date in month-selection,
        // the day selection shall focus automatically the day in calendarBody.
        setTimeout(() => (this.initialFocus = true));
    }
    ngOnInit() {
        if (this.config.enableDateRange && this.rangeType === 'END' && this.dateRange?.end) {
            // The user chose to trigger the datepicker from the date-range end, in this
            // case we
            this.focusedDate = this.dateRange?.end;
        }
        else {
            this.focusedDate = getDateSameOrBetween(this.startDate ?? this.focusedDate, this.config.minDate, this.config.maxDate);
        }
    }
    ngOnChanges(changes) {
        if (changes.date && !this.config.enableDateRange) {
            if (this.date && !isValid(this.date)) {
                this.date = undefined;
            }
            if (this.date) {
                this.focusedDate = this.date;
                if (changes.date.isFirstChange()) {
                    this.previousTime = new Date(this.date);
                    this.time = this.date;
                }
                if (this.time?.getTime() !== this.date?.getTime()) {
                    this.time = this.date;
                }
            }
        }
        if (changes.config) {
            this.config.minDate = getMinDate(changes.config.currentValue?.minDate);
            this.config.maxDate = getMaxDate(changes.config.currentValue?.maxDate);
            const disabledChange = !!changes.config.previousValue?.disabledTime !== this.disabledTime;
            if (disabledChange) {
                this.onDisabledTimeChanged();
            }
        }
        // Date-range input field has changed
        if (changes.dateRange) {
            const previous = changes.dateRange.previousValue;
            if (this.dateRange?.end && !isSameDate(this.dateRange?.end, previous?.end)) {
                this.focusedDate = this.dateRange?.end;
            }
            if (this.dateRange?.start && !isSameDate(this.dateRange?.start, previous?.start)) {
                this.focusedDate = this.dateRange?.start;
            }
        }
        // Ensure we set the focused date based on the input which is currently visible
        if (changes.rangeType) {
            if (this.rangeType === 'END' && this.dateRange?.end) {
                this.focusedDate = this.dateRange.end;
            }
            else if (this.rangeType === 'START' && this.dateRange?.start) {
                this.focusedDate = this.dateRange.start;
            }
        }
    }
    /** Initialize day and month labels */
    initCalendarLabels() {
        this.months = Object.assign([], getLocaleMonthNames(this.locale, FormStyle.Format, TranslationWidth.Wide));
    }
    setDate(date) {
        const dateWithoutTime = getDateWithoutTime(date);
        const validForMinDate = !(this.config?.minDate && dateWithoutTime < getDateWithoutTime(this.config.minDate));
        const validForMaxDate = !(this.config?.maxDate && dateWithoutTime > getDateWithoutTime(this.config.maxDate));
        if (this.date !== date && validForMinDate && validForMaxDate) {
            const previousValue = this.date;
            this.date = date;
            // eslint-disable-next-line @angular-eslint/no-lifecycle-call
            this.ngOnChanges({
                date: new SimpleChange(previousValue, this.date, previousValue === undefined)
            });
            this.dateChange.next(this.date);
        }
        else if (!validForMinDate || !validForMaxDate) {
            // eslint-disable-next-line @angular-eslint/no-lifecycle-call
            this.ngOnChanges({ date: new SimpleChange(undefined, this.date, true) });
        }
        if (this.config.enableTimeValidation &&
            this.timePicker &&
            (this.config.minDate || this.config.maxDate)) {
            this.validateTime(date);
        }
        this.cdRef.markForCheck();
    }
    dateSelected(day) {
        const selectedDateWithoutTime = getDateWithoutTime(day);
        const isValidRange = isSameOrBetween(selectedDateWithoutTime, this.config?.minDate, this.config?.maxDate);
        if (!isValidRange) {
            return;
        }
        const date = createDate(day, this.time?.getHours(), this.time?.getMinutes(), this.time?.getSeconds(), this.time?.getMilliseconds());
        if (!this.config.enableDateRange) {
            this.setDate(date);
        }
        else {
            // eslint-disable-next-line max-len
            if ((!this.dateRange?.start && this.rangeType !== 'END') ||
                (this.dateRange?.start && this.dateRange.end && this.rangeType !== 'END')) {
                this.setDateRange({
                    start: date,
                    end: undefined
                });
            }
            else if (this.rangeType === 'END' || (this.dateRange?.start && !this.dateRange.end)) {
                this.setDateRange({
                    start: this.dateRange?.start,
                    end: date
                });
                this.rangeType = undefined;
            }
        }
    }
    setDateRange(dtRange) {
        if (dtRange.start && dtRange.end && dtRange.end < dtRange.start) {
            // The user selected a date before the current range start in this is used as new start
            this.dateRange = { start: dtRange.end, end: undefined };
            this.rangeType = 'START'; // Switch back to start so that the next selection is end
        }
        else {
            this.dateRange = dtRange;
        }
        // Toggle rangeType every time the user used the datepicker to change the range
        const previousType = this.rangeType;
        this.rangeType = !this.rangeType || this.rangeType === 'START' ? 'END' : 'START';
        // Reset end range when we started start
        if (previousType === 'START' && this.dateRange.end) {
            this.dateRange.end = undefined;
        }
        this.dateRangeChange.next(this.dateRange);
    }
    timeSelected(newTime) {
        if (!newTime) {
            return;
        }
        if (this.time?.getTime() !== newTime.getTime()) {
            this.previousTime = this.time;
            this.time = newTime;
            let newDate;
            if (this.disabledTime) {
                // if time is disabled, ensure that 00:00:00 is displayed in any timezone
                newDate = createDate(this.date);
                this.time = newDate;
            }
            else {
                newDate = createDate(this.date, this.time.getHours(), this.time.getMinutes(), this.time.getSeconds(), this.time.getMilliseconds());
            }
            this.dateSelected(newDate);
        }
        else {
            this.validateTime(newTime);
        }
    }
    toggleDisabledTime() {
        this.config.disabledTime = !this.disabledTime;
        this.onDisabledTimeChanged();
    }
    onDisabledTimeChanged() {
        if (this.disabledTime) {
            const newTime = new Date(Date.UTC(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), 0, 0, 0, 0));
            this.timeSelected(newTime);
        }
        else if (this.previousTime) {
            this.timeSelected(this.previousTime);
        }
        else {
            this.timeSelected(new Date());
        }
        this.disabledTimeChange.next(this.disabledTime);
    }
    validateTime(date) {
        if (!this.disabledTime &&
            ((this.config.minDate && date < this.config.minDate) ||
                (this.config.maxDate && date > this.config.maxDate))) {
            // wait for a cycle to initialize timepicker
            setTimeout(() => {
                this.timePicker.invalidHours = this.timePicker.invalidMinutes = true;
                this.timePicker.invalidSeconds = this.timePicker.invalidMilliseconds = true;
                this.cdRef.markForCheck();
            });
        }
        else {
            this.timePicker.invalidHours = this.timePicker.invalidMinutes = false;
            this.timePicker.invalidSeconds = this.timePicker.invalidMilliseconds = false;
        }
    }
    /**
     * Get the current shown view.
     */
    getActiveView() {
        switch (this.view) {
            case 'month':
                return this.monthSelection;
            case 'year':
                return this.yearSelection;
            default:
                return this.daySelection;
        }
    }
    switchView(newView) {
        this.view = newView;
        this.cdRef.markForCheck();
    }
    /**
     * Handle selection in the day view.
     * @param selection selected date.
     */
    selectionChange(selection) {
        if (this.config.enableDateRange) {
            const range = !this.rangeType || this.rangeType === 'START'
                ? { start: selection, end: undefined }
                : { start: this.dateRange?.start, end: selection };
            this.setDateRange(range);
        }
        else {
            this.focusedDate = selection;
            const newDate = createDate(selection, this.time?.getHours(), this.time?.getMinutes(), this.time?.getSeconds(), this.time?.getMilliseconds());
            this.setDate(newDate);
        }
    }
    /**
     * Handle month/year changes
     * @param selection the selected month or null of cancelled.
     */
    activeMonthChange(selection) {
        if (selection) {
            this.focusedDate = changeDay(selection, this.focusedDate.getDate());
            this.cdRef.markForCheck();
        }
        this.switchView('week');
    }
    /**
     * Handle year changes
     * @param selection the selected year or null of cancelled.
     */
    activeYearChange(selection) {
        if (selection) {
            selection.setMonth(this.focusedDate.getMonth());
            this.focusedDate = changeDay(selection, this.focusedDate.getDate());
        }
        this.switchView('week');
    }
    /**
     * Focus the active cell in view.
     * The function is required to transfer the focus from input to the active date cell.
     */
    focusActiveCell() {
        this.getActiveView()?.focusActiveCell();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiDatepickerComponent, selector: "si-datepicker", inputs: { focusedDate: "focusedDate", date: "date", dateRange: "dateRange", initialFocus: "initialFocus", config: "config", previousLabel: "previousLabel", nextLabel: "nextLabel", calenderWeekLabel: "calenderWeekLabel", time12h: "time12h", rangeType: "rangeType" }, outputs: { dateChange: "dateChange", dateRangeChange: "dateRangeChange", disabledTimeChange: "disabledTimeChange" }, viewQueries: [{ propertyName: "timePicker", first: true, predicate: ["timePicker"], descendants: true }, { propertyName: "daySelection", first: true, predicate: SiDaySelectionComponent, descendants: true }, { propertyName: "monthSelection", first: true, predicate: SiMonthSelectionComponent, descendants: true }, { propertyName: "yearSelection", first: true, predicate: SiYearSelectionComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"text-center pb-6\" [ngSwitch]=\"view\">\n  <si-year-selection\n    *ngSwitchCase=\"'year'\"\n    [focusedDate]=\"focusedDate\"\n    [selectedDate]=\"startDate\"\n    [minDate]=\"config.minDate\"\n    [maxDate]=\"config.maxDate\"\n    [previousLabel]=\"previousLabel | translate\"\n    [nextLabel]=\"nextLabel | translate\"\n    (selectedValueChange)=\"activeYearChange($event)\"\n  ></si-year-selection>\n  <si-month-selection\n    *ngSwitchCase=\"'month'\"\n    [startDate]=\"startDate\"\n    [months]=\"months\"\n    [minDate]=\"config.minDate\"\n    [maxDate]=\"config.maxDate\"\n    [previousLabel]=\"previousLabel | translate\"\n    [nextLabel]=\"nextLabel | translate\"\n    [(focusedDate)]=\"focusedDate\"\n    (selectedValueChange)=\"activeMonthChange($event)\"\n    (viewChange)=\"switchView($event)\"\n  ></si-month-selection>\n  <si-day-selection\n    *ngSwitchCase=\"'week'\"\n    [initialFocus]=\"initialFocus\"\n    [startDate]=\"startDate\"\n    [endDate]=\"dateRange?.end\"\n    [isRangeSelection]=\"config.enableDateRange!\"\n    [previewRange]=\"rangeType === 'END'\"\n    [hideWeekNumbers]=\"hideWeekNumbers\"\n    [minDate]=\"config.minDate\"\n    [maxDate]=\"config.maxDate\"\n    [weekStartDay]=\"weekStartDay\"\n    [calenderWeekLabel]=\"calenderWeekLabel\"\n    [months]=\"months\"\n    [previousLabel]=\"previousLabel | translate\"\n    [nextLabel]=\"nextLabel | translate\"\n    [todayLabel]=\"config.todayText\"\n    [(focusedDate)]=\"focusedDate\"\n    (selectedValueChange)=\"selectionChange($event)\"\n    (viewChange)=\"switchView($event)\"\n  ></si-day-selection>\n</div>\n<div\n  *ngIf=\"this.config.showTime && (!this.config.enableDateRange ?? false)\"\n  class=\"border-top pt-6\"\n>\n  <div class=\"px-9 pb-6\">\n    <div *ngIf=\"!config.mandatoryTime ?? false\" class=\"mb-5 form-switch\">\n      <input\n        type=\"checkbox\"\n        class=\"form-check-input\"\n        role=\"switch\"\n        [id]=\"switchId\"\n        [checked]=\"!disabledTime\"\n        (change)=\"toggleDisabledTime()\"\n      />\n      <label [for]=\"switchId\">{{ includeTimeLabel | translate }}</label>\n    </div>\n    <si-timepicker\n      #timePicker\n      [ngModel]=\"time\"\n      [disabled]=\"disabledTime\"\n      [showMinutes]=\"config.showMinutes ?? true\"\n      [showSeconds]=\"config.showSeconds ?? false\"\n      [showMilliseconds]=\"config.showMilliseconds ?? false\"\n      [showMeridian]=\"time12h\"\n      (ngModelChange)=\"timeSelected($event)\"\n    ></si-timepicker>\n  </div>\n</div>\n", styles: [".selection .month:not(.disabled):hover,.selection .year:not(.disabled):hover,.year:not(.disabled):not(.selected):hover,.month:not(.disabled):not(.selected):hover,.day:not(.disabled):not(.selected):hover{background:var(--element-base-1-hover);color:var(--element-ui-0)}.year,.month,.day{block-size:32px;line-height:32px}.day{inline-size:32px}.year,.month,.day{margin-inline:auto;position:relative;cursor:pointer}:host{background:var(--element-base-1);border-radius:var(--element-radius-2);display:block;inline-size:348px}.header,.footer{display:flex;align-items:center}.header{padding-block-start:12px;padding-block-end:16px;padding-inline:32px;border-block-end:1px solid var(--element-ui-4)}.header a{text-decoration:none;cursor:pointer}.footer{margin-block-start:4px;text-align:center}table{inline-size:100%;border-collapse:separate;border-spacing:0 3px;table-layout:fixed;margin-block-end:-3px}.day.selected,.month.selected,.year.selected{background:var(--element-ui-0);color:var(--element-base-1)}td[role=gridcell]{text-align:center}th{font-weight:400;text-align:center;block-size:32px}.week-num,th{font-size:.75rem;color:var(--element-text-secondary);inline-size:32px;cursor:default}.today.selected:before{border-color:var(--element-ui-5)}.today:before{position:absolute;content:\"\";inset:1px;border:1px solid var(--element-ui-1);border-radius:var(--element-radius-2);display:inline-block}.selection .month,.selection .year{block-size:30px;line-height:30px;cursor:pointer}.selection .month{inline-size:50%}.selection .year{inline-size:33.3%}.disabled{color:var(--element-text-disabled);font-weight:400!important;cursor:default!important}.range{background-color:var(--element-ui-4)}.range:hover{background:var(--element-base-1-hover)}.range:hover div.si-title-1:hover{background:transparent}.range-hover{background-color:var(--element-base-1-hover)}td.range-start-end{background:var(--element-ui-0);color:var(--element-base-1)}td.range-start-end div.si-title-1:hover,td.range-start-end div.si-body-1:hover{background:transparent;color:var(--element-base-1)}td.range-start-end .today:before{border-color:var(--element-ui-5)}.calendar-button{font-weight:700;font-size:.875rem;line-height:1.143;color:var(--element-text-active);min-inline-size:0!important}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i2$a.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$a.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SiDaySelectionComponent, selector: "si-day-selection", inputs: ["hideWeekNumbers", "weekStartDay", "minDate", "maxDate", "startDate", "endDate", "isRangeSelection", "previewRange", "months", "focusedDate", "previousLabel", "nextLabel", "todayLabel", "calenderWeekLabel"], outputs: ["selectedValueChange", "focusedDateChange", "activeMonthChange", "viewChange"] }, { kind: "component", type: SiMonthSelectionComponent, selector: "si-month-selection", inputs: ["months", "minDate", "maxDate", "startDate", "focusedDate", "previousLabel", "nextLabel"], outputs: ["selectedValueChange", "focusedDateChange", "activeMonthChange", "viewChange"] }, { kind: "component", type: SiTimepickerComponent, selector: "si-timepicker", inputs: ["disabled", "hoursLabel", "minutesLabel", "secondsLabel", "millisecondsLabel", "hideLabels", "hoursAriaLabel", "minutesAriaLabel", "secondsAriaLabel", "millisecondsAriaLabel", "hoursPlaceholder", "minutesPlaceholder", "secondsPlaceholder", "millisecondsPlaceholder", "meridians", "meridiansLabel", "meridiansAriaLabel", "showMinutes", "showSeconds", "showMilliseconds", "showMeridian", "min", "max", "readonly"], outputs: ["isValid", "meridianChange", "inputCompleted"] }, { kind: "component", type: SiYearSelectionComponent, selector: "si-year-selection", inputs: ["minDate", "maxDate", "selectedDate", "focusedDate", "previousLabel", "nextLabel"], outputs: ["selectedValueChange", "yearRangeChange"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-datepicker', template: "<div class=\"text-center pb-6\" [ngSwitch]=\"view\">\n  <si-year-selection\n    *ngSwitchCase=\"'year'\"\n    [focusedDate]=\"focusedDate\"\n    [selectedDate]=\"startDate\"\n    [minDate]=\"config.minDate\"\n    [maxDate]=\"config.maxDate\"\n    [previousLabel]=\"previousLabel | translate\"\n    [nextLabel]=\"nextLabel | translate\"\n    (selectedValueChange)=\"activeYearChange($event)\"\n  ></si-year-selection>\n  <si-month-selection\n    *ngSwitchCase=\"'month'\"\n    [startDate]=\"startDate\"\n    [months]=\"months\"\n    [minDate]=\"config.minDate\"\n    [maxDate]=\"config.maxDate\"\n    [previousLabel]=\"previousLabel | translate\"\n    [nextLabel]=\"nextLabel | translate\"\n    [(focusedDate)]=\"focusedDate\"\n    (selectedValueChange)=\"activeMonthChange($event)\"\n    (viewChange)=\"switchView($event)\"\n  ></si-month-selection>\n  <si-day-selection\n    *ngSwitchCase=\"'week'\"\n    [initialFocus]=\"initialFocus\"\n    [startDate]=\"startDate\"\n    [endDate]=\"dateRange?.end\"\n    [isRangeSelection]=\"config.enableDateRange!\"\n    [previewRange]=\"rangeType === 'END'\"\n    [hideWeekNumbers]=\"hideWeekNumbers\"\n    [minDate]=\"config.minDate\"\n    [maxDate]=\"config.maxDate\"\n    [weekStartDay]=\"weekStartDay\"\n    [calenderWeekLabel]=\"calenderWeekLabel\"\n    [months]=\"months\"\n    [previousLabel]=\"previousLabel | translate\"\n    [nextLabel]=\"nextLabel | translate\"\n    [todayLabel]=\"config.todayText\"\n    [(focusedDate)]=\"focusedDate\"\n    (selectedValueChange)=\"selectionChange($event)\"\n    (viewChange)=\"switchView($event)\"\n  ></si-day-selection>\n</div>\n<div\n  *ngIf=\"this.config.showTime && (!this.config.enableDateRange ?? false)\"\n  class=\"border-top pt-6\"\n>\n  <div class=\"px-9 pb-6\">\n    <div *ngIf=\"!config.mandatoryTime ?? false\" class=\"mb-5 form-switch\">\n      <input\n        type=\"checkbox\"\n        class=\"form-check-input\"\n        role=\"switch\"\n        [id]=\"switchId\"\n        [checked]=\"!disabledTime\"\n        (change)=\"toggleDisabledTime()\"\n      />\n      <label [for]=\"switchId\">{{ includeTimeLabel | translate }}</label>\n    </div>\n    <si-timepicker\n      #timePicker\n      [ngModel]=\"time\"\n      [disabled]=\"disabledTime\"\n      [showMinutes]=\"config.showMinutes ?? true\"\n      [showSeconds]=\"config.showSeconds ?? false\"\n      [showMilliseconds]=\"config.showMilliseconds ?? false\"\n      [showMeridian]=\"time12h\"\n      (ngModelChange)=\"timeSelected($event)\"\n    ></si-timepicker>\n  </div>\n</div>\n", styles: [".selection .month:not(.disabled):hover,.selection .year:not(.disabled):hover,.year:not(.disabled):not(.selected):hover,.month:not(.disabled):not(.selected):hover,.day:not(.disabled):not(.selected):hover{background:var(--element-base-1-hover);color:var(--element-ui-0)}.year,.month,.day{block-size:32px;line-height:32px}.day{inline-size:32px}.year,.month,.day{margin-inline:auto;position:relative;cursor:pointer}:host{background:var(--element-base-1);border-radius:var(--element-radius-2);display:block;inline-size:348px}.header,.footer{display:flex;align-items:center}.header{padding-block-start:12px;padding-block-end:16px;padding-inline:32px;border-block-end:1px solid var(--element-ui-4)}.header a{text-decoration:none;cursor:pointer}.footer{margin-block-start:4px;text-align:center}table{inline-size:100%;border-collapse:separate;border-spacing:0 3px;table-layout:fixed;margin-block-end:-3px}.day.selected,.month.selected,.year.selected{background:var(--element-ui-0);color:var(--element-base-1)}td[role=gridcell]{text-align:center}th{font-weight:400;text-align:center;block-size:32px}.week-num,th{font-size:.75rem;color:var(--element-text-secondary);inline-size:32px;cursor:default}.today.selected:before{border-color:var(--element-ui-5)}.today:before{position:absolute;content:\"\";inset:1px;border:1px solid var(--element-ui-1);border-radius:var(--element-radius-2);display:inline-block}.selection .month,.selection .year{block-size:30px;line-height:30px;cursor:pointer}.selection .month{inline-size:50%}.selection .year{inline-size:33.3%}.disabled{color:var(--element-text-disabled);font-weight:400!important;cursor:default!important}.range{background-color:var(--element-ui-4)}.range:hover{background:var(--element-base-1-hover)}.range:hover div.si-title-1:hover{background:transparent}.range-hover{background-color:var(--element-base-1-hover)}td.range-start-end{background:var(--element-ui-0);color:var(--element-base-1)}td.range-start-end div.si-title-1:hover,td.range-start-end div.si-body-1:hover{background:transparent;color:var(--element-base-1)}td.range-start-end .today:before{border-color:var(--element-ui-5)}.calendar-button{font-weight:700;font-size:.875rem;line-height:1.143;color:var(--element-text-active);min-inline-size:0!important}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { focusedDate: [{
                type: Input
            }], date: [{
                type: Input
            }], dateRange: [{
                type: Input
            }], initialFocus: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], dateRangeChange: [{
                type: Output
            }], disabledTimeChange: [{
                type: Output
            }], config: [{
                type: Input
            }], previousLabel: [{
                type: Input
            }], nextLabel: [{
                type: Input
            }], calenderWeekLabel: [{
                type: Input
            }], time12h: [{
                type: Input
            }], rangeType: [{
                type: Input
            }], timePicker: [{
                type: ViewChild,
                args: ['timePicker']
            }], daySelection: [{
                type: ViewChild,
                args: [SiDaySelectionComponent]
            }], monthSelection: [{
                type: ViewChild,
                args: [SiMonthSelectionComponent]
            }], yearSelection: [{
                type: ViewChild,
                args: [SiYearSelectionComponent]
            }] } });

class SiDatepickerOverlayComponent {
    datepicker;
    /**
     * @inheritdoc SiDatepickerComponent#initialFocus
     */
    initialFocus = false;
    /**
     * @inheritdoc SiDatepickerComponent#config
     */
    config = {};
    /**
     * @inheritdoc SiDatepickerComponent#date
     */
    date;
    /**
     * @inheritdoc SiDatepickerComponent#dateRange
     */
    dateRange;
    /**
     * @inheritdoc SiDatepickerComponent#rangeType
     */
    rangeType;
    /**
     * @inheritdoc SiDatepickerComponent#time12h
     */
    time12h;
    /**
     * @inheritdoc SiDatepickerComponent#dateChange
     */
    dateChange = new EventEmitter();
    /**
     * @inheritdoc SiDatepickerComponent#dateRangeChange
     */
    dateRangeChange = new EventEmitter();
    /**
     * @inheritdoc SiDatepickerComponent#disabledTimeChange
     */
    disabledTimeChange = new EventEmitter();
    /** Indicate whether the datepicker overlay has the focus. */
    isFocused = false;
    elementRef = inject(ElementRef);
    focusMonitor = inject(FocusMonitor);
    ngAfterViewInit() {
        // Monitor focus events
        this.focusMonitor
            .monitor(this.elementRef, true)
            .subscribe(origin => (this.isFocused = origin !== undefined));
    }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.elementRef);
    }
    /**
     * Focus active cell in the current datepicker view.
     */
    focusActiveCell() {
        this.datepicker?.focusActiveCell();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerOverlayComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiDatepickerOverlayComponent, selector: "si-datepicker-overlay", inputs: { initialFocus: "initialFocus", config: "config", date: "date", dateRange: "dateRange", rangeType: "rangeType", time12h: "time12h" }, outputs: { dateChange: "dateChange", dateRangeChange: "dateRangeChange", disabledTimeChange: "disabledTimeChange" }, viewQueries: [{ propertyName: "datepicker", first: true, predicate: ["datepicker"], descendants: true }], ngImport: i0, template: `
    <si-datepicker
      #datepicker
      class="mt-1 elevation-2 mh-100 overflow-auto"
      tabindex="-1"
      cdkTrapFocus
      [initialFocus]="initialFocus"
      [config]="config"
      [date]="date"
      [dateRange]="dateRange"
      [rangeType]="rangeType"
      [time12h]="time12h"
      (dateChange)="dateChange.next($event)"
      (dateRangeChange)="dateRangeChange.next($event)"
      (disabledTimeChange)="disabledTimeChange.next($event)"
    ></si-datepicker>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "component", type: SiDatepickerComponent, selector: "si-datepicker", inputs: ["focusedDate", "date", "dateRange", "initialFocus", "config", "previousLabel", "nextLabel", "calenderWeekLabel", "time12h", "rangeType"], outputs: ["dateChange", "dateRangeChange", "disabledTimeChange"] }], changeDetection: i0.ChangeDetectionStrategy.Default });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerOverlayComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'si-datepicker-overlay',
                    template: `
    <si-datepicker
      #datepicker
      class="mt-1 elevation-2 mh-100 overflow-auto"
      tabindex="-1"
      cdkTrapFocus
      [initialFocus]="initialFocus"
      [config]="config"
      [date]="date"
      [dateRange]="dateRange"
      [rangeType]="rangeType"
      [time12h]="time12h"
      (dateChange)="dateChange.next($event)"
      (dateRangeChange)="dateRangeChange.next($event)"
      (disabledTimeChange)="disabledTimeChange.next($event)"
    ></si-datepicker>
  `,
                    changeDetection: ChangeDetectionStrategy.Default
                }]
        }], propDecorators: { datepicker: [{
                type: ViewChild,
                args: ['datepicker', { static: false }]
            }], initialFocus: [{
                type: Input
            }], config: [{
                type: Input
            }], date: [{
                type: Input
            }], dateRange: [{
                type: Input
            }], rangeType: [{
                type: Input
            }], time12h: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], dateRangeChange: [{
                type: Output
            }], disabledTimeChange: [{
                type: Output
            }] } });

var CloseCause;
(function (CloseCause) {
    CloseCause[CloseCause["Backdrop"] = 1] = "Backdrop";
    CloseCause[CloseCause["Detach"] = 2] = "Detach";
    CloseCause[CloseCause["Escape"] = 3] = "Escape";
    CloseCause[CloseCause["Select"] = 4] = "Select";
})(CloseCause || (CloseCause = {}));
/**
 * Directive with the responsibility to open/close datepicker overlay.
 */
class SiDatepickerOverlayDirective {
    placement;
    /**
     * Output event on closing datepicker e.g. by clicking backdrop or escape key.
     */
    siDatepickerClose = new EventEmitter();
    overlayRef;
    datepickerRef;
    destroyer$ = new Subject();
    autoCloseSelection = new Subject();
    /** Guard for siDatepickerClose event emitter to make sure the cause is emitter just once */
    ignoreClose = false;
    overlay = inject(Overlay);
    triggerElementRef = inject(ElementRef);
    defaultPlacement = [
        positionBottomStart,
        positionBottomCenter,
        positionBottomEnd,
        positionTopStart,
        positionTopCenter,
        positionTopEnd
    ];
    ngOnDestroy() {
        this.overlayRef?.dispose();
        this.datepickerRef = undefined;
        this.destroyer$.next();
        this.destroyer$.complete();
    }
    /**
     * Toggle open/close overlay.
     * @param focus move focus to the datepicker.
     * @param inputs for datepicker.
     * @returns create datepicker overlay instance or undefined
     */
    toggleOverlay(focus, inputs) {
        if (!this.datepickerRef) {
            return this.showDatepicker(this.triggerElementRef).setInputs(inputs).focus(focus)
                .datepickerRef;
        }
        else {
            return this.closeOverlay();
        }
    }
    /**
     * Show datepicker overlay.
     * @param focus move focus to the datepicker.
     * @returns create datepicker overlay instance
     */
    showOverlay(focus = false, inputs) {
        return this.showDatepicker(this.triggerElementRef).setInputs(inputs).focus(focus)
            .datepickerRef;
    }
    /**
     * Close datepicker.
     */
    closeOverlay() {
        if (this.overlayRef?.hasAttached()) {
            this.overlayRef?.detach();
            this.overlayRef?.dispose();
        }
        this.datepickerRef = undefined;
        return undefined;
    }
    /**
     * Focus active cell in datepicker.
     * @param focus show transfer focus.
     * @returns current instance.
     */
    focus(focus = true) {
        if (focus) {
            this.datepickerRef?.setInput('initialFocus', true);
            this.datepickerRef?.instance.focusActiveCell();
            this.datepickerRef?.changeDetectorRef.markForCheck();
        }
        return this;
    }
    /**
     * Indicate the datepicker or one of its children is focussed.
     * @returns is focused.
     */
    isFocused() {
        return this.datepickerRef?.instance.isFocused ?? false;
    }
    /**
     * Indicate the datepicker is visible.
     * @returns is visible.
     */
    isShown() {
        return this.datepickerRef;
    }
    /**
     * Indicate datepicker is visible and focussed.
     * @returns is visible and focussed.
     */
    isShownWithoutFocus() {
        return !!this.isShown() && !this.datepickerRef?.instance.initialFocus;
    }
    /** Set datepicker inputs */
    setInputs(inputs) {
        if (this.datepickerRef && inputs) {
            Object.entries(inputs).forEach(([key, value]) => {
                this.datepickerRef.setInput(key.toString(), value);
            });
        }
        return this;
    }
    /** Close overlay with cause select, which will recover the focus */
    closeAfterSelection() {
        this.autoCloseSelection.next();
    }
    /** Indicate whether the HTML element is a child of the datepicker overlay. */
    contains(element) {
        if (!element) {
            return false;
        }
        return this.overlayRef?.overlayElement?.contains(element) ?? false;
    }
    showDatepicker(elementRef) {
        if (this.overlayRef?.hasAttached()) {
            return this;
        }
        this.overlayRef = getOverlay(elementRef, this.overlay, true, this.placement ?? this.defaultPlacement, true);
        this.closeStream(this.overlayRef)
            .pipe(takeUntil(this.destroyer$))
            .subscribe(cause => {
            // The handler is called multiple times since we need to listen to detach events
            if (this.datepickerRef && !this.ignoreClose) {
                this.ignoreClose = true;
                this.closeOverlay();
                this.ignoreClose = false;
                this.siDatepickerClose.next(cause);
            }
        });
        const portal = new ComponentPortal(SiDatepickerOverlayComponent);
        this.datepickerRef = this.overlayRef.attach(portal);
        return this;
    }
    /**
     * Merge events which shall close the overlay
     * @param overlayRef source for backdrop, detach or escape events.
     * @returns merged observable
     */
    closeStream(overlayRef) {
        return merge(this.autoCloseSelection.pipe(mapTo(CloseCause.Select)), overlayRef.backdropClick().pipe(mapTo(CloseCause.Backdrop)), overlayRef.detachments().pipe(mapTo(CloseCause.Detach)), overlayRef.keydownEvents().pipe(filter(event => event.key === 'Escape'), mapTo(CloseCause.Escape)));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerOverlayDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiDatepickerOverlayDirective, isStandalone: true, selector: "[siDatepickerOverlay]", inputs: { placement: "placement" }, outputs: { siDatepickerClose: "siDatepickerClose" }, exportAs: ["siDatepickerOverlay"], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerOverlayDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siDatepickerOverlay]',
                    exportAs: 'siDatepickerOverlay',
                    standalone: true
                }]
        }], propDecorators: { placement: [{
                type: Input
            }], siDatepickerClose: [{
                type: Output
            }] } });

class SiDatepickerDirective extends SiDateInputDirective {
    /**
     * Automatically close overlay on date selection.
     * Do not use this behavior with config showTime = true, because it
     * will close the overlay when the user change one of the time units.
     */
    autoClose = false;
    /**
     * The input element which shall gain the focus when closing the datepicker overlay with Escape.
     */
    triggeringInput = inject(ElementRef);
    /**
     * During focus on close the datepicker will not show since we recover the focus on element.
     * The focus on close is only relevant when the directive is configured without a calendar button.
     */
    focusOnClose = false;
    overlaySubscriptions;
    externalTrigger;
    ngZone = inject(NgZone);
    focusMonitor = inject(FocusMonitor);
    overlayToggle = inject(SiDatepickerOverlayDirective);
    ngAfterViewInit() {
        if (!this.externalTrigger) {
            this.focusMonitor
                .monitor(this.triggeringInput)
                .subscribe(origin => this.ngZone.run(() => this.focusChange(origin)));
        }
        // Monitor datepicker close
        this.overlayToggle.siDatepickerClose.pipe(takeUntil(this.destroyer$)).subscribe(cause => {
            if ([CloseCause.Escape, CloseCause.Select].includes(cause)) {
                // In scenarios where the user closed the dropdown via escape we set the focus on the input
                this.focusOnClose = true;
                this.focusMonitor.focusVia(this.externalTrigger ?? this.triggeringInput, 'program');
            }
            else {
                // Mark component as touch when the focus isn't recovered on input
                this.onTouched();
                this.cdRef.markForCheck();
            }
        });
        // Update datepicker with new date value
        this.dateChange
            .pipe(takeUntil(this.destroyer$))
            .subscribe(date => this.overlayToggle.setInputs({ date }));
    }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.triggeringInput);
    }
    /**
     * On click shall show datepicker.
     */
    onClick() {
        if (!this.externalTrigger) {
            this.show();
        }
    }
    /**
     * Focus out shall close the datepicker except we are moving the focus to the datepicker.
     * @param event focus out event with the related target
     */
    onFocusOut(event) {
        const target = event.relatedTarget;
        if (!this.overlayToggle.contains(target)) {
            this.overlayToggle.closeOverlay();
        }
    }
    /**
     * @internal
     */
    show(initialFocus = false) {
        if (this.disabled ||
            this.readonly ||
            (!this.externalTrigger && this.focusOnClose) ||
            this.overlayToggle.isShown()) {
            return;
        }
        this.subscribeDateChanges(this.overlayToggle.showOverlay(initialFocus, {
            config: this.siDatepickerConfig,
            date: this.date,
            time12h: this.getTime12h()
        }));
    }
    /**
     * @internal
     */
    useExternalTrigger(element) {
        this.externalTrigger = element;
    }
    focusChange(origin) {
        if (origin) {
            this.show();
        }
        this.focusOnClose = false;
    }
    getTime12h() {
        const dateFormat = getDatepickerFormat(this.locale, this.siDatepickerConfig, true);
        return dateFormat?.includes('a');
    }
    subscribeDateChanges(overlay) {
        this.overlaySubscriptions?.forEach(s => s.unsubscribe());
        overlay?.instance.dateChange
            .pipe(takeUntil(this.destroyer$))
            .subscribe(d => this.onDateChanged(d));
        overlay?.instance.disabledTimeChange
            .pipe(takeUntil(this.destroyer$))
            .subscribe(d => this.onDisabledTime(d));
    }
    /**
     * Callback when the datepicker changes his value.
     * @param date updated date
     */
    onDateChanged(date) {
        super.onDateChanged(date);
        if (this.autoClose) {
            // a tick later so the event won't end on the wrong element
            setTimeout(() => this.overlayToggle.closeAfterSelection());
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiDatepickerDirective, selector: "[siDatepicker]", inputs: { autoClose: "autoClose", triggeringInput: "triggeringInput" }, host: { listeners: { "click": "onClick($event)", "focusout": "onFocusOut($event)" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: SiDatepickerDirective,
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: SiDatepickerDirective,
                multi: true
            }
        ], exportAs: ["siDatepicker"], usesInheritance: true, hostDirectives: [{ directive: SiDatepickerOverlayDirective, outputs: ["siDatepickerClose", "siDatepickerClose"] }], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siDatepicker]',
                    exportAs: 'siDatepicker',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SiDatepickerDirective,
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: SiDatepickerDirective,
                            multi: true
                        }
                    ],
                    hostDirectives: [
                        {
                            directive: SiDatepickerOverlayDirective,
                            // eslint-disable-next-line @angular-eslint/no-outputs-metadata-property
                            outputs: ['siDatepickerClose']
                        }
                    ]
                }]
        }], propDecorators: { autoClose: [{
                type: Input
            }], triggeringInput: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onFocusOut: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

class SiDateRangeComponent {
    inputDirectives;
    startInput;
    endInput;
    startDateInput;
    endDateInput;
    button;
    /** Date range component configuration. */
    siDatepickerConfig = { enableDateRange: true, showTime: false };
    /** Placeholder of the start date input. */
    startDatePlaceholder = $localize `:@@SI_DATEPICKER.START_DATE_PLACEHOLDER:Start date`;
    /** Placeholder of the end date input. */
    endDatePlaceholder = $localize `:@@SI_DATEPICKER.END_DATE_PLACEHOLDER:End date`;
    /** Aria label of the date-range calendar toggle button. */
    ariaLabelCalendarButton = $localize `:@@SI_DATEPICKER.CALENDAR_TOGGLE_BUTTON:Open calendar`;
    /**
     * The debounce time for the date input changes.
     */
    debounceTime = 200;
    /** Automatically close overlay on date selection. */
    autoClose = false;
    /** Emits on the date range value changes. */
    siDatepickerRangeChange = new EventEmitter();
    /**
     * Whether the date range input is disabled.
     * @defaultref {@link _disabled}
     */
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Whether the date range input is readonly.
     * @defaultref {@link _readonly}
     */
    set readonly(value) {
        this._readonly = coerceBooleanProperty(value);
    }
    get readonly() {
        return this._readonly;
    }
    get value() {
        return this._value;
    }
    /**
     * Set the date-range object displayed in the control.
     * The input can be used if the control is used outside Angular forms.
     * @defaultref {@link _value}
     */
    set value(value) {
        if (value !== this._value) {
            this._value = value;
            // this allows angular's built in required validator to work correctly
            if (!value?.start && !value?.end) {
                this._value = undefined;
            }
            this.onChange(this._value);
            this.onTouch();
            this.cdRef.markForCheck();
        }
    }
    dateRangeControl;
    /** Indicate whether the component has focus class, the property control the focus border */
    focusOn = false;
    _readonly = false;
    _disabled = false;
    _value;
    dateChangeSubscription;
    validator;
    onChange = (val) => { };
    onTouch = () => { };
    destroyer$ = new Subject();
    cdRef = inject(ChangeDetectorRef);
    ngZone = inject(NgZone);
    focusMonitor = inject(FocusMonitor);
    overlayToggle = inject(SiDatepickerOverlayDirective);
    injector = inject(Injector);
    defaultPlacement = [
        positionBottomCenter,
        positionBottomStart,
        positionBottomEnd,
        positionTopCenter,
        positionTopStart,
        positionTopEnd
    ];
    ngAfterViewInit() {
        this.dateRangeControl = this.injector.get(NgControl).control;
        this.validator = Validators.compose([
            () => this.endAfterStartValidator(),
            () => this.rangeBeforeMinDateValidator(),
            () => this.rangeAfterMaxDateValidator(),
            this.mapChildValidator('invalidFormat', 'invalidStartDateFormat', this.startInput),
            this.mapChildValidator('invalidFormat', 'invalidEndDateFormat', this.endInput)
        ]);
        this.overlayToggle.placement = this.defaultPlacement;
        this.overlayToggle.siDatepickerClose.pipe(takeUntil(this.destroyer$)).subscribe(cause => {
            if ([CloseCause.Escape, CloseCause.Select].includes(cause)) {
                this.focusMonitor.focusVia(this.button, 'program');
            }
            else {
                // Mark component as touch when the focus isn't recovered on input
                this.onTouch();
                this.cdRef.markForCheck();
            }
        });
        this.focusMonitor.monitor(this.startDateInput, true).subscribe(origin => this.ngZone.run(() => {
            this.focusOn = origin !== null;
            this.cdRef.markForCheck();
        }));
        this.focusMonitor.monitor(this.endDateInput, true).subscribe(origin => {
            this.ngZone.run(() => {
                this.focusOn = origin !== null;
                this.cdRef.markForCheck();
            });
        });
    }
    ngOnChanges(changes) {
        if (changes.siDatepickerConfig) {
            this.siDatepickerConfig = {
                ...changes.siDatepickerConfig.currentValue,
                enableDateRange: true,
                showTime: false
            };
        }
        this.overlayToggle.setInputs({ config: this.siDatepickerConfig, dateRange: this.value });
    }
    ngOnDestroy() {
        this.destroyer$.next();
        this.destroyer$.complete();
        [this.startDateInput, this.endDateInput].forEach(e => this.focusMonitor.stopMonitoring(e));
    }
    writeValue(dateRange) {
        this.value = dateRange ?? this.value;
        this.siDatepickerRangeChange.emit(dateRange);
        this.overlayToggle.setInputs({ dateRange });
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
        this.cdRef.markForCheck();
    }
    validate(c) {
        return this.validator ? this.validator(c) : null;
    }
    /**
     * Focus out shall close the datepicker except we are moving the focus to the datepicker or one of the input elements.
     * @param event focus out event with the related target
     */
    onFocusOut(event) {
        const target = event.relatedTarget;
        if (!this.overlayToggle.contains(target)) {
            this.overlayToggle.closeOverlay();
        }
        this.focusOn = false;
    }
    /** Forward date range input changes to datepicker overlay */
    onInputChanged(dateRange) {
        this.writeValue(dateRange);
    }
    show() {
        if (this.readonly || this.disabled) {
            return;
        }
        this.subscribeRangeChanges(this.overlayToggle.showOverlay(true, {
            config: this.siDatepickerConfig,
            dateRange: this.value
        }));
    }
    subscribeRangeChanges(overlay) {
        this.dateChangeSubscription?.unsubscribe();
        this.dateChangeSubscription = overlay?.instance.dateRangeChange
            .pipe(takeUntil(this.destroyer$))
            .subscribe(d => this.onRangeChanged(d));
    }
    onRangeChanged(range) {
        this.writeValue({
            ...range
        });
        this.validateChildren();
        if (this.autoClose && this.value?.start && this.value?.end) {
            this.overlayToggle.closeAfterSelection();
        }
        this.cdRef.markForCheck();
    }
    /** Run validators on the start/end inputs. */
    validateChildren() {
        this.inputDirectives.forEach(d => d.validatorOnChange());
    }
    /** The form control validator for the end date is greater equal start date. */
    endAfterStartValidator() {
        const endDate = this.endInput.value;
        const startDate = this.startInput.value;
        return !endDate || !startDate || endDate >= startDate
            ? null
            : {
                endBeforeStart: {
                    start: startDate,
                    end: endDate
                }
            };
    }
    rangeBeforeMinDateValidator() {
        const endDate = this.endInput.value;
        const startDate = this.startInput.value;
        const min = getMinDate(this.siDatepickerConfig?.minDate);
        return !min ||
            ((!startDate || compareDate(startDate, min) >= 0) &&
                (!endDate || compareDate(endDate, min) >= 0))
            ? null
            : {
                rangeBeforeMinDate: {
                    min,
                    start: startDate,
                    end: endDate
                }
            };
    }
    rangeAfterMaxDateValidator() {
        const endDate = this.endInput.value;
        const startDate = this.startInput.value;
        const max = getMaxDate(this.siDatepickerConfig?.maxDate);
        return !max ||
            ((!startDate || compareDate(startDate, max) <= 0) &&
                (!endDate || compareDate(endDate, max) <= 0))
            ? null
            : {
                rangeAfterMaxDate: {
                    max,
                    start: startDate,
                    end: endDate
                }
            };
    }
    /** Create validator function to expose nested child errors to parent control */
    mapChildValidator = (childValidationKey, exposedValidationKey, childControl) => {
        return (control) => {
            return !childControl.invalid || !childControl.hasError(childValidationKey)
                ? null
                : {
                    [exposedValidationKey]: childControl.errors[childValidationKey]
                };
        };
    };
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiDateRangeComponent, selector: "si-date-range", inputs: { siDatepickerConfig: "siDatepickerConfig", startDatePlaceholder: "startDatePlaceholder", endDatePlaceholder: "endDatePlaceholder", ariaLabelCalendarButton: "ariaLabelCalendarButton", debounceTime: "debounceTime", autoClose: "autoClose", disabled: "disabled", readonly: "readonly", value: "value" }, outputs: { siDatepickerRangeChange: "siDatepickerRangeChange" }, host: { listeners: { "focusout": "onFocusOut($event)" }, classAttribute: "form-control p-0 border-0" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: SiDateRangeComponent,
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: SiDateRangeComponent,
                multi: true
            }
        ], viewQueries: [{ propertyName: "startInput", first: true, predicate: ["startInput"], descendants: true, static: true }, { propertyName: "endInput", first: true, predicate: ["endInput"], descendants: true, static: true }, { propertyName: "startDateInput", first: true, predicate: ["start"], descendants: true, static: true }, { propertyName: "endDateInput", first: true, predicate: ["end"], descendants: true, static: true }, { propertyName: "button", first: true, predicate: ["button"], descendants: true, read: ElementRef, static: true }, { propertyName: "inputDirectives", predicate: SiDateInputDirective, descendants: true }], usesOnChanges: true, hostDirectives: [{ directive: SiDatepickerOverlayDirective, outputs: ["siDatepickerClose", "siDatepickerClose"] }], ngImport: i0, template: "<div\n  #range\n  class=\"form-control d-flex align-items-center pe-2\"\n  [class.disabled]=\"disabled\"\n  [class.readonly]=\"readonly\"\n  [class.focus]=\"focusOn\"\n  [class.ng-invalid]=\"!dateRangeControl?.valid\"\n  [class.ng-touched]=\"dateRangeControl?.touched\"\n  [class.ng-dirty]=\"dateRangeControl?.dirty\"\n>\n  <input\n    #start\n    #startInput=\"ngModel\"\n    type=\"text\"\n    class=\"border-0 p-0 focus-none\"\n    siDateInput\n    [ngModel]=\"dateRangeControl?.value && dateRangeControl?.value.start\"\n    [siDatepickerConfig]=\"siDatepickerConfig\"\n    [placeholder]=\"startDatePlaceholder | translate\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [dateInputDebounceTime]=\"debounceTime\"\n    (ngModelChange)=\"onInputChanged({ start: $event, end: value?.end })\"\n  />\n  <span class=\"mx-3\">-</span>\n  <input\n    #end\n    #endInput=\"ngModel\"\n    type=\"text\"\n    class=\"border-0 p-0 focus-none text-end\"\n    siDateInput\n    [ngModel]=\"dateRangeControl?.value && dateRangeControl?.value.end\"\n    [siDatepickerConfig]=\"siDatepickerConfig\"\n    [placeholder]=\"endDatePlaceholder | translate\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    (ngModelChange)=\"onInputChanged({ start: value?.start, end: $event })\"\n  />\n  <button\n    #button\n    type=\"button\"\n    class=\"btn btn-circle btn-tertiary btn-xs element-calendar ms-2\"\n    [attr.aria-label]=\"ariaLabelCalendarButton | translate\"\n    [disabled]=\"disabled || readonly\"\n    (click)=\"show()\"\n  >\n  </button>\n</div>\n", styles: [":host{display:block;min-inline-size:220px}.focus-none{outline:0}.focus{box-shadow:0 0 0 var(--element-button-focus-overlay-width) var(--element-button-focus-overlay-color),0 0 0 calc(var(--element-button-focus-width) + var(--element-button-focus-overlay-width)) var(--element-focus-default)}input{flex-grow:1;background-color:var(--element-base-1);min-inline-size:80px}input::placeholder{opacity:1;color:var(--element-text-secondary)}input:disabled,input[readonly]{background-color:var(--element-base-1);opacity:1}input:not([readonly]):focus::placeholder,input:focus:not([readonly]):focus::placeholder{color:transparent}.disabled,.disabled:hover,.disabled:focus{--border-color: var(--element-ui-3);color:var(--element-text-disabled)}\n"], dependencies: [{ kind: "directive", type: i2$a.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$a.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$a.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: SiDateInputDirective, selector: "[siDateInput]", inputs: ["siDatepickerConfig", "dateRange", "rangeType", "dateInputDebounceTime", "disabled", "readonly"], outputs: ["siDatepickerDisabledTime", "stateChange"], exportAs: ["siDateInput"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-date-range', host: {
                        class: 'form-control p-0 border-0'
                    }, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SiDateRangeComponent,
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: SiDateRangeComponent,
                            multi: true
                        }
                    ], hostDirectives: [
                        {
                            directive: SiDatepickerOverlayDirective,
                            // eslint-disable-next-line @angular-eslint/no-outputs-metadata-property
                            outputs: ['siDatepickerClose']
                        }
                    ], template: "<div\n  #range\n  class=\"form-control d-flex align-items-center pe-2\"\n  [class.disabled]=\"disabled\"\n  [class.readonly]=\"readonly\"\n  [class.focus]=\"focusOn\"\n  [class.ng-invalid]=\"!dateRangeControl?.valid\"\n  [class.ng-touched]=\"dateRangeControl?.touched\"\n  [class.ng-dirty]=\"dateRangeControl?.dirty\"\n>\n  <input\n    #start\n    #startInput=\"ngModel\"\n    type=\"text\"\n    class=\"border-0 p-0 focus-none\"\n    siDateInput\n    [ngModel]=\"dateRangeControl?.value && dateRangeControl?.value.start\"\n    [siDatepickerConfig]=\"siDatepickerConfig\"\n    [placeholder]=\"startDatePlaceholder | translate\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [dateInputDebounceTime]=\"debounceTime\"\n    (ngModelChange)=\"onInputChanged({ start: $event, end: value?.end })\"\n  />\n  <span class=\"mx-3\">-</span>\n  <input\n    #end\n    #endInput=\"ngModel\"\n    type=\"text\"\n    class=\"border-0 p-0 focus-none text-end\"\n    siDateInput\n    [ngModel]=\"dateRangeControl?.value && dateRangeControl?.value.end\"\n    [siDatepickerConfig]=\"siDatepickerConfig\"\n    [placeholder]=\"endDatePlaceholder | translate\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    (ngModelChange)=\"onInputChanged({ start: value?.start, end: $event })\"\n  />\n  <button\n    #button\n    type=\"button\"\n    class=\"btn btn-circle btn-tertiary btn-xs element-calendar ms-2\"\n    [attr.aria-label]=\"ariaLabelCalendarButton | translate\"\n    [disabled]=\"disabled || readonly\"\n    (click)=\"show()\"\n  >\n  </button>\n</div>\n", styles: [":host{display:block;min-inline-size:220px}.focus-none{outline:0}.focus{box-shadow:0 0 0 var(--element-button-focus-overlay-width) var(--element-button-focus-overlay-color),0 0 0 calc(var(--element-button-focus-width) + var(--element-button-focus-overlay-width)) var(--element-focus-default)}input{flex-grow:1;background-color:var(--element-base-1);min-inline-size:80px}input::placeholder{opacity:1;color:var(--element-text-secondary)}input:disabled,input[readonly]{background-color:var(--element-base-1);opacity:1}input:not([readonly]):focus::placeholder,input:focus:not([readonly]):focus::placeholder{color:transparent}.disabled,.disabled:hover,.disabled:focus{--border-color: var(--element-ui-3);color:var(--element-text-disabled)}\n"] }]
        }], propDecorators: { inputDirectives: [{
                type: ViewChildren,
                args: [SiDateInputDirective]
            }], startInput: [{
                type: ViewChild,
                args: ['startInput', { static: true }]
            }], endInput: [{
                type: ViewChild,
                args: ['endInput', { static: true }]
            }], startDateInput: [{
                type: ViewChild,
                args: ['start', { static: true }]
            }], endDateInput: [{
                type: ViewChild,
                args: ['end', { static: true }]
            }], button: [{
                type: ViewChild,
                args: ['button', { read: ElementRef, static: true }]
            }], siDatepickerConfig: [{
                type: Input
            }], startDatePlaceholder: [{
                type: Input
            }], endDatePlaceholder: [{
                type: Input
            }], ariaLabelCalendarButton: [{
                type: Input
            }], debounceTime: [{
                type: Input
            }], autoClose: [{
                type: Input
            }], siDatepickerRangeChange: [{
                type: Output
            }], disabled: [{
                type: Input
            }], readonly: [{
                type: Input
            }], value: [{
                type: Input
            }], onFocusOut: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }] } });

/**
 * Calendar toggle button used in combination with a datepicker directive.
 *
 * @example
 * ```
 * <si-calendar-button class="w-100">
 *   <input
 *     class="form-control"
 *     type="text"
 *     siDatepicker
 *     [siDatepickerConfig]="config"
 *   />
 * </si-calendar-button>
 * ```
 */
class SiCalendarButtonComponent {
    /** Aria label for the calendar toggle button. */
    ariaLabel = $localize `:@@SI_DATEPICKER.CALENDAR_TOGGLE_BUTTON:Open calendar`;
    button;
    /** Datepicker input directive instance used to watch for state changes and required to open the calendar. */
    datepicker;
    disabled = false;
    cdRef = inject(ChangeDetectorRef);
    sub;
    ngOnInit() {
        // Monitor input state changes and update the button accordingly
        this.sub = this.datepicker?.stateChange.subscribe(() => this.updateState());
    }
    ngAfterContentInit() {
        this.datepicker?.useExternalTrigger(this.button);
        this.updateState();
    }
    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
    show() {
        this.datepicker?.show(true);
    }
    updateState() {
        this.disabled = !!this.datepicker?.disabled || !!this.datepicker?.readonly;
        this.cdRef.markForCheck();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiCalendarButtonComponent, isStandalone: true, selector: "si-calendar-button", inputs: { ariaLabel: "ariaLabel" }, host: { classAttribute: "d-inline-block position-relative" }, queries: [{ propertyName: "datepicker", first: true, predicate: SiDatepickerDirective, descendants: true, read: SiDatepickerDirective, static: true }], viewQueries: [{ propertyName: "button", first: true, predicate: ["calendarButton"], descendants: true, static: true }], ngImport: i0, template: `<ng-content></ng-content>
    <button
      #calendarButton
      name="open-calendar"
      type="button"
      class="btn btn-circle btn-tertiary btn-xs element-calendar position-absolute end-0 top-0 me-2 mt-2"
      [attr.aria-label]="ariaLabel | translate"
      [disabled]="disabled"
      (click)="show()"
    >
    </button>`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: SiTranslateModule }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCalendarButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'si-calendar-button',
                    template: `<ng-content></ng-content>
    <button
      #calendarButton
      name="open-calendar"
      type="button"
      class="btn btn-circle btn-tertiary btn-xs element-calendar position-absolute end-0 top-0 me-2 mt-2"
      [attr.aria-label]="ariaLabel | translate"
      [disabled]="disabled"
      (click)="show()"
    >
    </button>`,
                    host: {
                        class: 'd-inline-block position-relative'
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    standalone: true,
                    imports: [CommonModule, SiTranslateModule]
                }]
        }], propDecorators: { ariaLabel: [{
                type: Input
            }], button: [{
                type: ViewChild,
                args: ['calendarButton', { static: true }]
            }], datepicker: [{
                type: ContentChild,
                args: [SiDatepickerDirective, { static: true, read: SiDatepickerDirective }]
            }] } });

class SiDatepickerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerModule, declarations: [SiDateInputDirective,
            SiDatepickerComponent,
            SiDatepickerDirective,
            SiDatepickerOverlayComponent,
            SiDateRangeComponent,
            SiDaySelectionComponent,
            SiMonthSelectionComponent,
            SiTimepickerComponent,
            SiYearSelectionComponent], imports: [A11yModule,
            BidiModule,
            CommonModule,
            FormsModule,
            OverlayModule,
            SiCalendarBodyComponent,
            SiCalendarButtonComponent,
            SiCalendarDirectionButtonComponent,
            SiDatepickerOverlayDirective,
            SiTranslateModule], exports: [SiCalendarButtonComponent,
            SiDateInputDirective,
            SiDatepickerComponent,
            SiDatepickerDirective,
            SiDateRangeComponent,
            SiTimepickerComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerModule, imports: [A11yModule,
            BidiModule,
            CommonModule,
            FormsModule,
            OverlayModule,
            SiCalendarBodyComponent,
            SiCalendarButtonComponent,
            SiCalendarDirectionButtonComponent,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        A11yModule,
                        BidiModule,
                        CommonModule,
                        FormsModule,
                        OverlayModule,
                        SiCalendarBodyComponent,
                        SiCalendarButtonComponent,
                        SiCalendarDirectionButtonComponent,
                        SiDatepickerOverlayDirective,
                        SiTranslateModule
                    ],
                    declarations: [
                        SiDateInputDirective,
                        SiDatepickerComponent,
                        SiDatepickerDirective,
                        SiDatepickerOverlayComponent,
                        SiDateRangeComponent,
                        SiDaySelectionComponent,
                        SiMonthSelectionComponent,
                        SiTimepickerComponent,
                        SiYearSelectionComponent
                    ],
                    exports: [
                        SiCalendarButtonComponent,
                        SiDateInputDirective,
                        SiDatepickerComponent,
                        SiDatepickerDirective,
                        SiDateRangeComponent,
                        SiTimepickerComponent
                    ]
                }]
        }] });

/**
 * Service to transform and calculate with DateRangeFilter objects.
 */
class SiDateRangeCalculationService {
    /**
     * Calculates the start and end dates of a DateRangeFilter.
     * @param filter The date range filter object to be resolved.
     * @returns The resolved result in form of a ResolvedDateRange object.
     */
    resolveDateRangeFilter(filter) {
        const ref = filter.point1 === 'now' ? new Date() : filter.point1 ?? new Date(NaN);
        if (filter.point2 instanceof Date) {
            return this.normalize(ref, filter.point2);
        }
        const offset = filter.point2;
        switch (filter.range) {
            case undefined:
            case 'before':
                return this.normalize(ref, this.datePlusOffset(ref, -offset));
            case 'after':
                return this.normalize(ref, this.datePlusOffset(ref, offset));
            case 'within':
                return this.normalize(this.datePlusOffset(ref, -offset), this.datePlusOffset(ref, offset));
        }
    }
    datePlusOffset(date, offset) {
        return new Date(date.getTime() + offset);
    }
    normalize(date1, date2) {
        const valid = !isNaN(date1.getTime()) && !isNaN(date2.getTime());
        return date1 < date2
            ? { start: date1, end: date2, valid }
            : { start: date2, end: date1, valid };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeCalculationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeCalculationService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeCalculationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const ONE_MINUTE = 60 * 1000;
const ONE_DAY = ONE_MINUTE * 60 * 24;

class SiRelativeDateComponent {
    cdRef = inject(ChangeDetectorRef);
    value = 0;
    enableTimeSelection = false;
    valueLabel;
    unitLabel;
    valueChange = new EventEmitter();
    internalValue = 0;
    offset = 0;
    unit = 'days';
    fullOffsetList = [
        {
            id: 'minutes',
            title: $localize `:@@SI_DATE_RANGE_FILTER.MINUTES:Minutes`,
            offset: ONE_MINUTE
        },
        { id: 'hours', title: $localize `:@@SI_DATE_RANGE_FILTER.HOURS:Hours`, offset: 60 * ONE_MINUTE },
        { id: 'days', title: $localize `:@@SI_DATE_RANGE_FILTER.DAYS:Days`, offset: ONE_DAY },
        { id: 'weeks', title: $localize `:@@SI_DATE_RANGE_FILTER.WEEKS:Weeks`, offset: 7 * ONE_DAY },
        { id: 'months', title: $localize `:@@SI_DATE_RANGE_FILTER.MONTHS:Months`, offset: 30 * ONE_DAY },
        { id: 'years', title: $localize `:@@SI_DATE_RANGE_FILTER.YEARS:Years`, offset: 365 * ONE_DAY }
    ];
    offsetList = [];
    ngOnInit() {
        this.setupOffsetList();
        this.calculateOffset();
    }
    ngOnChanges(changes) {
        if (changes.enableTimeSelection) {
            this.setupOffsetList();
        }
        if (changes.value && this.value !== this.internalValue) {
            this.internalValue = this.value;
            this.calculateOffset();
        }
    }
    setupOffsetList() {
        if (this.enableTimeSelection) {
            this.offsetList = this.fullOffsetList;
        }
        else {
            this.offsetList = this.fullOffsetList.filter(item => item.offset >= ONE_DAY);
        }
    }
    calculateOffset() {
        for (let i = this.offsetList.length - 1; i >= 0; i--) {
            const item = this.offsetList[i];
            if (this.internalValue % item.offset === 0) {
                this.offset = this.internalValue / item.offset;
                this.unit = item.id;
                this.cdRef.markForCheck();
                break;
            }
        }
    }
    updateValue() {
        const item = this.offsetList.find(x => x.id === this.unit);
        this.internalValue = this.offset * item.offset;
        this.valueChange.emit(this.internalValue);
        this.cdRef.markForCheck();
    }
    changeUnit() {
        const item = this.offsetList.find(x => x.id === this.unit);
        this.offset = Math.max(1, Math.round(this.internalValue / item.offset));
        this.internalValue = this.offset * item.offset;
        this.valueChange.emit(this.internalValue);
        this.cdRef.markForCheck();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiRelativeDateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiRelativeDateComponent, selector: "si-relative-date", inputs: { value: "value", enableTimeSelection: "enableTimeSelection", valueLabel: "valueLabel", unitLabel: "unitLabel" }, outputs: { valueChange: "valueChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"d-flex\">\n  <si-number-input\n    class=\"form-control flex-fill\"\n    [aria-label]=\"valueLabel\"\n    [(ngModel)]=\"offset\"\n    (ngModelChange)=\"updateValue()\"\n  ></si-number-input>\n  <si-select\n    class=\"form-control ms-4 flex-fill\"\n    min=\"0\"\n    [ariaLabel]=\"unitLabel\"\n    [options]=\"offsetList\"\n    [(ngModel)]=\"unit\"\n    (ngModelChange)=\"changeUnit()\"\n  ></si-select>\n</div>\n", styles: [".form-control{min-inline-size:0}\n"], dependencies: [{ kind: "directive", type: i2$a.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$a.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$6.SiNumberInputComponent, selector: "si-number-input", inputs: ["min", "max", "step", "value", "unit", "showButtons", "aria-label", "inputId", "disabled", "readonly", "required"], outputs: ["valueChange"] }, { kind: "component", type: i3$3.SiSelectComponent, selector: "si-select", inputs: ["id", "ariaLabel", "labelledby", "filterPlaceholder", "noResultsFoundLabel", "readonly", "hasFilter"], outputs: ["dropdownClose"] }, { kind: "directive", type: i3$3.SiSelectSimpleOptionsDirective, selector: "si-select[options]", inputs: ["options"] }, { kind: "directive", type: i3$3.SiSelectSingleValueDirective, selector: "si-select:not([multi])" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiRelativeDateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-relative-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex\">\n  <si-number-input\n    class=\"form-control flex-fill\"\n    [aria-label]=\"valueLabel\"\n    [(ngModel)]=\"offset\"\n    (ngModelChange)=\"updateValue()\"\n  ></si-number-input>\n  <si-select\n    class=\"form-control ms-4 flex-fill\"\n    min=\"0\"\n    [ariaLabel]=\"unitLabel\"\n    [options]=\"offsetList\"\n    [(ngModel)]=\"unit\"\n    (ngModelChange)=\"changeUnit()\"\n  ></si-select>\n</div>\n", styles: [".form-control{min-inline-size:0}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }], enableTimeSelection: [{
                type: Input
            }], valueLabel: [{
                type: Input
            }], unitLabel: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

let idCounter = 1;
class SiDateRangeFilterComponent {
    service = inject(SiDateRangeCalculationService);
    cdRef = inject(ChangeDetectorRef);
    /** The filter range object */
    range;
    /** List of preset time ranges. When not present or empty, the preset section won't show */
    presetList;
    /** Determines if there's a search field for the preset list */
    presetSearch = true;
    /** Determines if time is selectable or only dates */
    enableTimeSelection = false;
    /** label for the "Reference point" title */
    refLabel = $localize `:@@SI_DATE_RANGE_FILTER.REF_POINT:Reference point`;
    /** label for the "Range" title */
    rangeLabel = $localize `:@@SI_DATE_RANGE_FILTER.RANGE:Range`;
    /** label for the "Today" checkbox */
    todayLabel = $localize `:@@SI_DATE_RANGE_FILTER.TODAY:Today`;
    /** label for the "Now" checkbox */
    nowLabel = $localize `:@@SI_DATE_RANGE_FILTER.NOW:Now`;
    /** label for "Date" field / radio button */
    dateLabel = $localize `:@@SI_DATE_RANGE_FILTER.DATE:Date`;
    /** label for "Duration" radio button */
    durationLabel = $localize `:@@SI_DATE_RANGE_FILTER.DURATION:Duration`;
    /** label for the "Preview" title */
    previewLabel = $localize `:@@SI_DATE_RANGE_FILTER.PREVIEW:Preview`;
    /** Placeholder for date fields */
    datePlaceholder = $localize `:@@SI_DATE_RANGE_FILTER.DATE_PLACEHOLDER:Select date`;
    /** label for the "Before" toggle */
    beforeLabel = $localize `:@@SI_DATE_RANGE_FILTER.BEFORE:Before`;
    /** label for the "After" toggle */
    afterLabel = $localize `:@@SI_DATE_RANGE_FILTER.AFTER:After`;
    /** label for the "Within" toggle */
    withinLabel = $localize `:@@SI_DATE_RANGE_FILTER.WITHIN:Within`;
    /** label for the "value" number input */
    valueLabel = $localize `:@@SI_DATE_RANGE_FILTER.VALUE:Value`;
    /** label for the "Unit" select */
    unitLabel = $localize `:@@SI_DATE_RANGE_FILTER.UNIT:Unit`;
    /** label for the "search" input */
    searchLabel = $localize `:@@SI_DATE_RANGE_FILTER.SEARCH:Search`;
    /** label for the "search" input */
    presetLabel = $localize `:@@SI_DATE_RANGE_FILTER.PRESETS:Presets`;
    /** Event fired when the selected range changes */
    rangeChange = new EventEmitter();
    point1Now = true;
    point2Mode = 'duration';
    point1date = new Date();
    point2date = new Date();
    point2offset = 0;
    point2range = 'before';
    calculatedRange = {
        start: new Date(),
        end: new Date(),
        valid: true
    };
    pipeFormat = 'shortDate';
    datepickerConfig = {};
    filteredPresetList = [];
    presetFilter = '';
    componentId = '__si-date-range-filter-' + idCounter++;
    trackByIndex = (index) => index;
    ngOnChanges(changes) {
        if (changes.enableTimeSelection ||
            (changes.range && this.rangeChanged(changes.range.previousValue, changes.range.currentValue))) {
            this.updateFromRange();
        }
        if (changes.presetList || changes.enableTimeSelection) {
            this.filterPresetList();
        }
    }
    rangeChanged(oldRange, newRange) {
        return (!oldRange ||
            oldRange.point1 !== newRange.point1 ||
            oldRange.point2 !== newRange.point2 ||
            oldRange.range !== newRange.range);
    }
    updateFromRange() {
        this.point1Now = this.range.point1 === 'now';
        this.point1date = this.range.point1 === 'now' ? new Date() : this.range.point1;
        this.point2Mode = this.range.point2 instanceof Date ? 'date' : 'duration';
        this.point2date = this.range.point2 instanceof Date ? this.range.point2 : new Date();
        this.point2range = this.range.range ?? 'before';
        this.point2offset =
            this.range.point2 instanceof Date
                ? Math.round(this.point1date.getTime() - this.range.point2.getTime())
                : this.range.point2;
        this.pipeFormat = this.enableTimeSelection ? 'short' : 'shortDate';
        this.datepickerConfig = this.enableTimeSelection ? { showTime: true, mandatoryTime: true } : {};
        this.updateCalculatedRange();
    }
    point1Changed() {
        if (this.point1Now) {
            this.range.point1 = 'now';
            this.point1date = new Date();
            if (this.point2Mode !== 'date') {
                this.point2range ??= 'before';
            }
        }
        else {
            this.range.point1 = this.point1date ?? new Date(NaN);
        }
        this.updateCalculatedRange();
        this.emitChange();
    }
    point2Changed() {
        if (this.point2Mode === 'date') {
            this.range.point2 = this.point2date;
            this.range.range = undefined;
        }
        else {
            this.range.point2 = this.point2offset;
            this.range.range = this.point2range;
        }
        this.updateCalculatedRange();
        this.emitChange();
    }
    selectPresetItem(item) {
        this.range.point1 = 'now';
        this.range.range = 'before';
        this.range.point2 = item.offset;
        this.point2range = 'before';
        this.updateFromRange();
        this.emitChange();
    }
    updateCalculatedRange() {
        this.calculatedRange = this.service.resolveDateRangeFilter(this.range);
        this.cdRef.markForCheck();
    }
    filterPresetList() {
        const timeFilter = (item) => this.enableTimeSelection || item.offset >= ONE_DAY;
        if (!this.presetFilter || !this.presetList) {
            this.filteredPresetList = (this.presetList ?? []).filter(timeFilter);
            return;
        }
        const regex = new RegExp(this.presetFilter, 'i');
        this.filteredPresetList = this.presetList.filter(item => regex.test(item.label) && timeFilter(item));
    }
    emitChange() {
        this.rangeChange.emit({ ...this.range });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiDateRangeFilterComponent, selector: "si-date-range-filter", inputs: { range: "range", presetList: "presetList", presetSearch: "presetSearch", enableTimeSelection: "enableTimeSelection", refLabel: "refLabel", rangeLabel: "rangeLabel", todayLabel: "todayLabel", nowLabel: "nowLabel", dateLabel: "dateLabel", durationLabel: "durationLabel", previewLabel: "previewLabel", datePlaceholder: "datePlaceholder", beforeLabel: "beforeLabel", afterLabel: "afterLabel", withinLabel: "withinLabel", valueLabel: "valueLabel", unitLabel: "unitLabel", searchLabel: "searchLabel", presetLabel: "presetLabel" }, outputs: { rangeChange: "rangeChange" }, usesOnChanges: true, ngImport: i0, template: "<form class=\"main-form d-flex flex-column flex-fill pe-6\">\n  <b>{{ refLabel | translate }}</b>\n  <div class=\"mt-4 mb-8\">\n    <label class=\"d-block\">\n      <span class=\"form-label\">{{ dateLabel | translate }}</span>\n      <input\n        type=\"text\"\n        class=\"form-control\"\n        name=\"point1\"\n        required\n        siDatepicker\n        [siDatepickerConfig]=\"datepickerConfig\"\n        [disabled]=\"point1Now\"\n        [placeholder]=\"datePlaceholder | translate\"\n        [(ngModel)]=\"point1date\"\n        (ngModelChange)=\"point1Changed()\"\n      />\n    </label>\n    <label class=\"mt-4 text-nowrap\">\n      <input\n        type=\"checkbox\"\n        class=\"form-check-input me-3\"\n        name=\"point1now\"\n        [(ngModel)]=\"point1Now\"\n        (ngModelChange)=\"point1Changed()\"\n      />\n      <span class=\"form-check-label\">{{\n        (enableTimeSelection ? nowLabel : todayLabel) | translate\n      }}</span>\n    </label>\n  </div>\n\n  <b>{{ rangeLabel | translate }}</b>\n  <div class=\"mt-4 mb-8\">\n    <label>\n      <input\n        type=\"radio\"\n        class=\"form-check-input me-3\"\n        value=\"duration\"\n        name=\"point2mode\"\n        [(ngModel)]=\"point2Mode\"\n        (ngModelChange)=\"point2Changed()\"\n      />\n      <span class=\"form-check-label\">{{ durationLabel | translate }}</span>\n    </label>\n    <label class=\"ms-6\">\n      <input\n        type=\"radio\"\n        class=\"form-check-input me-3\"\n        value=\"date\"\n        name=\"point2mode\"\n        [(ngModel)]=\"point2Mode\"\n        (ngModelChange)=\"point2Changed()\"\n      />\n      <span class=\"form-check-label\">{{ dateLabel | translate }}</span>\n    </label>\n    <div *ngIf=\"point2Mode === 'date'\" class=\"my-4 pb-9\">\n      <input\n        type=\"text\"\n        class=\"form-control\"\n        name=\"point2\"\n        required\n        siDatepicker\n        [siDatepickerConfig]=\"datepickerConfig\"\n        [attr.aria-label]=\"dateLabel | translate\"\n        [placeholder]=\"datePlaceholder | translate\"\n        [(ngModel)]=\"point2date\"\n        (ngModelChange)=\"point2Changed()\"\n      />\n    </div>\n    <div *ngIf=\"point2Mode === 'duration'\" class=\"mt-4\">\n      <si-relative-date\n        class=\"d-block my-4\"\n        [unitLabel]=\"unitLabel | translate\"\n        [valueLabel]=\"valueLabel | translate\"\n        [enableTimeSelection]=\"enableTimeSelection\"\n        [(value)]=\"point2offset\"\n        (valueChange)=\"point2Changed()\"\n      ></si-relative-date>\n      <div class=\"btn-group w-100\">\n        <input\n          type=\"radio\"\n          class=\"btn-check\"\n          value=\"before\"\n          name=\"point2range\"\n          [id]=\"componentId + '_range-before'\"\n          [(ngModel)]=\"point2range\"\n          (ngModelChange)=\"point2Changed()\"\n        />\n        <label class=\"btn btn-sm\" [for]=\"componentId + '_range-before'\">\n          <i class=\"icon element-left-4\" aria-hidden=\"true\"></i>\n          {{ beforeLabel | translate }}\n        </label>\n        <input\n          type=\"radio\"\n          class=\"btn-check\"\n          value=\"after\"\n          name=\"point2range\"\n          [id]=\"componentId + '_range-after'\"\n          [(ngModel)]=\"point2range\"\n          (ngModelChange)=\"point2Changed()\"\n        />\n        <label class=\"btn btn-sm\" [for]=\"componentId + '_range-after'\">\n          <i class=\"icon element-right-4\" aria-hidden=\"true\"></i>\n          {{ afterLabel | translate }}\n        </label>\n        <input\n          type=\"radio\"\n          class=\"btn-check\"\n          value=\"within\"\n          name=\"point2range\"\n          [id]=\"componentId + '_range-within'\"\n          [(ngModel)]=\"point2range\"\n          (ngModelChange)=\"point2Changed()\"\n        />\n        <label class=\"btn btn-sm\" [for]=\"componentId + '_range-within'\">\n          <i class=\"icon element-zoom\" aria-hidden=\"true\"></i>\n          {{ withinLabel | translate }}\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <b>{{ previewLabel | translate }}</b>\n  <div class=\"preview mt-4\">\n    <ng-container *ngIf=\"calculatedRange.valid; else invalidRange\">\n      {{ calculatedRange.start | date : pipeFormat }} -\n      {{ calculatedRange.end | date : pipeFormat }}\n    </ng-container>\n    <ng-template #invalidRange>?</ng-template>\n  </div>\n</form>\n<div *ngIf=\"presetList?.length\" class=\"preset-select ps-6 border-start\">\n  <si-search-bar\n    *ngIf=\"presetSearch\"\n    colorVariant=\"base-0\"\n    class=\"mb-6\"\n    [placeholder]=\"searchLabel | translate\"\n    [showIcon]=\"true\"\n    [(ngModel)]=\"presetFilter\"\n    (ngModelChange)=\"filterPresetList()\"\n  ></si-search-bar>\n  <ul class=\"overflow-auto\" cdkListbox [attr.aria-label]=\"presetLabel | translate\">\n    <li\n      *ngFor=\"let item of filteredPresetList; trackBy: trackByIndex\"\n      class=\"preset-item focus-inside p-5\"\n      [class.selected]=\"point1Now && point2range === 'before' && point2offset === item.offset\"\n      [cdkOption]=\"item.offset\"\n      (click)=\"selectPresetItem(item)\"\n      (keydown.enter)=\"selectPresetItem(item)\"\n    >\n      {{ item.label | translate }}\n    </li>\n  </ul>\n</div>\n", styles: [":host{display:inline-flex;background:var(--element-base-1)}.main-form{inline-size:360px}.preset-select{display:flex;inline-size:200px;flex-direction:column}ul{flex:1 1 0;padding-inline-start:0;list-style:none}.preset-item{cursor:pointer;line-height:1.143}.preset-item:hover{background:var(--element-base-1-hover)}.preset-item.selected{background:var(--element-base-1-selected)}label{display:inline-flex;align-items:center}.form-check-input{inset-block-start:0}.element-zoom{rotate:45deg}\n"], dependencies: [{ kind: "directive", type: i1$2.CdkListbox, selector: "[cdkListbox]", inputs: ["id", "tabindex", "cdkListboxValue", "cdkListboxMultiple", "cdkListboxDisabled", "cdkListboxUseActiveDescendant", "cdkListboxOrientation", "cdkListboxCompareWith", "cdkListboxNavigationWrapDisabled", "cdkListboxNavigatesDisabledOptions"], outputs: ["cdkListboxValueChange"], exportAs: ["cdkListbox"] }, { kind: "directive", type: i1$2.CdkOption, selector: "[cdkOption]", inputs: ["id", "cdkOption", "cdkOptionTypeaheadLabel", "cdkOptionDisabled", "tabindex"], exportAs: ["cdkOption"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$a.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$a.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$a.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2$a.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i2$a.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$a.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$a.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$a.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2$a.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: SiDatepickerDirective, selector: "[siDatepicker]", inputs: ["autoClose", "triggeringInput"], exportAs: ["siDatepicker"] }, { kind: "component", type: i5.SiSearchBarComponent, selector: "si-search-bar", inputs: ["debounceTime", "prohibitedCharacters", "placeholder", "showIcon", "tabbable", "value", "disabled", "readonly", "colorVariant"], outputs: ["searchChange"] }, { kind: "component", type: SiRelativeDateComponent, selector: "si-relative-date", inputs: ["value", "enableTimeSelection", "valueLabel", "unitLabel"], outputs: ["valueChange"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-date-range-filter', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form class=\"main-form d-flex flex-column flex-fill pe-6\">\n  <b>{{ refLabel | translate }}</b>\n  <div class=\"mt-4 mb-8\">\n    <label class=\"d-block\">\n      <span class=\"form-label\">{{ dateLabel | translate }}</span>\n      <input\n        type=\"text\"\n        class=\"form-control\"\n        name=\"point1\"\n        required\n        siDatepicker\n        [siDatepickerConfig]=\"datepickerConfig\"\n        [disabled]=\"point1Now\"\n        [placeholder]=\"datePlaceholder | translate\"\n        [(ngModel)]=\"point1date\"\n        (ngModelChange)=\"point1Changed()\"\n      />\n    </label>\n    <label class=\"mt-4 text-nowrap\">\n      <input\n        type=\"checkbox\"\n        class=\"form-check-input me-3\"\n        name=\"point1now\"\n        [(ngModel)]=\"point1Now\"\n        (ngModelChange)=\"point1Changed()\"\n      />\n      <span class=\"form-check-label\">{{\n        (enableTimeSelection ? nowLabel : todayLabel) | translate\n      }}</span>\n    </label>\n  </div>\n\n  <b>{{ rangeLabel | translate }}</b>\n  <div class=\"mt-4 mb-8\">\n    <label>\n      <input\n        type=\"radio\"\n        class=\"form-check-input me-3\"\n        value=\"duration\"\n        name=\"point2mode\"\n        [(ngModel)]=\"point2Mode\"\n        (ngModelChange)=\"point2Changed()\"\n      />\n      <span class=\"form-check-label\">{{ durationLabel | translate }}</span>\n    </label>\n    <label class=\"ms-6\">\n      <input\n        type=\"radio\"\n        class=\"form-check-input me-3\"\n        value=\"date\"\n        name=\"point2mode\"\n        [(ngModel)]=\"point2Mode\"\n        (ngModelChange)=\"point2Changed()\"\n      />\n      <span class=\"form-check-label\">{{ dateLabel | translate }}</span>\n    </label>\n    <div *ngIf=\"point2Mode === 'date'\" class=\"my-4 pb-9\">\n      <input\n        type=\"text\"\n        class=\"form-control\"\n        name=\"point2\"\n        required\n        siDatepicker\n        [siDatepickerConfig]=\"datepickerConfig\"\n        [attr.aria-label]=\"dateLabel | translate\"\n        [placeholder]=\"datePlaceholder | translate\"\n        [(ngModel)]=\"point2date\"\n        (ngModelChange)=\"point2Changed()\"\n      />\n    </div>\n    <div *ngIf=\"point2Mode === 'duration'\" class=\"mt-4\">\n      <si-relative-date\n        class=\"d-block my-4\"\n        [unitLabel]=\"unitLabel | translate\"\n        [valueLabel]=\"valueLabel | translate\"\n        [enableTimeSelection]=\"enableTimeSelection\"\n        [(value)]=\"point2offset\"\n        (valueChange)=\"point2Changed()\"\n      ></si-relative-date>\n      <div class=\"btn-group w-100\">\n        <input\n          type=\"radio\"\n          class=\"btn-check\"\n          value=\"before\"\n          name=\"point2range\"\n          [id]=\"componentId + '_range-before'\"\n          [(ngModel)]=\"point2range\"\n          (ngModelChange)=\"point2Changed()\"\n        />\n        <label class=\"btn btn-sm\" [for]=\"componentId + '_range-before'\">\n          <i class=\"icon element-left-4\" aria-hidden=\"true\"></i>\n          {{ beforeLabel | translate }}\n        </label>\n        <input\n          type=\"radio\"\n          class=\"btn-check\"\n          value=\"after\"\n          name=\"point2range\"\n          [id]=\"componentId + '_range-after'\"\n          [(ngModel)]=\"point2range\"\n          (ngModelChange)=\"point2Changed()\"\n        />\n        <label class=\"btn btn-sm\" [for]=\"componentId + '_range-after'\">\n          <i class=\"icon element-right-4\" aria-hidden=\"true\"></i>\n          {{ afterLabel | translate }}\n        </label>\n        <input\n          type=\"radio\"\n          class=\"btn-check\"\n          value=\"within\"\n          name=\"point2range\"\n          [id]=\"componentId + '_range-within'\"\n          [(ngModel)]=\"point2range\"\n          (ngModelChange)=\"point2Changed()\"\n        />\n        <label class=\"btn btn-sm\" [for]=\"componentId + '_range-within'\">\n          <i class=\"icon element-zoom\" aria-hidden=\"true\"></i>\n          {{ withinLabel | translate }}\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <b>{{ previewLabel | translate }}</b>\n  <div class=\"preview mt-4\">\n    <ng-container *ngIf=\"calculatedRange.valid; else invalidRange\">\n      {{ calculatedRange.start | date : pipeFormat }} -\n      {{ calculatedRange.end | date : pipeFormat }}\n    </ng-container>\n    <ng-template #invalidRange>?</ng-template>\n  </div>\n</form>\n<div *ngIf=\"presetList?.length\" class=\"preset-select ps-6 border-start\">\n  <si-search-bar\n    *ngIf=\"presetSearch\"\n    colorVariant=\"base-0\"\n    class=\"mb-6\"\n    [placeholder]=\"searchLabel | translate\"\n    [showIcon]=\"true\"\n    [(ngModel)]=\"presetFilter\"\n    (ngModelChange)=\"filterPresetList()\"\n  ></si-search-bar>\n  <ul class=\"overflow-auto\" cdkListbox [attr.aria-label]=\"presetLabel | translate\">\n    <li\n      *ngFor=\"let item of filteredPresetList; trackBy: trackByIndex\"\n      class=\"preset-item focus-inside p-5\"\n      [class.selected]=\"point1Now && point2range === 'before' && point2offset === item.offset\"\n      [cdkOption]=\"item.offset\"\n      (click)=\"selectPresetItem(item)\"\n      (keydown.enter)=\"selectPresetItem(item)\"\n    >\n      {{ item.label | translate }}\n    </li>\n  </ul>\n</div>\n", styles: [":host{display:inline-flex;background:var(--element-base-1)}.main-form{inline-size:360px}.preset-select{display:flex;inline-size:200px;flex-direction:column}ul{flex:1 1 0;padding-inline-start:0;list-style:none}.preset-item{cursor:pointer;line-height:1.143}.preset-item:hover{background:var(--element-base-1-hover)}.preset-item.selected{background:var(--element-base-1-selected)}label{display:inline-flex;align-items:center}.form-check-input{inset-block-start:0}.element-zoom{rotate:45deg}\n"] }]
        }], propDecorators: { range: [{
                type: Input
            }], presetList: [{
                type: Input
            }], presetSearch: [{
                type: Input
            }], enableTimeSelection: [{
                type: Input
            }], refLabel: [{
                type: Input
            }], rangeLabel: [{
                type: Input
            }], todayLabel: [{
                type: Input
            }], nowLabel: [{
                type: Input
            }], dateLabel: [{
                type: Input
            }], durationLabel: [{
                type: Input
            }], previewLabel: [{
                type: Input
            }], datePlaceholder: [{
                type: Input
            }], beforeLabel: [{
                type: Input
            }], afterLabel: [{
                type: Input
            }], withinLabel: [{
                type: Input
            }], valueLabel: [{
                type: Input
            }], unitLabel: [{
                type: Input
            }], searchLabel: [{
                type: Input
            }], presetLabel: [{
                type: Input
            }], rangeChange: [{
                type: Output
            }] } });

class SiDateRangeFilterModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeFilterModule, declarations: [SiDateRangeFilterComponent, SiRelativeDateComponent], imports: [CdkListboxModule,
            CommonModule,
            FormsModule,
            SiDatepickerModule,
            SiNumberInputModule,
            SiSearchBarModule,
            SiSelectModule,
            SiTranslateModule], exports: [SiDateRangeFilterComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeFilterModule, imports: [CdkListboxModule,
            CommonModule,
            FormsModule,
            SiDatepickerModule,
            SiNumberInputModule,
            SiSearchBarModule,
            SiSelectModule,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDateRangeFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CdkListboxModule,
                        CommonModule,
                        FormsModule,
                        SiDatepickerModule,
                        SiNumberInputModule,
                        SiSearchBarModule,
                        SiSelectModule,
                        SiTranslateModule
                    ],
                    declarations: [SiDateRangeFilterComponent, SiRelativeDateComponent],
                    exports: [SiDateRangeFilterComponent]
                }]
        }] });

class SiElectrontitlebarComponent {
    /**
     * Title of your application
     */
    appTitle;
    /**
     * Defines if the application can go back or not
     */
    canGoBack = false;
    /**
     * Defines if the application can go forward or not
     */
    canGoForward = false;
    /**
     * Defines if the application is focused or not
     */
    hasFocus = true;
    /**
     * List of menu items for the dropdown
     * In this dropdown should the zoom functionality as well as the refresh function be provided
     */
    menuItems = [];
    /**
     * Browsing forward function
     */
    forward = new EventEmitter();
    /**
     * Browsing back function
     */
    back = new EventEmitter();
    /**
     * Aria Label for Forward Button
     */
    ariaLabelForward = $localize `:@@SI_ELECTRON_TITLEBAR.FORWARD:Forward`;
    /**
     * Aria Label for Back Button
     */
    ariaLabelBack = $localize `:@@SI_ELECTRON_TITLEBAR.BACK:Back`;
    /**
     * Aria Label for Menu Button
     */
    ariaLabelMenu = $localize `:@@SI_ELECTRON_TITLEBAR.MENU:Menu`;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiElectrontitlebarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiElectrontitlebarComponent, selector: "si-electron-titlebar", inputs: { appTitle: "appTitle", canGoBack: "canGoBack", canGoForward: "canGoForward", hasFocus: "hasFocus", menuItems: "menuItems", ariaLabelForward: "ariaLabelForward", ariaLabelBack: "ariaLabelBack", ariaLabelMenu: "ariaLabelMenu" }, outputs: { forward: "forward", back: "back" }, ngImport: i0, template: "<div class=\"electron-title-bar-container w-100 bg-base-1 border-bottom fixed-top\">\n  <div class=\"electron-title-bar align-items-center d-flex h-100\">\n    <span\n      class=\"ms-6 me-9 si-body-2 electron-title-bar-app-name text-truncate\"\n      [class.unfocused]=\"!hasFocus\"\n      >{{ appTitle }}</span\n    >\n    <button\n      type=\"button\"\n      class=\"btn btn-circle btn-xs btn-inline element-left-4 flip-rtl me-6\"\n      [class.unfocused]=\"!hasFocus\"\n      [attr.aria-label]=\"ariaLabelBack | translate\"\n      [disabled]=\"!canGoBack\"\n      (click)=\"back.emit()\"\n    ></button>\n    <button\n      type=\"button\"\n      class=\"btn btn-circle btn-xs btn-inline element-right-4 flip-rtl me-6\"\n      [class.unfocused]=\"!hasFocus\"\n      [attr.aria-label]=\"ariaLabelForward | translate\"\n      [disabled]=\"!canGoForward\"\n      (click)=\"forward.emit()\"\n    ></button>\n    <div\n      *ngIf=\"menuItems.length > 0\"\n      #dropdown=\"si-dropdown\"\n      siDropdown\n      class=\"btn-group me-5\"\n      dropdownDirection=\"down\"\n      dropdownContainer=\"body\"\n    >\n      <button\n        siDropdownToggle\n        type=\"button\"\n        class=\"btn btn-circle electron-title-bar-btn btn-inline btn-xs element-options-vertical me-6\"\n        [class.unfocused]=\"!hasFocus\"\n        [attr.aria-label]=\"ariaLabelMenu | translate\"\n      ></button>\n      <si-menu *ngIf=\"dropdown.isOpen\" class=\"dropdown-menu m-5\" siDropdownMenu [items]=\"menuItems\">\n      </si-menu>\n    </div>\n    <div class=\"electron-title-bar-draggable flex-grow-1 w-100 h-100\"></div>\n  </div>\n</div>\n", styles: [".electron-title-bar-container{block-size:36px}.electron-title-bar{position:absolute;inset-inline-start:env(titlebar-area-x,0);inline-size:env(titlebar-area-width,100%)}.electron-title-bar-app-name{color:var(--element-text-secondary);-webkit-app-region:drag;-webkit-user-select:none;user-select:none}.electron-title-bar-draggable{flex-basis:content;-webkit-app-region:drag}.unfocused{color:var(--element-ui-3)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$4.SiDropdownDirective, selector: "[siDropdown]", inputs: ["dropdownIsDisabled", "dropdownIsOpen", "dropdownOpenOnLoad", "dropdownCloseOnSelect", "dropdownCloseOnClickOut", "dropdownCloseOnEsc", "dropdownDirection", "dropdownAlign", "dropdownContainer", "dropdownResponsiveDirection", "dropdownResponsiveDirectionToPlacement", "dropdownPlacement", "dropdownPlacementReference", "dropdownItemSelector", "dropdownItemSelectorException", "dropdownFocusOnOpen", "dropdownFocusOnClose", "closeOnMenuScrollOut", "closeOnPlacementReferenceScrollOut"], outputs: ["dropdownOnToggle", "dropdownOnSelect", "dropdownResponsiveDirectionChange"], exportAs: ["si-dropdown"] }, { kind: "directive", type: i2$4.SiDropdownMenuDirective, selector: "[siDropdownMenu]", inputs: ["tabindex"], exportAs: ["si-dropdown-menu"] }, { kind: "directive", type: i2$4.SiDropdownToggleDirective, selector: "[siDropdownToggle]", exportAs: ["si-dropdown-toggle"] }, { kind: "component", type: i3$2.SiMenuComponent, selector: "si-menu", inputs: ["items", "dropleft", "dropstart", "responsiveDropleft", "responsiveDropstart", "responsivelyDropUpwards", "actionParam", "focusOnLoad", "focus", "focusLastFromParent", "isSubList", "parentItem", "refocusAfterEnter", "position", "autofocusFromParent", "relativePositioning", "forceTitle"], outputs: ["activeChange"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiElectrontitlebarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-electron-titlebar', template: "<div class=\"electron-title-bar-container w-100 bg-base-1 border-bottom fixed-top\">\n  <div class=\"electron-title-bar align-items-center d-flex h-100\">\n    <span\n      class=\"ms-6 me-9 si-body-2 electron-title-bar-app-name text-truncate\"\n      [class.unfocused]=\"!hasFocus\"\n      >{{ appTitle }}</span\n    >\n    <button\n      type=\"button\"\n      class=\"btn btn-circle btn-xs btn-inline element-left-4 flip-rtl me-6\"\n      [class.unfocused]=\"!hasFocus\"\n      [attr.aria-label]=\"ariaLabelBack | translate\"\n      [disabled]=\"!canGoBack\"\n      (click)=\"back.emit()\"\n    ></button>\n    <button\n      type=\"button\"\n      class=\"btn btn-circle btn-xs btn-inline element-right-4 flip-rtl me-6\"\n      [class.unfocused]=\"!hasFocus\"\n      [attr.aria-label]=\"ariaLabelForward | translate\"\n      [disabled]=\"!canGoForward\"\n      (click)=\"forward.emit()\"\n    ></button>\n    <div\n      *ngIf=\"menuItems.length > 0\"\n      #dropdown=\"si-dropdown\"\n      siDropdown\n      class=\"btn-group me-5\"\n      dropdownDirection=\"down\"\n      dropdownContainer=\"body\"\n    >\n      <button\n        siDropdownToggle\n        type=\"button\"\n        class=\"btn btn-circle electron-title-bar-btn btn-inline btn-xs element-options-vertical me-6\"\n        [class.unfocused]=\"!hasFocus\"\n        [attr.aria-label]=\"ariaLabelMenu | translate\"\n      ></button>\n      <si-menu *ngIf=\"dropdown.isOpen\" class=\"dropdown-menu m-5\" siDropdownMenu [items]=\"menuItems\">\n      </si-menu>\n    </div>\n    <div class=\"electron-title-bar-draggable flex-grow-1 w-100 h-100\"></div>\n  </div>\n</div>\n", styles: [".electron-title-bar-container{block-size:36px}.electron-title-bar{position:absolute;inset-inline-start:env(titlebar-area-x,0);inline-size:env(titlebar-area-width,100%)}.electron-title-bar-app-name{color:var(--element-text-secondary);-webkit-app-region:drag;-webkit-user-select:none;user-select:none}.electron-title-bar-draggable{flex-basis:content;-webkit-app-region:drag}.unfocused{color:var(--element-ui-3)}\n"] }]
        }], propDecorators: { appTitle: [{
                type: Input,
                args: [{ required: true }]
            }], canGoBack: [{
                type: Input
            }], canGoForward: [{
                type: Input
            }], hasFocus: [{
                type: Input
            }], menuItems: [{
                type: Input
            }], forward: [{
                type: Output
            }], back: [{
                type: Output
            }], ariaLabelForward: [{
                type: Input
            }], ariaLabelBack: [{
                type: Input
            }], ariaLabelMenu: [{
                type: Input
            }] } });

class SiElectrontitlebarModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiElectrontitlebarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiElectrontitlebarModule, declarations: [SiElectrontitlebarComponent], imports: [CommonModule, SiDropdownModule, SiMenuModule, SiTranslateModule], exports: [SiElectrontitlebarComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiElectrontitlebarModule, imports: [CommonModule, SiDropdownModule, SiMenuModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiElectrontitlebarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiElectrontitlebarComponent],
                    imports: [CommonModule, SiDropdownModule, SiMenuModule, SiTranslateModule],
                    exports: [SiElectrontitlebarComponent]
                }]
        }] });

const runsInElectron = () => {
    const windowAny = window;
    const processAny = windowAny.process;
    // Renderer process
    if (typeof windowAny !== 'undefined' &&
        typeof processAny === 'object' &&
        processAny.type === 'renderer') {
        return true;
    }
    // Main process
    if (typeof processAny !== 'undefined' &&
        typeof processAny.versions === 'object' &&
        !!processAny.versions.electron) {
        return true;
    }
    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' &&
        typeof navigator.userAgent === 'string' &&
        navigator.userAgent.includes('Electron')) {
        return true;
    }
    return false;
};

class SiPaginationComponent {
    static maxItems = 7;
    /**
     * The total number of pages.
     * Alternatively use `itemsPerPage` and `totalItems`
     */
    totalPages;
    /**
     * The current active page, counting starts from 1
     */
    currentPage = 1;
    /**
     * The number of items per page.
     * Used to calculate the total number of page if `totalPages` is not available
     */
    pageSize;
    /**
     * The total number of items.
     * Used to calculate the total number of page if `totalPages` is not available
     */
    totalRowCount;
    /**
     * The text of the back button for pagination. Required for a11y.
     */
    backButtonText = $localize `:@@SI_PAGINATION.BACK:Back`;
    /**
     * The text of the forward button for pagination. Required for a11y.
     */
    forwardButtonText = $localize `:@@SI_PAGINATION.FORWARD:Forward`;
    /**
     * When multiple paginations are used on the same page each pagination needs a distinct aria label.
     * Required for a11y.
     */
    navAriaLabel = $localize `:@@SI_PAGINATION.NAV_LABEL:Pagination`;
    /**
     * Fired when the user changes the page
     */
    currentPageChange = new EventEmitter();
    pageButtons = [];
    prevDisabled = false;
    nextDisabled = false;
    ngOnChanges() {
        this.createPages();
    }
    createPages() {
        this.pageButtons = [];
        const totalPages = this.totalPages ?? Math.ceil((this.totalRowCount ?? 0) / (this.pageSize ?? 1));
        if (totalPages <= SiPaginationComponent.maxItems) {
            for (let i = 0; i < totalPages; i++) {
                this.pageButtons.push({ page: i + 1, sep: false });
            }
        }
        else if (this.currentPage < SiPaginationComponent.maxItems - 2) {
            // separator only on the right (in LTR)
            for (let i = 0; i < SiPaginationComponent.maxItems - 2; i++) {
                this.pageButtons.push({ page: i + 1, sep: false });
            }
            this.pageButtons.push({ page: 0, sep: true });
            this.pageButtons.push({ page: totalPages, sep: false });
        }
        else if (this.currentPage >= totalPages - 3) {
            // separator only on the left (in LTR)
            this.pageButtons.push({ page: 1, sep: false });
            this.pageButtons.push({ page: 0, sep: true });
            for (let i = totalPages - SiPaginationComponent.maxItems + 2; i < totalPages; i++) {
                this.pageButtons.push({ page: i + 1, sep: false });
            }
        }
        else {
            // separator on both sides
            this.pageButtons.push({ page: 1, sep: false });
            this.pageButtons.push({ page: 0, sep: true });
            for (let i = -1; i <= 1; i++) {
                this.pageButtons.push({ page: this.currentPage + i, sep: false });
            }
            this.pageButtons.push({ page: 0, sep: true });
            this.pageButtons.push({ page: totalPages, sep: false });
        }
        this.prevDisabled = this.currentPage === 1;
        this.nextDisabled = this.currentPage === totalPages;
    }
    trackByIndex = (index) => index;
    direction(event, delta) {
        this.setPage(event, this.currentPage + delta);
    }
    setPage(event, page) {
        event.currentTarget.blur();
        this.currentPage = page;
        this.createPages();
        this.currentPageChange.emit(page);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiPaginationComponent, selector: "si-pagination", inputs: { totalPages: "totalPages", currentPage: "currentPage", pageSize: "pageSize", totalRowCount: "totalRowCount", backButtonText: "backButtonText", forwardButtonText: "forwardButtonText", navAriaLabel: "navAriaLabel" }, outputs: { currentPageChange: "currentPageChange" }, usesOnChanges: true, ngImport: i0, template: "<nav role=\"navigation\" [attr.aria-label]=\"navAriaLabel | translate\">\n  <ul class=\"pagination\">\n    <li class=\"me-5\">\n      <button\n        type=\"button\"\n        class=\"btn nav-button border-0 mx-4\"\n        [disabled]=\"prevDisabled\"\n        [attr.aria-label]=\"backButtonText | translate\"\n        (click)=\"direction($event, -1)\"\n      >\n        <i class=\"element-left-3 flip-rtl\"></i>\n      </button>\n    </li>\n    <li *ngFor=\"let page of pageButtons; trackBy: trackByIndex\">\n      <button\n        *ngIf=\"!page.sep\"\n        type=\"button\"\n        class=\"btn page-button border-0 mx-1 si-title-2 px-2\"\n        [attr.aria-current]=\"page.page === currentPage ? 'page' : ''\"\n        [disabled]=\"page.page === currentPage\"\n        (click)=\"setPage($event, page.page)\"\n      >\n        {{ page.page }}\n      </button>\n      <span *ngIf=\"page.sep\" class=\"separator mx-2\">&hellip;</span>\n    </li>\n    <li class=\"ms-5\">\n      <button\n        type=\"button\"\n        class=\"btn nav-button border-0 mx-4\"\n        [disabled]=\"nextDisabled\"\n        [attr.aria-label]=\"forwardButtonText | translate\"\n        (click)=\"direction($event, 1)\"\n      >\n        <i class=\"element-right-3 flip-rtl\"></i>\n      </button>\n    </li>\n  </ul>\n</nav>\n", styles: [".pagination{display:flex;align-items:center;block-size:40px}.page-button,.nav-button,.separator{display:flex;align-items:center;justify-content:center;border-radius:12px;min-inline-size:24px!important;block-size:24px;padding-block:0;padding-inline:2px;background:transparent;font-size:.875rem}.nav-button{font-size:1.5rem;color:var(--element-text-primary);inline-size:24px}.nav-button:hover{background:var(--element-base-1-selected)}.nav-button:disabled{opacity:var(--element-action-disabled-opacity)}.page-button:hover{background:var(--element-base-1-selected)}.page-button:disabled{background:var(--element-base-1-selected);opacity:1}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-pagination', changeDetection: ChangeDetectionStrategy.OnPush, template: "<nav role=\"navigation\" [attr.aria-label]=\"navAriaLabel | translate\">\n  <ul class=\"pagination\">\n    <li class=\"me-5\">\n      <button\n        type=\"button\"\n        class=\"btn nav-button border-0 mx-4\"\n        [disabled]=\"prevDisabled\"\n        [attr.aria-label]=\"backButtonText | translate\"\n        (click)=\"direction($event, -1)\"\n      >\n        <i class=\"element-left-3 flip-rtl\"></i>\n      </button>\n    </li>\n    <li *ngFor=\"let page of pageButtons; trackBy: trackByIndex\">\n      <button\n        *ngIf=\"!page.sep\"\n        type=\"button\"\n        class=\"btn page-button border-0 mx-1 si-title-2 px-2\"\n        [attr.aria-current]=\"page.page === currentPage ? 'page' : ''\"\n        [disabled]=\"page.page === currentPage\"\n        (click)=\"setPage($event, page.page)\"\n      >\n        {{ page.page }}\n      </button>\n      <span *ngIf=\"page.sep\" class=\"separator mx-2\">&hellip;</span>\n    </li>\n    <li class=\"ms-5\">\n      <button\n        type=\"button\"\n        class=\"btn nav-button border-0 mx-4\"\n        [disabled]=\"nextDisabled\"\n        [attr.aria-label]=\"forwardButtonText | translate\"\n        (click)=\"direction($event, 1)\"\n      >\n        <i class=\"element-right-3 flip-rtl\"></i>\n      </button>\n    </li>\n  </ul>\n</nav>\n", styles: [".pagination{display:flex;align-items:center;block-size:40px}.page-button,.nav-button,.separator{display:flex;align-items:center;justify-content:center;border-radius:12px;min-inline-size:24px!important;block-size:24px;padding-block:0;padding-inline:2px;background:transparent;font-size:.875rem}.nav-button{font-size:1.5rem;color:var(--element-text-primary);inline-size:24px}.nav-button:hover{background:var(--element-base-1-selected)}.nav-button:disabled{opacity:var(--element-action-disabled-opacity)}.page-button:hover{background:var(--element-base-1-selected)}.page-button:disabled{background:var(--element-base-1-selected);opacity:1}\n"] }]
        }], propDecorators: { totalPages: [{
                type: Input
            }], currentPage: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], totalRowCount: [{
                type: Input
            }], backButtonText: [{
                type: Input
            }], forwardButtonText: [{
                type: Input
            }], navAriaLabel: [{
                type: Input
            }], currentPageChange: [{
                type: Output
            }] } });

class SiPaginationModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiPaginationModule, declarations: [SiPaginationComponent], imports: [CommonModule, SiTranslateModule], exports: [SiPaginationComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPaginationModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiTranslateModule],
                    declarations: [SiPaginationComponent],
                    exports: [SiPaginationComponent]
                }]
        }] });

/**
 * @deprecated The SiPromptDialogButtonsComponent only reuses element's
 * circle buttons and does it's arrangement. We will remove the component
 * in the future. Please add the circle buttons directly to you application.
 */
class SiPromptDialogButtonsComponent {
    /**
     * Input for disabling cancel button.
     */
    cancelDisabled = false;
    /**
     * Input for disabling confirm button.
     */
    confirmDisabled = false;
    /**
     * Input for disabling save button.
     */
    saveDisabled = false;
    /**
     * Text for aria-label of cancel button. Needed for a11y.
     */
    cancelLabel = $localize `:@@SI_PROMPT_DIALOG_BUTTONS.CANCEL:Cancel`;
    /**
     * Text for aria-label of confirm button. Needed for a11y.
     */
    confirmLabel = $localize `:@@SI_PROMPT_DIALOG_BUTTONS.CONFIRM:Confirm`;
    /**
     * Text for aria-label of save button. Needed for a11y.
     */
    saveLabel = $localize `:@@SI_PROMPT_DIALOG_BUTTONS.SAVE:Save`;
    /**
     * Output callback event notifying you when the cancel button is pushed.
     */
    cancel = new EventEmitter();
    /**
     * Output callback event that is trigger on confirm.
     */
    confirm = new EventEmitter();
    /**
     * Output callback event this triggers when the save button was pressed.
     */
    save = new EventEmitter();
    showSave = false;
    ngOnInit() {
        this.showSave = this.save.observers.length > 0;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPromptDialogButtonsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiPromptDialogButtonsComponent, selector: "si-prompt-dialog-buttons", inputs: { cancelDisabled: "cancelDisabled", confirmDisabled: "confirmDisabled", saveDisabled: "saveDisabled", cancelLabel: "cancelLabel", confirmLabel: "confirmLabel", saveLabel: "saveLabel" }, outputs: { cancel: "cancel", confirm: "confirm", save: "save" }, ngImport: i0, template: "<div class=\"d-flex\">\n  <button\n    *ngIf=\"showSave\"\n    type=\"button\"\n    class=\"element-save btn btn-circle btn-sm btn-secondary\"\n    [disabled]=\"saveDisabled\"\n    [attr.aria-label]=\"saveLabel | translate\"\n    (click)=\"save.emit()\"\n  ></button>\n\n  <button\n    type=\"button\"\n    class=\"ms-auto element-cancel btn btn-circle btn-sm btn-secondary\"\n    [disabled]=\"cancelDisabled\"\n    [attr.aria-label]=\"cancelLabel | translate\"\n    (click)=\"cancel.emit()\"\n  ></button>\n  <button\n    type=\"button\"\n    class=\"element-ok btn btn-circle btn-sm btn-primary ms-4\"\n    [disabled]=\"confirmDisabled\"\n    [attr.aria-label]=\"confirmLabel | translate\"\n    (click)=\"confirm.emit()\"\n  ></button>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPromptDialogButtonsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-prompt-dialog-buttons', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex\">\n  <button\n    *ngIf=\"showSave\"\n    type=\"button\"\n    class=\"element-save btn btn-circle btn-sm btn-secondary\"\n    [disabled]=\"saveDisabled\"\n    [attr.aria-label]=\"saveLabel | translate\"\n    (click)=\"save.emit()\"\n  ></button>\n\n  <button\n    type=\"button\"\n    class=\"ms-auto element-cancel btn btn-circle btn-sm btn-secondary\"\n    [disabled]=\"cancelDisabled\"\n    [attr.aria-label]=\"cancelLabel | translate\"\n    (click)=\"cancel.emit()\"\n  ></button>\n  <button\n    type=\"button\"\n    class=\"element-ok btn btn-circle btn-sm btn-primary ms-4\"\n    [disabled]=\"confirmDisabled\"\n    [attr.aria-label]=\"confirmLabel | translate\"\n    (click)=\"confirm.emit()\"\n  ></button>\n</div>\n" }]
        }], propDecorators: { cancelDisabled: [{
                type: Input
            }], confirmDisabled: [{
                type: Input
            }], saveDisabled: [{
                type: Input
            }], cancelLabel: [{
                type: Input
            }], confirmLabel: [{
                type: Input
            }], saveLabel: [{
                type: Input
            }], cancel: [{
                type: Output
            }], confirm: [{
                type: Output
            }], save: [{
                type: Output
            }] } });

class SiPromptDialogButtonsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPromptDialogButtonsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiPromptDialogButtonsModule, declarations: [SiPromptDialogButtonsComponent], imports: [CommonModule, SiTranslateModule], exports: [SiPromptDialogButtonsComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPromptDialogButtonsModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiPromptDialogButtonsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiTranslateModule],
                    declarations: [SiPromptDialogButtonsComponent],
                    exports: [SiPromptDialogButtonsComponent]
                }]
        }] });

class SiEmptyStateComponent {
    /**
     * CSS class name of the desired icon.
     */
    icon;
    /**
     * Heading of empty state content.
     */
    heading;
    /**
     * Description of empty state content.
     */
    content;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiEmptyStateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiEmptyStateComponent, selector: "si-empty-state", inputs: { icon: "icon", heading: "heading", content: "content" }, ngImport: i0, template: "<div class=\"list-group-item-empty\">\n  <span class=\"state-icon\" [ngClass]=\"icon\"></span>\n  <h3 class=\"my-6\">{{ heading | translate }}</h3>\n  <p *ngIf=\"content\" class=\"text-pre-wrap text-center mb-6\">{{ content | translate }}</p>\n  <ng-content></ng-content>\n</div>\n", styles: [".list-group-item-empty{block-size:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:16px}.state-icon{color:var(--element-ui-2);font-size:80px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiEmptyStateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-empty-state', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"list-group-item-empty\">\n  <span class=\"state-icon\" [ngClass]=\"icon\"></span>\n  <h3 class=\"my-6\">{{ heading | translate }}</h3>\n  <p *ngIf=\"content\" class=\"text-pre-wrap text-center mb-6\">{{ content | translate }}</p>\n  <ng-content></ng-content>\n</div>\n", styles: [".list-group-item-empty{block-size:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:16px}.state-icon{color:var(--element-ui-2);font-size:80px}\n"] }]
        }], propDecorators: { icon: [{
                type: Input,
                args: [{ required: true }]
            }], heading: [{
                type: Input,
                args: [{ required: true }]
            }], content: [{
                type: Input
            }] } });

class SiEmptyStateModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiEmptyStateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiEmptyStateModule, declarations: [SiEmptyStateComponent], imports: [CommonModule, SiTranslateModule], exports: [SiEmptyStateComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiEmptyStateModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiEmptyStateModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiTranslateModule],
                    declarations: [SiEmptyStateComponent],
                    exports: [SiEmptyStateComponent]
                }]
        }] });

class SiFilterPillComponent {
    /**
     * Settings of the filter pill.
     */
    filter;
    /**
     * True if variant is responsive
     */
    responsive = false;
    disabled = false;
    totalPills = 0;
    /**
     * Output callback event which will provide you the name of the deleted filter
     * pill if a filter was deleted.
     */
    deleteFilters = new EventEmitter();
    deleteClicked() {
        this.deleteFilters.emit(this.filter);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilterPillComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiFilterPillComponent, selector: "si-filter-pill", inputs: { filter: "filter", responsive: "responsive", disabled: "disabled", totalPills: "totalPills" }, outputs: { deleteFilters: "deleteFilters" }, ngImport: i0, template: "<div\n  class=\"filter-pill\"\n  [class.disabled]=\"disabled\"\n  [class.responsive]=\"responsive\"\n  [ngClass]=\"filter.status ? 'filter-pill-' + filter.status : ''\"\n  [attr.aria-disabled]=\"disabled\"\n>\n  <div class=\"wrapper\">\n    <div\n      *ngIf=\"filter.title\"\n      class=\"name\"\n      [class.empty-desc]=\"!filter.description && !responsive\"\n      >{{ filter.title | translate }}</div\n    >\n    <span *ngIf=\"responsive && filter.title && filter.description\" class=\"name pe-4\">:</span>\n    <div class=\"value\">{{ filter.description || '' | translate }}</div>\n    <div *ngIf=\"!filter.title && !responsive\">&#160;</div>\n  </div>\n  <ng-container *ngIf=\"!responsive || !disabled\">\n    <ng-container *ngTemplateOutlet=\"remove\"></ng-container>\n  </ng-container>\n</div>\n<ng-template #remove>\n  <button\n    type=\"button\"\n    class=\"btn-remove element-cancel btn btn-circle btn-ghost focus-inside\"\n    role=\"button\"\n    aria-label=\"Remove\"\n    [class.ms-0]=\"responsive\"\n    [class.ms-2]=\"!responsive\"\n    [class.btn-xs]=\"responsive\"\n    [class.btn-sm]=\"!responsive\"\n    (keydown.enter)=\"deleteClicked()\"\n    (click)=\"deleteClicked()\"\n  >\n  </button>\n</ng-template>\n", styles: [":host{--filter-pill-background-color: var(--element-base-1)}:host.dark-background{--filter-pill-background-color: var(--element-base-0)}.filter-pill{margin-inline-start:8px;font-weight:500;block-size:32px;border-radius:16px;background:var(--filter-pill-background-color);display:flex;padding-block:0 4px;padding-inline:16px 0;line-height:12px}.filter-pill:not(.responsive) .name{padding-block-start:4px}.wrapper{display:flex;flex-direction:column}.filter-pill.responsive{display:flex;align-items:center;padding-block:0;padding-inline:8px 0;block-size:24px}.filter-pill.responsive .wrapper{flex-direction:row}.filter-pill.responsive .name{font-weight:700;white-space:nowrap}.filter-pill.responsive .value{color:var(--element-text-primary);white-space:nowrap;margin-inline-end:4px}.filter-pill.responsive.disabled,.filter-pill.responsive.disabled .value{padding-inline-end:2px;color:var(--element-text-disabled)}.name{margin:0}.name.empty-desc{margin:0;position:relative;inset-block-start:50%;transform:translateY(-50%)}.filter-pill .value,.filter-pill-default .value{color:var(--element-text-active)}.filter-pill-success .value{color:var(--element-text-success)}.filter-pill-info .value{color:var(--element-text-information)}.filter-pill-warning .value{color:var(--element-text-warning)}.filter-pill-danger .value{color:var(--element-text-danger)}.filter-pill-inactive .value{color:var(--element-text-secondary)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilterPillComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-filter-pill', template: "<div\n  class=\"filter-pill\"\n  [class.disabled]=\"disabled\"\n  [class.responsive]=\"responsive\"\n  [ngClass]=\"filter.status ? 'filter-pill-' + filter.status : ''\"\n  [attr.aria-disabled]=\"disabled\"\n>\n  <div class=\"wrapper\">\n    <div\n      *ngIf=\"filter.title\"\n      class=\"name\"\n      [class.empty-desc]=\"!filter.description && !responsive\"\n      >{{ filter.title | translate }}</div\n    >\n    <span *ngIf=\"responsive && filter.title && filter.description\" class=\"name pe-4\">:</span>\n    <div class=\"value\">{{ filter.description || '' | translate }}</div>\n    <div *ngIf=\"!filter.title && !responsive\">&#160;</div>\n  </div>\n  <ng-container *ngIf=\"!responsive || !disabled\">\n    <ng-container *ngTemplateOutlet=\"remove\"></ng-container>\n  </ng-container>\n</div>\n<ng-template #remove>\n  <button\n    type=\"button\"\n    class=\"btn-remove element-cancel btn btn-circle btn-ghost focus-inside\"\n    role=\"button\"\n    aria-label=\"Remove\"\n    [class.ms-0]=\"responsive\"\n    [class.ms-2]=\"!responsive\"\n    [class.btn-xs]=\"responsive\"\n    [class.btn-sm]=\"!responsive\"\n    (keydown.enter)=\"deleteClicked()\"\n    (click)=\"deleteClicked()\"\n  >\n  </button>\n</ng-template>\n", styles: [":host{--filter-pill-background-color: var(--element-base-1)}:host.dark-background{--filter-pill-background-color: var(--element-base-0)}.filter-pill{margin-inline-start:8px;font-weight:500;block-size:32px;border-radius:16px;background:var(--filter-pill-background-color);display:flex;padding-block:0 4px;padding-inline:16px 0;line-height:12px}.filter-pill:not(.responsive) .name{padding-block-start:4px}.wrapper{display:flex;flex-direction:column}.filter-pill.responsive{display:flex;align-items:center;padding-block:0;padding-inline:8px 0;block-size:24px}.filter-pill.responsive .wrapper{flex-direction:row}.filter-pill.responsive .name{font-weight:700;white-space:nowrap}.filter-pill.responsive .value{color:var(--element-text-primary);white-space:nowrap;margin-inline-end:4px}.filter-pill.responsive.disabled,.filter-pill.responsive.disabled .value{padding-inline-end:2px;color:var(--element-text-disabled)}.name{margin:0}.name.empty-desc{margin:0;position:relative;inset-block-start:50%;transform:translateY(-50%)}.filter-pill .value,.filter-pill-default .value{color:var(--element-text-active)}.filter-pill-success .value{color:var(--element-text-success)}.filter-pill-info .value{color:var(--element-text-information)}.filter-pill-warning .value{color:var(--element-text-warning)}.filter-pill-danger .value{color:var(--element-text-danger)}.filter-pill-inactive .value{color:var(--element-text-secondary)}\n"] }]
        }], propDecorators: { filter: [{
                type: Input,
                args: [{ required: true }]
            }], responsive: [{
                type: Input
            }], disabled: [{
                type: Input
            }], totalPills: [{
                type: Input
            }], deleteFilters: [{
                type: Output
            }] } });

class SiFilterBarComponent {
    /**
     * Title of filter bar.
     */
    filterTitle = $localize `:@@SI_FILTER_BAR.TITLE:Filters`;
    /**
     * Custom text if no filters are selected.
     */
    filterDefaultText = $localize `:@@SI_FILTER_BAR.NO_FILTERS:No filters applied`;
    /**
     * Array of filter items to show
     */
    filters = [];
    /**
     * Enable to render responsive variant
     */
    responsive = false;
    /**
     * Text for reset button
     */
    resetText = $localize `:@@SI_FILTER_BAR.RESET_FILTERS:Reset filters`;
    /**
     * Set false to hide reset filters button
     */
    allowReset = true;
    /**
     * Color to use for component background
     */
    colorVariant = 'base-1';
    collapsableListDirective;
    _disabled = false;
    /**
     * Set to true to disable component
     * @defaultref {@link _disabled}
     */
    set disabled(val) {
        this._disabled = coerceBooleanProperty(val);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Output callback to be executed when the filter changes
     */
    filtersChange = new EventEmitter();
    /**
     * Output callback to be executed when the reset filter is clicked
     */
    resetFilters = new EventEmitter();
    trackByIndex = (index) => index;
    deleteFilters(deletedPill) {
        this.filters.splice(this.filters.indexOf(deletedPill), 1);
        this.filtersChange.emit(this.filters);
    }
    /**
     * Whether the filter bar currently doesn't contain any filters.
     */
    get isEmpty() {
        return !this.filters.length;
    }
    onResetFilters() {
        this.filters = [];
        this.resetFilters.emit();
    }
    deleteOverflowFilter() {
        this.filters.splice(this.collapsableListDirective.items.toArray().findIndex(item => !item.isVisible));
        this.filtersChange.emit(this.filters);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilterBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiFilterBarComponent, selector: "si-filter-bar", inputs: { filterTitle: "filterTitle", filterDefaultText: "filterDefaultText", filters: "filters", responsive: "responsive", resetText: "resetText", allowReset: "allowReset", colorVariant: "colorVariant", disabled: "disabled" }, outputs: { filtersChange: "filtersChange", resetFilters: "resetFilters" }, viewQueries: [{ propertyName: "collapsableListDirective", first: true, predicate: SiAutoCollapsableListDirective, descendants: true, static: true }], ngImport: i0, template: "<div\n  [class.rounded]=\"!responsive\"\n  [class.list-header]=\"!responsive\"\n  [class.responsive]=\"responsive\"\n  [class.py-2]=\"responsive\"\n  [siAutoCollapsableList]=\"responsive\"\n>\n  <span *ngIf=\"!responsive\" class=\"list-title\">{{ filterTitle | translate }}:</span>\n  <span *ngIf=\"isEmpty\" class=\"list-text\">{{ filterDefaultText | translate }}</span>\n  <div\n    *ngFor=\"let filter of filters; let i = index; trackBy: trackByIndex\"\n    class=\"pill-wrapper\"\n    siAutoCollapsableListItem\n  >\n    <si-filter-pill\n      [class.dark-background]=\"responsive && colorVariant === 'base-0'\"\n      [totalPills]=\"filters.length\"\n      [filter]=\"filter\"\n      [responsive]=\"responsive\"\n      [disabled]=\"disabled\"\n      (deleteFilters)=\"deleteFilters($event)\"\n    >\n    </si-filter-pill>\n  </div>\n  <si-filter-pill\n    #overflowItem=\"siAutoCollapsableListOverflowItem\"\n    siAutoCollapsableListOverflowItem\n    [class.dark-background]=\"responsive && colorVariant === 'base-0'\"\n    [responsive]=\"responsive\"\n    [disabled]=\"disabled\"\n    [filter]=\"{\n      description: '+ ' + overflowItem.hiddenItemCount + ' filters',\n      title: '',\n      status: 'default',\n      filterName: ''\n    }\"\n    (deleteFilters)=\"deleteOverflowFilter()\"\n  >\n  </si-filter-pill>\n  <button\n    *ngIf=\"allowReset && responsive && !isEmpty\"\n    siAutoCollapsableListAdditionalContent\n    type=\"button\"\n    class=\"text-nowrap btn btn-tertiary ms-4\"\n    [disabled]=\"disabled\"\n    (click)=\"onResetFilters()\"\n  >\n    {{ resetText | translate }}\n  </button>\n</div>\n", styles: [".list-header{margin-block-start:12px;background:var(--element-base-0);padding-block:6px;padding-inline:12px;white-space:nowrap;overflow-y:hidden;overflow-x:auto;display:flex;align-items:center}.list-text{line-height:32px}.pill-wrapper{display:inline-block;vertical-align:middle}.responsive{overflow:hidden;display:flex;align-items:center}.responsive .list-text{color:var(--element-text-disabled)}.responsive .invisible{position:absolute}.list-title{margin-inline-end:6px;font-weight:500}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.SiAutoCollapsableListAdditionalContentDirective, selector: "[siAutoCollapsableListAdditionalContent]" }, { kind: "directive", type: i2.SiAutoCollapsableListDirective, selector: "[siAutoCollapsableList]", inputs: ["siAutoCollapsableList"], exportAs: ["siAutoCollapsableList"] }, { kind: "directive", type: i2.SiAutoCollapsableListItemDirective, selector: "[siAutoCollapsableListItem]", inputs: ["forceHide"], exportAs: ["siAutoCollapsableListItem"] }, { kind: "directive", type: i2.SiAutoCollapsableListOverflowItemDirective, selector: "[siAutoCollapsableListOverflowItem]", exportAs: ["siAutoCollapsableListOverflowItem"] }, { kind: "component", type: SiFilterPillComponent, selector: "si-filter-pill", inputs: ["filter", "responsive", "disabled", "totalPills"], outputs: ["deleteFilters"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilterBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-filter-bar', template: "<div\n  [class.rounded]=\"!responsive\"\n  [class.list-header]=\"!responsive\"\n  [class.responsive]=\"responsive\"\n  [class.py-2]=\"responsive\"\n  [siAutoCollapsableList]=\"responsive\"\n>\n  <span *ngIf=\"!responsive\" class=\"list-title\">{{ filterTitle | translate }}:</span>\n  <span *ngIf=\"isEmpty\" class=\"list-text\">{{ filterDefaultText | translate }}</span>\n  <div\n    *ngFor=\"let filter of filters; let i = index; trackBy: trackByIndex\"\n    class=\"pill-wrapper\"\n    siAutoCollapsableListItem\n  >\n    <si-filter-pill\n      [class.dark-background]=\"responsive && colorVariant === 'base-0'\"\n      [totalPills]=\"filters.length\"\n      [filter]=\"filter\"\n      [responsive]=\"responsive\"\n      [disabled]=\"disabled\"\n      (deleteFilters)=\"deleteFilters($event)\"\n    >\n    </si-filter-pill>\n  </div>\n  <si-filter-pill\n    #overflowItem=\"siAutoCollapsableListOverflowItem\"\n    siAutoCollapsableListOverflowItem\n    [class.dark-background]=\"responsive && colorVariant === 'base-0'\"\n    [responsive]=\"responsive\"\n    [disabled]=\"disabled\"\n    [filter]=\"{\n      description: '+ ' + overflowItem.hiddenItemCount + ' filters',\n      title: '',\n      status: 'default',\n      filterName: ''\n    }\"\n    (deleteFilters)=\"deleteOverflowFilter()\"\n  >\n  </si-filter-pill>\n  <button\n    *ngIf=\"allowReset && responsive && !isEmpty\"\n    siAutoCollapsableListAdditionalContent\n    type=\"button\"\n    class=\"text-nowrap btn btn-tertiary ms-4\"\n    [disabled]=\"disabled\"\n    (click)=\"onResetFilters()\"\n  >\n    {{ resetText | translate }}\n  </button>\n</div>\n", styles: [".list-header{margin-block-start:12px;background:var(--element-base-0);padding-block:6px;padding-inline:12px;white-space:nowrap;overflow-y:hidden;overflow-x:auto;display:flex;align-items:center}.list-text{line-height:32px}.pill-wrapper{display:inline-block;vertical-align:middle}.responsive{overflow:hidden;display:flex;align-items:center}.responsive .list-text{color:var(--element-text-disabled)}.responsive .invisible{position:absolute}.list-title{margin-inline-end:6px;font-weight:500}\n"] }]
        }], propDecorators: { filterTitle: [{
                type: Input
            }], filterDefaultText: [{
                type: Input
            }], filters: [{
                type: Input
            }], responsive: [{
                type: Input
            }], resetText: [{
                type: Input
            }], allowReset: [{
                type: Input
            }], colorVariant: [{
                type: Input
            }], collapsableListDirective: [{
                type: ViewChild,
                args: [SiAutoCollapsableListDirective, { static: true }]
            }], disabled: [{
                type: Input
            }], filtersChange: [{
                type: Output
            }], resetFilters: [{
                type: Output
            }] } });

class SiFilterBarModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilterBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiFilterBarModule, declarations: [SiFilterBarComponent, SiFilterPillComponent], imports: [CommonModule, SiAutoCollapsableListModule, SiTranslateModule], exports: [SiFilterBarComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilterBarModule, imports: [CommonModule, SiAutoCollapsableListModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilterBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiAutoCollapsableListModule, SiTranslateModule],
                    declarations: [SiFilterBarComponent, SiFilterPillComponent],
                    exports: [SiFilterBarComponent]
                }]
        }] });

class SiFooterComponent {
    /**
     * Copyright of your application.
     */
    copyright;
    /**
     * List of additional links.
     */
    links;
    trackByIndex = (index) => index;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiFooterComponent, selector: "si-footer", inputs: { copyright: "copyright", links: "links" }, ngImport: i0, template: "<footer>\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-sm-4 col-md-6\"> \u00A9 {{ copyright }} </div>\n      <div class=\"col-sm-8 col-md-6 text-sm-end\">\n        <span *ngFor=\"let link of links; trackBy: trackByIndex\">\n          <a [siLink]=\"link\">\n            {{ link.title! | translate }}\n          </a>\n        </span>\n      </div>\n    </div>\n  </div>\n</footer>\n", styles: ["footer{margin-block-end:0;background-color:var(--element-base-0);color:var(--element-text-secondary);font-size:.75rem;border-block-start:1px solid var(--element-ui-4);overflow:auto}a,span{display:inline-flex}a+a:before,a+span:before,span+a:before,span+span:before{content:\"|\";padding-inline:8px}.container-fluid{padding-block:12px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3$5.SiLinkDirective, selector: "[siLink]", inputs: ["siLink", "siLinkDefaultTarget", "actionParam", "activeClass", "exactMatch", "ariaCurrent"], outputs: ["activeChange"], exportAs: ["siLink"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-footer', template: "<footer>\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-sm-4 col-md-6\"> \u00A9 {{ copyright }} </div>\n      <div class=\"col-sm-8 col-md-6 text-sm-end\">\n        <span *ngFor=\"let link of links; trackBy: trackByIndex\">\n          <a [siLink]=\"link\">\n            {{ link.title! | translate }}\n          </a>\n        </span>\n      </div>\n    </div>\n  </div>\n</footer>\n", styles: ["footer{margin-block-end:0;background-color:var(--element-base-0);color:var(--element-text-secondary);font-size:.75rem;border-block-start:1px solid var(--element-ui-4);overflow:auto}a,span{display:inline-flex}a+a:before,a+span:before,span+a:before,span+span:before{content:\"|\";padding-inline:8px}.container-fluid{padding-block:12px}\n"] }]
        }], propDecorators: { copyright: [{
                type: Input,
                args: [{ required: true }]
            }], links: [{
                type: Input
            }] } });

class SiFooterModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiFooterModule, declarations: [SiFooterComponent], imports: [CommonModule, RouterModule, SiLinkModule, SiTranslateModule], exports: [SiFooterComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFooterModule, imports: [CommonModule, RouterModule, SiLinkModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RouterModule, SiLinkModule, SiTranslateModule],
                    declarations: [SiFooterComponent],
                    exports: [SiFooterComponent]
                }]
        }] });

class SiIconStatusComponent {
    /** Icon to display. */
    icon;
    /** Stacked icon to display. */
    stackedIcon;
    /** Counter below the icon */
    count = 0;
    /** Color of the icon */
    color;
    /** Whether the icon is disabled. */
    disabled;
    get isDisabledOrCountZero() {
        return !!this.disabled || this.count === 0;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconStatusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiIconStatusComponent, selector: "si-icon-status", inputs: { icon: "icon", stackedIcon: "stackedIcon", count: "count", color: "color", disabled: "disabled" }, ngImport: i0, template: "<si-icon\n  [icon]=\"icon\"\n  [stackedIcon]=\"stackedIcon\"\n  [color]=\"isDisabledOrCountZero ? undefined : color\"\n  [class.inactive]=\"isDisabledOrCountZero\"\n  [stackedColor]=\"isDisabledOrCountZero ? 'inactive-contrast' : color + '-contrast'\"\n></si-icon>\n<span *ngIf=\"!disabled\">{{ count }}</span>\n", styles: [":host{display:flex;align-items:center;flex-direction:column;text-align:center;gap:4px}.inactive{color:var(--element-ui-3)}si-icon ::ng-deep .inactive-contrast{color:var(--element-ui-5)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.SiIconComponent, selector: "si-icon", inputs: ["icon", "color", "stackedIcon", "stackedColor", "alt", "size"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconStatusComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-icon-status', template: "<si-icon\n  [icon]=\"icon\"\n  [stackedIcon]=\"stackedIcon\"\n  [color]=\"isDisabledOrCountZero ? undefined : color\"\n  [class.inactive]=\"isDisabledOrCountZero\"\n  [stackedColor]=\"isDisabledOrCountZero ? 'inactive-contrast' : color + '-contrast'\"\n></si-icon>\n<span *ngIf=\"!disabled\">{{ count }}</span>\n", styles: [":host{display:flex;align-items:center;flex-direction:column;text-align:center;gap:4px}.inactive{color:var(--element-ui-3)}si-icon ::ng-deep .inactive-contrast{color:var(--element-ui-5)}\n"] }]
        }], propDecorators: { icon: [{
                type: Input,
                args: [{ required: true }]
            }], stackedIcon: [{
                type: Input
            }], count: [{
                type: Input
            }], color: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class SiIconStatusModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconStatusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiIconStatusModule, declarations: [SiIconStatusComponent], imports: [CommonModule, SiIconModule], exports: [SiIconStatusComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconStatusModule, imports: [CommonModule, SiIconModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiIconStatusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiIconModule],
                    declarations: [SiIconStatusComponent],
                    exports: [SiIconStatusComponent]
                }]
        }] });

class SiLandingPageComponent {
    /**
     * Heading of the application.
     */
    heading;
    /**
     * Secondary heading of the application.
     */
    subheading;
    /**
     * Short description of the application.
     */
    subtitle;
    /**
     * Copyright Text for footer.
     * @deprecated Use the {@link copyrightDetails} input instead. Alternatively, you can use the {@link SI_COPYRIGHT_DETAILS} global inject.
     */
    copyright;
    /**
     * List of links (e.g. Corporate information)
     */
    links = [];
    /**
     * URL to custom background image
     */
    backgroundImageUrl = './assets/images/landing-page-digitalcity.webp';
    /**
     * URL to custom brand image
     */
    logoUrl;
    /**
     * Input of si-language-switcher: Key for translation.
     * If your languages are already translated, you may display them without any
     * manipulation by passing in an empty string.
     */
    translationKey = 'LANGUAGE';
    /**
     * Input of si-language-switcher: List of all available languages in this
     * application.
     */
    availableLanguages;
    /**
     *
     * Config to enable/disable general alerts on landing page
     */
    announcement;
    /**
     *
     * Config to enable/disable login related error/alerts
     */
    loginAlert;
    trackByIndex = (index) => index;
    /**
     * Copyright information to be displayed. Alternatively, you can use the {@link SI_COPYRIGHT_DETAILS} global inject.
     */
    copyrightDetails;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLandingPageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiLandingPageComponent, selector: "si-landing-page", inputs: { heading: "heading", subheading: "subheading", subtitle: "subtitle", copyright: "copyright", links: "links", backgroundImageUrl: "backgroundImageUrl", logoUrl: "logoUrl", translationKey: "translationKey", availableLanguages: "availableLanguages", announcement: "announcement", loginAlert: "loginAlert", copyrightDetails: "copyrightDetails" }, ngImport: i0, template: "<si-inline-notification\n  *ngIf=\"announcement\"\n  [severity]=\"announcement.severity\"\n  [heading]=\"announcement.heading\"\n  [message]=\"announcement.message\"\n></si-inline-notification>\n<div class=\"landing-page\">\n  <div\n    class=\"landing-page-background d-none d-md-block\"\n    [style.background-image]=\"'url(' + backgroundImageUrl + ')'\"\n  >\n  </div>\n  <div class=\"landing-page-content\">\n    <div class=\"d-flex justify-content-between align-items-center pb-9\">\n      <div class=\"landing-page-brand\">\n        <svg\n          *ngIf=\"!logoUrl\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"103\"\n          height=\"20\"\n          viewBox=\"0 0 142.315 22.5\"\n        >\n          <path\n            d=\"M125.878 21.704v-4.378c2.53.806 4.718 1.209 6.566 1.209 2.53 0 3.795-.674 3.795-2.02 0-.49-.183-.898-.549-1.225-.43-.388-1.419-.903-2.971-1.545-2.735-1.113-4.5-2.006-5.296-2.68-1.325-1.121-1.99-2.581-1.99-4.376 0-2.235.873-3.94 2.617-5.113C129.623.525 131.744 0 134.418 0c2.143 0 4.21.27 6.198.811v4.194c-2.172-.838-4.116-1.255-5.83-1.255-2.276 0-3.415.647-3.415 1.942 0 .522.247.94.737 1.257.417.265 1.53.786 3.335 1.561 2.725 1.174 4.522 2.194 5.388 3.061.989.99 1.484 2.301 1.484 3.934 0 2.5-1.03 4.356-3.09 5.571-1.612.949-3.755 1.424-6.43 1.424-2.489 0-4.796-.266-6.917-.796m-22.913.352V.367h7.101l7.469 14.097V.367h4.349v21.69h-6.859L107.31 7.744v14.311h-4.345zm-19.73 0V.367H99v3.964h-9.705V9.2h8.45v3.581h-8.45v5.096h9.935v4.18H83.235zm-31.837 0V.367h7.913l5.434 13.607L70.378.367h7.546v21.69h-5.939V7.238L65.679 22.27h-3.781L55.76 7.239v14.817h-4.362zm-19.775 0V.367h15.78v3.964H37.7V9.2h8.45v3.581H37.7v5.096h9.919v4.18H31.623zM20.05.367h6.29v21.69h-6.29V.366zM.443 21.704v-4.378c2.52.806 4.71 1.209 6.567 1.209 2.531 0 3.796-.674 3.796-2.02 0-.49-.185-.898-.551-1.225-.419-.388-1.414-.903-2.985-1.545-2.704-1.103-4.464-1.995-5.28-2.68C.663 9.944 0 8.484 0 6.689c0-2.235.873-3.94 2.618-5.113C4.178.525 6.3 0 8.984 0c2.142 0 4.211.27 6.2.811v4.194C12.989 4.167 11.046 3.75 9.35 3.75c-2.275 0-3.412.647-3.412 1.942 0 .512.249.93.749 1.257.408.265 1.516.786 3.323 1.561 2.724 1.174 4.519 2.194 5.387 3.061.99.99 1.486 2.301 1.486 3.934 0 2.5-1.036 4.356-3.109 5.571-1.601.949-3.74 1.424-6.414 1.424-2.49 0-4.795-.266-6.918-.796\"\n            fill=\"currentColor\"\n          ></path>\n        </svg>\n        <img\n          *ngIf=\"logoUrl\"\n          class=\"landing-page-logo\"\n          [src]=\"logoUrl\"\n          [alt]=\"heading + '\\'s Background'\"\n        />\n      </div>\n      <div\n        *ngIf=\"availableLanguages && availableLanguages.length > 1\"\n        class=\"landing-page-language-switcher\"\n      >\n        <si-language-switcher\n          [translationKey]=\"translationKey\"\n          [availableLanguages]=\"availableLanguages\"\n        >\n        </si-language-switcher>\n      </div>\n    </div>\n    <div class=\"landing-page-main\">\n      <div *ngIf=\"subheading\" class=\"si-h2\">{{ subheading }}</div>\n      <h1 class=\"si-h1-black my-2\">{{ heading }}</h1>\n      <h2 *ngIf=\"!loginAlert\" class=\"mt-10 si-h2\">{{ subtitle }}</h2>\n      <si-inline-notification\n        *ngIf=\"loginAlert\"\n        class=\"my-6\"\n        [severity]=\"loginAlert.severity || 'danger'\"\n        [heading]=\"loginAlert.heading\"\n        [message]=\"loginAlert.message\"\n      ></si-inline-notification>\n      <div class=\"landing-page-custom-content\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <footer>\n      <div>\n        <div class=\"d-flex justify-content-start flex-row flex-wrap mt-6\">\n          <span *ngFor=\"let link of links; trackBy: trackByIndex\">\n            <a siLinkDefaultTarget=\"_blank\" class=\"si-body-2 d-flex-inline pe-6\" [siLink]=\"link\">\n              {{ link.title ?? '' | translate }}\n            </a>\n          </span>\n        </div>\n        <div *ngIf=\"copyright\" class=\"si-caption mt-4 mb-6 text-body\">\n          {{ copyright }}\n        </div>\n        <si-copyright-notice\n          *ngIf=\"!copyright\"\n          [copyright]=\"copyrightDetails\"\n        ></si-copyright-notice>\n      </div>\n    </footer>\n  </div>\n</div>\n", styles: [":host{--landing-page-logo-width: 180px;display:flex;flex-direction:column;block-size:100%;padding-block-start:var(--element-titlebar-spacing, 0px)}.landing-page{display:flex;flex-direction:row-reverse;flex-grow:1}.landing-page-background{background-size:cover;background-position:center;inline-size:60%}.landing-page-logo{inline-size:var(--landing-page-logo-width);block-size:var(--landing-page-logo-height)}.landing-page-content{display:flex;flex-direction:column;justify-content:space-between;position:relative;inline-size:40%;background-color:var(--element-base-0);padding-block:32px 32px;padding-inline:96px}.landing-page-brand{color:var(--element-logo-color)}.landing-page-custom-content{margin-block:16px;margin-inline:0}.landing-page-links a{font-size:12px}footer{color:var(--element-text-secondary);overflow:auto}@media (max-width: 1199.98px){.landing-page-background{padding:64px}.landing-page-content{padding-block:32px 32px;padding-inline:64px}}@media (max-width: 991.98px){.landing-page-background{padding:32px}.landing-page-content{padding-block:32px 32px;padding-inline:32px}}@media (max-width: 767.98px){.landing-page{flex-direction:column}.landing-page-logo{transform:scale(.6);transform-origin:top left}.landing-page-content{inline-size:100%;flex-grow:1;padding:32px}}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$4.SiCopyrightNoticeComponent, selector: "si-copyright-notice", inputs: ["copyright"] }, { kind: "component", type: i3.SiInlineNotificationComponent, selector: "si-inline-notification", inputs: ["severity", "heading", "message", "action", "translationParams", "embedded"] }, { kind: "component", type: i4$1.SiLanguageSwitcherComponent, selector: "si-language-switcher", inputs: ["translationKey", "languageSwitcherLabel", "availableLanguages"] }, { kind: "directive", type: i3$5.SiLinkDirective, selector: "[siLink]", inputs: ["siLink", "siLinkDefaultTarget", "actionParam", "activeClass", "exactMatch", "ariaCurrent"], outputs: ["activeChange"], exportAs: ["siLink"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLandingPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-landing-page', changeDetection: ChangeDetectionStrategy.OnPush, template: "<si-inline-notification\n  *ngIf=\"announcement\"\n  [severity]=\"announcement.severity\"\n  [heading]=\"announcement.heading\"\n  [message]=\"announcement.message\"\n></si-inline-notification>\n<div class=\"landing-page\">\n  <div\n    class=\"landing-page-background d-none d-md-block\"\n    [style.background-image]=\"'url(' + backgroundImageUrl + ')'\"\n  >\n  </div>\n  <div class=\"landing-page-content\">\n    <div class=\"d-flex justify-content-between align-items-center pb-9\">\n      <div class=\"landing-page-brand\">\n        <svg\n          *ngIf=\"!logoUrl\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          width=\"103\"\n          height=\"20\"\n          viewBox=\"0 0 142.315 22.5\"\n        >\n          <path\n            d=\"M125.878 21.704v-4.378c2.53.806 4.718 1.209 6.566 1.209 2.53 0 3.795-.674 3.795-2.02 0-.49-.183-.898-.549-1.225-.43-.388-1.419-.903-2.971-1.545-2.735-1.113-4.5-2.006-5.296-2.68-1.325-1.121-1.99-2.581-1.99-4.376 0-2.235.873-3.94 2.617-5.113C129.623.525 131.744 0 134.418 0c2.143 0 4.21.27 6.198.811v4.194c-2.172-.838-4.116-1.255-5.83-1.255-2.276 0-3.415.647-3.415 1.942 0 .522.247.94.737 1.257.417.265 1.53.786 3.335 1.561 2.725 1.174 4.522 2.194 5.388 3.061.989.99 1.484 2.301 1.484 3.934 0 2.5-1.03 4.356-3.09 5.571-1.612.949-3.755 1.424-6.43 1.424-2.489 0-4.796-.266-6.917-.796m-22.913.352V.367h7.101l7.469 14.097V.367h4.349v21.69h-6.859L107.31 7.744v14.311h-4.345zm-19.73 0V.367H99v3.964h-9.705V9.2h8.45v3.581h-8.45v5.096h9.935v4.18H83.235zm-31.837 0V.367h7.913l5.434 13.607L70.378.367h7.546v21.69h-5.939V7.238L65.679 22.27h-3.781L55.76 7.239v14.817h-4.362zm-19.775 0V.367h15.78v3.964H37.7V9.2h8.45v3.581H37.7v5.096h9.919v4.18H31.623zM20.05.367h6.29v21.69h-6.29V.366zM.443 21.704v-4.378c2.52.806 4.71 1.209 6.567 1.209 2.531 0 3.796-.674 3.796-2.02 0-.49-.185-.898-.551-1.225-.419-.388-1.414-.903-2.985-1.545-2.704-1.103-4.464-1.995-5.28-2.68C.663 9.944 0 8.484 0 6.689c0-2.235.873-3.94 2.618-5.113C4.178.525 6.3 0 8.984 0c2.142 0 4.211.27 6.2.811v4.194C12.989 4.167 11.046 3.75 9.35 3.75c-2.275 0-3.412.647-3.412 1.942 0 .512.249.93.749 1.257.408.265 1.516.786 3.323 1.561 2.724 1.174 4.519 2.194 5.387 3.061.99.99 1.486 2.301 1.486 3.934 0 2.5-1.036 4.356-3.109 5.571-1.601.949-3.74 1.424-6.414 1.424-2.49 0-4.795-.266-6.918-.796\"\n            fill=\"currentColor\"\n          ></path>\n        </svg>\n        <img\n          *ngIf=\"logoUrl\"\n          class=\"landing-page-logo\"\n          [src]=\"logoUrl\"\n          [alt]=\"heading + '\\'s Background'\"\n        />\n      </div>\n      <div\n        *ngIf=\"availableLanguages && availableLanguages.length > 1\"\n        class=\"landing-page-language-switcher\"\n      >\n        <si-language-switcher\n          [translationKey]=\"translationKey\"\n          [availableLanguages]=\"availableLanguages\"\n        >\n        </si-language-switcher>\n      </div>\n    </div>\n    <div class=\"landing-page-main\">\n      <div *ngIf=\"subheading\" class=\"si-h2\">{{ subheading }}</div>\n      <h1 class=\"si-h1-black my-2\">{{ heading }}</h1>\n      <h2 *ngIf=\"!loginAlert\" class=\"mt-10 si-h2\">{{ subtitle }}</h2>\n      <si-inline-notification\n        *ngIf=\"loginAlert\"\n        class=\"my-6\"\n        [severity]=\"loginAlert.severity || 'danger'\"\n        [heading]=\"loginAlert.heading\"\n        [message]=\"loginAlert.message\"\n      ></si-inline-notification>\n      <div class=\"landing-page-custom-content\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <footer>\n      <div>\n        <div class=\"d-flex justify-content-start flex-row flex-wrap mt-6\">\n          <span *ngFor=\"let link of links; trackBy: trackByIndex\">\n            <a siLinkDefaultTarget=\"_blank\" class=\"si-body-2 d-flex-inline pe-6\" [siLink]=\"link\">\n              {{ link.title ?? '' | translate }}\n            </a>\n          </span>\n        </div>\n        <div *ngIf=\"copyright\" class=\"si-caption mt-4 mb-6 text-body\">\n          {{ copyright }}\n        </div>\n        <si-copyright-notice\n          *ngIf=\"!copyright\"\n          [copyright]=\"copyrightDetails\"\n        ></si-copyright-notice>\n      </div>\n    </footer>\n  </div>\n</div>\n", styles: [":host{--landing-page-logo-width: 180px;display:flex;flex-direction:column;block-size:100%;padding-block-start:var(--element-titlebar-spacing, 0px)}.landing-page{display:flex;flex-direction:row-reverse;flex-grow:1}.landing-page-background{background-size:cover;background-position:center;inline-size:60%}.landing-page-logo{inline-size:var(--landing-page-logo-width);block-size:var(--landing-page-logo-height)}.landing-page-content{display:flex;flex-direction:column;justify-content:space-between;position:relative;inline-size:40%;background-color:var(--element-base-0);padding-block:32px 32px;padding-inline:96px}.landing-page-brand{color:var(--element-logo-color)}.landing-page-custom-content{margin-block:16px;margin-inline:0}.landing-page-links a{font-size:12px}footer{color:var(--element-text-secondary);overflow:auto}@media (max-width: 1199.98px){.landing-page-background{padding:64px}.landing-page-content{padding-block:32px 32px;padding-inline:64px}}@media (max-width: 991.98px){.landing-page-background{padding:32px}.landing-page-content{padding-block:32px 32px;padding-inline:32px}}@media (max-width: 767.98px){.landing-page{flex-direction:column}.landing-page-logo{transform:scale(.6);transform-origin:top left}.landing-page-content{inline-size:100%;flex-grow:1;padding:32px}}\n"] }]
        }], propDecorators: { heading: [{
                type: Input,
                args: [{ required: true }]
            }], subheading: [{
                type: Input
            }], subtitle: [{
                type: Input,
                args: [{ required: true }]
            }], copyright: [{
                type: Input
            }], links: [{
                type: Input
            }], backgroundImageUrl: [{
                type: Input
            }], logoUrl: [{
                type: Input
            }], translationKey: [{
                type: Input
            }], availableLanguages: [{
                type: Input
            }], announcement: [{
                type: Input
            }], loginAlert: [{
                type: Input
            }], copyrightDetails: [{
                type: Input
            }] } });

class SiLandingPageModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLandingPageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiLandingPageModule, declarations: [SiLandingPageComponent], imports: [CommonModule,
            SiCopyrightNoticeModule,
            SiInlineNotificationModule,
            SiLanguageSwitcherModule,
            SiLinkModule,
            SiTranslateModule], exports: [SiLandingPageComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLandingPageModule, imports: [CommonModule,
            SiCopyrightNoticeModule,
            SiInlineNotificationModule,
            SiLanguageSwitcherModule,
            SiLinkModule,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiLandingPageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SiCopyrightNoticeModule,
                        SiInlineNotificationModule,
                        SiLanguageSwitcherModule,
                        SiLinkModule,
                        SiTranslateModule
                    ],
                    declarations: [SiLandingPageComponent],
                    exports: [SiLandingPageComponent]
                }]
        }] });

class SiCommissioningStatusComponent {
    /**
     * Is the component disabled.
     */
    disabled;
    /**
     * Number of "overwritten" items. Hidden when `null` is passed.
     */
    overwritten = null;
    /**
     * Number of "checked" items. Hidden when `null` is passed.
     */
    checked = null;
    /**
     * Number of "failed" items. Hidden when `null` is passed.
     */
    failed = null;
    /**
     * Number of "unchecked" items. Hidden when `null` is passed.
     */
    unchecked = null;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCommissioningStatusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiCommissioningStatusComponent, selector: "si-commissioning-status", inputs: { disabled: "disabled", overwritten: "overwritten", checked: "checked", failed: "failed", unchecked: "unchecked" }, ngImport: i0, template: "<si-icon-status\n  *ngIf=\"overwritten !== null\"\n  class=\"si-commissioning-status-item me-2\"\n  icon=\"element-manual-filled\"\n  color=\"status-warning\"\n  [count]=\"overwritten\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<si-icon-status\n  *ngIf=\"checked !== null\"\n  class=\"si-commissioning-status-item me-2\"\n  icon=\"element-circle-filled\"\n  stackedIcon=\"element-state-tick\"\n  color=\"status-success\"\n  [count]=\"checked\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<si-icon-status\n  *ngIf=\"failed !== null\"\n  class=\"si-commissioning-status-item me-2\"\n  icon=\"element-circle-filled\"\n  stackedIcon=\"element-state-exclamation-mark\"\n  color=\"status-danger\"\n  [count]=\"failed\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<si-icon-status\n  *ngIf=\"unchecked !== null\"\n  class=\"si-commissioning-status-item\"\n  icon=\"element-not-checked\"\n  [count]=\"unchecked\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<ng-content></ng-content>\n", styles: [":host{display:flex;align-items:center}.si-commissioning-status-item{display:flex;align-items:center;flex-direction:column;text-align:center;inline-size:24px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SiIconStatusComponent, selector: "si-icon-status", inputs: ["icon", "stackedIcon", "count", "color", "disabled"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCommissioningStatusComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-commissioning-status', changeDetection: ChangeDetectionStrategy.OnPush, template: "<si-icon-status\n  *ngIf=\"overwritten !== null\"\n  class=\"si-commissioning-status-item me-2\"\n  icon=\"element-manual-filled\"\n  color=\"status-warning\"\n  [count]=\"overwritten\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<si-icon-status\n  *ngIf=\"checked !== null\"\n  class=\"si-commissioning-status-item me-2\"\n  icon=\"element-circle-filled\"\n  stackedIcon=\"element-state-tick\"\n  color=\"status-success\"\n  [count]=\"checked\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<si-icon-status\n  *ngIf=\"failed !== null\"\n  class=\"si-commissioning-status-item me-2\"\n  icon=\"element-circle-filled\"\n  stackedIcon=\"element-state-exclamation-mark\"\n  color=\"status-danger\"\n  [count]=\"failed\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<si-icon-status\n  *ngIf=\"unchecked !== null\"\n  class=\"si-commissioning-status-item\"\n  icon=\"element-not-checked\"\n  [count]=\"unchecked\"\n  [disabled]=\"disabled\"\n></si-icon-status>\n<ng-content></ng-content>\n", styles: [":host{display:flex;align-items:center}.si-commissioning-status-item{display:flex;align-items:center;flex-direction:column;text-align:center;inline-size:24px}\n"] }]
        }], propDecorators: { disabled: [{
                type: Input
            }], overwritten: [{
                type: Input
            }], checked: [{
                type: Input
            }], failed: [{
                type: Input
            }], unchecked: [{
                type: Input
            }] } });

class SiCommissioningStatusModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCommissioningStatusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiCommissioningStatusModule, declarations: [SiCommissioningStatusComponent], imports: [CommonModule, SiIconStatusModule], exports: [SiCommissioningStatusComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCommissioningStatusModule, imports: [CommonModule, SiIconStatusModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCommissioningStatusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiIconStatusModule],
                    declarations: [SiCommissioningStatusComponent],
                    exports: [SiCommissioningStatusComponent]
                }]
        }] });

var AlertDialogResult;
(function (AlertDialogResult) {
    AlertDialogResult[AlertDialogResult["Confirm"] = 0] = "Confirm";
})(AlertDialogResult || (AlertDialogResult = {}));
/**
 * @deprecated use {@link EditDiscardDialogResult} instead.
 */
var EditAbortDialogResult;
(function (EditAbortDialogResult) {
    EditAbortDialogResult[EditAbortDialogResult["Save"] = 0] = "Save";
    // eslint-disable-next-line detect-bad-words/in-code
    EditAbortDialogResult[EditAbortDialogResult["Abort"] = 1] = "Abort";
    EditAbortDialogResult[EditAbortDialogResult["Cancel"] = 2] = "Cancel";
})(EditAbortDialogResult || (EditAbortDialogResult = {}));
var EditDiscardDialogResult;
(function (EditDiscardDialogResult) {
    EditDiscardDialogResult[EditDiscardDialogResult["Save"] = 0] = "Save";
    EditDiscardDialogResult[EditDiscardDialogResult["Discard"] = 1] = "Discard";
    EditDiscardDialogResult[EditDiscardDialogResult["Cancel"] = 2] = "Cancel";
})(EditDiscardDialogResult || (EditDiscardDialogResult = {}));
var ConfirmationDialogResult;
(function (ConfirmationDialogResult) {
    ConfirmationDialogResult[ConfirmationDialogResult["Confirm"] = 0] = "Confirm";
    ConfirmationDialogResult[ConfirmationDialogResult["Decline"] = 1] = "Decline";
})(ConfirmationDialogResult || (ConfirmationDialogResult = {}));
var DeleteConfirmationDialogResult;
(function (DeleteConfirmationDialogResult) {
    DeleteConfirmationDialogResult[DeleteConfirmationDialogResult["Delete"] = 0] = "Delete";
    DeleteConfirmationDialogResult[DeleteConfirmationDialogResult["Cancel"] = 1] = "Cancel";
})(DeleteConfirmationDialogResult || (DeleteConfirmationDialogResult = {}));

class SiAlertDialogComponent {
    titleId;
    heading = '';
    message = '';
    confirmBtnName = $localize `:@@SI_ALERT_DIALOG.OK:OK`;
    translationParams = {};
    modalRef = inject((ModalRef));
    onConfirm() {
        this.modalRef.hide(AlertDialogResult.Confirm);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAlertDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiAlertDialogComponent, selector: "si-alert-dialog", inputs: { titleId: "titleId", heading: "heading", message: "message", confirmBtnName: "confirmBtnName", translationParams: "translationParams" }, ngImport: i0, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"confirmBtnName | translate\"\n    (click)=\"onConfirm()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{ message | translate : translationParams }}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"onConfirm()\">{{\n    confirmBtnName | translate\n  }}</button>\n</div>\n", dependencies: [{ kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiAlertDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-alert-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"confirmBtnName | translate\"\n    (click)=\"onConfirm()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{ message | translate : translationParams }}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"onConfirm()\">{{\n    confirmBtnName | translate\n  }}</button>\n</div>\n" }]
        }], propDecorators: { titleId: [{
                type: Input
            }], heading: [{
                type: Input
            }], message: [{
                type: Input
            }], confirmBtnName: [{
                type: Input
            }], translationParams: [{
                type: Input
            }] } });

class SiConfirmationDialogComponent {
    titleId;
    heading = '';
    message = '';
    confirmBtnName = $localize `:@@SI_CONFIRMATION_DIALOG.YES:Yes`;
    declineBtnName = $localize `:@@SI_CONFIRMATION_DIALOG.NO:No`;
    translationParams = {};
    modalRef = inject((ModalRef));
    onConfirm() {
        this.modalRef.hide(ConfirmationDialogResult.Confirm);
    }
    onDecline() {
        this.modalRef.hide(ConfirmationDialogResult.Decline);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiConfirmationDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiConfirmationDialogComponent, selector: "si-confirmation-dialog", inputs: { titleId: "titleId", heading: "heading", message: "message", confirmBtnName: "confirmBtnName", declineBtnName: "declineBtnName", translationParams: "translationParams" }, ngImport: i0, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"declineBtnName | translate\"\n    (click)=\"onDecline()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{ message | translate : translationParams }}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"onDecline()\">{{\n    declineBtnName | translate\n  }}</button>\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"onConfirm()\">{{\n    confirmBtnName | translate\n  }}</button>\n</div>\n", dependencies: [{ kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiConfirmationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-confirmation-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"declineBtnName | translate\"\n    (click)=\"onDecline()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{ message | translate : translationParams }}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"onDecline()\">{{\n    declineBtnName | translate\n  }}</button>\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"onConfirm()\">{{\n    confirmBtnName | translate\n  }}</button>\n</div>\n" }]
        }], propDecorators: { titleId: [{
                type: Input
            }], heading: [{
                type: Input
            }], message: [{
                type: Input
            }], confirmBtnName: [{
                type: Input
            }], declineBtnName: [{
                type: Input
            }], translationParams: [{
                type: Input
            }] } });

class SiDeleteConfirmationDialogComponent {
    titleId;
    heading = '';
    message = $localize `:@@SI_DELETE_CONFIRMATION_DIALOG.MESSAGE:Do you really want to delete the selected elements?`;
    deleteBtnName = $localize `:@@SI_DELETE_CONFIRMATION_DIALOG.DELETE_BTN:Delete`;
    cancelBtnName = $localize `:@@SI_DELETE_CONFIRMATION_DIALOG.CANCEL_BTN:Cancel`;
    translationParams = {};
    modalRef = inject((ModalRef));
    onDelete() {
        this.modalRef.hide(DeleteConfirmationDialogResult.Delete);
    }
    onCancel() {
        this.modalRef.hide(DeleteConfirmationDialogResult.Cancel);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDeleteConfirmationDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiDeleteConfirmationDialogComponent, selector: "si-delete-confirmation-dialog", inputs: { titleId: "titleId", heading: "heading", message: "message", deleteBtnName: "deleteBtnName", cancelBtnName: "cancelBtnName", translationParams: "translationParams" }, ngImport: i0, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"cancelBtnName | translate\"\n    (click)=\"onCancel()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{ message | translate : translationParams }}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"onCancel()\">\n    {{ cancelBtnName | translate }}\n  </button>\n  <button type=\"button\" class=\"btn btn-danger\" (click)=\"onDelete()\">\n    {{ deleteBtnName | translate }}\n  </button>\n</div>\n", dependencies: [{ kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDeleteConfirmationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-delete-confirmation-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"cancelBtnName | translate\"\n    (click)=\"onCancel()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{ message | translate : translationParams }}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"onCancel()\">\n    {{ cancelBtnName | translate }}\n  </button>\n  <button type=\"button\" class=\"btn btn-danger\" (click)=\"onDelete()\">\n    {{ deleteBtnName | translate }}\n  </button>\n</div>\n" }]
        }], propDecorators: { titleId: [{
                type: Input
            }], heading: [{
                type: Input
            }], message: [{
                type: Input
            }], deleteBtnName: [{
                type: Input
            }], cancelBtnName: [{
                type: Input
            }], translationParams: [{
                type: Input
            }] } });

class SiEditDiscardDialogComponent {
    titleId;
    heading = '';
    message = $localize `:@@SI_EDIT_DISCARD_DIALOG.MESSAGE:Do you want to save changes to the modified element?`;
    saveBtnName = $localize `:@@SI_EDIT_DISCARD_DIALOG.SAVE_BTN:Save`;
    discardBtnName = $localize `:@@SI_EDIT_DISCARD_DIALOG.DISCARD_BTN:Don't save`;
    cancelBtnName = $localize `:@@SI_EDIT_DISCARD_DIALOG.CANCEL_BTN:Cancel`;
    disableSave = false;
    disableSaveMessage = $localize `:@@SI_EDIT_DISCARD_DIALOG.DISABLE_SAVE_MESSAGE:Do you want to discard the changes`;
    disableSaveDiscardBtnName = $localize `:@@SI_EDIT_DISCARD_DIALOG.DISABLE_SAVE_DISCARD_BTN:Discard`;
    translationParams = {};
    modalRef = inject((ModalRef));
    onSave() {
        this.modalRef.hide(EditDiscardDialogResult.Save);
    }
    onDiscard() {
        this.modalRef.hide(EditDiscardDialogResult.Discard);
    }
    onCancel() {
        this.modalRef.hide(EditDiscardDialogResult.Cancel);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiEditDiscardDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiEditDiscardDialogComponent, selector: "si-edit-discard-dialog", inputs: { titleId: "titleId", heading: "heading", message: "message", saveBtnName: "saveBtnName", discardBtnName: "discardBtnName", cancelBtnName: "cancelBtnName", disableSave: "disableSave", disableSaveMessage: "disableSaveMessage", disableSaveDiscardBtnName: "disableSaveDiscardBtnName", translationParams: "translationParams" }, ngImport: i0, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"cancelBtnName | translate\"\n    (click)=\"onCancel()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{\n  (!disableSave ? message : disableSaveMessage) | translate : translationParams\n}}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"onCancel()\">{{\n    cancelBtnName | translate\n  }}</button>\n  <button type=\"button\" class=\"btn btn-danger\" (click)=\"onDiscard()\">{{\n    (!disableSave ? discardBtnName : disableSaveDiscardBtnName) | translate\n  }}</button>\n  <button *ngIf=\"!disableSave\" type=\"button\" class=\"btn btn-primary\" (click)=\"onSave()\">{{\n    saveBtnName | translate\n  }}</button>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiEditDiscardDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-edit-discard-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"cancelBtnName | translate\"\n    (click)=\"onCancel()\"\n  >\n  </button>\n</div>\n<div class=\"modal-body text-pre-wrap text-break\">{{\n  (!disableSave ? message : disableSaveMessage) | translate : translationParams\n}}</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"onCancel()\">{{\n    cancelBtnName | translate\n  }}</button>\n  <button type=\"button\" class=\"btn btn-danger\" (click)=\"onDiscard()\">{{\n    (!disableSave ? discardBtnName : disableSaveDiscardBtnName) | translate\n  }}</button>\n  <button *ngIf=\"!disableSave\" type=\"button\" class=\"btn btn-primary\" (click)=\"onSave()\">{{\n    saveBtnName | translate\n  }}</button>\n</div>\n" }]
        }], propDecorators: { titleId: [{
                type: Input
            }], heading: [{
                type: Input
            }], message: [{
                type: Input
            }], saveBtnName: [{
                type: Input
            }], discardBtnName: [{
                type: Input
            }], cancelBtnName: [{
                type: Input
            }], disableSave: [{
                type: Input
            }], disableSaveMessage: [{
                type: Input
            }], disableSaveDiscardBtnName: [{
                type: Input
            }], translationParams: [{
                type: Input
            }] } });

/**
 * The service provides convenient methods to show common modal dialogs.
 * All return an observable, which emit the dialog results. After emitting,
 * the observables complete. Therefore, clients do not need to unsubscribe.
 */
class SiActionDialogService {
    modalService = inject(SiModalService);
    /**
     * Show an alert dialog.
     */
    showAlertDialog(message, heading, confirmBtnName, translationParams) {
        return new Observable(subscriber => {
            const config = createModalConfig({
                message,
                heading,
                confirmBtnName,
                translationParams
            });
            config.keyboard = true;
            const modalRef = this.modalService.show(SiAlertDialogComponent, config, AlertDialogResult.Confirm);
            modalRef.hidden.subscribe(subscriber);
            return () => modalRef.detach();
        });
    }
    /**
     * Show a confirmation dialog.
     */
    showConfirmationDialog(message, heading, confirmBtnName, declineBtnName, translationParams) {
        return new Observable(subscriber => {
            const config = createModalConfig({
                message,
                heading,
                confirmBtnName,
                declineBtnName,
                translationParams
            });
            config.keyboard = true;
            const modalRef = this.modalService.show(SiConfirmationDialogComponent, config, ConfirmationDialogResult.Decline);
            modalRef.hidden.subscribe(subscriber);
            return () => modalRef.detach();
        });
    }
    /**
     * @deprecated use {@link showEditDiscardDialog} instead.
     */
    showEditAbortDialog(disableSave, message, heading, saveBtnName, abortBtnName, cancelBtnName, disableSaveMessage, disableSaveAbortBtnName, translationParams) {
        return this.showEditDiscardDialog(disableSave, message, heading, saveBtnName, abortBtnName, cancelBtnName, disableSaveMessage, disableSaveAbortBtnName, translationParams).pipe(map((editDialogRes) => {
            switch (editDialogRes) {
                case EditDiscardDialogResult.Cancel:
                    return EditAbortDialogResult.Cancel;
                case EditDiscardDialogResult.Discard:
                    // eslint-disable-next-line detect-bad-words/in-code
                    return EditAbortDialogResult.Abort;
                case EditDiscardDialogResult.Save:
                    return EditAbortDialogResult.Save;
            }
        }));
    }
    /**
     * Show an edit dialog with the option to discard.
     */
    showEditDiscardDialog(disableSave, message, heading, saveBtnName, discardBtnName, cancelBtnName, disableSaveMessage, disableSaveDiscardBtnName, translationParams) {
        return new Observable(subscriber => {
            const config = createModalConfig({
                message,
                heading,
                saveBtnName,
                discardBtnName,
                cancelBtnName,
                disableSave,
                disableSaveMessage,
                disableSaveDiscardBtnName,
                translationParams
            });
            config.keyboard = true;
            const modalRef = this.modalService.show(SiEditDiscardDialogComponent, config, EditDiscardDialogResult.Cancel);
            modalRef.hidden.subscribe(subscriber);
            return () => modalRef.detach();
        });
    }
    /**
     * Show a dialog confirming a deletion.
     */
    showDeleteConfirmationDialog(message, heading, deleteBtnName, cancelBtnName, translationParams) {
        return new Observable(subscriber => {
            const config = createModalConfig({
                message,
                heading,
                deleteBtnName,
                cancelBtnName,
                translationParams
            });
            config.keyboard = true;
            const modalRef = this.modalService.show(SiDeleteConfirmationDialogComponent, config, DeleteConfirmationDialogResult.Cancel);
            modalRef.hidden.subscribe(subscriber);
            return () => modalRef.detach();
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiActionDialogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiActionDialogService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiActionDialogService, decorators: [{
            type: Injectable
        }] });

class SiActionDialogModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiActionDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiActionDialogModule, declarations: [SiAlertDialogComponent,
            SiConfirmationDialogComponent,
            SiDeleteConfirmationDialogComponent,
            SiEditDiscardDialogComponent], imports: [CommonModule, RouterModule, SiModalModule, SiTranslateModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiActionDialogModule, providers: [SiActionDialogService], imports: [CommonModule, RouterModule, SiModalModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiActionDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SiAlertDialogComponent,
                        SiConfirmationDialogComponent,
                        SiDeleteConfirmationDialogComponent,
                        SiEditDiscardDialogComponent
                    ],
                    imports: [CommonModule, RouterModule, SiModalModule, SiTranslateModule],
                    providers: [SiActionDialogService]
                }]
        }] });

class SiColumnSelectionDialogComponent {
    titleId;
    heading;
    bodyTitle;
    submitBtnName = $localize `:@@SI_COLUMN_SELECTION_DIALOG.SUBMIT:Apply`;
    cancelBtnName = $localize `:@@SI_COLUMN_SELECTION_DIALOG.CANCEL:Cancel`;
    restoreToDefaultBtnName = $localize `:@@SI_COLUMN_SELECTION_DIALOG.RESTORE_TO_DEFAULT:Restore to default`;
    hiddenText = $localize `:@@SI_COLUMN_SELECTION_DIALOG.HIDDEN:Hidden`;
    visibleText = $localize `:@@SI_COLUMN_SELECTION_DIALOG.VISIBLE:Visible`;
    restoreEnabled = false;
    columns;
    translationParams = {};
    // eslint-disable-next-line max-len
    listAriaLabel = $localize `:@@SI_COLUMN_SELECTION_DIALOG.LIST_ARIA_LABEL:List of possible columns. Items can be moved using Alt+ArrowUp or Alt+ArrowDown`;
    a11yItemMovedMessage = $localize `:@@SI_COLUMN_SELECTION_DIALOG.ITEM_MOVED:Item is now at position {{targetPosition}}`;
    a11yItemNotMovedMessage = $localize `:@@SI_COLUMN_SELECTION_DIALOG.ITEM_NOT_MOVED:Item was not moved`;
    columnVisibilityConfigurable = true;
    listOptions;
    modalBodyElement;
    tempHeaderData = [];
    modalRef = inject((ModalRef));
    visibleIds = [];
    trackByItem = (index, item) => item;
    liveAnnouncer = inject(LiveAnnouncer);
    translateService = inject(SiTranslateService);
    ngOnInit() {
        this.createBackupData();
        this.visibleIds = this.columns.filter(column => column.visible).map(column => column.id);
    }
    get backupColumns() {
        return this.tempHeaderData;
    }
    submitColumnSelection() {
        this.modalRef.hide({ type: 'ok', columns: this.columns });
    }
    cancelColumnSelection() {
        this.columns.length = 0;
        this.tempHeaderData.forEach(element => this.columns.push(element));
        this.modalRef.hide({ type: 'cancel', columns: this.columns });
    }
    drop(event) {
        if (this.columns[event.currentIndex].draggable) {
            moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
            this.modalRef.hidden.next({ type: 'instant', columns: this.columns });
        }
    }
    restoreToDefault() {
        this.modalRef.hidden.next({
            type: 'restoreDefault',
            columns: this.columns,
            updateColumns: columns => {
                this.columns = columns;
                this.createBackupData();
            }
        });
    }
    changeColumnVisibilityFromListbox({ value }) {
        for (const column of this.columns) {
            column.visible = value.includes(column.id);
        }
        this.modalRef.hidden.next({ type: 'instant', columns: this.columns });
    }
    moveDown(index, event) {
        if (this.columns[index].draggable) {
            let targetIndex = index + 1;
            while (this.columns[targetIndex] && !this.columns[targetIndex].draggable) {
                targetIndex++;
            }
            if (targetIndex !== index && this.columns[targetIndex]?.draggable) {
                event.preventDefault();
                moveItemInArray(this.columns, index, targetIndex);
                // When moving the first partially visible item down,
                // the browser tries to keep its position stable within the viewport by automatically scrolling down.
                // This behavior is not wanted here, so we restore the previous scroll after moving the item
                // TODO: check if this could be solved easier
                if (this.listOptions.get(index).element.getBoundingClientRect().top <=
                    this.modalBodyElement.nativeElement.getBoundingClientRect().top) {
                    const previousScrollTop = this.modalBodyElement.nativeElement.scrollTop;
                    setTimeout(() => (this.modalBodyElement.nativeElement.scrollTop = previousScrollTop));
                }
                // When moving the last visible element down, the scroll position is not adopted. So its scroll out of view.
                // We correct this manually by scrolling it back into view
                const targetElement = this.listOptions.get(targetIndex).element;
                if (targetElement.getBoundingClientRect().bottom >
                    this.modalBodyElement.nativeElement.getBoundingClientRect().bottom) {
                    targetElement.scrollIntoView({ block: 'end' });
                }
                this.announceSuccessfulMove(targetIndex);
            }
            else {
                this.announceNotSuccessfulMove();
            }
        }
    }
    moveUp(index, event) {
        if (this.columns[index].draggable) {
            let targetIndex = index - 1;
            while (this.columns[targetIndex] && !this.columns[targetIndex].draggable) {
                targetIndex--;
            }
            if (targetIndex !== index && this.columns[targetIndex]?.draggable) {
                event.preventDefault();
                moveItemInArray(this.columns, index, targetIndex);
                // it seems like this is only necessary for move up. Don't know why
                setTimeout(() => this.listOptions.get(targetIndex).focus());
                this.announceSuccessfulMove(targetIndex);
            }
            else {
                this.announceNotSuccessfulMove();
            }
        }
    }
    createBackupData() {
        this.tempHeaderData = this.columns.map(x => Object.assign({}, x));
    }
    announceSuccessfulMove(index) {
        this.announceMove(this.a11yItemMovedMessage, {
            ...this.translationParams,
            targetPosition: index + 1
        });
    }
    announceNotSuccessfulMove() {
        this.announceMove(this.a11yItemNotMovedMessage, this.translationParams);
    }
    announceMove(message, translationParams) {
        if (message) {
            this.translateService
                .translateAsync(message, translationParams)
                .pipe(first())
                .subscribe(translatedMessage => this.liveAnnouncer.announce(translatedMessage));
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiColumnSelectionDialogComponent, selector: "si-column-selection-dialog", inputs: { titleId: "titleId", heading: "heading", bodyTitle: "bodyTitle", submitBtnName: "submitBtnName", cancelBtnName: "cancelBtnName", restoreToDefaultBtnName: "restoreToDefaultBtnName", hiddenText: "hiddenText", visibleText: "visibleText", restoreEnabled: "restoreEnabled", columns: "columns", translationParams: "translationParams", listAriaLabel: "listAriaLabel", a11yItemMovedMessage: "a11yItemMovedMessage", a11yItemNotMovedMessage: "a11yItemNotMovedMessage", columnVisibilityConfigurable: "columnVisibilityConfigurable" }, viewQueries: [{ propertyName: "modalBodyElement", first: true, predicate: ["modalBody"], descendants: true, static: true }, { propertyName: "listOptions", predicate: CdkOption, descendants: true }], ngImport: i0, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"cancelBtnName | translate\"\n    (click)=\"cancelColumnSelection()\"\n  ></button>\n</div>\n<p class=\"text-secondary px-8 pb-5 mb-0\">{{ bodyTitle | translate : translationParams }}</p>\n<div #modalBody class=\"modal-body py-0\">\n  <div\n    cdkListbox\n    cdkListboxMultiple\n    cdkDropList\n    aria-keyshortcuts=\"Alt+ArrowUp Alt+ArrowDown\"\n    [cdkListboxValue]=\"visibleIds\"\n    [attr.aria-label]=\"listAriaLabel | translate : translationParams\"\n    (cdkListboxValueChange)=\"changeColumnVisibilityFromListbox($event)\"\n    (cdkDropListDropped)=\"drop($event)\"\n  >\n    <div\n      *ngFor=\"let headerContent of columns; let index = index; trackBy: trackByItem\"\n      cdkDrag\n      class=\"d-flex justify-content-between user-select-none my-4 mx-1 p-5 rounded-2 elevation-1 bg-base-1\"\n      [cdkDragDisabled]=\"!headerContent.draggable\"\n      [cdkOption]=\"headerContent.id\"\n      [cdkOptionDisabled]=\"headerContent.disabled\"\n      (keydown.alt.arrowUp)=\"moveUp(index, $event)\"\n      (keydown.alt.arrowDown)=\"moveDown(index, $event)\"\n    >\n      <div class=\"d-flex align-items-center\">\n        <div\n          cdkDragHandle\n          aria-hidden=\"true\"\n          class=\"drag-handle element-menu me-5 rounded-1\"\n          [class.disabled]=\"headerContent.disabled\"\n          [class.draggable]=\"headerContent.draggable\"\n        ></div>\n        <span class=\"si-body-2\" [class.disabled]=\"headerContent.disabled\">{{\n          headerContent.title | translate : translationParams\n        }}</span>\n      </div>\n      <div\n        *ngIf=\"columnVisibilityConfigurable\"\n        class=\"d-flex align-items-center form-check form-switch\"\n        aria-hidden=\"true\"\n      >\n        <span class=\"si-body-2 me-4 form-check-label\" [class.disabled]=\"headerContent.disabled\">{{\n          (headerContent.visible ? visibleText : hiddenText) | translate\n        }}</span>\n        <span\n          type=\"checkbox\"\n          class=\"form-check-input\"\n          [class.disabled]=\"headerContent.disabled\"\n          [class.checked]=\"headerContent.visible\"\n        ></span>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button\n    *ngIf=\"restoreEnabled\"\n    type=\"button\"\n    class=\"btn btn-secondary me-auto\"\n    (click)=\"restoreToDefault()\"\n  >\n    {{ restoreToDefaultBtnName | translate }}\n  </button>\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelColumnSelection()\">\n    {{ cancelBtnName | translate }}\n  </button>\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"submitColumnSelection()\">\n    {{ submitBtnName | translate }}\n  </button>\n</div>\n", styles: [":host{-webkit-user-select:none;user-select:none;max-block-size:100%;overflow:hidden;display:flex;flex-direction:column}.disabled{color:var(--element-text-disabled)}.drag-handle{font-size:24px;color:var(--element-ui-2)}.drag-handle.disabled{color:var(--element-ui-3)}.drag-handle.draggable{cursor:pointer}.drag-handle.draggable:hover,.drag-handle.draggable.hover{background:var(--element-base-0)}.cdk-drag-placeholder{opacity:0}.cdk-drag-preview .drag-handle{color:var(--element-ui-5);background-color:var(--element-ui-3)}.switch{margin:0}\n"], dependencies: [{ kind: "directive", type: i1$2.CdkListbox, selector: "[cdkListbox]", inputs: ["id", "tabindex", "cdkListboxValue", "cdkListboxMultiple", "cdkListboxDisabled", "cdkListboxUseActiveDescendant", "cdkListboxOrientation", "cdkListboxCompareWith", "cdkListboxNavigationWrapDisabled", "cdkListboxNavigatesDisabledOptions"], outputs: ["cdkListboxValueChange"], exportAs: ["cdkListbox"] }, { kind: "directive", type: i1$2.CdkOption, selector: "[cdkOption]", inputs: ["id", "cdkOption", "cdkOptionTypeaheadLabel", "cdkOptionDisabled", "tabindex"], exportAs: ["cdkOption"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$6.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i3$6.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i3$6.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-column-selection-dialog', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"modal-header\">\n  <span class=\"modal-title\" [id]=\"titleId\">{{ heading | translate : translationParams }}</span>\n  <button\n    type=\"button\"\n    class=\"btn btn-circle btn-sm btn-ghost element-cancel\"\n    [attr.aria-label]=\"cancelBtnName | translate\"\n    (click)=\"cancelColumnSelection()\"\n  ></button>\n</div>\n<p class=\"text-secondary px-8 pb-5 mb-0\">{{ bodyTitle | translate : translationParams }}</p>\n<div #modalBody class=\"modal-body py-0\">\n  <div\n    cdkListbox\n    cdkListboxMultiple\n    cdkDropList\n    aria-keyshortcuts=\"Alt+ArrowUp Alt+ArrowDown\"\n    [cdkListboxValue]=\"visibleIds\"\n    [attr.aria-label]=\"listAriaLabel | translate : translationParams\"\n    (cdkListboxValueChange)=\"changeColumnVisibilityFromListbox($event)\"\n    (cdkDropListDropped)=\"drop($event)\"\n  >\n    <div\n      *ngFor=\"let headerContent of columns; let index = index; trackBy: trackByItem\"\n      cdkDrag\n      class=\"d-flex justify-content-between user-select-none my-4 mx-1 p-5 rounded-2 elevation-1 bg-base-1\"\n      [cdkDragDisabled]=\"!headerContent.draggable\"\n      [cdkOption]=\"headerContent.id\"\n      [cdkOptionDisabled]=\"headerContent.disabled\"\n      (keydown.alt.arrowUp)=\"moveUp(index, $event)\"\n      (keydown.alt.arrowDown)=\"moveDown(index, $event)\"\n    >\n      <div class=\"d-flex align-items-center\">\n        <div\n          cdkDragHandle\n          aria-hidden=\"true\"\n          class=\"drag-handle element-menu me-5 rounded-1\"\n          [class.disabled]=\"headerContent.disabled\"\n          [class.draggable]=\"headerContent.draggable\"\n        ></div>\n        <span class=\"si-body-2\" [class.disabled]=\"headerContent.disabled\">{{\n          headerContent.title | translate : translationParams\n        }}</span>\n      </div>\n      <div\n        *ngIf=\"columnVisibilityConfigurable\"\n        class=\"d-flex align-items-center form-check form-switch\"\n        aria-hidden=\"true\"\n      >\n        <span class=\"si-body-2 me-4 form-check-label\" [class.disabled]=\"headerContent.disabled\">{{\n          (headerContent.visible ? visibleText : hiddenText) | translate\n        }}</span>\n        <span\n          type=\"checkbox\"\n          class=\"form-check-input\"\n          [class.disabled]=\"headerContent.disabled\"\n          [class.checked]=\"headerContent.visible\"\n        ></span>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button\n    *ngIf=\"restoreEnabled\"\n    type=\"button\"\n    class=\"btn btn-secondary me-auto\"\n    (click)=\"restoreToDefault()\"\n  >\n    {{ restoreToDefaultBtnName | translate }}\n  </button>\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"cancelColumnSelection()\">\n    {{ cancelBtnName | translate }}\n  </button>\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"submitColumnSelection()\">\n    {{ submitBtnName | translate }}\n  </button>\n</div>\n", styles: [":host{-webkit-user-select:none;user-select:none;max-block-size:100%;overflow:hidden;display:flex;flex-direction:column}.disabled{color:var(--element-text-disabled)}.drag-handle{font-size:24px;color:var(--element-ui-2)}.drag-handle.disabled{color:var(--element-ui-3)}.drag-handle.draggable{cursor:pointer}.drag-handle.draggable:hover,.drag-handle.draggable.hover{background:var(--element-base-0)}.cdk-drag-placeholder{opacity:0}.cdk-drag-preview .drag-handle{color:var(--element-ui-5);background-color:var(--element-ui-3)}.switch{margin:0}\n"] }]
        }], propDecorators: { titleId: [{
                type: Input
            }], heading: [{
                type: Input
            }], bodyTitle: [{
                type: Input
            }], submitBtnName: [{
                type: Input
            }], cancelBtnName: [{
                type: Input
            }], restoreToDefaultBtnName: [{
                type: Input
            }], hiddenText: [{
                type: Input
            }], visibleText: [{
                type: Input
            }], restoreEnabled: [{
                type: Input
            }], columns: [{
                type: Input
            }], translationParams: [{
                type: Input
            }], listAriaLabel: [{
                type: Input
            }], a11yItemMovedMessage: [{
                type: Input
            }], a11yItemNotMovedMessage: [{
                type: Input
            }], columnVisibilityConfigurable: [{
                type: Input
            }], listOptions: [{
                type: ViewChildren,
                args: [CdkOption]
            }], modalBodyElement: [{
                type: ViewChild,
                args: ['modalBody', { static: true }]
            }] } });

class SiColumnSelectionDialogService {
    modalService = inject(SiModalService);
    /**
     * @deprecated use {showColumnSelectionDialog(config: SiColumnSelectionDialogConfig)} instead
     */
    showColumnSelectionDialog(headingOrConfig, bodyTitle, submitBtnName, cancelBtnName, columns, translationParams, restoreToDefaultBtnName, restoreEnabled, visibleText, hiddenText) {
        return new Observable(subscriber => {
            let config;
            if (typeof headingOrConfig === 'object') {
                config = createModalConfig(headingOrConfig);
            }
            else {
                config = createModalConfig({
                    heading: headingOrConfig,
                    bodyTitle,
                    submitBtnName,
                    cancelBtnName,
                    visibleText,
                    hiddenText,
                    columns,
                    translationParams,
                    restoreToDefaultBtnName,
                    restoreEnabled
                });
            }
            config.class += ' modal-dialog-scrollable';
            config.keyboard = true;
            const modalRef = this.modalService.show(SiColumnSelectionDialogComponent, config);
            const subscription = modalRef.hidden.subscribe((confirmationResult) => {
                const keepModalOpen = confirmationResult?.type === 'instant' || confirmationResult?.type === 'restoreDefault';
                if (!confirmationResult) {
                    confirmationResult = { type: 'cancel', columns: modalRef.content.backupColumns };
                }
                subscriber.next(confirmationResult);
                if (!keepModalOpen) {
                    subscription.unsubscribe();
                    subscriber.complete();
                }
            });
            return () => {
                if (!subscription.closed) {
                    subscription.unsubscribe();
                    modalRef.detach();
                }
            };
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionDialogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionDialogService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionDialogService, decorators: [{
            type: Injectable
        }] });

const dragConfig = {
    dragStartThreshold: 0,
    pointerDirectionChangeThreshold: 5,
    zIndex: 10000
};
class SiColumnSelectionModalModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionModalModule, declarations: [SiColumnSelectionDialogComponent], imports: [CdkListboxModule,
            CommonModule,
            DragDropModule,
            RouterModule,
            SiModalModule,
            SiTranslateModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionModalModule, providers: [SiColumnSelectionDialogService, { provide: CDK_DRAG_CONFIG, useValue: dragConfig }], imports: [CdkListboxModule,
            CommonModule,
            DragDropModule,
            RouterModule,
            SiModalModule,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiColumnSelectionModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiColumnSelectionDialogComponent],
                    imports: [
                        CdkListboxModule,
                        CommonModule,
                        DragDropModule,
                        RouterModule,
                        SiModalModule,
                        SiTranslateModule
                    ],
                    providers: [SiColumnSelectionDialogService, { provide: CDK_DRAG_CONFIG, useValue: dragConfig }]
                }]
        }] });

class SiMainDetailContainerComponent {
    animationDuration = 500;
    resizeSubs;
    elementRef = inject(ElementRef);
    resizeObserver = inject(ResizeObserverService);
    changeDetectorRef = inject(ChangeDetectorRef);
    /**
     * A numeric value defining the minimum width in px, which the container needs
     * to be displayed in its large layout. Whenever smaller than
     * this threshold, the small layout will be used. Default is
     * value is BOOTSTRAP_BREAKPOINTS.mdMinimum.
     */
    largeLayoutBreakpoint = BOOTSTRAP_BREAKPOINTS.mdMinimum;
    /**
     * Whether the main-detail layout component has a large size or not,
     * `true` if the container´s width matches or exceeds the `largeLayoutBreakpoint`.
     */
    hasLargeSize;
    /**
     * Emits whether the components size is large enough to display
     * main and details views next to each other or not.
     */
    hasLargeSizeChange = new EventEmitter();
    /**
     * Whether the details are currently active or not, mostly relevant in the
     * responsive scenario when the viewport only shows either the main or the detail.
     */
    detailsActive = false;
    /**
     * Emits the new value of `detailsActive` whenever its value changes.
     */
    detailsActiveChange = new EventEmitter();
    /**
     * The heading of the main-detail layout component, usually a page heading.
     */
    heading = '';
    /**
     * Whether the heading should be truncated (single line) or not.
     * Default value is `false`.
     */
    truncateHeading = false;
    /**
     * The heading of the detail area.
     */
    detailsHeading = '';
    /**
     * Whether the main and detail parts should be resizable by a splitter or not.
     * This is only supported in the 'large' scenario (when `hasLargeSize` is `true`).
     * Default value is `false`.
     */
    resizableParts = false;
    /**
     * You can hide the back button in the mobile view by setting true. Required
     * in add, edit workflows on mobile sizes. During add or edit, the back button
     * should be hidden. Default value is `false`.
     */
    hideBackButton = false;
    /**
     * Details back button text. Required for a11y.
     */
    detailsBackButtonText = $localize `:@@SI_MAIN_DETAIL_CONTAINER.BACK:Back`;
    /**
     * CSS class(es) applied to the outermost container. Per default, Bootstrap classes
     * to handle responsive paddings are applied: `px-6 pt-6 px-md-9`.
     */
    containerClass = 'px-6 pt-6 px-md-9';
    /**
     * CSS class(es) applied to the main container. In combination with `containerClass`,
     * this allows for settings individual padding and margin values on the individual containers.
     */
    mainContainerClass = '';
    /**
     * CSS class(es) applied to the detail container. In combination with `containerClass`,
     * this allows for settings individual padding and margin values on the individual containers.
     * Default value: `pb-7 pb-md-9`
     */
    detailContainerClass = 'pb-6 pb-md-9';
    /**
     * The percentage width of the main container from the overall component width.
     * Can be a number or `'default'`, which is 32% when {@link resizableParts} is active, otherwise 50%.
     */
    mainContainerWidth = 'default';
    /**
     * Emits on split changes the new percentage width of the main container from
     * the overall container width.
     */
    mainContainerWidthChange = new EventEmitter();
    /**
     * Sets the minimal width of the main container in pixel.
     */
    minMainSize = 300;
    /**
     * Sets the minimal width of the detail container in pixel.
     */
    minDetailSize = 300;
    /**
     * An optional stateId to uniquely identify a component instance.
     * Required for persistence of ui state.
     */
    stateId;
    get actualMainContainerWidth() {
        return this.mainContainerWidth === 'default'
            ? this.resizableParts
                ? 32
                : 50
            : this.mainContainerWidth;
    }
    splitSizes = [
        this.actualMainContainerWidth,
        100 - this.actualMainContainerWidth
    ];
    // The max size to limit the main container in the static flex layout (if less than 50%), otherwise not set.
    maxMainSize = this.getMaxSize(0);
    // The max size to limit the detail container in the static flex layout (if less than 50%), otherwise not set.
    maxDetailSize = this.getMaxSize(1);
    get mainStateId() {
        return this.stateId ? `${this.stateId}-main` : undefined;
    }
    get detailStateId() {
        return this.stateId ? `${this.stateId}-detail` : undefined;
    }
    animate = false;
    opacity = '0';
    ngOnInit() {
        this.resizeSubs = this.resizeObserver
            .observe(this.elementRef.nativeElement, 100, true)
            .subscribe(dimensions => this.determineLayout(dimensions));
    }
    ngOnChanges(changes) {
        if (changes.detailsActive) {
            this.doAnimation(changes.detailsActive.currentValue);
        }
        if (changes.mainContainerWidth || changes.resizableParts) {
            this.splitSizes = [this.actualMainContainerWidth, 100 - this.actualMainContainerWidth];
            this.maxMainSize = this.getMaxSize(0);
            this.maxDetailSize = this.getMaxSize(1);
        }
    }
    ngOnDestroy() {
        this.resizeSubs?.unsubscribe();
    }
    onSplitSizesChange(sizes) {
        this.mainContainerWidth = sizes[0];
        this.mainContainerWidthChange.emit(this.actualMainContainerWidth);
    }
    detailsBackClicked() {
        this.detailsActive = false;
        this.doAnimation(false);
    }
    /**
     * Get the max size to limit in the static flex layout (if less than 50%), otherwise not set
     */
    getMaxSize(part) {
        return this.resizableParts ||
            this.mainContainerWidth === 'default' ||
            !this.hasLargeSize ||
            this.splitSizes[part] > 50
            ? ''
            : this.splitSizes[part] + '%';
    }
    determineLayout(dimensions) {
        const newHasLargeSize = dimensions.width >= this.largeLayoutBreakpoint;
        if (this.hasLargeSize !== newHasLargeSize) {
            this.hasLargeSize = newHasLargeSize;
            this.maxMainSize = this.getMaxSize(0);
            this.maxDetailSize = this.getMaxSize(0);
            this.hasLargeSizeChange.emit(this.hasLargeSize);
            this.changeDetectorRef.markForCheck();
        }
        if (this.opacity === '0') {
            this.opacity = '';
            this.changeDetectorRef.markForCheck();
        }
    }
    doAnimation(detailsActive) {
        this.animate = true;
        setTimeout(() => {
            this.animate = false;
            this.changeDetectorRef.markForCheck();
        }, this.animationDuration);
        this.detailsActiveChange.emit(detailsActive);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMainDetailContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiMainDetailContainerComponent, selector: "si-main-detail-container", inputs: { largeLayoutBreakpoint: "largeLayoutBreakpoint", detailsActive: "detailsActive", heading: "heading", truncateHeading: "truncateHeading", detailsHeading: "detailsHeading", resizableParts: "resizableParts", hideBackButton: "hideBackButton", detailsBackButtonText: "detailsBackButtonText", containerClass: "containerClass", mainContainerClass: "mainContainerClass", detailContainerClass: "detailContainerClass", mainContainerWidth: "mainContainerWidth", minMainSize: "minMainSize", minDetailSize: "minDetailSize", stateId: "stateId" }, outputs: { hasLargeSizeChange: "hasLargeSizeChange", detailsActiveChange: "detailsActiveChange", mainContainerWidthChange: "mainContainerWidthChange" }, host: { properties: { "class.animate": "this.animate", "style.opacity": "this.opacity" }, classAttribute: "si-layout-inner" }, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"resizableParts && hasLargeSize; else staticTemplate\">\n  <div class=\"main-detail-layout d-flex flex-column\" [ngClass]=\"containerClass\">\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <si-split\n      class=\"w-100 flex-grow-1\"\n      orientation=\"horizontal\"\n      [stateId]=\"stateId\"\n      [sizes]=\"splitSizes\"\n      (sizesChange)=\"onSplitSizesChange($event)\"\n    >\n      <si-split-part\n        scale=\"none\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minMainSize\"\n        [stateId]=\"mainStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"mainTemplate\"></ng-container>\n      </si-split-part>\n      <si-split-part\n        scale=\"auto\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minDetailSize\"\n        [stateId]=\"detailStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"detailTemplate\"></ng-container>\n      </si-split-part>\n    </si-split>\n  </div>\n</ng-container>\n\n<ng-template #staticTemplate>\n  <div\n    class=\"main-detail-layout d-flex flex-column\"\n    [ngClass]=\"containerClass\"\n    [class.large-size]=\"hasLargeSize\"\n  >\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <div\n      class=\"main-detail-container d-flex flex-grow-1\"\n      [class.details-active]=\"detailsActive && !hasLargeSize\"\n    >\n      <ng-container\n        *ngTemplateOutlet=\"\n          mainTemplate;\n          context: { customClass: hasLargeSize ? 'col-3 ps-0 pe-4' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"\n          detailTemplate;\n          context: { customClass: hasLargeSize ? 'col-9 ps-4 pe-0' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Templates -->\n<ng-template #headingTemplate>\n  <h2\n    *ngIf=\"heading\"\n    class=\"main-detail-heading page-top-title flex-grow-0 flex-shrink-0 text-secondary\"\n    [class.text-truncate]=\"truncateHeading\"\n    >{{ heading | translate }}</h2\n  >\n</ng-template>\n\n<ng-template #mainTemplate let-customClass=\"customClass\">\n  <div\n    class=\"main-container d-flex flex-column\"\n    [ngClass]=\"[mainContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxMainSize\"\n  >\n    <div class=\"main-search-actions d-flex align-items-center\">\n      <ng-content select=\"[slot=mainSearch]\"></ng-content>\n      <ng-content select=\"[slot=mainActions]\"></ng-content>\n      <ng-content select=\"[slot=masterSearch]\"></ng-content>\n      <ng-content select=\"[slot=masterActions]\"></ng-content>\n    </div>\n    <div class=\"main-data-container d-flex\">\n      <ng-content select=\"[slot=mainData]\"></ng-content>\n      <ng-content select=\"[slot=masterData]\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #detailTemplate let-customClass=\"customClass\">\n  <div\n    class=\"detail-container d-flex flex-column\"\n    [ngClass]=\"[detailContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxDetailSize\"\n  >\n    <div class=\"detail-heading-actions d-flex align-items-center\">\n      <button\n        *ngIf=\"!this.hasLargeSize && !this.hideBackButton\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-secondary element-back\"\n        (click)=\"detailsBackClicked()\"\n        ><span class=\"visually-hidden\">{{ detailsBackButtonText | translate }}</span></button\n      >\n      <span\n        *ngIf=\"detailsHeading\"\n        class=\"detail-heading si-title-1 me-auto ms-6 my-auto text-truncate\"\n        >{{ detailsHeading | translate }}</span\n      >\n      <ng-content select=\"[slot=detailActions]\"></ng-content>\n    </div>\n    <ng-content select=\"[slot=details]\"></ng-content>\n  </div>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;overflow-x:hidden;overflow-y:auto}:host ::ng-deep [slot=masterSearch],:host ::ng-deep [slot=mainSearch]{flex:1 1 0}:host ::ng-deep [slot=masterSearch]+[slot=masterActions],:host ::ng-deep [slot=masterSearch]+[slot=mainActions],:host ::ng-deep [slot=mainSearch]+[slot=masterActions],:host ::ng-deep [slot=mainSearch]+[slot=mainActions]{margin-inline-start:12px}:host ::ng-deep [slot=masterActions],:host ::ng-deep [slot=mainActions]{margin-inline-start:auto}:host ::ng-deep [slot=masterData],:host ::ng-deep [slot=mainData],:host ::ng-deep [slot=details]{flex:1 1 0;min-block-size:0}:host ::ng-deep [slot=detailActions]{margin-inline-start:auto}:host ::ng-deep .detail-heading+[slot=detailActions]{margin-inline-start:12px}:host ::ng-deep si-split{--si-split-gutter-background: transparent;min-block-size:0}:host ::ng-deep si-split si-split-part,:host ::ng-deep si-split .si-split-container,:host ::ng-deep si-split .si-split-part-content{overflow:visible}:host.animate{--si-main-detail-animation-duration: calc(.5s * var(--element-animations-enabled, 1))}.main-detail-layout{overflow-x:hidden;position:relative}.main-detail-layout.large-size{--si-main-detail-container-width: 100%;--si-main-detail-container-transition: none;--si-main-detail-container-transform: none;--si-main-detail-transition: none;--si-main-detail-opacity: 1;--si-main-detail-pointer-events: auto}.main-detail-heading{margin-block-end:20px}.main-detail-container{--si-main-detail-transition: opacity var(--si-main-detail-animation-duration, 0) ease-in-out;--si-main-detail-detail-opacity: 0;--si-main-detail-detail-pointer-events: none;inline-size:var(--si-main-detail-container-width, 200%);transform:var(--si-main-detail-container-transform, none);transform-origin:top left;transition:var(--si-main-detail-container-transition, transform var(--si-main-detail-animation-duration, 0) ease-in-out)}.main-detail-container.details-active{--si-main-detail-container-transform: translateX(-50%);--si-main-detail-main-opacity: 0;--si-main-detail-detail-opacity: 1;--si-main-detail-main-pointer-events: none;--si-main-detail-detail-pointer-events: auto}.main-detail-layout,.main-detail-container,.main-container,.detail-container,.main-data-container{flex:1 1 0;min-block-size:0}.main-container,.detail-container{transition:var(--si-main-detail-transition, none)}.main-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-main-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-main-pointer-events, auto))}.detail-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-detail-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-detail-pointer-events, auto))}.main-search-actions,.detail-heading-actions{min-block-size:32px;margin-block-end:12px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$1.SiSplitComponent, selector: "si-split", inputs: ["orientation", "sizes", "gutterSize", "stateId"], outputs: ["sizesChange"] }, { kind: "component", type: i2$1.SiSplitPartComponent, selector: "si-split-part", inputs: ["actions", "collapseDirection", "collapseIconClass", "collapseToMinSize", "headerStatusColor", "headerStatusIconClass", "headerTemplate", "heading", "minSize", "removeContentOnCollapse", "scale", "showCollapseButton", "showHeader", "collapseLabel", "stateId", "expanded", "size"], outputs: ["collapseChanged", "stateChange"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMainDetailContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-main-detail-container', host: { class: 'si-layout-inner' }, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"resizableParts && hasLargeSize; else staticTemplate\">\n  <div class=\"main-detail-layout d-flex flex-column\" [ngClass]=\"containerClass\">\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <si-split\n      class=\"w-100 flex-grow-1\"\n      orientation=\"horizontal\"\n      [stateId]=\"stateId\"\n      [sizes]=\"splitSizes\"\n      (sizesChange)=\"onSplitSizesChange($event)\"\n    >\n      <si-split-part\n        scale=\"none\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minMainSize\"\n        [stateId]=\"mainStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"mainTemplate\"></ng-container>\n      </si-split-part>\n      <si-split-part\n        scale=\"auto\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minDetailSize\"\n        [stateId]=\"detailStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"detailTemplate\"></ng-container>\n      </si-split-part>\n    </si-split>\n  </div>\n</ng-container>\n\n<ng-template #staticTemplate>\n  <div\n    class=\"main-detail-layout d-flex flex-column\"\n    [ngClass]=\"containerClass\"\n    [class.large-size]=\"hasLargeSize\"\n  >\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <div\n      class=\"main-detail-container d-flex flex-grow-1\"\n      [class.details-active]=\"detailsActive && !hasLargeSize\"\n    >\n      <ng-container\n        *ngTemplateOutlet=\"\n          mainTemplate;\n          context: { customClass: hasLargeSize ? 'col-3 ps-0 pe-4' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"\n          detailTemplate;\n          context: { customClass: hasLargeSize ? 'col-9 ps-4 pe-0' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Templates -->\n<ng-template #headingTemplate>\n  <h2\n    *ngIf=\"heading\"\n    class=\"main-detail-heading page-top-title flex-grow-0 flex-shrink-0 text-secondary\"\n    [class.text-truncate]=\"truncateHeading\"\n    >{{ heading | translate }}</h2\n  >\n</ng-template>\n\n<ng-template #mainTemplate let-customClass=\"customClass\">\n  <div\n    class=\"main-container d-flex flex-column\"\n    [ngClass]=\"[mainContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxMainSize\"\n  >\n    <div class=\"main-search-actions d-flex align-items-center\">\n      <ng-content select=\"[slot=mainSearch]\"></ng-content>\n      <ng-content select=\"[slot=mainActions]\"></ng-content>\n      <ng-content select=\"[slot=masterSearch]\"></ng-content>\n      <ng-content select=\"[slot=masterActions]\"></ng-content>\n    </div>\n    <div class=\"main-data-container d-flex\">\n      <ng-content select=\"[slot=mainData]\"></ng-content>\n      <ng-content select=\"[slot=masterData]\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #detailTemplate let-customClass=\"customClass\">\n  <div\n    class=\"detail-container d-flex flex-column\"\n    [ngClass]=\"[detailContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxDetailSize\"\n  >\n    <div class=\"detail-heading-actions d-flex align-items-center\">\n      <button\n        *ngIf=\"!this.hasLargeSize && !this.hideBackButton\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-secondary element-back\"\n        (click)=\"detailsBackClicked()\"\n        ><span class=\"visually-hidden\">{{ detailsBackButtonText | translate }}</span></button\n      >\n      <span\n        *ngIf=\"detailsHeading\"\n        class=\"detail-heading si-title-1 me-auto ms-6 my-auto text-truncate\"\n        >{{ detailsHeading | translate }}</span\n      >\n      <ng-content select=\"[slot=detailActions]\"></ng-content>\n    </div>\n    <ng-content select=\"[slot=details]\"></ng-content>\n  </div>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;overflow-x:hidden;overflow-y:auto}:host ::ng-deep [slot=masterSearch],:host ::ng-deep [slot=mainSearch]{flex:1 1 0}:host ::ng-deep [slot=masterSearch]+[slot=masterActions],:host ::ng-deep [slot=masterSearch]+[slot=mainActions],:host ::ng-deep [slot=mainSearch]+[slot=masterActions],:host ::ng-deep [slot=mainSearch]+[slot=mainActions]{margin-inline-start:12px}:host ::ng-deep [slot=masterActions],:host ::ng-deep [slot=mainActions]{margin-inline-start:auto}:host ::ng-deep [slot=masterData],:host ::ng-deep [slot=mainData],:host ::ng-deep [slot=details]{flex:1 1 0;min-block-size:0}:host ::ng-deep [slot=detailActions]{margin-inline-start:auto}:host ::ng-deep .detail-heading+[slot=detailActions]{margin-inline-start:12px}:host ::ng-deep si-split{--si-split-gutter-background: transparent;min-block-size:0}:host ::ng-deep si-split si-split-part,:host ::ng-deep si-split .si-split-container,:host ::ng-deep si-split .si-split-part-content{overflow:visible}:host.animate{--si-main-detail-animation-duration: calc(.5s * var(--element-animations-enabled, 1))}.main-detail-layout{overflow-x:hidden;position:relative}.main-detail-layout.large-size{--si-main-detail-container-width: 100%;--si-main-detail-container-transition: none;--si-main-detail-container-transform: none;--si-main-detail-transition: none;--si-main-detail-opacity: 1;--si-main-detail-pointer-events: auto}.main-detail-heading{margin-block-end:20px}.main-detail-container{--si-main-detail-transition: opacity var(--si-main-detail-animation-duration, 0) ease-in-out;--si-main-detail-detail-opacity: 0;--si-main-detail-detail-pointer-events: none;inline-size:var(--si-main-detail-container-width, 200%);transform:var(--si-main-detail-container-transform, none);transform-origin:top left;transition:var(--si-main-detail-container-transition, transform var(--si-main-detail-animation-duration, 0) ease-in-out)}.main-detail-container.details-active{--si-main-detail-container-transform: translateX(-50%);--si-main-detail-main-opacity: 0;--si-main-detail-detail-opacity: 1;--si-main-detail-main-pointer-events: none;--si-main-detail-detail-pointer-events: auto}.main-detail-layout,.main-detail-container,.main-container,.detail-container,.main-data-container{flex:1 1 0;min-block-size:0}.main-container,.detail-container{transition:var(--si-main-detail-transition, none)}.main-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-main-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-main-pointer-events, auto))}.detail-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-detail-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-detail-pointer-events, auto))}.main-search-actions,.detail-heading-actions{min-block-size:32px;margin-block-end:12px}\n"] }]
        }], propDecorators: { largeLayoutBreakpoint: [{
                type: Input
            }], hasLargeSizeChange: [{
                type: Output
            }], detailsActive: [{
                type: Input
            }], detailsActiveChange: [{
                type: Output
            }], heading: [{
                type: Input
            }], truncateHeading: [{
                type: Input
            }], detailsHeading: [{
                type: Input
            }], resizableParts: [{
                type: Input
            }], hideBackButton: [{
                type: Input
            }], detailsBackButtonText: [{
                type: Input
            }], containerClass: [{
                type: Input
            }], mainContainerClass: [{
                type: Input
            }], detailContainerClass: [{
                type: Input
            }], mainContainerWidth: [{
                type: Input
            }], mainContainerWidthChange: [{
                type: Output
            }], minMainSize: [{
                type: Input
            }], minDetailSize: [{
                type: Input
            }], stateId: [{
                type: Input
            }], animate: [{
                type: HostBinding,
                args: ['class.animate']
            }], opacity: [{
                type: HostBinding,
                args: ['style.opacity']
            }] } });

class SiMainDetailContainerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMainDetailContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiMainDetailContainerModule, declarations: [SiMainDetailContainerComponent], imports: [CommonModule, SiSplitModule, SiTranslateModule], exports: [SiMainDetailContainerComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMainDetailContainerModule, imports: [CommonModule, SiSplitModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMainDetailContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiMainDetailContainerComponent],
                    imports: [CommonModule, SiSplitModule, SiTranslateModule],
                    exports: [SiMainDetailContainerComponent]
                }]
        }] });

/* eslint-disable detect-bad-words/in-code, detect-bad-words/in-comment */
/**
 * @deprecated `si-main-detail-container` should be used instead
 */
class SiMasterDetailContainerComponent extends SiMainDetailContainerComponent {
    /**
     * CSS class(es) applied to the master container. In combination with `containerClass`,
     * this allows for settings individual padding and margin values on the individual containers.
     */
    set masterContainerClass(c) {
        this.mainContainerClass = c;
        this.cdRef.markForCheck();
    }
    get masterContainerClass() {
        return this.mainContainerClass;
    }
    /**
     * The percentage width of the master container from the overall component width.
     * Can be a number or `'default'`, which is 32% when {@link resizableParts} is active, otherwise 50%.
     */
    set masterContainerWidth(v) {
        this.mainContainerWidth = v;
        this.cdRef.markForCheck();
    }
    get masterContainerWidth() {
        return this.mainContainerWidth;
    }
    /**
     * Sets the minimal width of the master container in pixel.
     */
    set minMasterSize(v) {
        this.minMainSize = v;
        this.cdRef.markForCheck();
    }
    get minMasterSize() {
        return this.minMainSize;
    }
    /**
     * Emits on split changes the new percentage width of the master container from
     * the overall container width.
     */
    masterContainerWidthChange = new EventEmitter();
    destroyRef = inject(DestroyRef);
    cdRef = inject(ChangeDetectorRef);
    ngAfterViewInit() {
        this.mainContainerWidthChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(v => this.masterContainerWidthChange.next(v));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMasterDetailContainerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiMasterDetailContainerComponent, selector: "si-master-detail-container", inputs: { masterContainerClass: "masterContainerClass", masterContainerWidth: "masterContainerWidth", minMasterSize: "minMasterSize" }, outputs: { masterContainerWidthChange: "masterContainerWidthChange" }, usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"resizableParts && hasLargeSize; else staticTemplate\">\n  <div class=\"main-detail-layout d-flex flex-column\" [ngClass]=\"containerClass\">\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <si-split\n      class=\"w-100 flex-grow-1\"\n      orientation=\"horizontal\"\n      [stateId]=\"stateId\"\n      [sizes]=\"splitSizes\"\n      (sizesChange)=\"onSplitSizesChange($event)\"\n    >\n      <si-split-part\n        scale=\"none\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minMainSize\"\n        [stateId]=\"mainStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"mainTemplate\"></ng-container>\n      </si-split-part>\n      <si-split-part\n        scale=\"auto\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minDetailSize\"\n        [stateId]=\"detailStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"detailTemplate\"></ng-container>\n      </si-split-part>\n    </si-split>\n  </div>\n</ng-container>\n\n<ng-template #staticTemplate>\n  <div\n    class=\"main-detail-layout d-flex flex-column\"\n    [ngClass]=\"containerClass\"\n    [class.large-size]=\"hasLargeSize\"\n  >\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <div\n      class=\"main-detail-container d-flex flex-grow-1\"\n      [class.details-active]=\"detailsActive && !hasLargeSize\"\n    >\n      <ng-container\n        *ngTemplateOutlet=\"\n          mainTemplate;\n          context: { customClass: hasLargeSize ? 'col-3 ps-0 pe-4' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"\n          detailTemplate;\n          context: { customClass: hasLargeSize ? 'col-9 ps-4 pe-0' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Templates -->\n<ng-template #headingTemplate>\n  <h2\n    *ngIf=\"heading\"\n    class=\"main-detail-heading page-top-title flex-grow-0 flex-shrink-0 text-secondary\"\n    [class.text-truncate]=\"truncateHeading\"\n    >{{ heading | translate }}</h2\n  >\n</ng-template>\n\n<ng-template #mainTemplate let-customClass=\"customClass\">\n  <div\n    class=\"main-container d-flex flex-column\"\n    [ngClass]=\"[mainContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxMainSize\"\n  >\n    <div class=\"main-search-actions d-flex align-items-center\">\n      <ng-content select=\"[slot=mainSearch]\"></ng-content>\n      <ng-content select=\"[slot=mainActions]\"></ng-content>\n      <ng-content select=\"[slot=masterSearch]\"></ng-content>\n      <ng-content select=\"[slot=masterActions]\"></ng-content>\n    </div>\n    <div class=\"main-data-container d-flex\">\n      <ng-content select=\"[slot=mainData]\"></ng-content>\n      <ng-content select=\"[slot=masterData]\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #detailTemplate let-customClass=\"customClass\">\n  <div\n    class=\"detail-container d-flex flex-column\"\n    [ngClass]=\"[detailContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxDetailSize\"\n  >\n    <div class=\"detail-heading-actions d-flex align-items-center\">\n      <button\n        *ngIf=\"!this.hasLargeSize && !this.hideBackButton\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-secondary element-back\"\n        (click)=\"detailsBackClicked()\"\n        ><span class=\"visually-hidden\">{{ detailsBackButtonText | translate }}</span></button\n      >\n      <span\n        *ngIf=\"detailsHeading\"\n        class=\"detail-heading si-title-1 me-auto ms-6 my-auto text-truncate\"\n        >{{ detailsHeading | translate }}</span\n      >\n      <ng-content select=\"[slot=detailActions]\"></ng-content>\n    </div>\n    <ng-content select=\"[slot=details]\"></ng-content>\n  </div>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;overflow-x:hidden;overflow-y:auto}:host ::ng-deep [slot=masterSearch],:host ::ng-deep [slot=mainSearch]{flex:1 1 0}:host ::ng-deep [slot=masterSearch]+[slot=masterActions],:host ::ng-deep [slot=masterSearch]+[slot=mainActions],:host ::ng-deep [slot=mainSearch]+[slot=masterActions],:host ::ng-deep [slot=mainSearch]+[slot=mainActions]{margin-inline-start:12px}:host ::ng-deep [slot=masterActions],:host ::ng-deep [slot=mainActions]{margin-inline-start:auto}:host ::ng-deep [slot=masterData],:host ::ng-deep [slot=mainData],:host ::ng-deep [slot=details]{flex:1 1 0;min-block-size:0}:host ::ng-deep [slot=detailActions]{margin-inline-start:auto}:host ::ng-deep .detail-heading+[slot=detailActions]{margin-inline-start:12px}:host ::ng-deep si-split{--si-split-gutter-background: transparent;min-block-size:0}:host ::ng-deep si-split si-split-part,:host ::ng-deep si-split .si-split-container,:host ::ng-deep si-split .si-split-part-content{overflow:visible}:host.animate{--si-main-detail-animation-duration: calc(.5s * var(--element-animations-enabled, 1))}.main-detail-layout{overflow-x:hidden;position:relative}.main-detail-layout.large-size{--si-main-detail-container-width: 100%;--si-main-detail-container-transition: none;--si-main-detail-container-transform: none;--si-main-detail-transition: none;--si-main-detail-opacity: 1;--si-main-detail-pointer-events: auto}.main-detail-heading{margin-block-end:20px}.main-detail-container{--si-main-detail-transition: opacity var(--si-main-detail-animation-duration, 0) ease-in-out;--si-main-detail-detail-opacity: 0;--si-main-detail-detail-pointer-events: none;inline-size:var(--si-main-detail-container-width, 200%);transform:var(--si-main-detail-container-transform, none);transform-origin:top left;transition:var(--si-main-detail-container-transition, transform var(--si-main-detail-animation-duration, 0) ease-in-out)}.main-detail-container.details-active{--si-main-detail-container-transform: translateX(-50%);--si-main-detail-main-opacity: 0;--si-main-detail-detail-opacity: 1;--si-main-detail-main-pointer-events: none;--si-main-detail-detail-pointer-events: auto}.main-detail-layout,.main-detail-container,.main-container,.detail-container,.main-data-container{flex:1 1 0;min-block-size:0}.main-container,.detail-container{transition:var(--si-main-detail-transition, none)}.main-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-main-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-main-pointer-events, auto))}.detail-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-detail-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-detail-pointer-events, auto))}.main-search-actions,.detail-heading-actions{min-block-size:32px;margin-block-end:12px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$1.SiSplitComponent, selector: "si-split", inputs: ["orientation", "sizes", "gutterSize", "stateId"], outputs: ["sizesChange"] }, { kind: "component", type: i2$1.SiSplitPartComponent, selector: "si-split-part", inputs: ["actions", "collapseDirection", "collapseIconClass", "collapseToMinSize", "headerStatusColor", "headerStatusIconClass", "headerTemplate", "heading", "minSize", "removeContentOnCollapse", "scale", "showCollapseButton", "showHeader", "collapseLabel", "stateId", "expanded", "size"], outputs: ["collapseChanged", "stateChange"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMasterDetailContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-master-detail-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"resizableParts && hasLargeSize; else staticTemplate\">\n  <div class=\"main-detail-layout d-flex flex-column\" [ngClass]=\"containerClass\">\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <si-split\n      class=\"w-100 flex-grow-1\"\n      orientation=\"horizontal\"\n      [stateId]=\"stateId\"\n      [sizes]=\"splitSizes\"\n      (sizesChange)=\"onSplitSizesChange($event)\"\n    >\n      <si-split-part\n        scale=\"none\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minMainSize\"\n        [stateId]=\"mainStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"mainTemplate\"></ng-container>\n      </si-split-part>\n      <si-split-part\n        scale=\"auto\"\n        [showCollapseButton]=\"false\"\n        [showHeader]=\"false\"\n        [minSize]=\"minDetailSize\"\n        [stateId]=\"detailStateId\"\n      >\n        <ng-container *ngTemplateOutlet=\"detailTemplate\"></ng-container>\n      </si-split-part>\n    </si-split>\n  </div>\n</ng-container>\n\n<ng-template #staticTemplate>\n  <div\n    class=\"main-detail-layout d-flex flex-column\"\n    [ngClass]=\"containerClass\"\n    [class.large-size]=\"hasLargeSize\"\n  >\n    <ng-container *ngTemplateOutlet=\"headingTemplate\"></ng-container>\n    <div\n      class=\"main-detail-container d-flex flex-grow-1\"\n      [class.details-active]=\"detailsActive && !hasLargeSize\"\n    >\n      <ng-container\n        *ngTemplateOutlet=\"\n          mainTemplate;\n          context: { customClass: hasLargeSize ? 'col-3 ps-0 pe-4' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"\n          detailTemplate;\n          context: { customClass: hasLargeSize ? 'col-9 ps-4 pe-0' : 'col-6 px-0' }\n        \"\n      ></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Templates -->\n<ng-template #headingTemplate>\n  <h2\n    *ngIf=\"heading\"\n    class=\"main-detail-heading page-top-title flex-grow-0 flex-shrink-0 text-secondary\"\n    [class.text-truncate]=\"truncateHeading\"\n    >{{ heading | translate }}</h2\n  >\n</ng-template>\n\n<ng-template #mainTemplate let-customClass=\"customClass\">\n  <div\n    class=\"main-container d-flex flex-column\"\n    [ngClass]=\"[mainContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxMainSize\"\n  >\n    <div class=\"main-search-actions d-flex align-items-center\">\n      <ng-content select=\"[slot=mainSearch]\"></ng-content>\n      <ng-content select=\"[slot=mainActions]\"></ng-content>\n      <ng-content select=\"[slot=masterSearch]\"></ng-content>\n      <ng-content select=\"[slot=masterActions]\"></ng-content>\n    </div>\n    <div class=\"main-data-container d-flex\">\n      <ng-content select=\"[slot=mainData]\"></ng-content>\n      <ng-content select=\"[slot=masterData]\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #detailTemplate let-customClass=\"customClass\">\n  <div\n    class=\"detail-container d-flex flex-column\"\n    [ngClass]=\"[detailContainerClass, customClass ? customClass : '']\"\n    [style.max-inline-size]=\"maxDetailSize\"\n  >\n    <div class=\"detail-heading-actions d-flex align-items-center\">\n      <button\n        *ngIf=\"!this.hasLargeSize && !this.hideBackButton\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-secondary element-back\"\n        (click)=\"detailsBackClicked()\"\n        ><span class=\"visually-hidden\">{{ detailsBackButtonText | translate }}</span></button\n      >\n      <span\n        *ngIf=\"detailsHeading\"\n        class=\"detail-heading si-title-1 me-auto ms-6 my-auto text-truncate\"\n        >{{ detailsHeading | translate }}</span\n      >\n      <ng-content select=\"[slot=detailActions]\"></ng-content>\n    </div>\n    <ng-content select=\"[slot=details]\"></ng-content>\n  </div>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;overflow-x:hidden;overflow-y:auto}:host ::ng-deep [slot=masterSearch],:host ::ng-deep [slot=mainSearch]{flex:1 1 0}:host ::ng-deep [slot=masterSearch]+[slot=masterActions],:host ::ng-deep [slot=masterSearch]+[slot=mainActions],:host ::ng-deep [slot=mainSearch]+[slot=masterActions],:host ::ng-deep [slot=mainSearch]+[slot=mainActions]{margin-inline-start:12px}:host ::ng-deep [slot=masterActions],:host ::ng-deep [slot=mainActions]{margin-inline-start:auto}:host ::ng-deep [slot=masterData],:host ::ng-deep [slot=mainData],:host ::ng-deep [slot=details]{flex:1 1 0;min-block-size:0}:host ::ng-deep [slot=detailActions]{margin-inline-start:auto}:host ::ng-deep .detail-heading+[slot=detailActions]{margin-inline-start:12px}:host ::ng-deep si-split{--si-split-gutter-background: transparent;min-block-size:0}:host ::ng-deep si-split si-split-part,:host ::ng-deep si-split .si-split-container,:host ::ng-deep si-split .si-split-part-content{overflow:visible}:host.animate{--si-main-detail-animation-duration: calc(.5s * var(--element-animations-enabled, 1))}.main-detail-layout{overflow-x:hidden;position:relative}.main-detail-layout.large-size{--si-main-detail-container-width: 100%;--si-main-detail-container-transition: none;--si-main-detail-container-transform: none;--si-main-detail-transition: none;--si-main-detail-opacity: 1;--si-main-detail-pointer-events: auto}.main-detail-heading{margin-block-end:20px}.main-detail-container{--si-main-detail-transition: opacity var(--si-main-detail-animation-duration, 0) ease-in-out;--si-main-detail-detail-opacity: 0;--si-main-detail-detail-pointer-events: none;inline-size:var(--si-main-detail-container-width, 200%);transform:var(--si-main-detail-container-transform, none);transform-origin:top left;transition:var(--si-main-detail-container-transition, transform var(--si-main-detail-animation-duration, 0) ease-in-out)}.main-detail-container.details-active{--si-main-detail-container-transform: translateX(-50%);--si-main-detail-main-opacity: 0;--si-main-detail-detail-opacity: 1;--si-main-detail-main-pointer-events: none;--si-main-detail-detail-pointer-events: auto}.main-detail-layout,.main-detail-container,.main-container,.detail-container,.main-data-container{flex:1 1 0;min-block-size:0}.main-container,.detail-container{transition:var(--si-main-detail-transition, none)}.main-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-main-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-main-pointer-events, auto))}.detail-container{opacity:var(--si-main-detail-opacity, var(--si-main-detail-detail-opacity, 1));pointer-events:var(--si-main-detail-pointer-events, var(--si-main-detail-detail-pointer-events, auto))}.main-search-actions,.detail-heading-actions{min-block-size:32px;margin-block-end:12px}\n"] }]
        }], propDecorators: { masterContainerClass: [{
                type: Input
            }], masterContainerWidth: [{
                type: Input
            }], minMasterSize: [{
                type: Input
            }], masterContainerWidthChange: [{
                type: Output
            }] } });

/**
 * @deprecated Use the `SiMainDetailContainerModule` instead.
 */
class SiMasterDetailContainerModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMasterDetailContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiMasterDetailContainerModule, declarations: [SiMasterDetailContainerComponent], imports: [CommonModule, SiMainDetailContainerModule, SiSplitModule, SiTranslateModule], exports: [SiMasterDetailContainerComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMasterDetailContainerModule, imports: [CommonModule, SiMainDetailContainerModule, SiSplitModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiMasterDetailContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiMasterDetailContainerComponent],
                    imports: [CommonModule, SiMainDetailContainerModule, SiSplitModule, SiTranslateModule],
                    exports: [SiMasterDetailContainerComponent]
                }]
        }] });

/* eslint-disable detect-bad-words/in-code */

/**
 * This enum defines the state that a detailed result step can have.
 */
var ResultDetailStepState;
(function (ResultDetailStepState) {
    ResultDetailStepState["Passed"] = "Passed";
    ResultDetailStepState["Failed"] = "Failed";
    ResultDetailStepState["Running"] = "Running";
    ResultDetailStepState["NotSupported"] = "Not supported";
    ResultDetailStepState["NotStarted"] = "Not started";
})(ResultDetailStepState || (ResultDetailStepState = {}));

class SiResultDetailsListComponent {
    /**
     * Array of steps to show in the list.
     */
    steps = [];
    trackByIndex = (index) => index;
    resultDetailStepState = ResultDetailStepState;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiResultDetailsListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiResultDetailsListComponent, selector: "si-result-details-list", inputs: { steps: "steps" }, ngImport: i0, template: "<ul class=\"list-unstyled d-flex flex-column mb-0\">\n  <li\n    *ngFor=\"let step of steps; trackBy: trackByIndex\"\n    class=\"position-relative d-flex align-items-center timeline px-6 py-5\"\n    [class.text-primary]=\"step.state === 'Running'\"\n  >\n    <si-loading-spinner *ngIf=\"step.state === 'Running'\" class=\"me-4\"></si-loading-spinner>\n    <si-icon\n      *ngIf=\"step.icon && step.state !== 'Running'\"\n      class=\"me-4\"\n      [icon]=\"step.icon\"\n    ></si-icon>\n    <ng-container *ngIf=\"!step.icon && step.state !== 'Running'\" [ngSwitch]=\"step.state\">\n      <si-icon\n        *ngSwitchCase=\"resultDetailStepState.Passed\"\n        class=\"me-4\"\n        icon=\"element-circle-filled\"\n        color=\"status-success\"\n        stackedIcon=\"element-state-tick\"\n        stackedColor=\"status-critical-contrast\"\n      ></si-icon>\n      <si-icon\n        *ngSwitchCase=\"resultDetailStepState.Failed\"\n        class=\"me-4\"\n        icon=\"element-circle-filled\"\n        color=\"status-danger\"\n        stackedIcon=\"element-state-exclamation-mark\"\n        stackedColor=\"status-critical-contrast\"\n      ></si-icon>\n      <si-icon\n        *ngSwitchCase=\"resultDetailStepState.NotStarted\"\n        class=\"me-4\"\n        icon=\"element-not-checked\"\n      ></si-icon>\n      <si-icon *ngSwitchDefault class=\"me-4\" icon=\"element-out-of-service\"></si-icon>\n    </ng-container>\n    <div class=\"d-flex flex-column justify-content-center w-100\">\n      <div class=\"d-flex\">\n        <span class=\"result-description si-title-2\">{{ step.description | translate }}</span>\n        <span *ngIf=\"step.value\" class=\"result-value\">{{ step.value }}</span>\n      </div>\n      <span *ngIf=\"step.errorMessage\" class=\"si-title-2 text-danger\">{{\n        step.errorMessage | translate\n      }}</span>\n    </div>\n  </li>\n</ul>\n", styles: ["si-loading-spinner{--loading-spinner-size: 1.5rem;--loading-spinner-color: var(--element-text-active)}.result-description{flex:2 1;align-self:center}.result-value{flex:1 1;white-space:nowrap;align-self:center}.timeline:not(:last-child):after,.timeline:not(:first-child):before{content:\"\";position:absolute;inline-size:1px;background-color:var(--element-ui-2);block-size:calc(50% - .75rem);margin-inline-start:calc(.75rem - .5px)}si-icon{color:var(--element-ui-2)}.timeline:not(:first-child):before{inset-block-start:0}.timeline:not(:last-child):after{inset-block-end:0}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i2$5.SiIconComponent, selector: "si-icon", inputs: ["icon", "color", "stackedIcon", "stackedColor", "alt", "size"] }, { kind: "component", type: i3$1.SiLoadingSpinnerComponent, selector: "si-loading-spinner", inputs: ["isBlockingSpinner", "isSpinnerOverlay", "ariaLabel"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiResultDetailsListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-result-details-list', template: "<ul class=\"list-unstyled d-flex flex-column mb-0\">\n  <li\n    *ngFor=\"let step of steps; trackBy: trackByIndex\"\n    class=\"position-relative d-flex align-items-center timeline px-6 py-5\"\n    [class.text-primary]=\"step.state === 'Running'\"\n  >\n    <si-loading-spinner *ngIf=\"step.state === 'Running'\" class=\"me-4\"></si-loading-spinner>\n    <si-icon\n      *ngIf=\"step.icon && step.state !== 'Running'\"\n      class=\"me-4\"\n      [icon]=\"step.icon\"\n    ></si-icon>\n    <ng-container *ngIf=\"!step.icon && step.state !== 'Running'\" [ngSwitch]=\"step.state\">\n      <si-icon\n        *ngSwitchCase=\"resultDetailStepState.Passed\"\n        class=\"me-4\"\n        icon=\"element-circle-filled\"\n        color=\"status-success\"\n        stackedIcon=\"element-state-tick\"\n        stackedColor=\"status-critical-contrast\"\n      ></si-icon>\n      <si-icon\n        *ngSwitchCase=\"resultDetailStepState.Failed\"\n        class=\"me-4\"\n        icon=\"element-circle-filled\"\n        color=\"status-danger\"\n        stackedIcon=\"element-state-exclamation-mark\"\n        stackedColor=\"status-critical-contrast\"\n      ></si-icon>\n      <si-icon\n        *ngSwitchCase=\"resultDetailStepState.NotStarted\"\n        class=\"me-4\"\n        icon=\"element-not-checked\"\n      ></si-icon>\n      <si-icon *ngSwitchDefault class=\"me-4\" icon=\"element-out-of-service\"></si-icon>\n    </ng-container>\n    <div class=\"d-flex flex-column justify-content-center w-100\">\n      <div class=\"d-flex\">\n        <span class=\"result-description si-title-2\">{{ step.description | translate }}</span>\n        <span *ngIf=\"step.value\" class=\"result-value\">{{ step.value }}</span>\n      </div>\n      <span *ngIf=\"step.errorMessage\" class=\"si-title-2 text-danger\">{{\n        step.errorMessage | translate\n      }}</span>\n    </div>\n  </li>\n</ul>\n", styles: ["si-loading-spinner{--loading-spinner-size: 1.5rem;--loading-spinner-color: var(--element-text-active)}.result-description{flex:2 1;align-self:center}.result-value{flex:1 1;white-space:nowrap;align-self:center}.timeline:not(:last-child):after,.timeline:not(:first-child):before{content:\"\";position:absolute;inline-size:1px;background-color:var(--element-ui-2);block-size:calc(50% - .75rem);margin-inline-start:calc(.75rem - .5px)}si-icon{color:var(--element-ui-2)}.timeline:not(:first-child):before{inset-block-start:0}.timeline:not(:last-child):after{inset-block-end:0}\n"] }]
        }], propDecorators: { steps: [{
                type: Input
            }] } });

class SiResultDetailsListModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiResultDetailsListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiResultDetailsListModule, declarations: [SiResultDetailsListComponent], imports: [CommonModule, SiIconModule, SiLoadingSpinnerModule, SiTranslateModule], exports: [SiResultDetailsListComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiResultDetailsListModule, imports: [CommonModule, SiIconModule, SiLoadingSpinnerModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiResultDetailsListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiIconModule, SiLoadingSpinnerModule, SiTranslateModule],
                    declarations: [SiResultDetailsListComponent],
                    exports: [SiResultDetailsListComponent]
                }]
        }] });

/** Convert options to option criterions */
const toOptionCriteria = (values) => values?.map(v => typeof v === 'string'
    ? { label: v, value: v, selected: false }
    : { label: v.label ?? v.value, value: v.value, selected: false, iconClass: v.iconClass }) ?? [];
/*
 * Update selected state the matching is based on value since plain
 * string options will automatically fill the value attribute with the
 * actual string value.
 */
const selectOptions = (options, toSelect) => options.forEach(val => (val.selected = toSelect.includes(val.value)));
/** Filter option criterions by label (case-insensitive) */
const filterByLabel = (options, searchLabel) => searchLabel
    ? options.filter(e => e.label.toLowerCase().includes(searchLabel.toLowerCase()))
    : options;
/** Whether the criteria's contain the label (case-insensitive) */
const hasCriteriaLabel = (criterias, searchLabel) => searchLabel
    ? criterias.some(c => c.label.toLowerCase().includes(searchLabel.toLowerCase()))
    : false;
/** Find criterion by name */
const findByName = (source, name) => source.find(item => name === item.name);
/**
 * Difference by name, create an array that contains those elements of criteria's a that are not in criteria's b.
 * This operation is also sometimes called minus (-).
 */
const differenceByName = (a, b) => a.filter(x => b.filter(y => y.name === x.name).length === 0); // filter has not
/** Whether Criteria is date or date-time */
const isDateTimeCriteria = (crit) => crit?.validationType === 'date' || crit?.validationType === 'date-time';
/** Convert criteria to internal model criteria */
const toCriteriaIntern = (crit) => {
    const result = {
        ...crit,
        label: crit.label ?? crit.name,
        options: crit.options ?? [],
        value: crit.value ?? ''
    };
    if (isDateTimeCriteria(result)) {
        result.dateValue = result.value ? new Date(result.value.toString()) : new Date();
    }
    return result;
};
/** Convert search criteria to internal model search criteria */
const toSearchCriteriaIntern = (crit, critConfig) => {
    const defaultValue = critConfig?.multiSelect ? [] : '';
    const result = {
        ...crit,
        label: crit.label ?? critConfig?.label ?? crit.name,
        options: crit.options ?? [],
        value: crit.value ?? defaultValue
    };
    // Fix input, in case the user provided the value as string for the multi-select use case.
    if (critConfig?.multiSelect && typeof result.value === 'string') {
        result.value = result.value !== '' ? [result.value] : [];
    }
    // Resolve value label from options to set the correct value in the input field.
    if (typeof result.value === 'string') {
        const matchingOption = critConfig?.options?.find(o => typeof o !== 'string' ? o.value === result.value : false);
        result.valueLabel = matchingOption?.label ?? result.value;
    }
    if (isDateTimeCriteria(critConfig)) {
        result.dateValue = crit.value ? new Date(crit.value.toString()) : new Date();
    }
    return result;
};

class ToLabelPipe {
    /**
     * It gets the label from options for the token (value) passed
     * @param options The options
     * @param token The token
     */
    static getLabel(options, token) {
        return ToLabelPipe.getFor(options, 'value', 'label', token);
    }
    /**
     * It gets the value from options for the token (label) passed
     * @param options The options
     * @param token The token
     */
    static getValue(options, token) {
        return ToLabelPipe.getFor(options, 'label', 'value', token);
    }
    static getFor(options, propertyToCompare, propertyToRetrieve, token) {
        if (!options || options.length === 0) {
            return token;
        }
        if (typeof token === 'string') {
            const option = options.find(op => typeof op === 'string' ? op === token : op[propertyToCompare] === token);
            if (option) {
                return typeof option === 'string' ? option : option[propertyToRetrieve];
            }
            return token;
        }
        else {
            const tokenArr = [];
            token?.forEach(tokenVal => {
                const option = options.find(op => typeof op === 'string' ? op === tokenVal : op[propertyToCompare] === tokenVal);
                if (option) {
                    tokenArr.push(typeof option === 'string' ? option : option[propertyToRetrieve]);
                }
                else {
                    tokenArr.push(tokenVal);
                }
            });
            return tokenArr;
        }
    }
    /**
     * Method which is called on any data passed to the pipe.
     * Called by Angular, should not be called directly.
     */
    transform(token, options) {
        return ToLabelPipe.getLabel(options, token);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: ToLabelPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: ToLabelPipe, name: "toLabel" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: ToLabelPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toLabel'
                }]
        }] });

const FOCUS_INDEX_FREE_TEXT_INPUT_FIELD = -1;
const FOCUS_INDEX_OUT_OF_COMPONENT = -2;
class SiFilteredSearchComponent {
    static criterionRegex = '(\\S+:)';
    // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
    // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code
    static keys = {
        backspace: 'Backspace',
        colon: ':',
        enter: 'Enter',
        semicolon: ';',
        separator: ';',
        tab: 'Tab'
    };
    /**
     * Output callback event that provides an object describing the
     * selected criteria and additional filter text.
     */
    doSearch = new EventEmitter();
    /**
     * If this is set to `true`, the search triggers for each input (implicit search).
     * By default search is triggered by "Apply search criteria" explicitelly only.
     * This hides "Apply search criteria" also.
     */
    doSearchOnInputChange = false;
    /**
     * In addition to lazy loaded value, you can also lazy load the criteria itself
     */
    lazyCriterionProvider;
    /**
     * In many cases, your application defines the criteria, but the values need
     * to be loaded from a server. In this case you can provide a function that
     * returns the possible criterion options as an Observable.
     */
    lazyValueProvider;
    /**
     * Disable any interactivity.
     */
    disabled = false;
    /**
     * Do not allow changes. Search can still be triggered.
     */
    readonly = false;
    /**
     * Limit criteria to the predefined ones.
     */
    strictCriterion = false;
    /**
     * Limit criterion options to the predefined ones. `[strictValue]`
     * enforces `[strictCriterion]` to true automatically.
     */
    strictValue = false;
    /**
     * Limit criterion options to the predefined ones and prevent typing. `[onlySelectValue]`
     * enforces `[strictValue]` and `[strictCriterion]` to true automatically.
     */
    onlySelectValue = false;
    /**
     * Custom debounce time for lazy loading of criteria data.
     */
    lazyLoadingDebounceTime = 500;
    /**
     * Custom debounce time (in mills) to delay the search emission.
     * (Default is 0 as in most cases a users manually triggers a search.
     * Recommended to increase a bit when using doSearchOnInputChange=true)
     */
    searchDebounceTime = 0;
    /**
     * The placeholder for input field.
     */
    placeholder = '';
    /**
     * Show a search icon in input field.
     */
    showIcon = false;
    /**
     * Custom 'submit' text.
     */
    submitText = $localize `:@@SI_FILTERED_SEARCH.SUBMIT:Apply search criteria`;
    /**
     * Index of the criteria in dropdown which should be selected initially.
     */
    selectedCriteriaIndex = 0;
    /**
     * Defines the number of criterions or criteria values or operators visible at once.
     */
    optionsInScrollableView = 10;
    /**
     * The current selected search criteria and entered search text.
     */
    searchCriteria = { criteria: [], value: '' };
    /**
     * Emits changes of the {@link searchCriteria} and enables a bi-directionally binding.
     */
    searchCriteriaChange = new EventEmitter();
    /**
     * Predefine criteria options.
     */
    criteria = [];
    /**
     * Opt-in to search for each criterion only once.
     */
    exclusiveCriteria = false;
    /**
     * Limit the number of possible criteria. The default is undefined so that any number of criteria can be used.
     * For example, setting the value to 1 let you only select one criterion that you need to remove before being
     * able to set another one.
     */
    maxCriteria = undefined;
    /**
     * Defines the maximum options within one criteria. The default is 20 and 0 means unlimited.
     */
    maxCriteriaOptions = 20;
    /**
     * Search input aria label, Needed by a11y
     */
    searchLabel = $localize `:@@SI_FILTERED_SEARCH.SEARCH:Search`;
    /**
     * Clear button aria label. Needed for a11y
     */
    clearButtonLabel = $localize `:@@SI_FILTERED_SEARCH.CLEAR:Clear`;
    /**
     * Items count text appended to the count in case of multi-selection of values.
     * Translation key, `{{itemCount}}` in the translation will be replaced with the actual value
     */
    itemCountText = '';
    /**
     * Color variant to determine component background
     */
    colorVariant = 'base-1';
    /**
     * Text or translate key for multi selection pills text.
     */
    items = $localize `:@@SI_FILTERED_SEARCH.ITEMS:items`;
    /**
     * Disables the free text search to only use the criterion for filtering.
     */
    disableFreeTextSearch = false;
    /**
     * Limit on the number of criteria/criteria value to be displayed by the typeahead
     */
    typeaheadOptionsLimit = 20;
    /**
     * Text for first entry in dropdown in case that no criteria
     * match the text input and the property `disableFreeTextSearch`
     * is set to `true`.
     */
    noMatchingCriteriaText = $localize `:@@SI_FILTERED_SEARCH.NO_MATCHING_CRITERIA:No matching criteria`;
    /**
     * The interceptor is called when the list of criteria is shown as soon as the user starts typing in the input field.
     * The interceptor's {@link DisplayedCriteriaEventArgs.allow} method can be used to filter the list of displayed criteria.
     *
     * **Note:** The interceptor is called as long as the {@link searchCriteria} does not exceed {@link maxCriteria}.
     * Further, the interceptor is not called when using the {@link lazyCriterionProvider}.
     *
     * @example
     * ```
     * <si-filtered-search
     *   [criteria]="[{ name: 'foo', label: 'Foo' }, { name: 'bar', label: 'Bar' }]"
     *   (interceptDisplayedCriteria)="$event.allow(
     *       $event.searchCriteria.criteria.some(s => s.name === 'foo')
     *         ? $event.criteria.filter(c => c !== 'foo')
     *         : $event.criteria
     *     ))">
     * </si-filtered-search>
     * ```
     */
    interceptDisplayedCriteria = new EventEmitter();
    clearInputButton;
    valueInput;
    dataSource;
    editCriterionIndex = FOCUS_INDEX_FREE_TEXT_INPUT_FIELD;
    /** Internal representation of the input search criteria */
    internSearchCriteria = {
        criteria: [],
        value: ''
    };
    /** Internal criteria model */
    internCriteria = [];
    shortDateFormat;
    focusState = false;
    integerInvalidChar = [',', '.'];
    debouncedCriterionQueueSubject = new Subject();
    previousEditingValue;
    /** Used to debounce while fetching for criteria data */
    debouncedValueSubject = new Subject();
    /** Used to trigger a renewed search */
    typeaheadInputChange = new Subject();
    lastTypeaheadInput = '';
    /** Used to debounce the Search emissions */
    searchEmitQueue = new Subject();
    destroySubscriptions = new Subject();
    translationSubs = [];
    lazyLoadedValue = new Subject();
    elementRef = inject(ElementRef);
    locale = inject(LOCALE_ID);
    cdRef = inject(ChangeDetectorRef);
    translateService = inject(SiTranslateService);
    /**
     * The cache is used to control when the interceptDisplayedCriteria event needs to be called.
     * Every time a criteria gain the focus we have to reset the cache to call the interceptor.
     */
    allowedCriteriaCache;
    constructor() {
        this.shortDateFormat = getNamedFormat(this.locale, 'shortDate');
        if (!this.shortDateFormat.includes('yyyy')) {
            this.shortDateFormat = this.shortDateFormat.replace('yy', 'yyyy');
        }
        this.dataSource = new Observable((observer) => {
            if (this.lazyCriterionProvider) {
                this.debouncedCriterionQueueSubject.next(observer);
            }
            else {
                observer.next(this.getCriteriaToDisplay(''));
            }
            this.typeaheadInputChange.subscribe(value => {
                if (this.lazyCriterionProvider) {
                    this.debouncedCriterionQueueSubject.next(observer);
                }
                else {
                    observer.next(this.getCriteriaToDisplay(value));
                }
            });
        });
    }
    ngOnChanges(changes) {
        if (changes.searchCriteria || changes.criteria) {
            this.initCriteria();
            this.initSearchCriteria();
            this.processTranslationChange();
        }
    }
    ngOnInit() {
        if (this.onlySelectValue) {
            this.strictValue = true;
        }
        if (this.strictValue) {
            this.strictCriterion = true;
        }
        if (this.strictCriterion && this.internCriteria.length === 0) {
            throw new Error('strict criterion mode activated without predefined criteria!');
        }
        this.setupCriteriaFetchQueue();
        this.searchEmitQueue
            .pipe(debounceTime(this.searchDebounceTime), takeUntil(this.destroySubscriptions))
            .subscribe(searchCriteria => this.doSearch.emit(searchCriteria));
        if (this.elementRef.nativeElement.attributes.disabled) {
            this.disabled = true;
        }
    }
    processTranslationChange() {
        this.cleanupTranslationSubs();
        this.translateCriterions();
        this.translateCriterionOptions();
    }
    translateCriterionOptions() {
        // prepare criteria options keys for translation
        const options = this.internCriteria
            .map(c => c.options)
            .flat()
            .filter(o => typeof o !== 'string' && o?.label);
        const translationKeys = options.map(o => o.label);
        const optionValues = Array.from(new Set(translationKeys));
        if (optionValues.length > 0) {
            this.translationSubs.push(this.translateService.translateAsync(optionValues).subscribe(keys => {
                // update the criteria with the translated values
                options.forEach(opt => {
                    const optionCrit = opt;
                    optionCrit.label = keys[optionCrit.label] ?? optionCrit.label;
                });
            }));
        }
    }
    translateCriterions() {
        // prepare criterion keys for translation
        const criteriaLabels = this.internCriteria.filter(criteria => criteria.label);
        const criteriaKeys = criteriaLabels.map(criteria => criteria.label);
        if (criteriaKeys.length > 0) {
            this.translationSubs?.push(this.translateService.translateAsync(criteriaKeys).subscribe(keys => {
                criteriaLabels.forEach(crit => {
                    crit.label = keys[crit.label] ?? crit.label;
                });
                // update the search criteria with the translated values
                this.internSearchCriteria.criteria
                    .filter(criteria => criteria.label)
                    .forEach(crit => {
                    crit.label = keys[crit.label] ?? crit.label;
                });
            }));
        }
    }
    ngOnDestroy() {
        this.destroySubscriptions.next(true);
        this.destroySubscriptions.unsubscribe();
        this.cleanupTranslationSubs();
    }
    trackByIndex = (index) => index;
    cleanupTranslationSubs() {
        this.translationSubs.forEach(s => s.unsubscribe());
        this.translationSubs = [];
    }
    initCriteria() {
        this.criteria = this.criteria ?? [];
        this.internCriteria = this.criteria.map(c => toCriteriaIntern(c));
    }
    initSearchCriteria() {
        this.searchCriteria = this.searchCriteria ?? { criteria: [], value: '' };
        this.internSearchCriteria = {
            criteria: this.searchCriteria.criteria.map(c => toSearchCriteriaIntern(c, this.getCriterionByName(c.name))) ?? [],
            value: this.searchCriteria?.value ?? ''
        };
    }
    /**
     * It sets the value for searchCriteria for free text and patch the form control accordingly
     * @param newValue the new value
     */
    setSearchCriteriaValue(newValue) {
        if (this.internSearchCriteria.value !== newValue) {
            this.internSearchCriteria.value = newValue;
            this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        }
    }
    getCriteriaToDisplay(value) {
        const filtered = this.getFilteredTypeaheadCriteria(value);
        const topItems = (this.disableFreeTextSearch && filtered.length === 0) || !this.doSearchOnInputChange
            ? [
                {
                    name: '',
                    value: '',
                    label: this.disableFreeTextSearch && filtered.length === 0
                        ? this.noMatchingCriteriaText
                        : this.submitText
                }
            ]
            : [];
        return [...topItems, ...filtered];
    }
    criterionInputKeyUp(event) {
        let newValue = event.target.value;
        if (event.key === SiFilteredSearchComponent.keys.enter) {
            newValue = this.previousEditingValue;
        }
        else if (event.key === SiFilteredSearchComponent.keys.backspace) {
            this.handleInputBackspace();
        }
        else if (event.key === SiFilteredSearchComponent.keys.colon && !this.onlySelectValue) {
            this.handleInputColon();
            // emit clear, when doSearchOnInputChange is wished or value is empty
            if (this.doSearchOnInputChange || !this.internSearchCriteria.value) {
                this.searchEmitQueue.next(this.searchCriteria);
            }
        }
        else if (this.doSearchOnInputChange) {
            // trigger search if value doesn't include criterion.label
            const labelIncluded = hasCriteriaLabel(this.internCriteria, newValue);
            if (labelIncluded) {
                this.searchEmitQueue.next(this.searchCriteria);
            }
        }
        this.previousEditingValue = newValue;
    }
    handleContextMenuPaste(event) {
        if (!this.disableFreeTextSearch) {
            const clipboardData = event.clipboardData;
            this.previousEditingValue = clipboardData?.getData('Text') ?? '';
        }
    }
    /**
     * Deletes all currently selected criteria and effectively resets the filtered search.
     */
    deleteAllCriteria(event) {
        if (this.isReadOnly()) {
            return;
        }
        event?.stopPropagation();
        // Reset search criteria
        this.internSearchCriteria = { criteria: [], value: '' };
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        this.doSearch.emit(this.searchCriteria);
    }
    deleteCriterion(event, index) {
        if (this.isReadOnly()) {
            return;
        }
        if (event) {
            event.stopPropagation();
            this.editCriterionByIndex(FOCUS_INDEX_FREE_TEXT_INPUT_FIELD);
        }
        this.internSearchCriteria.criteria.splice(index, 1);
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        this.doSearch.emit(this.searchCriteria);
    }
    editCriterion(criterion) {
        if (this.isReadOnly()) {
            return;
        }
        const index = this.internSearchCriteria.criteria.indexOf(criterion);
        const criterionOptions = this.getCriterionByName(criterion.name);
        this.editCriterionByIndex(index, (criterionOptions?.operators?.length ?? 0) > 0);
    }
    editOperator(criterion, event) {
        if (this.isReadOnly()) {
            return;
        }
        event.stopPropagation();
        const index = this.internSearchCriteria.criteria.indexOf(criterion);
        this.editCriterionByIndex(index, true);
    }
    editValue(criterion, event) {
        if (this.isReadOnly()) {
            return;
        }
        event.stopPropagation();
        const index = this.internSearchCriteria.criteria.indexOf(criterion);
        this.editCriterionByIndex(index);
    }
    getCriterionOptions(name, index, typed) {
        return new Observable((observer) => {
            if (!typed) {
                typed = '';
            }
            const searchLabel = this.onlySelectValue ? '' : typed?.toString();
            const existingSearchCriteria = this.internSearchCriteria.criteria[index];
            if (this.lazyValueProvider) {
                const lazyValRequest = {
                    criterionName: name,
                    typed
                };
                // Initiate call to app with typed string and selected criteria
                this.debouncedValueSubject.next(lazyValRequest);
                // Listen to subscription when app sends back server data
                this.lazyLoadedValue.pipe(takeUntil(this.destroySubscriptions)).subscribe(result => {
                    const criteria = this.internCriteria.find(crit => crit.name === name);
                    if (criteria) {
                        criteria.options = result;
                    }
                    const options = this.filterOptionCriteria(name, existingSearchCriteria.value, searchLabel, result);
                    observer.next(options);
                });
            }
            else {
                const criterionOptions = this.getCriterionByName(name);
                const selected = existingSearchCriteria.value;
                const options = this.filterOptionCriteria(name, selected, searchLabel, criterionOptions?.options);
                observer.next(options);
            }
        });
    }
    /** Create a filtered criterions option list based on the search label */
    filterOptionCriteria(optionName, selected, searchLabel, options) {
        const optionCriteria = toOptionCriteria(options);
        if (this.isMultiSelect(optionName)) {
            selectOptions(optionCriteria, selected);
        }
        return filterByLabel(optionCriteria, searchLabel?.toString());
    }
    getCriterionOperators(name, typed) {
        return new Observable((observer) => {
            const criterionOptions = this.getCriterionByName(name);
            if (!criterionOptions?.operators) {
                observer.next([]);
            }
            else if (typed && typed !== this.previousEditingValue) {
                observer.next(criterionOptions.operators.filter(operator => operator.includes(typed)));
            }
            else {
                observer.next(criterionOptions.operators);
            }
        });
    }
    getCriterionOnlySelectValue(name) {
        const criterion = this.getCriterionByName(name);
        return criterion ? !!criterion.onlySelectValue && !criterion.multiSelect : false;
    }
    getSelectedOperatorIndex(name, operator) {
        const criterionOptions = this.getCriterionByName(name);
        if (!operator || !criterionOptions?.operators) {
            return -1;
        }
        else if (operator && operator !== this.previousEditingValue) {
            return criterionOptions.operators.filter(op => op.includes(operator)).indexOf(operator);
        }
        return criterionOptions.operators.indexOf(operator);
    }
    getLongestOperatorLength(name) {
        const criterionOptions = this.getCriterionByName(name);
        if (!criterionOptions?.operators) {
            return 0;
        }
        return Math.max(...criterionOptions.operators.map(a => a.length));
    }
    getValueInputForCriterion(index, editOperator = false) {
        if (index === FOCUS_INDEX_FREE_TEXT_INPUT_FIELD) {
            return this.elementRef.nativeElement.getElementsByClassName('value-input')[0];
        }
        else if (editOperator) {
            return this.elementRef.nativeElement.getElementsByClassName('operator-input-' + index)[0];
        }
        else {
            return this.elementRef.nativeElement.getElementsByClassName('value-input-' + index)[0];
        }
    }
    highlight(criterion) {
        let label = criterion.label;
        const lcValue = this.internSearchCriteria.value
            ? this.internSearchCriteria.value.toLowerCase()
            : '';
        if (criterion.name === '' || !lcValue || lcValue.length === 0) {
            return this.translateService.translateAsync(label);
        }
        let lcLabel = label.toLowerCase();
        let idx;
        // eslint-disable-next-line no-cond-assign
        while ((idx = lcLabel.lastIndexOf(lcValue)) >= 0) {
            // eslint-disable-next-line max-len
            label = `${label.substring(0, idx)}<strong>${label.substring(idx, idx + lcValue.length)}</strong>${label.substring(idx + lcValue.length)}`;
            lcLabel = lcLabel.substring(0, idx);
        }
        return of(label);
    }
    inputFocused(event, index = FOCUS_INDEX_FREE_TEXT_INPUT_FIELD) {
        this.editCriterionIndex = index;
        this.previousEditingValue = event.target.value;
        this.focusState = true;
        this.allowedCriteriaCache = undefined;
    }
    isOperatorSpecified(criterionName) {
        const criterionOptions = this.getCriterionByName(criterionName);
        return (criterionOptions?.operators?.length ?? 0) > 0;
    }
    /** selectValue is invoked by select boxes in strict value mode. If the user selects an entry, the criterion is deselected. */
    selectValue() {
        this.editCriterionByIndex(FOCUS_INDEX_FREE_TEXT_INPUT_FIELD);
    }
    typeaheadOnSelectCriterion(event) {
        const criterion = event;
        if (criterion.label === this.noMatchingCriteriaText) {
            return;
        }
        else if (!criterion.name || criterion.name.trim().length === 0) {
            this.internSearchCriteria.value = this.previousEditingValue;
            this.setSearchCriteriaValue(this.previousEditingValue);
            this.searchEmitQueue.next(this.convertToExternalModel(this.internSearchCriteria));
            return;
        }
        const editor = this.getValueInputForCriterion(this.editCriterionIndex);
        const endIndex = editor.selectionStart;
        const value = criterion.name;
        this.addCriterion({
            name: value,
            label: criterion.label,
            value: ''
        });
        if (!endIndex) {
            // selected from typeahead dropdown
            this.setSearchCriteriaValue('');
        }
        else {
            // not selected from typeahead dropdown
            this.setSearchCriteriaValue(value.substring(0, endIndex - value.length - 1) + value.substring(endIndex, value.length));
        }
    }
    typeaheadOnSelectValue(criterionName, index, match) {
        const existingCriteria = this.getCriterionByName(criterionName);
        if (!existingCriteria?.multiSelect) {
            this.handleInputSeparator(false);
        }
        else {
            // In multi-select scenarios the internal model value is always of type array (see toSearchCriteriaIntern)
            const existingSearchCriteria = this.internSearchCriteria.criteria[index];
            const option = match.option;
            if (existingSearchCriteria) {
                if (match.itemSelected) {
                    existingSearchCriteria.value.push(option.value);
                }
                else {
                    if (typeof existingSearchCriteria.value !== 'string') {
                        existingSearchCriteria.value = existingSearchCriteria.value?.filter(elem => elem !== option.value);
                    }
                }
            }
            // Since in case of multiselect the model will not change, we need to explicitly call the output event
            this.updateAndEmitSearchCriteria(this.internSearchCriteria);
            if (this.doSearchOnInputChange) {
                this.searchEmitQueue.next(this.searchCriteria);
            }
        }
    }
    typeaheadOnSelectOperator() {
        // When an operator is selected from typeahead using the keyboard enter, it selects the operator and edits
        // the value input field. The action is so fast that the user keyup event is later called for the value
        // input which then exists the current criterion To delay this focus, below timeout is provided.
        this.editCriterionByIndex(this.editCriterionIndex, false, 200);
    }
    validateCriterionValue(criterion) {
        const originalCriterion = this.getCriterionByName(criterion.name);
        const validMinMax = this.validateDateMinMaxCriteria(criterion);
        if (!originalCriterion ||
            (!this.strictValue && !originalCriterion.strictValue && !originalCriterion.onlySelectValue)) {
            return validMinMax;
        }
        const values = this.getOptionsForCriterion(criterion.name, null);
        return values && criterion.value
            ? validMinMax && this.matchesValues(values, criterion)
            : !values && !!criterion.value;
    }
    matchesValues(values, criterion) {
        return Array.isArray(criterion.value)
            ? criterion.value.every(val => values.some(v => (v.label ? v.label === val : v.value === val)))
            : values.some(v => v.label ? v.label === criterion.valueLabel : v.value === criterion.value);
    }
    validateCriterionLabel(criterion) {
        if (!this.strictCriterion) {
            return true;
        }
        return !!this.getCriterionByName(criterion.name);
    }
    trimCharBasedOnType(criterionName) {
        let trimLastCharacter = true;
        const existingCriteria = this.getCriterionByName(criterionName);
        if (existingCriteria &&
            (existingCriteria.validationType === 'float' || existingCriteria.validationType === 'integer')) {
            trimLastCharacter = false;
        }
        return trimLastCharacter;
    }
    operatorKeyUp(event) {
        const newValue = event.target.value;
        if (event.key === SiFilteredSearchComponent.keys.backspace) {
            this.handleInputBackspace(true);
        }
        else if (event.key === SiFilteredSearchComponent.keys.enter) {
            this.editCriterionByIndex(this.editCriterionIndex);
        }
        this.previousEditingValue = newValue;
    }
    inputFocusOut(event, criterionName, index) {
        const newValue = event.target.value;
        const criterionOptions = this.getCriterionByName(criterionName);
        if (criterionOptions?.operators && !criterionOptions.operators.includes(newValue)) {
            const existingSearchCriteria = this.internSearchCriteria.criteria[index];
            if (existingSearchCriteria) {
                existingSearchCriteria.operator = criterionOptions.operators.includes('=')
                    ? '='
                    : criterionOptions.operators[0];
                this.updateAndEmitSearchCriteria(this.internSearchCriteria);
            }
        }
    }
    /**
     * It gets the array of OptionType for the criteria passed
     * @param name
     */
    getOptionsFromCriteria(name) {
        return this.getCriterionByName(name)?.options ?? [];
    }
    /**
     * Converts the internally used data model to the external model.
     * In case options for Criterion is Option[] map to the value from the label.
     * @param searchCriteria searchCriteria to be converted.
     */
    convertToExternalModel(searchCriteria) {
        const correctedCriteria = {
            ...searchCriteria,
            criteria: searchCriteria.criteria.map(criterion => {
                // Strip internal properties from result
                const { valueLabel, ...sc } = criterion;
                if (this.isDate(sc.name)) {
                    return { ...sc, value: sc.dateValue ? this.getISODateString(sc.dateValue) : '' };
                }
                else if (this.isDateTime(sc.name)) {
                    if (sc.datepickerConfig?.disabledTime) {
                        return { ...sc, value: sc.dateValue ? this.getISODateString(sc.dateValue) : '' };
                    }
                    else {
                        return { ...sc, value: sc.dateValue ? sc.dateValue.toISOString() : '' };
                    }
                }
                else {
                    return { ...sc, value: this.getValue(sc) };
                }
            })
        };
        if (this.disableFreeTextSearch) {
            correctedCriteria.value = '';
        }
        return correctedCriteria;
    }
    getValue(sc) {
        const val = ToLabelPipe.getValue(this.getOptionsFromCriteria(sc.name), sc.value ?? '');
        return val ? this.getValueBasedOnType(val, sc.value) : sc.value;
    }
    getValueBasedOnType(val, searchCritVal) {
        if (Array.isArray(searchCritVal) && Array.isArray(val)) {
            // this is the case for multi-select
            return val.map((value, index) => value ?? searchCritVal[index]);
        }
        return val;
    }
    getISODateString(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
    addCriterion(criterion) {
        if (!criterion.label || criterion.label.trim().length === 0) {
            criterion.label = criterion.name;
        }
        const criterionOptions = this.getCriterionByName(criterion.name);
        this.internSearchCriteria.criteria.push(toSearchCriteriaIntern(criterion, criterionOptions));
        // on initialization we do not want to set any criterion to editing
        if ((criterionOptions?.operators?.length ?? 0) > 0) {
            // when a new criterion is selected from typeahead using the keyboard enter, it adds the editable operator
            // input field and focuses on the operator field. The action is so fast that the user keyup event is later
            // called for the edited operator which then shifts focus and edit the value field. to delay this focus,
            // below timeout is provided.
            this.editCriterionByIndex(this.internSearchCriteria.criteria.length - 1, true, 200);
        }
        else {
            this.editCriterionByIndex(this.internSearchCriteria.criteria.length - 1);
        }
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        if (this.doSearchOnInputChange) {
            this.searchEmitQueue.next(this.searchCriteria);
        }
    }
    editCriterionByIndex(index, editOperator = false, timeout = 0) {
        this.editCriterionIndex = index;
        setTimeout(() => {
            const editor = this.getValueInputForCriterion(index, editOperator);
            if (editor) {
                editor.focus();
            }
            this.cdRef.markForCheck();
        }, timeout);
    }
    getCriterionByName(criterionName) {
        if (!this.internCriteria) {
            return undefined;
        }
        // TODO: This does not work for lazy load criteria
        return findByName(this.internCriteria, criterionName);
    }
    hasMultiSelections(criterionName, criterionValue) {
        return (this.isMultiSelect(criterionName) &&
            Array.isArray(criterionValue) &&
            criterionValue.length > 1);
    }
    /**
     * Get criteria list to be shown in typeahead.
     * @param token input field value.
     * @returns list of criteria to be shown in typeahead.
     */
    getFilteredTypeaheadCriteria(token) {
        if (this.maxCriteria === undefined ||
            this.internSearchCriteria.criteria.length < this.maxCriteria) {
            let allowedCriteria = !this.exclusiveCriteria
                ? this.internCriteria
                : differenceByName(this.internCriteria, this.internSearchCriteria.criteria);
            if (allowedCriteria.length > 0 && !this.allowedCriteriaCache) {
                // Call interceptor to allow applications to customize the list of available criteria
                const available = allowedCriteria.map(c => c.name);
                // Ensure that all entries are allowed in case the consumer doesn't use the allow callback
                this.allowedCriteriaCache = available;
                this.interceptDisplayedCriteria.next({
                    criteria: available,
                    searchCriteria: this.internSearchCriteria,
                    allow: criteriaNamesToDisplay => {
                        if (criteriaNamesToDisplay) {
                            this.allowedCriteriaCache = criteriaNamesToDisplay;
                        }
                    }
                });
            }
            allowedCriteria = allowedCriteria.filter(c => this.allowedCriteriaCache?.includes(c.name));
            return filterByLabel(allowedCriteria, token.length > 0 ? token : undefined);
        }
        else {
            return [];
        }
    }
    getOptionsForCriterion(criterionName, emptyResult) {
        const criterion = this.getCriterionByName(criterionName);
        if (!criterion) {
            return emptyResult;
        }
        if (criterion.options && criterion.options.length > 0) {
            // return criterion options if not empty
            return toOptionCriteria(criterion.options);
        }
        else {
            if (this.lazyValueProvider) {
                const request = { criterionName, typed: '' };
                this.debouncedValueSubject.next(request);
            }
            return emptyResult;
        }
    }
    handleInputBackspace(actionFromOperator = false) {
        // True if the backspace is pressed in operator input field.
        if (actionFromOperator) {
            const editor = this.getValueInputForCriterion(this.editCriterionIndex, true);
            this.deleteCriterionAndEditLastCriterion(editor);
        }
        else if (this.editCriterionIndex === FOCUS_INDEX_FREE_TEXT_INPUT_FIELD) {
            if (this.internSearchCriteria.value.length === 0 && this.previousEditingValue.length === 0) {
                // edit last criterion if user presses backspace in empty search input
                this.editCriterionByIndex(this.internSearchCriteria.criteria.length - 1);
            }
        }
        else {
            // The condition executes when user enters backspace in the value input field
            const editor = this.getValueInputForCriterion(this.editCriterionIndex);
            const operatorEditor = this.getValueInputForCriterion(this.editCriterionIndex, true);
            // Check if operator is specified for the criteria. If yes edit the operator when value field is empty.
            if (operatorEditor &&
                editor &&
                editor.value.length === 0 &&
                this.previousEditingValue.length === 0) {
                this.editCriterionByIndex(this.editCriterionIndex, true);
            }
            else {
                this.deleteCriterionAndEditLastCriterion(editor);
            }
        }
        if (this.doSearchOnInputChange && this.previousEditingValue.length > 0) {
            this.updateAndEmitSearchCriteria(this.internSearchCriteria);
            this.searchEmitQueue.next(this.searchCriteria);
        }
    }
    deleteCriterionAndEditLastCriterion(editor) {
        if (editor && editor.value.length === 0 && this.previousEditingValue.length === 0) {
            this.deleteCriterion(null, this.editCriterionIndex);
            if (this.editCriterionIndex >= 0) {
                this.editCriterionByIndex(this.editCriterionIndex - 1);
            }
        }
    }
    handleInputColon() {
        if (this.editCriterionIndex !== FOCUS_INDEX_FREE_TEXT_INPUT_FIELD) {
            return;
        }
        const editor = this.getValueInputForCriterion(this.editCriterionIndex);
        if (!editor || editor.value.length <= 1) {
            return;
        }
        let match;
        const endIndex = editor.selectionStart;
        const value = editor.value;
        const re = new RegExp(SiFilteredSearchComponent.criterionRegex, 'g');
        // eslint-disable-next-line no-cond-assign
        while ((match = re.exec(value)) != null) {
            if (endIndex === re.lastIndex) {
                const criterionName = value.substring(match.index, re.lastIndex - 1);
                this.addCriterion({ name: criterionName, label: criterionName, value: '' });
                this.setSearchCriteriaValue(value.substring(0, match.index - 1) + value.substring(re.lastIndex, value.length));
            }
        }
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
    }
    handleInputSeparator(trimLastCharacter) {
        const editedCriterion = this.internSearchCriteria.criteria[this.editCriterionIndex];
        if (!editedCriterion) {
            return;
        }
        if (trimLastCharacter) {
            editedCriterion.value =
                editedCriterion.value?.toString().substring(0, editedCriterion.value.length - 1) ?? '';
        }
        if (editedCriterion.value) {
            this.editCriterionByIndex(FOCUS_INDEX_FREE_TEXT_INPUT_FIELD);
        }
    }
    setupCriteriaFetchQueue() {
        this.debouncedCriterionQueueSubject
            .pipe(debounceTime(this.lazyLoadingDebounceTime))
            .subscribe((observer) => {
            let subscription;
            if (this.lazyCriterionProvider) {
                subscription = this.getCriteriaDisplaySubscription(this.lastTypeaheadInput, observer);
            }
            this.typeaheadInputChange.subscribe(() => {
                if (this.lazyCriterionProvider) {
                    subscription?.unsubscribe();
                    subscription = this.getCriteriaDisplaySubscription(this.lastTypeaheadInput, observer);
                }
            });
        });
        this.debouncedValueSubject
            .pipe(debounceTime(this.lazyLoadingDebounceTime))
            .subscribe((request) => {
            if (this.lazyValueProvider) {
                this.lazyValueProvider(request.criterionName, request.typed)
                    .pipe(takeUntil(this.destroySubscriptions))
                    .subscribe(result => {
                    this.lazyLoadedValue.next(result);
                });
            }
        });
    }
    getCriteriaDisplaySubscription(value, observer) {
        return this.lazyCriterionProvider
            ? this.lazyCriterionProvider(value, this.searchCriteria)
                .pipe(takeUntil(this.destroySubscriptions))
                .subscribe(result => {
                observer.next(this.getCriteriaToDisplayFromSubscription(result));
            })
            : undefined;
    }
    getCriteriaToDisplayFromSubscription(result) {
        this.criteria = result;
        this.internCriteria = this.criteria.map(c => toCriteriaIntern(c));
        let displayCriteria = [];
        if (this.maxCriteria === undefined ||
            this.internSearchCriteria.criteria.length < this.maxCriteria) {
            displayCriteria = !this.exclusiveCriteria
                ? result
                : differenceByName(result, this.internSearchCriteria.criteria);
        }
        const topItems = (this.disableFreeTextSearch &&
            this.internSearchCriteria.value.length > 0 &&
            displayCriteria.length === 0) ||
            !this.doSearchOnInputChange
            ? [
                {
                    name: '',
                    label: this.disableFreeTextSearch &&
                        this.internSearchCriteria.value.length > 0 &&
                        displayCriteria.length === 0
                        ? this.noMatchingCriteriaText
                        : this.submitText
                }
            ]
            : [];
        return [...topItems, ...displayCriteria];
    }
    getInputType(criterionName) {
        const existingCriteria = this.getCriterionByName(criterionName);
        if (existingCriteria &&
            (existingCriteria.validationType === 'integer' || existingCriteria.validationType === 'float')) {
            return 'number';
        }
        return 'text';
    }
    isDateOrDateTime(criterionName) {
        const existingCriteria = this.getCriterionByName(criterionName);
        return (existingCriteria?.validationType === 'date-time' ||
            existingCriteria?.validationType === 'date');
    }
    isDate(criterionName) {
        const existingCriteria = this.getCriterionByName(criterionName);
        return existingCriteria?.validationType === 'date';
    }
    isDateTime(criterionName) {
        const existingCriteria = this.getCriterionByName(criterionName);
        return existingCriteria?.validationType === 'date-time';
    }
    getDateTimeFormat(searchCriterion) {
        const existingCriteria = this.getCriterionByName(searchCriterion.name);
        // The information if the time is currently disabled is only present in the
        // current search criterion instance and not in the generic configuration.
        // So we need to merge the initial config with the current instance config.
        const config = { ...existingCriteria?.datepickerConfig, ...searchCriterion.datepickerConfig };
        return getDatepickerFormat(this.locale, config);
    }
    disableTime(criterion, disabledTime) {
        const dateConfig = criterion.datepickerConfig ? criterion.datepickerConfig : {};
        dateConfig.disabledTime = disabledTime;
        criterion.datepickerConfig = dateConfig;
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        if (this.doSearchOnInputChange) {
            this.searchEmitQueue.next(this.searchCriteria);
        }
    }
    getDatepickerConfig(searchCriterion) {
        const existingCriteria = this.getCriterionByName(searchCriterion.name);
        // a clone of the general criterion configuration
        const config = { ...existingCriteria?.datepickerConfig };
        // the current value could have an updated version, so we update
        if (searchCriterion.datepickerConfig?.disabledTime) {
            config.disabledTime = searchCriterion.datepickerConfig?.disabledTime;
        }
        return config;
    }
    isMultiSelect(criterionName) {
        const existingCriteria = this.getCriterionByName(criterionName);
        return !!existingCriteria?.multiSelect;
    }
    getStepAttribute(criterionName) {
        const existingCriteria = this.getCriterionByName(criterionName);
        if (existingCriteria && existingCriteria.validationType === 'integer') {
            return '1';
        }
        return 'any';
    }
    filterKeyInputEvents(event, criterionName) {
        const existingCriteria = this.getCriterionByName(criterionName);
        if (existingCriteria &&
            existingCriteria.validationType === 'integer' &&
            this.integerInvalidChar.includes(event.key)) {
            event.preventDefault();
        }
    }
    onValueInputKeyEvent(event, criterionName) {
        const newValue = event.target.value;
        if (event.key === SiFilteredSearchComponent.keys.backspace) {
            this.handleInputBackspace();
        }
        else if (event.key === SiFilteredSearchComponent.keys.separator &&
            !this.isMultiSelect(criterionName)) {
            const trimLastCharacter = this.trimCharBasedOnType(criterionName);
            this.handleInputSeparator(trimLastCharacter);
        }
        else if (event.key === SiFilteredSearchComponent.keys.enter &&
            !this.isMultiSelect(criterionName)) {
            this.handleInputSeparator(false);
        }
        this.previousEditingValue = newValue;
    }
    onValueInputClosed() {
        if (this.clearInputButton?.nativeElement === document.activeElement) {
            return;
        }
        // editCriterionIndex = -1 represents that the free text input is currently edited
        // all other numbers will represent the filtered pill, so we use -2 here.
        // Only apply when the focus does not shift on free text (i.e. "-1")
        if (this.editCriterionIndex !== FOCUS_INDEX_FREE_TEXT_INPUT_FIELD) {
            this.editCriterionIndex = FOCUS_INDEX_OUT_OF_COMPONENT;
        }
        this.cdRef.markForCheck();
    }
    onDateTimeKeyDown(event) {
        if (event.key === SiFilteredSearchComponent.keys.tab) {
            setTimeout(() => {
                this.onValueInputClosed();
            });
        }
    }
    onDateTimeKeyEvent(event) {
        const newValue = event.target.value;
        if (event.key === SiFilteredSearchComponent.keys.backspace) {
            this.handleInputBackspace();
        }
        else if (event.key === SiFilteredSearchComponent.keys.enter) {
            this.handleInputSeparator(false);
        }
        this.previousEditingValue = newValue;
    }
    onDatePickerClose() {
        if (!this.elementRef.nativeElement.contains(document.activeElement)) {
            this.editCriterionIndex = FOCUS_INDEX_OUT_OF_COMPONENT;
        }
    }
    selectDate(searchCriterion, date) {
        // In case the user type an illegal date into the date input,
        // our directive emits a new undefined value and keeps
        if (!date && searchCriterion.dateValue) {
            date = new Date(searchCriterion.dateValue);
        }
        searchCriterion.dateValue = date;
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        if (this.doSearchOnInputChange) {
            this.searchEmitQueue.next(this.searchCriteria);
        }
    }
    validateDateMinMaxCriteria(criterion) {
        const dateConfig = this.getDatepickerConfig(criterion);
        const minDate = dateConfig?.minDate ?? false;
        const maxDate = dateConfig?.maxDate ?? false;
        const dateValue = criterion?.dateValue ?? false;
        return ((!minDate || (minDate && dateValue && dateValue >= minDate)) &&
            (!maxDate || (maxDate && dateValue && dateValue <= maxDate)));
    }
    focusFreeInputField() {
        this.editCriterionByIndex(FOCUS_INDEX_FREE_TEXT_INPUT_FIELD);
        this.allowedCriteriaCache = undefined;
    }
    editFreeInputField() {
        this.editCriterionIndex = FOCUS_INDEX_FREE_TEXT_INPUT_FIELD;
    }
    onCriterionValueInputChange(criterion, newValue) {
        const criterionConfig = this.getCriterionByName(criterion.name);
        if (!criterionConfig?.multiSelect) {
            criterion.value = newValue;
            criterion.value = this.getValue(criterion);
            criterion.valueLabel = newValue;
            this.updateAndEmitSearchCriteria(this.internSearchCriteria);
            if (this.doSearchOnInputChange && newValue) {
                this.searchEmitQueue.next(this.searchCriteria);
            }
        }
    }
    onCriterionOperatorInputChange(criterion, newOperator) {
        criterion.operator = newOperator;
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        // Also make sure event is not empty to prevent extra emissions. For example
        // when the user presses "Enter" or clicks to manually trigger the search
        if (this.doSearchOnInputChange && newOperator) {
            this.searchEmitQueue.next(this.searchCriteria);
        }
    }
    onSearchTermChange(searchTerm) {
        this.internSearchCriteria.value = searchTerm;
        // Ignore value changes when the filtered search doesn't allow free text values.
        // Background: In case the consumer has a bidirectional binding on the searchCriteria
        // input the new created update object will trigger another change detection cycle in
        // on push mode. When the current searchCriteria.value will be dropped we are not able
        // to indicate that there is no matching criteria (see noMatchingCriteriaText).
        if (!this.disableFreeTextSearch) {
            this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        }
        // Also make sure event is not empty to prevent extra emissions. For example
        // when the user presses "Enter" or clicks to manually trigger the search
        if (this.doSearchOnInputChange && searchTerm) {
            this.searchEmitQueue.next(this.searchCriteria);
        }
    }
    onTypeaheadInputChange(event) {
        this.typeaheadInputChange.next(event);
        this.lastTypeaheadInput = event;
    }
    isReadOnly = () => this.readonly || this.disabled;
    clearValueInput(index, criterion) {
        if (this.isDateOrDateTime(criterion.name)) {
            criterion.dateValue = undefined;
            criterion.value = '';
        }
        else {
            if (this.isMultiSelect(criterion.name)) {
                this.valueInput.nativeElement.value = '';
                criterion.value = [];
            }
            else {
                criterion.value = '';
                criterion.valueLabel = '';
            }
        }
        this.editCriterionByIndex(index);
        this.updateAndEmitSearchCriteria(this.internSearchCriteria);
        this.doSearch.emit(this.searchCriteria);
    }
    updateAndEmitSearchCriteria(internSearchCriteria) {
        this.searchCriteria = this.convertToExternalModel(internSearchCriteria);
        this.searchCriteriaChange.next(this.searchCriteria);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilteredSearchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiFilteredSearchComponent, selector: "si-filtered-search", inputs: { doSearchOnInputChange: "doSearchOnInputChange", lazyCriterionProvider: "lazyCriterionProvider", lazyValueProvider: "lazyValueProvider", disabled: "disabled", readonly: "readonly", strictCriterion: "strictCriterion", strictValue: "strictValue", onlySelectValue: "onlySelectValue", lazyLoadingDebounceTime: "lazyLoadingDebounceTime", searchDebounceTime: "searchDebounceTime", placeholder: "placeholder", showIcon: "showIcon", submitText: "submitText", selectedCriteriaIndex: "selectedCriteriaIndex", optionsInScrollableView: "optionsInScrollableView", searchCriteria: "searchCriteria", criteria: "criteria", exclusiveCriteria: "exclusiveCriteria", maxCriteria: "maxCriteria", maxCriteriaOptions: "maxCriteriaOptions", searchLabel: "searchLabel", clearButtonLabel: "clearButtonLabel", itemCountText: "itemCountText", colorVariant: "colorVariant", items: "items", disableFreeTextSearch: "disableFreeTextSearch", typeaheadOptionsLimit: "typeaheadOptionsLimit", noMatchingCriteriaText: "noMatchingCriteriaText" }, outputs: { doSearch: "doSearch", searchCriteriaChange: "searchCriteriaChange", interceptDisplayedCriteria: "interceptDisplayedCriteria" }, viewQueries: [{ propertyName: "clearInputButton", first: true, predicate: ["clearInputButton"], descendants: true, read: ElementRef }, { propertyName: "valueInput", first: true, predicate: ["valueInput"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: "<ng-template #criterionItemTemplate let-model=\"item\">\n  <span [innerHTML]=\"highlight(model) | async\"></span>\n</ng-template>\n<div\n  class=\"filtered-search py-1 px-2\"\n  [class.dark-background]=\"colorVariant === 'base-0'\"\n  [class.focus-within]=\"editCriterionIndex === -1 && internSearchCriteria.criteria.length === 0\"\n  [class.disabled]=\"disabled\"\n>\n  <!-- placeholder icon-->\n  <span\n    *ngIf=\"showIcon\"\n    class=\"placeholder-icon icon element-search mx-0\"\n    [class.empty]=\"!internSearchCriteria.criteria.length && !internSearchCriteria.value\"\n  >\n  </span>\n\n  <div\n    *ngFor=\"let criterion of internSearchCriteria.criteria; let i = index; trackBy: trackByIndex\"\n    class=\"criteria\"\n    [class.disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [class.invalid-criterion]=\"!validateCriterionLabel(criterion)\"\n  >\n    <div class=\"criterion-label me-1 si-title-2\" (click)=\"editCriterion(criterion)\">\n      {{ criterion.label }}\n    </div>\n    <div class=\"criterion-operator-section\">\n      <!-- criterion operator input -->\n      <input\n        *ngIf=\"isOperatorSpecified(criterion.name) && editCriterionIndex === i\"\n        type=\"text\"\n        class=\"operator-input\"\n        [ngClass]=\"'operator-input-' + i\"\n        [siTypeahead]=\"getCriterionOperators(criterion.name, criterion.operator)\"\n        [typeaheadProcess]=\"false\"\n        [typeaheadAutoSelectIndex]=\"getSelectedOperatorIndex(criterion.name, criterion.operator)\"\n        [typeaheadMinLength]=\"0\"\n        [typeaheadOptionsLimit]=\"0\"\n        [readOnly]=\"false\"\n        [typeaheadScrollable]=\"true\"\n        [typeaheadOptionsInScrollableView]=\"optionsInScrollableView\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        [attr.size]=\"getLongestOperatorLength(criterion.name)\"\n        [ngModel]=\"criterion.operator\"\n        (ngModelChange)=\"onCriterionOperatorInputChange(criterion, $event)\"\n        (keyup)=\"operatorKeyUp($event)\"\n        (click)=\"editOperator(criterion, $event)\"\n        (focus)=\"inputFocused($event, i)\"\n        (focusout)=\"inputFocusOut($event, criterion.name, i)\"\n        (typeaheadOnSelect)=\"typeaheadOnSelectOperator()\"\n      />\n      <!-- criterion operator field -->\n      <div\n        *ngIf=\"criterion.operator && editCriterionIndex !== i\"\n        class=\"criterion-operator me-1 focus-inside\"\n        (keyup.enter)=\"editOperator(criterion, $event)\"\n        (click)=\"editOperator(criterion, $event)\"\n      >\n        <span\n          *ngIf=\"!!criterion.operator\"\n          class=\"criterion-operator-text focus-inside\"\n          [tabindex]=\"!disabled ? 0 : -1\"\n        >\n          {{ criterion.operator }}\n        </span>\n      </div>\n    </div>\n    <div class=\"criterion-value-section\">\n      <!-- criterion value field -->\n      <div\n        *ngIf=\"editCriterionIndex !== i\"\n        class=\"criterion-value px-0 focus-inside\"\n        [class.invalid-criterion]=\"\n          !validateCriterionLabel(criterion) || !validateCriterionValue(criterion)\n        \"\n        (keyup.enter)=\"editValue(criterion, $event)\"\n        (click)=\"editValue(criterion, $event)\"\n      >\n        <ng-container\n          [ngTemplateOutlet]=\"\n            !!criterion.dateValue && isDateTime(criterion.name)\n              ? dateTimeTemplate\n              : !!criterion.dateValue && isDate(criterion.name)\n              ? dateTemplate\n              : !!criterion.value && hasMultiSelections(criterion.name, criterion.value)\n              ? itemCount\n              : valueTemplate\n          \"\n        ></ng-container>\n        <ng-template #dateTemplate>\n          <span class=\"criterion-value-text focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n            {{ criterion.dateValue | date : shortDateFormat }}\n          </span>\n        </ng-template>\n        <ng-template #dateTimeTemplate>\n          <span class=\"criterion-value-text p-0\">\n            <span class=\"d-block px-4 focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ criterion.dateValue | date : getDateTimeFormat(criterion) }}\n            </span>\n          </span>\n        </ng-template>\n        <ng-template #itemCount>\n          <span *ngIf=\"!!criterion.value && itemCountText\" class=\"criterion-value-text p-0\">\n            <span class=\"d-block px-4 focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ itemCountText | translate : { itemCount: criterion.value.length } }}\n            </span>\n          </span>\n          <span *ngIf=\"!!criterion.value && !itemCountText\" class=\"criterion-value-text p-0\">\n            <span class=\"ps-4 pe-2 d-block focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ criterion.value.length }} {{ items | translate }}\n            </span>\n          </span>\n        </ng-template>\n        <ng-template #valueTemplate>\n          <span class=\"criterion-value-text p-0\">\n            <span class=\"d-block px-4 focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ criterion.value! | toLabel : getOptionsFromCriteria(criterion.name) }}\n            </span>\n          </span>\n        </ng-template>\n        <button\n          *ngIf=\"!readonly\"\n          type=\"button\"\n          class=\"criterion-value-button ps-0 ms-0 py-0 btn btn-circle btn-xs btn-ghost element-cancel focus-inside\"\n          [attr.aria-label]=\"clearButtonLabel | translate\"\n          [disabled]=\"disabled\"\n          (click)=\"deleteCriterion($event, i)\"\n        >\n        </button>\n      </div>\n      <!-- criterion value input -->\n      <input\n        *ngIf=\"editCriterionIndex === i && !isDateOrDateTime(criterion.name)\"\n        #valueInput\n        typeaheadOptionField=\"label\"\n        class=\"criterion-value pe-4\"\n        [ngClass]=\"'value-input-' + i\"\n        [class.me-n8]=\"criterion.value.length\"\n        [class.pe-8]=\"criterion.value.length\"\n        [type]=\"getInputType(criterion.name)\"\n        [step]=\"getStepAttribute(criterion.name)\"\n        [ngModel]=\"criterion.valueLabel\"\n        [siTypeahead]=\"\n          getCriterionOptions(\n            criterion.name,\n            i,\n            isMultiSelect(criterion.name) ? '' : criterion.value\n          )\n        \"\n        [typeaheadProcess]=\"isMultiSelect(criterion.name)\"\n        [typeaheadMultiSelect]=\"isMultiSelect(criterion.name)\"\n        [typeaheadMinLength]=\"0\"\n        [typeaheadOptionsLimit]=\"maxCriteriaOptions\"\n        [readOnly]=\"readonly || onlySelectValue || this.getCriterionOnlySelectValue(criterion.name)\"\n        [typeaheadScrollable]=\"true\"\n        [typeaheadOptionsInScrollableView]=\"optionsInScrollableView\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        (keydown)=\"filterKeyInputEvents($event, criterion.name)\"\n        (keyup)=\"onValueInputKeyEvent($event, criterion.name)\"\n        (focus)=\"inputFocused($event, i)\"\n        (blur)=\"focusState = false\"\n        (ngModelChange)=\"onCriterionValueInputChange(criterion, $event)\"\n        (typeaheadOnSelect)=\"typeaheadOnSelectValue(criterion.name, i, $event)\"\n        (typeaheadOnMultiselectClose)=\"focusFreeInputField()\"\n        (typeaheadClosed)=\"onValueInputClosed()\"\n      />\n\n      <input\n        *ngIf=\"editCriterionIndex === i && isDate(criterion.name)\"\n        type=\"text\"\n        siDatepicker\n        class=\"criterion-value datepicker\"\n        [ngClass]=\"'value-input-' + i\"\n        [class.me-n8]=\"criterion.dateValue\"\n        [class.pe-8]=\"criterion.dateValue\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        [siDatepickerConfig]=\"getDatepickerConfig(criterion)\"\n        [ngModel]=\"criterion.dateValue!\"\n        (keydown)=\"onDateTimeKeyDown($event)\"\n        (keyup)=\"onDateTimeKeyEvent($event)\"\n        (focus)=\"inputFocused($event, i)\"\n        (blur)=\"focusState = false\"\n        (siDatepickerClose)=\"onDatePickerClose()\"\n        (ngModelChange)=\"selectDate(criterion, $event)\"\n      />\n      <input\n        *ngIf=\"editCriterionIndex === i && isDateTime(criterion.name)\"\n        type=\"text\"\n        siDatepicker\n        class=\"criterion-value datepicker\"\n        [ngClass]=\"'value-input-' + i\"\n        [class.me-n8]=\"criterion.dateValue\"\n        [class.pe-8]=\"criterion.dateValue\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        [siDatepickerConfig]=\"getDatepickerConfig(criterion)\"\n        [ngModel]=\"criterion.dateValue!\"\n        (keydown)=\"onDateTimeKeyDown($event)\"\n        (keyup)=\"onDateTimeKeyEvent($event)\"\n        (focus)=\"inputFocused($event, i)\"\n        (blur)=\"focusState = false\"\n        (siDatepickerClose)=\"onDatePickerClose()\"\n        (siDatepickerDisabledTime)=\"disableTime(criterion, $event)\"\n        (ngModelChange)=\"selectDate(criterion, $event)\"\n      />\n      <button\n        *ngIf=\"\n          editCriterionIndex === i && (criterion.value?.length || criterion.dateValue) && !readonly\n        \"\n        #clearInputButton\n        type=\"button\"\n        class=\"clear-input btn btn-circle btn-xs btn-ghost element-cancel\"\n        [attr.aria-label]=\"clearButtonLabel | translate\"\n        (click)=\"clearValueInput(i, criterion)\"\n      ></button>\n    </div>\n  </div>\n  <!-- criterion input -->\n  <input\n    type=\"text\"\n    class=\"value-input ps-2 me-3\"\n    typeaheadOptionField=\"name\"\n    [class.ms-1]=\"internSearchCriteria.criteria.length\"\n    [siTypeahead]=\"dataSource\"\n    [typeaheadProcess]=\"false\"\n    [typeaheadClearValueOnSelect]=\"true\"\n    [typeaheadMinLength]=\"readonly ? 1 : 0\"\n    [typeaheadOptionsLimit]=\"typeaheadOptionsLimit\"\n    [typeaheadAutoSelectIndex]=\"selectedCriteriaIndex\"\n    [typeaheadItemTemplate]=\"criterionItemTemplate\"\n    [typeaheadScrollable]=\"true\"\n    [typeaheadOptionsInScrollableView]=\"optionsInScrollableView\"\n    [readonly]=\"readonly\"\n    [disabled]=\"disabled\"\n    [placeholder]=\"placeholder\"\n    [attr.aria-label]=\"searchLabel | translate\"\n    [ngModel]=\"internSearchCriteria.value\"\n    (ngModelChange)=\"onSearchTermChange($event)\"\n    (keyup)=\"criterionInputKeyUp($event)\"\n    (paste)=\"handleContextMenuPaste($event)\"\n    (click)=\"editFreeInputField()\"\n    (blur)=\"editCriterionIndex = -2; focusState = false\"\n    (focus)=\"inputFocused($event)\"\n    (typeaheadOnInput)=\"onTypeaheadInputChange($event)\"\n    (typeaheadOnSelect)=\"typeaheadOnSelectCriterion($event.option)\"\n  />\n\n  <!-- clear all searchCriteria -->\n  <button\n    *ngIf=\"(internSearchCriteria.criteria.length || internSearchCriteria.value.length) && !readonly\"\n    type=\"button\"\n    class=\"btn-circle btn-xs btn-ghost element-cancel\"\n    [disabled]=\"disabled\"\n    [attr.aria-label]=\"clearButtonLabel | translate\"\n    (click)=\"deleteAllCriteria($event)\"\n  ></button>\n</div>\n", styles: [":host{--search-bar-icon-color: var(--element-text-primary);--input-background-color: var(--element-base-1);--input-background-hover-color: var(--element-base-1);--filter-search-background-color: var(--element-base-1);--filter-pill-background-color: var(--element-base-0)}.dark-background{--input-background-color: var(--element-base-0);--input-background-hover-color: var(--element-ui-4);--filter-search-background-color: var(--element-base-0);--filter-pill-background-color: var(--element-base-1)}.filtered-search{border-radius:4px;display:flex;flex-direction:row;line-height:24px;background-color:var(--filter-search-background-color);overflow-x:auto;overflow-y:hidden;min-block-size:32px;align-items:center}.filtered-search:hover:not(.disabled) .placeholder-icon,.filtered-search:hover:not(.disabled) input:not(:focus)::placeholder{color:var(--element-text-primary)}.filtered-search.focus-within:not(.disabled):focus-within{box-shadow:0 0 0 2px var(--element-focus-default)}.filtered-search.focus-within:not(.disabled):focus-within .value-input{box-shadow:none;border:0}.filtered-search.focus-within:not(.disabled):focus-within .placeholder-icon{color:var(--element-text-primary)}.filtered-search .placeholder-icon.empty{color:var(--element-text-secondary)}.filtered-search .criterion-value:not(input) .criterion-value-text{padding-block:0;padding-inline:8px;margin-inline-end:2px}.filtered-search:not(.disabled) .criterion-label:hover,.filtered-search:not(.disabled) .criterion-value-text:hover,.filtered-search:not(.disabled) :not(.invalid-criterion) .element-cancel:hover,.filtered-search:not(.disabled) .criterion-operator:hover{background:var(--element-action-secondary-hover)}.filtered-search .criterion-label{border-start-start-radius:24px;border-end-start-radius:24px}.filtered-search.disabled{color:var(--element-text-disabled)}.filtered-search.disabled input,.filtered-search.disabled button,.filtered-search.disabled .badge,.filtered-search.disabled .placeholder-icon,.filtered-search.disabled ::placeholder{color:var(--element-text-disabled)}.filtered-search.disabled .element-cancel.criterion-value-button{display:none}.criteria{display:flex;cursor:pointer;white-space:nowrap;margin-block:2px;margin-inline:4px;border-radius:24px}.criteria.invalid-criterion{box-shadow:0 0 0 1px var(--element-status-danger)}.criteria:not(.invalid-criterion) .invalid-criterion>span{box-shadow:inset 0 0 0 1px var(--element-status-danger);padding:1px!important}.criteria:not(.invalid-criterion) .invalid-criterion>span>span{block-size:22px;line-height:22px}.criteria.disabled{cursor:inherit}.criterion-operator-section,.criterion-value-section{display:inline-flex;align-items:center}.criterion-label,.criterion-value{background:var(--filter-pill-background-color);display:inline-flex;align-items:center;padding:0 8px;padding-inline-start:12px}.criterion-value{border:0;border-start-start-radius:0;border-end-start-radius:0;border-start-end-radius:24px;border-end-end-radius:24px;outline:none}.criterion-value.datepicker{inline-size:auto}.criterion-operator{display:inline-flex;align-items:center}.criterion-operator .criterion-operator-text{min-inline-size:20px;text-align:center;padding-inline:4px}.criterion-value,.operator-input,.criterion-operator{background:var(--filter-pill-background-color)}.criterion-value-button{background-color:transparent;font-size:1.5rem;border:0}.criterion-value-text+.criterion-value-button{margin-inline-start:0}.value-input{border:0;flex-grow:1;line-height:24px;background-color:var(--input-background-color);margin:0;outline:none}.operator-input{display:inline-flex;align-items:center;margin-inline-end:4px;padding-inline-start:12px;padding-block:0;border:0;outline:none}input::placeholder{color:var(--element-text-secondary);padding-inline:0;margin-block:0;margin-inline:4px}input:focus::placeholder,.criteria+input::placeholder{color:transparent!important}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$a.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$a.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$a.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: SiDatepickerDirective, selector: "[siDatepicker]", inputs: ["autoClose", "triggeringInput"], exportAs: ["siDatepicker"] }, { kind: "directive", type: i4$2.SiTypeaheadDirective, selector: "[siTypeahead]", inputs: ["siTypeahead", "typeaheadProcess", "typeaheadScrollable", "typeaheadOptionsInScrollableView", "typeaheadOptionsLimit", "typeaheadScrollableAdditionalHeight", "typeaheadAutoSelectIndex", "typeaheadCloseOnEsc", "typeaheadClearValueOnSelect", "typeaheadWaitMs", "typeaheadMinLength", "typeaheadOptionField", "typeaheadMultiSelect", "typeaheadTokenize", "typeaheadMatchAllTokens", "typeaheadItemTemplate", "typeaheadDropup", "typeaheadSkipSortingMatches", "typeaheadAutocompleteListLabel"], outputs: ["typeaheadOnInput", "typeaheadOnSelect", "typeaheadOnMultiselectClose", "typeaheadOnFullMatch", "typeaheadClosed"], exportAs: ["si-typeahead"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.DatePipe, name: "date" }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }, { kind: "pipe", type: ToLabelPipe, name: "toLabel" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilteredSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-filtered-search', template: "<ng-template #criterionItemTemplate let-model=\"item\">\n  <span [innerHTML]=\"highlight(model) | async\"></span>\n</ng-template>\n<div\n  class=\"filtered-search py-1 px-2\"\n  [class.dark-background]=\"colorVariant === 'base-0'\"\n  [class.focus-within]=\"editCriterionIndex === -1 && internSearchCriteria.criteria.length === 0\"\n  [class.disabled]=\"disabled\"\n>\n  <!-- placeholder icon-->\n  <span\n    *ngIf=\"showIcon\"\n    class=\"placeholder-icon icon element-search mx-0\"\n    [class.empty]=\"!internSearchCriteria.criteria.length && !internSearchCriteria.value\"\n  >\n  </span>\n\n  <div\n    *ngFor=\"let criterion of internSearchCriteria.criteria; let i = index; trackBy: trackByIndex\"\n    class=\"criteria\"\n    [class.disabled]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    [class.invalid-criterion]=\"!validateCriterionLabel(criterion)\"\n  >\n    <div class=\"criterion-label me-1 si-title-2\" (click)=\"editCriterion(criterion)\">\n      {{ criterion.label }}\n    </div>\n    <div class=\"criterion-operator-section\">\n      <!-- criterion operator input -->\n      <input\n        *ngIf=\"isOperatorSpecified(criterion.name) && editCriterionIndex === i\"\n        type=\"text\"\n        class=\"operator-input\"\n        [ngClass]=\"'operator-input-' + i\"\n        [siTypeahead]=\"getCriterionOperators(criterion.name, criterion.operator)\"\n        [typeaheadProcess]=\"false\"\n        [typeaheadAutoSelectIndex]=\"getSelectedOperatorIndex(criterion.name, criterion.operator)\"\n        [typeaheadMinLength]=\"0\"\n        [typeaheadOptionsLimit]=\"0\"\n        [readOnly]=\"false\"\n        [typeaheadScrollable]=\"true\"\n        [typeaheadOptionsInScrollableView]=\"optionsInScrollableView\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        [attr.size]=\"getLongestOperatorLength(criterion.name)\"\n        [ngModel]=\"criterion.operator\"\n        (ngModelChange)=\"onCriterionOperatorInputChange(criterion, $event)\"\n        (keyup)=\"operatorKeyUp($event)\"\n        (click)=\"editOperator(criterion, $event)\"\n        (focus)=\"inputFocused($event, i)\"\n        (focusout)=\"inputFocusOut($event, criterion.name, i)\"\n        (typeaheadOnSelect)=\"typeaheadOnSelectOperator()\"\n      />\n      <!-- criterion operator field -->\n      <div\n        *ngIf=\"criterion.operator && editCriterionIndex !== i\"\n        class=\"criterion-operator me-1 focus-inside\"\n        (keyup.enter)=\"editOperator(criterion, $event)\"\n        (click)=\"editOperator(criterion, $event)\"\n      >\n        <span\n          *ngIf=\"!!criterion.operator\"\n          class=\"criterion-operator-text focus-inside\"\n          [tabindex]=\"!disabled ? 0 : -1\"\n        >\n          {{ criterion.operator }}\n        </span>\n      </div>\n    </div>\n    <div class=\"criterion-value-section\">\n      <!-- criterion value field -->\n      <div\n        *ngIf=\"editCriterionIndex !== i\"\n        class=\"criterion-value px-0 focus-inside\"\n        [class.invalid-criterion]=\"\n          !validateCriterionLabel(criterion) || !validateCriterionValue(criterion)\n        \"\n        (keyup.enter)=\"editValue(criterion, $event)\"\n        (click)=\"editValue(criterion, $event)\"\n      >\n        <ng-container\n          [ngTemplateOutlet]=\"\n            !!criterion.dateValue && isDateTime(criterion.name)\n              ? dateTimeTemplate\n              : !!criterion.dateValue && isDate(criterion.name)\n              ? dateTemplate\n              : !!criterion.value && hasMultiSelections(criterion.name, criterion.value)\n              ? itemCount\n              : valueTemplate\n          \"\n        ></ng-container>\n        <ng-template #dateTemplate>\n          <span class=\"criterion-value-text focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n            {{ criterion.dateValue | date : shortDateFormat }}\n          </span>\n        </ng-template>\n        <ng-template #dateTimeTemplate>\n          <span class=\"criterion-value-text p-0\">\n            <span class=\"d-block px-4 focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ criterion.dateValue | date : getDateTimeFormat(criterion) }}\n            </span>\n          </span>\n        </ng-template>\n        <ng-template #itemCount>\n          <span *ngIf=\"!!criterion.value && itemCountText\" class=\"criterion-value-text p-0\">\n            <span class=\"d-block px-4 focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ itemCountText | translate : { itemCount: criterion.value.length } }}\n            </span>\n          </span>\n          <span *ngIf=\"!!criterion.value && !itemCountText\" class=\"criterion-value-text p-0\">\n            <span class=\"ps-4 pe-2 d-block focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ criterion.value.length }} {{ items | translate }}\n            </span>\n          </span>\n        </ng-template>\n        <ng-template #valueTemplate>\n          <span class=\"criterion-value-text p-0\">\n            <span class=\"d-block px-4 focus-inside\" [tabindex]=\"disabled ? -1 : 0\">\n              {{ criterion.value! | toLabel : getOptionsFromCriteria(criterion.name) }}\n            </span>\n          </span>\n        </ng-template>\n        <button\n          *ngIf=\"!readonly\"\n          type=\"button\"\n          class=\"criterion-value-button ps-0 ms-0 py-0 btn btn-circle btn-xs btn-ghost element-cancel focus-inside\"\n          [attr.aria-label]=\"clearButtonLabel | translate\"\n          [disabled]=\"disabled\"\n          (click)=\"deleteCriterion($event, i)\"\n        >\n        </button>\n      </div>\n      <!-- criterion value input -->\n      <input\n        *ngIf=\"editCriterionIndex === i && !isDateOrDateTime(criterion.name)\"\n        #valueInput\n        typeaheadOptionField=\"label\"\n        class=\"criterion-value pe-4\"\n        [ngClass]=\"'value-input-' + i\"\n        [class.me-n8]=\"criterion.value.length\"\n        [class.pe-8]=\"criterion.value.length\"\n        [type]=\"getInputType(criterion.name)\"\n        [step]=\"getStepAttribute(criterion.name)\"\n        [ngModel]=\"criterion.valueLabel\"\n        [siTypeahead]=\"\n          getCriterionOptions(\n            criterion.name,\n            i,\n            isMultiSelect(criterion.name) ? '' : criterion.value\n          )\n        \"\n        [typeaheadProcess]=\"isMultiSelect(criterion.name)\"\n        [typeaheadMultiSelect]=\"isMultiSelect(criterion.name)\"\n        [typeaheadMinLength]=\"0\"\n        [typeaheadOptionsLimit]=\"maxCriteriaOptions\"\n        [readOnly]=\"readonly || onlySelectValue || this.getCriterionOnlySelectValue(criterion.name)\"\n        [typeaheadScrollable]=\"true\"\n        [typeaheadOptionsInScrollableView]=\"optionsInScrollableView\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        (keydown)=\"filterKeyInputEvents($event, criterion.name)\"\n        (keyup)=\"onValueInputKeyEvent($event, criterion.name)\"\n        (focus)=\"inputFocused($event, i)\"\n        (blur)=\"focusState = false\"\n        (ngModelChange)=\"onCriterionValueInputChange(criterion, $event)\"\n        (typeaheadOnSelect)=\"typeaheadOnSelectValue(criterion.name, i, $event)\"\n        (typeaheadOnMultiselectClose)=\"focusFreeInputField()\"\n        (typeaheadClosed)=\"onValueInputClosed()\"\n      />\n\n      <input\n        *ngIf=\"editCriterionIndex === i && isDate(criterion.name)\"\n        type=\"text\"\n        siDatepicker\n        class=\"criterion-value datepicker\"\n        [ngClass]=\"'value-input-' + i\"\n        [class.me-n8]=\"criterion.dateValue\"\n        [class.pe-8]=\"criterion.dateValue\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        [siDatepickerConfig]=\"getDatepickerConfig(criterion)\"\n        [ngModel]=\"criterion.dateValue!\"\n        (keydown)=\"onDateTimeKeyDown($event)\"\n        (keyup)=\"onDateTimeKeyEvent($event)\"\n        (focus)=\"inputFocused($event, i)\"\n        (blur)=\"focusState = false\"\n        (siDatepickerClose)=\"onDatePickerClose()\"\n        (ngModelChange)=\"selectDate(criterion, $event)\"\n      />\n      <input\n        *ngIf=\"editCriterionIndex === i && isDateTime(criterion.name)\"\n        type=\"text\"\n        siDatepicker\n        class=\"criterion-value datepicker\"\n        [ngClass]=\"'value-input-' + i\"\n        [class.me-n8]=\"criterion.dateValue\"\n        [class.pe-8]=\"criterion.dateValue\"\n        [attr.aria-label]=\"searchLabel | translate\"\n        [siDatepickerConfig]=\"getDatepickerConfig(criterion)\"\n        [ngModel]=\"criterion.dateValue!\"\n        (keydown)=\"onDateTimeKeyDown($event)\"\n        (keyup)=\"onDateTimeKeyEvent($event)\"\n        (focus)=\"inputFocused($event, i)\"\n        (blur)=\"focusState = false\"\n        (siDatepickerClose)=\"onDatePickerClose()\"\n        (siDatepickerDisabledTime)=\"disableTime(criterion, $event)\"\n        (ngModelChange)=\"selectDate(criterion, $event)\"\n      />\n      <button\n        *ngIf=\"\n          editCriterionIndex === i && (criterion.value?.length || criterion.dateValue) && !readonly\n        \"\n        #clearInputButton\n        type=\"button\"\n        class=\"clear-input btn btn-circle btn-xs btn-ghost element-cancel\"\n        [attr.aria-label]=\"clearButtonLabel | translate\"\n        (click)=\"clearValueInput(i, criterion)\"\n      ></button>\n    </div>\n  </div>\n  <!-- criterion input -->\n  <input\n    type=\"text\"\n    class=\"value-input ps-2 me-3\"\n    typeaheadOptionField=\"name\"\n    [class.ms-1]=\"internSearchCriteria.criteria.length\"\n    [siTypeahead]=\"dataSource\"\n    [typeaheadProcess]=\"false\"\n    [typeaheadClearValueOnSelect]=\"true\"\n    [typeaheadMinLength]=\"readonly ? 1 : 0\"\n    [typeaheadOptionsLimit]=\"typeaheadOptionsLimit\"\n    [typeaheadAutoSelectIndex]=\"selectedCriteriaIndex\"\n    [typeaheadItemTemplate]=\"criterionItemTemplate\"\n    [typeaheadScrollable]=\"true\"\n    [typeaheadOptionsInScrollableView]=\"optionsInScrollableView\"\n    [readonly]=\"readonly\"\n    [disabled]=\"disabled\"\n    [placeholder]=\"placeholder\"\n    [attr.aria-label]=\"searchLabel | translate\"\n    [ngModel]=\"internSearchCriteria.value\"\n    (ngModelChange)=\"onSearchTermChange($event)\"\n    (keyup)=\"criterionInputKeyUp($event)\"\n    (paste)=\"handleContextMenuPaste($event)\"\n    (click)=\"editFreeInputField()\"\n    (blur)=\"editCriterionIndex = -2; focusState = false\"\n    (focus)=\"inputFocused($event)\"\n    (typeaheadOnInput)=\"onTypeaheadInputChange($event)\"\n    (typeaheadOnSelect)=\"typeaheadOnSelectCriterion($event.option)\"\n  />\n\n  <!-- clear all searchCriteria -->\n  <button\n    *ngIf=\"(internSearchCriteria.criteria.length || internSearchCriteria.value.length) && !readonly\"\n    type=\"button\"\n    class=\"btn-circle btn-xs btn-ghost element-cancel\"\n    [disabled]=\"disabled\"\n    [attr.aria-label]=\"clearButtonLabel | translate\"\n    (click)=\"deleteAllCriteria($event)\"\n  ></button>\n</div>\n", styles: [":host{--search-bar-icon-color: var(--element-text-primary);--input-background-color: var(--element-base-1);--input-background-hover-color: var(--element-base-1);--filter-search-background-color: var(--element-base-1);--filter-pill-background-color: var(--element-base-0)}.dark-background{--input-background-color: var(--element-base-0);--input-background-hover-color: var(--element-ui-4);--filter-search-background-color: var(--element-base-0);--filter-pill-background-color: var(--element-base-1)}.filtered-search{border-radius:4px;display:flex;flex-direction:row;line-height:24px;background-color:var(--filter-search-background-color);overflow-x:auto;overflow-y:hidden;min-block-size:32px;align-items:center}.filtered-search:hover:not(.disabled) .placeholder-icon,.filtered-search:hover:not(.disabled) input:not(:focus)::placeholder{color:var(--element-text-primary)}.filtered-search.focus-within:not(.disabled):focus-within{box-shadow:0 0 0 2px var(--element-focus-default)}.filtered-search.focus-within:not(.disabled):focus-within .value-input{box-shadow:none;border:0}.filtered-search.focus-within:not(.disabled):focus-within .placeholder-icon{color:var(--element-text-primary)}.filtered-search .placeholder-icon.empty{color:var(--element-text-secondary)}.filtered-search .criterion-value:not(input) .criterion-value-text{padding-block:0;padding-inline:8px;margin-inline-end:2px}.filtered-search:not(.disabled) .criterion-label:hover,.filtered-search:not(.disabled) .criterion-value-text:hover,.filtered-search:not(.disabled) :not(.invalid-criterion) .element-cancel:hover,.filtered-search:not(.disabled) .criterion-operator:hover{background:var(--element-action-secondary-hover)}.filtered-search .criterion-label{border-start-start-radius:24px;border-end-start-radius:24px}.filtered-search.disabled{color:var(--element-text-disabled)}.filtered-search.disabled input,.filtered-search.disabled button,.filtered-search.disabled .badge,.filtered-search.disabled .placeholder-icon,.filtered-search.disabled ::placeholder{color:var(--element-text-disabled)}.filtered-search.disabled .element-cancel.criterion-value-button{display:none}.criteria{display:flex;cursor:pointer;white-space:nowrap;margin-block:2px;margin-inline:4px;border-radius:24px}.criteria.invalid-criterion{box-shadow:0 0 0 1px var(--element-status-danger)}.criteria:not(.invalid-criterion) .invalid-criterion>span{box-shadow:inset 0 0 0 1px var(--element-status-danger);padding:1px!important}.criteria:not(.invalid-criterion) .invalid-criterion>span>span{block-size:22px;line-height:22px}.criteria.disabled{cursor:inherit}.criterion-operator-section,.criterion-value-section{display:inline-flex;align-items:center}.criterion-label,.criterion-value{background:var(--filter-pill-background-color);display:inline-flex;align-items:center;padding:0 8px;padding-inline-start:12px}.criterion-value{border:0;border-start-start-radius:0;border-end-start-radius:0;border-start-end-radius:24px;border-end-end-radius:24px;outline:none}.criterion-value.datepicker{inline-size:auto}.criterion-operator{display:inline-flex;align-items:center}.criterion-operator .criterion-operator-text{min-inline-size:20px;text-align:center;padding-inline:4px}.criterion-value,.operator-input,.criterion-operator{background:var(--filter-pill-background-color)}.criterion-value-button{background-color:transparent;font-size:1.5rem;border:0}.criterion-value-text+.criterion-value-button{margin-inline-start:0}.value-input{border:0;flex-grow:1;line-height:24px;background-color:var(--input-background-color);margin:0;outline:none}.operator-input{display:inline-flex;align-items:center;margin-inline-end:4px;padding-inline-start:12px;padding-block:0;border:0;outline:none}input::placeholder{color:var(--element-text-secondary);padding-inline:0;margin-block:0;margin-inline:4px}input:focus::placeholder,.criteria+input::placeholder{color:transparent!important}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { doSearch: [{
                type: Output
            }], doSearchOnInputChange: [{
                type: Input
            }], lazyCriterionProvider: [{
                type: Input
            }], lazyValueProvider: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readonly: [{
                type: Input
            }], strictCriterion: [{
                type: Input
            }], strictValue: [{
                type: Input
            }], onlySelectValue: [{
                type: Input
            }], lazyLoadingDebounceTime: [{
                type: Input
            }], searchDebounceTime: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], showIcon: [{
                type: Input
            }], submitText: [{
                type: Input
            }], selectedCriteriaIndex: [{
                type: Input
            }], optionsInScrollableView: [{
                type: Input
            }], searchCriteria: [{
                type: Input
            }], searchCriteriaChange: [{
                type: Output
            }], criteria: [{
                type: Input
            }], exclusiveCriteria: [{
                type: Input
            }], maxCriteria: [{
                type: Input
            }], maxCriteriaOptions: [{
                type: Input
            }], searchLabel: [{
                type: Input
            }], clearButtonLabel: [{
                type: Input
            }], itemCountText: [{
                type: Input
            }], colorVariant: [{
                type: Input
            }], items: [{
                type: Input
            }], disableFreeTextSearch: [{
                type: Input
            }], typeaheadOptionsLimit: [{
                type: Input
            }], noMatchingCriteriaText: [{
                type: Input
            }], interceptDisplayedCriteria: [{
                type: Output
            }], clearInputButton: [{
                type: ViewChild,
                args: ['clearInputButton', { read: ElementRef }]
            }], valueInput: [{
                type: ViewChild,
                args: ['valueInput', { read: ElementRef }]
            }] } });

class SiFilteredSearchModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilteredSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiFilteredSearchModule, declarations: [SiFilteredSearchComponent, ToLabelPipe], imports: [CommonModule, FormsModule, SiDatepickerModule, SiTranslateModule, SiTypeaheadModule], exports: [SiFilteredSearchComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilteredSearchModule, imports: [CommonModule, FormsModule, SiDatepickerModule, SiTranslateModule, SiTypeaheadModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFilteredSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SiDatepickerModule, SiTranslateModule, SiTypeaheadModule],
                    declarations: [SiFilteredSearchComponent, ToLabelPipe],
                    exports: [SiFilteredSearchComponent]
                }]
        }] });

class SiFileDropzoneComponent {
    /**
     * Text or translation key of the input file selector (is combined with the `uploadTextRest`).
     */
    uploadTextFileSelect = $localize `:@@SI_FILE_UPLOADER.FILE_SELECT:click to upload`;
    /**
     * Text or translation key of the drag&drop field (is combined with the `uploadTextFileSelect`).
     */
    uploadDropText = $localize `:@@SI_FILE_UPLOADER.DROP:Drop files here or`;
    /**
     * Text or translation key for max file size.
     */
    maxFileSizeText = $localize `:@@SI_FILE_UPLOADER.MAX_SIZE:Maximum upload size`;
    /**
     * Text or translation key for accepted types.
     */
    acceptText = $localize `:@@SI_FILE_UPLOADER.ACCEPTED_FILE_TYPES:Accepted file types`;
    /**
     * Text or translation key of message title if incorrect file type is dragged / dropped.
     */
    errorTextFileType = $localize `:@@SI_FILE_UPLOADER.ERROR_FILE_TYPE:Incorrect file type selected`;
    /**
     * Message or translation key if file exceeds the maximum file size limit.
     */
    errorTextFileMaxSize = $localize `:@@SI_FILE_UPLOADER.ERROR_FILE_SIZE_EXCEEDED:File exceeds allowed maximum size`;
    /**
     * Define which file types are suggested in file browser.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#attr-accept
     */
    accept;
    /**
     * Define maximal allowed file size in bytes.
     */
    maxFileSize;
    /**
     * Defines whether the file input allows selecting multiple files.
     */
    multiple = false;
    /**
     * Event emitted when files are added.
     */
    filesAdded = new EventEmitter();
    maxFileSizeString = '';
    dragOver = false;
    fileInput;
    locale = inject(LOCALE_ID);
    numberFormat = new Intl.NumberFormat(this.locale, { maximumFractionDigits: 2 });
    ngOnChanges(changes) {
        if (changes.maxFileSize) {
            this.maxFileSizeString = this.maxFileSize ? this.fileSizeToString(this.maxFileSize) : '';
        }
    }
    dropHandler(event) {
        event.preventDefault();
        this.handleFiles(event.dataTransfer.files);
        this.dragOver = false;
    }
    dragOverHandler(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = true;
    }
    inputEnterHandler() {
        this.fileInput?.nativeElement.click();
    }
    inputHandler(event) {
        this.handleFiles(event.target.files);
    }
    handleFiles(files) {
        if (!files?.length) {
            return;
        }
        const newFiles = [];
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < files.length; i++) {
            newFiles.push(this.makeUploadFile(files[i]));
        }
        newFiles.sort((a, b) => a.fileName.localeCompare(b.fileName));
        this.filesAdded.emit(newFiles);
    }
    /**
     * Reset all the files inside the native file input (and therefore the dropzone).
     */
    reset() {
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
    }
    makeUploadFile(file) {
        const uploadFile = {
            fileName: file.name,
            file,
            size: this.fileSizeToString(file.size),
            progress: 0,
            status: 'added'
        };
        // use MIME type of file if set. Otherwise fall back to file name ending
        const ext = '.' + uploadFile.file.name.split('.').pop();
        if (!this.verifyFileType(uploadFile.file.type, ext)) {
            uploadFile.status = 'invalid';
            uploadFile.errorText = this.errorTextFileType;
        }
        else if (!this.verifyFileSize(uploadFile.file.size)) {
            uploadFile.status = 'invalid';
            uploadFile.errorText = this.errorTextFileMaxSize;
        }
        return uploadFile;
    }
    verifyFileSize(size) {
        return !this.maxFileSize || size <= this.maxFileSize;
    }
    verifyFileType(fileType, ext) {
        if (!this.accept) {
            return true;
        }
        if (fileType === undefined && ext === undefined) {
            return false;
        }
        // Spec says that comma is the delimiter for filetypes. Also allow pipe for compatibility
        return this.accept.split(/,|\|/).some(acceptedType => {
            // convert accept glob into regex (example: images/* --> images/.*)
            const acceptedRegexStr = acceptedType.replace('.', '.').replace('*', '.*').trim();
            const acceptedRegex = new RegExp(acceptedRegexStr, 'i');
            // if fileType is set and accepted type looks like a MIME type, match that otherwise extension
            if (fileType && acceptedType.includes('/')) {
                return !!fileType.match(acceptedRegex);
            }
            return !!ext?.match(acceptedRegex);
        });
    }
    fileSizeToString(num) {
        let suffix = 'B';
        if (num >= 1073741824) {
            num /= 1073741824;
            suffix = 'GB';
        }
        if (num >= 1048576) {
            num /= 1048576;
            suffix = 'MB';
        }
        else if (num >= 1024) {
            num /= 1024;
            suffix = 'KB';
        }
        return this.numberFormat.format(num) + suffix;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFileDropzoneComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiFileDropzoneComponent, selector: "si-file-dropzone", inputs: { uploadTextFileSelect: "uploadTextFileSelect", uploadDropText: "uploadDropText", maxFileSizeText: "maxFileSizeText", acceptText: "acceptText", errorTextFileType: "errorTextFileType", errorTextFileMaxSize: "errorTextFileMaxSize", accept: "accept", maxFileSize: "maxFileSize", multiple: "multiple" }, outputs: { filesAdded: "filesAdded" }, viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"drag-and-drop rounded p-6\"\n  [class.drag-over]=\"dragOver\"\n  (drop)=\"dropHandler($event)\"\n  (dragover)=\"dragOverHandler($event)\"\n  (dragleave)=\"dragOver = false\"\n>\n  <i class=\"display-6 element-upload mb-6\" role=\"presentation\"></i>\n  <span class=\"drag-and-drop-description si-title-2 d-flex\">\n    <span>{{ uploadDropText | translate }}</span>\n    &nbsp;\n    <label class=\"select-file mb-0\">\n      <span class=\"select-file\" tabindex=\"0\" (keydown.enter)=\"inputEnterHandler()\">{{\n        uploadTextFileSelect | translate\n      }}</span>\n      <input\n        #fileInput\n        type=\"file\"\n        tabindex=\"-1\"\n        class=\"d-none\"\n        [accept]=\"accept\"\n        [multiple]=\"multiple\"\n        (change)=\"inputHandler($event)\"\n      />\n    </label>\n  </span>\n  <div *ngIf=\"maxFileSize || accept\" class=\"allowed si-caption mt-6\">\n    <ng-container *ngIf=\"maxFileSize\">\n      {{ maxFileSizeText | translate }}: {{ maxFileSizeString }}.\n    </ng-container>\n    <ng-container *ngIf=\"accept\"> {{ acceptText | translate }}: {{ accept }}. </ng-container>\n  </div>\n</div>\n", styles: [":host{display:block}.select-file{margin-block-end:0;cursor:pointer;font-weight:700;color:var(--element-ui-0)}.select-file:hover,.select-file:active{text-decoration:underline}.drag-and-drop{background-color:var(--element-base-1);border:1px dashed var(--element-ui-2);display:flex;flex-direction:column;justify-content:center;align-items:center}.drag-and-drop.drag-over{border:1px solid var(--element-focus-default);box-shadow:0 0 0 1px var(--element-focus-default)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFileDropzoneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-file-dropzone', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"drag-and-drop rounded p-6\"\n  [class.drag-over]=\"dragOver\"\n  (drop)=\"dropHandler($event)\"\n  (dragover)=\"dragOverHandler($event)\"\n  (dragleave)=\"dragOver = false\"\n>\n  <i class=\"display-6 element-upload mb-6\" role=\"presentation\"></i>\n  <span class=\"drag-and-drop-description si-title-2 d-flex\">\n    <span>{{ uploadDropText | translate }}</span>\n    &nbsp;\n    <label class=\"select-file mb-0\">\n      <span class=\"select-file\" tabindex=\"0\" (keydown.enter)=\"inputEnterHandler()\">{{\n        uploadTextFileSelect | translate\n      }}</span>\n      <input\n        #fileInput\n        type=\"file\"\n        tabindex=\"-1\"\n        class=\"d-none\"\n        [accept]=\"accept\"\n        [multiple]=\"multiple\"\n        (change)=\"inputHandler($event)\"\n      />\n    </label>\n  </span>\n  <div *ngIf=\"maxFileSize || accept\" class=\"allowed si-caption mt-6\">\n    <ng-container *ngIf=\"maxFileSize\">\n      {{ maxFileSizeText | translate }}: {{ maxFileSizeString }}.\n    </ng-container>\n    <ng-container *ngIf=\"accept\"> {{ acceptText | translate }}: {{ accept }}. </ng-container>\n  </div>\n</div>\n", styles: [":host{display:block}.select-file{margin-block-end:0;cursor:pointer;font-weight:700;color:var(--element-ui-0)}.select-file:hover,.select-file:active{text-decoration:underline}.drag-and-drop{background-color:var(--element-base-1);border:1px dashed var(--element-ui-2);display:flex;flex-direction:column;justify-content:center;align-items:center}.drag-and-drop.drag-over{border:1px solid var(--element-focus-default);box-shadow:0 0 0 1px var(--element-focus-default)}\n"] }]
        }], propDecorators: { uploadTextFileSelect: [{
                type: Input
            }], uploadDropText: [{
                type: Input
            }], maxFileSizeText: [{
                type: Input
            }], acceptText: [{
                type: Input
            }], errorTextFileType: [{
                type: Input
            }], errorTextFileMaxSize: [{
                type: Input
            }], accept: [{
                type: Input
            }], maxFileSize: [{
                type: Input
            }], multiple: [{
                type: Input
            }], filesAdded: [{
                type: Output
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }] } });

class SiFileUploaderComponent {
    /**
     * Text of the link to open the file select dialog (follows `uploadDropText`).
     */
    uploadTextFileSelect = $localize `:@@SI_FILE_UPLOADER.FILE_SELECT:click to upload`;
    /**
     * Text instructing a user to drop the files inside the dropzone.
     */
    uploadDropText = $localize `:@@SI_FILE_UPLOADER.DROP:Drop files here or`;
    /**
     * Text to describe the maximum file size.
     */
    maxFileSizeText = $localize `:@@SI_FILE_UPLOADER.MAX_SIZE:Maximum upload size`;
    /**
     * Error message shown when the maximum number of files are reached.
     */
    maxFilesReachedText = $localize `:@@SI_FILE_UPLOADER.MAX_FILE_REACHED:Maximum number of files reached`;
    /**
     * Text for the accepted file types.
     */
    acceptText = $localize `:@@SI_FILE_UPLOADER.ACCEPTED_FILE_TYPES:Accepted file types`;
    /**
     * Text used inside the upload button.
     */
    uploadButtonText = $localize `:@@SI_FILE_UPLOADER.UPLOAD:Upload`;
    /**
     * Text used inside the clear button.
     */
    clearButtonText = $localize `:@@SI_FILE_UPLOADER.CLEAR:Clear`;
    /**
     * Text shown during the file upload.
     */
    uploadingText = $localize `:@@SI_FILE_UPLOADER.UPLOADING:Uploading`;
    /**
     * Text shown to remove a file from the file list. Required for a11y.
     */
    removeButtonText = $localize `:@@SI_FILE_UPLOADER.REMOVE:Remove`;
    /**
     * Text of cancel button. Shown during upload. Required for a11y.
     */
    cancelButtonText = $localize `:@@SI_FILE_UPLOADER.CANCEL:Cancel`;
    /**
     * Text shown if the upload was successful.
     */
    successTextTitle = $localize `:@@SI_FILE_UPLOADER.UPLOAD_COMPLETED:Upload completed`;
    /**
     * Text shown if the upload failed.
     */
    errorUploadFailed = $localize `:@@SI_FILE_UPLOADER.UPLOAD_FAILED:Upload failed`;
    /**
     * On failed upload, show the error received from the server.
     */
    showHttpError = false;
    /**
     * Text shown to indicate that an incorrect file type was added to file list.
     */
    errorTextFileType = $localize `:@@SI_FILE_UPLOADER.ERROR_FILE_TYPE:Incorrect file type selected`;
    /**
     * Message or translation key if file exceeds the maximum file size limit.
     */
    errorTextFileMaxSize = $localize `:@@SI_FILE_UPLOADER.ERROR_FILE_SIZE_EXCEEDED:File exceeds allowed maximum size`;
    /**
     * Config for HTTP request to upload file.
     */
    uploadConfig = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        headers: new HttpHeaders({ 'Accept': 'application/json' }),
        method: 'POST',
        url: '',
        fieldName: 'upload_file',
        responseType: 'json'
    };
    /**
     * Define which file types are suggested in file browser.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#attr-accept
     */
    accept;
    /**
     * Define maximal allowed file size in bytes.
     */
    maxFileSize;
    /**
     * Define maximal allowed number of files.
     */
    maxFiles = 10;
    /**
     * Maximum number of concurrent uploads.
     */
    maxConcurrentUploads = 3;
    /**
     * Numbers of retries for failed uploads.
     */
    retries = 0;
    /**
     * Auto-upload mode - automatically start upload once files are added.
     */
    autoUpload = false;
    /**
     * Disable the upload button.
     */
    disableUpload = false;
    /**
     * Output callback event will provide you if upload is finished. If an error
     * occurred it will be emitted.
     */
    uploadCompleted = new EventEmitter(true);
    /**
     * Output which fires whenever new files are added to or removed from the uploader.
     */
    filesChanges = new EventEmitter(true);
    files = [];
    pending = 0;
    uploading = 0;
    uploadEnabled = false;
    maxFilesReached = false;
    trackByItem = (index, item) => item;
    dropZone;
    cdRef = inject(ChangeDetectorRef);
    http = inject(HttpClient, { optional: true });
    ngOnChanges(changes) {
        if (changes.maxFiles || changes.disableUpload) {
            this.updateStates();
        }
    }
    handleFiles(files) {
        if (!files?.length) {
            return;
        }
        // for single-file case, replace exiting file if any
        if (this.maxFiles === 1 && this.files.length) {
            this.reset(false);
        }
        let numValid = this.countValid();
        for (const file of files) {
            if (this.isDuplicate(file)) {
                continue;
            }
            const canAdd = numValid + 1 <= this.maxFiles;
            const valid = file.status === 'added';
            if (valid && !canAdd) {
                this.maxFilesReached = true;
                break;
            }
            else if (valid) {
                numValid++;
            }
            this.files.push(file);
        }
        this.files.sort((a, b) => a.fileName.localeCompare(b.fileName));
        this.filesChanges.emit(this.files.slice());
        this.updateStates();
        if (this.autoUpload) {
            this.fileUpload(false);
        }
    }
    removeFile(index) {
        if (index >= 0) {
            this.files.splice(index, 1);
            this.filesChanges.emit(this.files.slice());
            this.dropZone?.reset();
            this.updateStates();
        }
    }
    cancelUpload(file) {
        if (file.subscription) {
            file.subscription.unsubscribe();
            this.pending--;
        }
        file.status = 'added';
        file.progress = 0;
        this.updateStates();
    }
    retryUpload(file) {
        file.status = 'added';
        this.doUpload([file], true);
    }
    /**
     * Reset the state.
     */
    reset(emit = true) {
        this.files.forEach(f => f.subscription?.unsubscribe());
        this.files = [];
        this.dropZone?.reset();
        this.updateStates();
        if (emit) {
            this.filesChanges.emit([]);
        }
    }
    /**
     * Uploads the file
     */
    fileUpload(doRetry = true) {
        if (!this.uploadEnabled) {
            return;
        }
        this.uploadEnabled = false;
        this.doUpload(this.files, doRetry);
    }
    doUpload(files, doRetry) {
        for (const file of files) {
            if (file.status !== 'added' && (!doRetry || file.status !== 'error')) {
                continue;
            }
            this.pending++;
            file.status = 'queued';
        }
        this.processQueue();
    }
    processQueue() {
        for (let i = 0; i < this.files.length && this.uploading < this.maxConcurrentUploads; i++) {
            const file = this.files[i];
            if (file.status === 'queued') {
                this.uploading++;
                this.uploadOneFile(file);
            }
        }
    }
    uploadOneFile(file) {
        let formData;
        if (!this.uploadConfig.sendBinary) {
            formData = new FormData();
            formData.append(this.uploadConfig.fieldName, file.file, file.fileName);
            if (this.uploadConfig.additionalFields) {
                Object.keys(this.uploadConfig.additionalFields).forEach(key => {
                    formData.append(key, this.uploadConfig.additionalFields[key]);
                });
            }
        }
        const headers = this.uploadConfig.headers instanceof HttpHeaders
            ? this.uploadConfig.headers
            : new HttpHeaders(this.uploadConfig.headers);
        const req = new HttpRequest(this.uploadConfig.method, this.uploadConfig.url, formData ?? file.file, {
            headers,
            responseType: this.uploadConfig.responseType,
            reportProgress: true
        });
        file.status = 'uploading';
        file.errorText = undefined;
        file.httpErrorText = undefined;
        const requestHandler = this.uploadConfig.handler ??
            (this.http ? (r) => this.http.request(r) : undefined);
        if (!requestHandler) {
            return;
        }
        file.subscription = requestHandler(req)
            .pipe(retry(this.retries))
            .subscribe(event => this.handleUploadEvent(file, event), (error) => this.handleUploadError(file, error), () => this.handleUploadComplete(file));
    }
    // this is a light check for duplicate file - name and size only, not content!
    isDuplicate(file) {
        for (const uploadFile of this.files) {
            if (uploadFile.file.name === file.file.name && uploadFile.file.size === file.file.size) {
                return true;
            }
        }
        return false;
    }
    handleUploadEvent(file, httpEvent) {
        if (httpEvent instanceof HttpResponse) {
            file.successResponse = httpEvent;
        }
        else if (httpEvent.type === HttpEventType.UploadProgress && httpEvent.total) {
            file.progress = Math.floor((100 * httpEvent.loaded) / httpEvent.total);
            this.cdRef.markForCheck();
        }
    }
    handleUploadError(file, error) {
        this.uploadCompleted.emit({ file: file.fileName, error });
        file.status = 'error';
        file.errorText = this.errorUploadFailed;
        if (this.showHttpError && error.status && error.statusText) {
            file.httpErrorText = `${error.status}: ${error.statusText}`;
        }
        this.oneUploadDone(file);
    }
    handleUploadComplete(file) {
        this.uploadCompleted.emit({ file: file.fileName, response: file.successResponse });
        file.status = 'success';
        file.progress = 100;
        file.successResponse = undefined;
        if (this.autoUpload) {
            this.fadeOut(file);
        }
        this.oneUploadDone(file);
    }
    oneUploadDone(file) {
        file.subscription = undefined;
        this.pending--;
        this.uploading--;
        this.updateStates();
        this.processQueue();
    }
    fadeOut(file) {
        setTimeout(() => {
            file.fadeOut = true;
            this.cdRef.markForCheck();
            setTimeout(() => {
                this.removeFile(this.files.indexOf(file));
                this.cdRef.markForCheck();
            }, 500);
            this.cdRef.markForCheck();
        }, 3500);
    }
    updateStates() {
        this.uploadEnabled =
            !this.disableUpload &&
                !this.pending &&
                this.files.some(f => f.status === 'added' || f.status === 'error');
        if (this.maxFilesReached && this.countValid() < this.maxFiles) {
            this.maxFilesReached = false;
        }
    }
    countValid() {
        return this.files.reduce((acc, f) => acc + (f.status !== 'invalid' ? 1 : 0), 0);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFileUploaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiFileUploaderComponent, selector: "si-file-uploader", inputs: { uploadTextFileSelect: "uploadTextFileSelect", uploadDropText: "uploadDropText", maxFileSizeText: "maxFileSizeText", maxFilesReachedText: "maxFilesReachedText", acceptText: "acceptText", uploadButtonText: "uploadButtonText", clearButtonText: "clearButtonText", uploadingText: "uploadingText", removeButtonText: "removeButtonText", cancelButtonText: "cancelButtonText", successTextTitle: "successTextTitle", errorUploadFailed: "errorUploadFailed", showHttpError: "showHttpError", errorTextFileType: "errorTextFileType", errorTextFileMaxSize: "errorTextFileMaxSize", uploadConfig: "uploadConfig", accept: "accept", maxFileSize: "maxFileSize", maxFiles: "maxFiles", maxConcurrentUploads: "maxConcurrentUploads", retries: "retries", autoUpload: "autoUpload", disableUpload: "disableUpload" }, outputs: { uploadCompleted: "uploadCompleted", filesChanges: "filesChanges" }, viewQueries: [{ propertyName: "dropZone", first: true, predicate: ["dropZone"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<si-file-dropzone\n  #dropZone\n  [ngClass]=\"autoUpload ? 'mb-8' : 'mb-4'\"\n  [uploadTextFileSelect]=\"uploadTextFileSelect\"\n  [uploadDropText]=\"uploadDropText\"\n  [multiple]=\"maxFiles > 1\"\n  [maxFileSizeText]=\"maxFileSizeText\"\n  [acceptText]=\"acceptText\"\n  [errorTextFileType]=\"errorTextFileType\"\n  [errorTextFileMaxSize]=\"errorTextFileMaxSize\"\n  [accept]=\"accept\"\n  [maxFileSize]=\"maxFileSize\"\n  (filesAdded)=\"handleFiles($event)\"\n></si-file-dropzone>\n\n<si-inline-notification\n  *ngIf=\"maxFilesReached\"\n  class=\"mb-4\"\n  severity=\"info\"\n  [message]=\"maxFilesReachedText\"\n></si-inline-notification>\n\n<div class=\"file-list\">\n  <div\n    *ngFor=\"let file of files; index as i; trackBy: trackByItem\"\n    class=\"file d-flex\"\n    [ngClass]=\"autoUpload ? 'mb-8' : 'mb-4'\"\n    [class.fade-out]=\"file.fadeOut\"\n  >\n    <i class=\"icon align-self-center ms-6 me-4 element-document\" role=\"presentation\"></i>\n    <div class=\"flex-fill overflow-hidden\">\n      <div class=\"file-info\">\n        <div class=\"file-name text-truncate fw-bold\">{{ file.fileName }}</div>\n        <div class=\"file-size text-secondary\">{{ file.size }}</div>\n      </div>\n      <div\n        *ngIf=\"file.errorText\"\n        class=\"error text-truncate d-flex align-items-center\"\n        [class.text-warning]=\"file.status === 'invalid'\"\n        [class.text-danger]=\"file.status === 'error'\"\n      >\n        <si-icon\n          class=\"d-inline-block my-n2 me-2\"\n          size=\"icon-small\"\n          stackedIcon=\"element-state-exclamation-mark smooth-auto\"\n          alt=\"\"\n          [icon]=\"file.status === 'invalid' ? 'element-triangle-filled' : 'element-circle-filled'\"\n          [color]=\"file.status === 'invalid' ? 'status-warning' : 'status-danger'\"\n          [stackedColor]=\"\n            file.status === 'invalid' ? 'status-warning-contrast' : 'status-danger-contrast'\n          \"\n        ></si-icon>\n        {{ file.errorText | translate\n        }}<ng-container *ngIf=\"file.httpErrorText\">: {{ file.httpErrorText }}</ng-container>\n      </div>\n      <div *ngIf=\"!file.errorText\" class=\"position-relative\">\n        <div class=\"position-absolute si-caption end-0 mt-n8\">{{ file.progress }} %</div>\n        <si-progressbar\n          height=\"small\"\n          [value]=\"file.progress\"\n          [ariaLabel]=\"uploadingText | translate\"\n        ></si-progressbar>\n      </div>\n    </div>\n    <div class=\"status align-self-center text-nowrap ps-4 pe-6\">\n      <button\n        *ngIf=\"file.status === 'error'\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-tertiary element-redo me-4\"\n        [disabled]=\"!uploadEnabled\"\n        [title]=\"uploadButtonText | translate\"\n        [attr.aria-label]=\"uploadButtonText | translate\"\n        (click)=\"retryUpload(file)\"\n      ></button>\n      <button\n        *ngIf=\"file.status === 'added' || file.status === 'error' || file.status === 'invalid'\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-ghost element-delete\"\n        [title]=\"removeButtonText | translate\"\n        [attr.aria-label]=\"removeButtonText | translate\"\n        (click)=\"removeFile(i)\"\n      ></button>\n      <button\n        *ngIf=\"file.status === 'uploading' || file.status === 'queued'\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-tertiary element-cancel\"\n        [title]=\"cancelButtonText | translate\"\n        [attr.aria-label]=\"cancelButtonText | translate\"\n        (click)=\"cancelUpload(file)\"\n      ></button>\n      <si-icon\n        *ngIf=\"file.status === 'success'\"\n        class=\"mx-2\"\n        icon=\"element-circle-filled\"\n        color=\"status-success\"\n        stackedIcon=\"element-state-tick smooth-auto\"\n        stackedColor=\"status-success-contrast\"\n        [alt]=\"successTextTitle\"\n      ></si-icon>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"!autoUpload\" class=\"buttons text-end\">\n  <button\n    type=\"button\"\n    class=\"btn btn-secondary me-4\"\n    [disabled]=\"pending || !files.length\"\n    (click)=\"reset()\"\n    >{{ clearButtonText | translate }}</button\n  >\n  <button\n    type=\"button\"\n    class=\"btn btn-primary\"\n    [disabled]=\"!uploadEnabled\"\n    (click)=\"fileUpload()\"\n    >{{ uploadButtonText | translate }}</button\n  >\n</div>\n", styles: [":host{display:flex;flex-direction:column;justify-content:center;align-items:stretch}:host>*{min-inline-size:320px;max-inline-size:680px;inline-size:100%;align-self:center}.file-list{overflow-y:auto}.file-info{display:flex;justify-content:center;flex-direction:column;block-size:56px}.file{min-block-size:72px;transition:opacity calc(.5s * var(--element-animations-enabled, 1))}.fade-out{opacity:0}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.SiIconComponent, selector: "si-icon", inputs: ["icon", "color", "stackedIcon", "stackedColor", "alt", "size"] }, { kind: "component", type: i3.SiInlineNotificationComponent, selector: "si-inline-notification", inputs: ["severity", "heading", "message", "action", "translationParams", "embedded"] }, { kind: "component", type: i4.SiProgressbarComponent, selector: "si-progressbar", inputs: ["ariaLabel", "max", "value", "heading", "progress", "height"] }, { kind: "component", type: SiFileDropzoneComponent, selector: "si-file-dropzone", inputs: ["uploadTextFileSelect", "uploadDropText", "maxFileSizeText", "acceptText", "errorTextFileType", "errorTextFileMaxSize", "accept", "maxFileSize", "multiple"], outputs: ["filesAdded"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFileUploaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-file-uploader', template: "<si-file-dropzone\n  #dropZone\n  [ngClass]=\"autoUpload ? 'mb-8' : 'mb-4'\"\n  [uploadTextFileSelect]=\"uploadTextFileSelect\"\n  [uploadDropText]=\"uploadDropText\"\n  [multiple]=\"maxFiles > 1\"\n  [maxFileSizeText]=\"maxFileSizeText\"\n  [acceptText]=\"acceptText\"\n  [errorTextFileType]=\"errorTextFileType\"\n  [errorTextFileMaxSize]=\"errorTextFileMaxSize\"\n  [accept]=\"accept\"\n  [maxFileSize]=\"maxFileSize\"\n  (filesAdded)=\"handleFiles($event)\"\n></si-file-dropzone>\n\n<si-inline-notification\n  *ngIf=\"maxFilesReached\"\n  class=\"mb-4\"\n  severity=\"info\"\n  [message]=\"maxFilesReachedText\"\n></si-inline-notification>\n\n<div class=\"file-list\">\n  <div\n    *ngFor=\"let file of files; index as i; trackBy: trackByItem\"\n    class=\"file d-flex\"\n    [ngClass]=\"autoUpload ? 'mb-8' : 'mb-4'\"\n    [class.fade-out]=\"file.fadeOut\"\n  >\n    <i class=\"icon align-self-center ms-6 me-4 element-document\" role=\"presentation\"></i>\n    <div class=\"flex-fill overflow-hidden\">\n      <div class=\"file-info\">\n        <div class=\"file-name text-truncate fw-bold\">{{ file.fileName }}</div>\n        <div class=\"file-size text-secondary\">{{ file.size }}</div>\n      </div>\n      <div\n        *ngIf=\"file.errorText\"\n        class=\"error text-truncate d-flex align-items-center\"\n        [class.text-warning]=\"file.status === 'invalid'\"\n        [class.text-danger]=\"file.status === 'error'\"\n      >\n        <si-icon\n          class=\"d-inline-block my-n2 me-2\"\n          size=\"icon-small\"\n          stackedIcon=\"element-state-exclamation-mark smooth-auto\"\n          alt=\"\"\n          [icon]=\"file.status === 'invalid' ? 'element-triangle-filled' : 'element-circle-filled'\"\n          [color]=\"file.status === 'invalid' ? 'status-warning' : 'status-danger'\"\n          [stackedColor]=\"\n            file.status === 'invalid' ? 'status-warning-contrast' : 'status-danger-contrast'\n          \"\n        ></si-icon>\n        {{ file.errorText | translate\n        }}<ng-container *ngIf=\"file.httpErrorText\">: {{ file.httpErrorText }}</ng-container>\n      </div>\n      <div *ngIf=\"!file.errorText\" class=\"position-relative\">\n        <div class=\"position-absolute si-caption end-0 mt-n8\">{{ file.progress }} %</div>\n        <si-progressbar\n          height=\"small\"\n          [value]=\"file.progress\"\n          [ariaLabel]=\"uploadingText | translate\"\n        ></si-progressbar>\n      </div>\n    </div>\n    <div class=\"status align-self-center text-nowrap ps-4 pe-6\">\n      <button\n        *ngIf=\"file.status === 'error'\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-tertiary element-redo me-4\"\n        [disabled]=\"!uploadEnabled\"\n        [title]=\"uploadButtonText | translate\"\n        [attr.aria-label]=\"uploadButtonText | translate\"\n        (click)=\"retryUpload(file)\"\n      ></button>\n      <button\n        *ngIf=\"file.status === 'added' || file.status === 'error' || file.status === 'invalid'\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-ghost element-delete\"\n        [title]=\"removeButtonText | translate\"\n        [attr.aria-label]=\"removeButtonText | translate\"\n        (click)=\"removeFile(i)\"\n      ></button>\n      <button\n        *ngIf=\"file.status === 'uploading' || file.status === 'queued'\"\n        type=\"button\"\n        class=\"btn btn-circle btn-sm btn-tertiary element-cancel\"\n        [title]=\"cancelButtonText | translate\"\n        [attr.aria-label]=\"cancelButtonText | translate\"\n        (click)=\"cancelUpload(file)\"\n      ></button>\n      <si-icon\n        *ngIf=\"file.status === 'success'\"\n        class=\"mx-2\"\n        icon=\"element-circle-filled\"\n        color=\"status-success\"\n        stackedIcon=\"element-state-tick smooth-auto\"\n        stackedColor=\"status-success-contrast\"\n        [alt]=\"successTextTitle\"\n      ></si-icon>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"!autoUpload\" class=\"buttons text-end\">\n  <button\n    type=\"button\"\n    class=\"btn btn-secondary me-4\"\n    [disabled]=\"pending || !files.length\"\n    (click)=\"reset()\"\n    >{{ clearButtonText | translate }}</button\n  >\n  <button\n    type=\"button\"\n    class=\"btn btn-primary\"\n    [disabled]=\"!uploadEnabled\"\n    (click)=\"fileUpload()\"\n    >{{ uploadButtonText | translate }}</button\n  >\n</div>\n", styles: [":host{display:flex;flex-direction:column;justify-content:center;align-items:stretch}:host>*{min-inline-size:320px;max-inline-size:680px;inline-size:100%;align-self:center}.file-list{overflow-y:auto}.file-info{display:flex;justify-content:center;flex-direction:column;block-size:56px}.file{min-block-size:72px;transition:opacity calc(.5s * var(--element-animations-enabled, 1))}.fade-out{opacity:0}\n"] }]
        }], propDecorators: { uploadTextFileSelect: [{
                type: Input
            }], uploadDropText: [{
                type: Input
            }], maxFileSizeText: [{
                type: Input
            }], maxFilesReachedText: [{
                type: Input
            }], acceptText: [{
                type: Input
            }], uploadButtonText: [{
                type: Input
            }], clearButtonText: [{
                type: Input
            }], uploadingText: [{
                type: Input
            }], removeButtonText: [{
                type: Input
            }], cancelButtonText: [{
                type: Input
            }], successTextTitle: [{
                type: Input
            }], errorUploadFailed: [{
                type: Input
            }], showHttpError: [{
                type: Input
            }], errorTextFileType: [{
                type: Input
            }], errorTextFileMaxSize: [{
                type: Input
            }], uploadConfig: [{
                type: Input
            }], accept: [{
                type: Input
            }], maxFileSize: [{
                type: Input
            }], maxFiles: [{
                type: Input
            }], maxConcurrentUploads: [{
                type: Input
            }], retries: [{
                type: Input
            }], autoUpload: [{
                type: Input
            }], disableUpload: [{
                type: Input
            }], uploadCompleted: [{
                type: Output
            }], filesChanges: [{
                type: Output
            }], dropZone: [{
                type: ViewChild,
                args: ['dropZone']
            }] } });

class SiFileUploaderModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFileUploaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiFileUploaderModule, declarations: [SiFileDropzoneComponent, SiFileUploaderComponent], imports: [CommonModule,
            SiIconModule,
            SiInlineNotificationModule,
            SiProgressbarModule,
            SiTranslateModule], exports: [SiFileDropzoneComponent, SiFileUploaderComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFileUploaderModule, imports: [CommonModule,
            SiIconModule,
            SiInlineNotificationModule,
            SiProgressbarModule,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiFileUploaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SiIconModule,
                        SiInlineNotificationModule,
                        SiProgressbarModule,
                        SiTranslateModule
                    ],
                    declarations: [SiFileDropzoneComponent, SiFileUploaderComponent],
                    exports: [SiFileDropzoneComponent, SiFileUploaderComponent]
                }]
        }] });

class SiSliderComponent {
    handleRef;
    /**
     * Current value of slider.
     */
    value;
    /**
     * Minimum of slider range.
     */
    min = 0;
    /**
     * Maximum of slider range.
     */
    max = 100;
    /**
     * Label to describe minimum of slider range.
     */
    minLabel = '';
    /**
     * Label to describe maximum of slider range.
     */
    maxLabel = '';
    /**
     * Interval to step through the slider.
     */
    step = 1;
    /**
     * Disables option to change slider value.
     */
    disabled = false;
    /**
     * Icon to use as the slider thumb.
     */
    thumbIcon;
    /**
     * Text for aria-label of increment. Needed for a11y.
     */
    incrementLabel = $localize `:@@SI_SLIDER.INCREMENT:Increment`;
    /**
     * Text for aria-label of decrement. Needed for a11y.
     */
    decrementLabel = $localize `:@@SI_SLIDER.DECREMENT:Decrement`;
    /**
     * Text for aria-label of slider. Needed for a11y
     */
    sliderLabel = $localize `:@@SI_SLIDER.LABEL:Value`;
    /**
     * Output callback that triggers when the slider value changes.
     */
    valueChange = new EventEmitter();
    get isDisabled() {
        return this.disabled || this.min === this.max;
    }
    indicatorPos = 50;
    isDragging = false;
    autoUpdate$ = timer(400, 80); // 250
    autoUpdateSubs;
    rtl = false;
    unlistenDragEvents = [];
    onTouchedCallback = () => { };
    onChangeCallback = () => { };
    zone = inject(NgZone);
    changeDetectorRef = inject(ChangeDetectorRef);
    incrementValue() {
        this.value = this.normalizeValue(this.value + this.step);
        this.valueChanged();
    }
    decrementValue() {
        this.value = this.normalizeValue(this.value - this.step);
        this.valueChanged();
    }
    roundToStepPrecision(value) {
        const factor = 1 / this.step;
        if (factor > 1) {
            return Math.round(value * factor) / factor;
        }
        return Math.round(value / this.step) * this.step;
    }
    normalizeValue(value) {
        return Math.min(Math.max(this.roundToStepPrecision(value), this.min), this.max);
    }
    updateIndicatorPosition() {
        const range = this.max - this.min;
        if (range === 0) {
            this.indicatorPos = 50;
            return;
        }
        const indicatorPos = ((this.value - this.min) * 100) / range;
        this.indicatorPos = Math.max(Math.min(indicatorPos, 100), 0);
    }
    handleTouchMove(event) {
        if (event.cancelable) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.handleDragMove(event.touches[0]);
    }
    handleMouseMove(event) {
        event.preventDefault();
        event.stopPropagation();
        this.handleDragMove(event);
    }
    handleDragMove(event) {
        const pointerPosX = event.clientX;
        const handleRect = this.handleRef.nativeElement.getBoundingClientRect();
        const handleWrapperWidth = this.handleRef.nativeElement.parentElement.clientWidth;
        const direction = this.rtl ? -1 : 1;
        const pointerPosDelta = Math.round(pointerPosX - (handleRect.x + handleRect.width / 2)) * direction;
        const valueDelta = (pointerPosDelta / handleWrapperWidth) * (this.max - this.min);
        const newValue = this.normalizeValue(this.value + valueDelta);
        if ((pointerPosDelta > 0 && newValue > this.value) ||
            (pointerPosDelta < 0 && newValue < this.value)) {
            // the zone is required to work around a problem on native device where CD doesn't trigger
            this.zone.run(() => {
                this.changeDetectorRef.markForCheck();
                this.value = newValue;
                this.valueChanged();
            });
        }
        window.getSelection()?.removeAllRanges();
    }
    handleDragEnd() {
        this.isDragging = false;
        this.unlistenDragEvents.forEach(handler => handler());
        this.unlistenDragEvents.length = 0;
    }
    handleUndefinedValue() {
        this.value ??= this.roundToStepPrecision((this.min + this.max) / 2);
    }
    ngOnChanges() {
        this.handleUndefinedValue();
        this.updateIndicatorPosition();
    }
    handlePointerDown(event) {
        event.stopPropagation();
    }
    autoUpdateKeydown(event) {
        const rtlCorrectedKey = correctKeyRTL(event.key);
        if (rtlCorrectedKey === 'ArrowLeft') {
            this.autoUpdateStart(event, false);
        }
        else if (rtlCorrectedKey === 'ArrowRight') {
            this.autoUpdateStart(event, true);
        }
    }
    autoUpdateStart(event, isIncrement) {
        event.preventDefault();
        const trigger = isIncrement ? () => this.incrementValue() : () => this.decrementValue();
        this.autoUpdateSubs?.unsubscribe();
        this.autoUpdateSubs = this.autoUpdate$.subscribe(trigger);
        trigger();
    }
    autoUpdateStop() {
        if (this.autoUpdateSubs) {
            this.autoUpdateSubs.unsubscribe();
            this.autoUpdateSubs = undefined;
        }
    }
    handleMouseDown(event) {
        this.unlistenDragEvents.push(listenGlobal('mousemove', moveEvent => this.handleMouseMove(moveEvent)));
        this.unlistenDragEvents.push(listenGlobal('mouseup', () => this.handleDragEnd()));
        this.isDragging = true;
        this.rtl = isRTL();
        this.handleMouseMove(event);
    }
    handleTouchStart(event) {
        if (event.touches.length !== 1) {
            return;
        }
        this.unlistenDragEvents.push(listenGlobal('touchmove', e => this.handleTouchMove(e), true));
        this.unlistenDragEvents.push(listenGlobal('touchend', () => this.handleDragEnd()));
        this.isDragging = true;
        this.rtl = isRTL();
        this.handleTouchMove(event);
    }
    valueChanged() {
        this.updateIndicatorPosition();
        this.onTouchedCallback();
        this.onChangeCallback(this.value);
        this.valueChange.emit(this.value);
    }
    /** @internal */
    writeValue(val) {
        this.value = val;
        this.handleUndefinedValue();
        this.updateIndicatorPosition();
    }
    /** @internal */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /** @internal */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /** @internal */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiSliderComponent, selector: "si-slider", inputs: { value: "value", min: "min", max: "max", minLabel: "minLabel", maxLabel: "maxLabel", step: "step", disabled: "disabled", thumbIcon: "thumbIcon", incrementLabel: "incrementLabel", decrementLabel: "decrementLabel", sliderLabel: "sliderLabel" }, outputs: { valueChange: "valueChange" }, host: { listeners: { "pointerdown": "handlePointerDown($event)", "mousedown": "handlePointerDown($event)", "touchstart": "handlePointerDown($event)" }, properties: { "class.disabled": "this.isDisabled" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                // eslint-disable-next-line @angular-eslint/no-forward-ref
                useExisting: forwardRef(() => SiSliderComponent),
                multi: true
            }
        ], viewQueries: [{ propertyName: "handleRef", first: true, predicate: ["handle"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"slider-container\">\n  <button\n    type=\"button\"\n    class=\"btn btn-sm btn-circle btn-secondary element-minus decrement-button\"\n    [disabled]=\"isDisabled\"\n    [attr.aria-label]=\"decrementLabel | translate\"\n    (mousedown)=\"autoUpdateStart($event, false)\"\n    (touchstart)=\"autoUpdateStart($event, false)\"\n    (keydown.enter)=\"autoUpdateStart($event, false)\"\n    (touchend)=\"autoUpdateStop()\"\n    (mouseup)=\"autoUpdateStop()\"\n    (keyup.enter)=\"autoUpdateStop()\"\n    (mouseleave)=\"autoUpdateStop()\"\n  ></button>\n\n  <div class=\"slider-wrapper\">\n    <div class=\"value-indicator-wrapper\">\n      <span class=\"value-indicator\" [style.inset-inline-start.%]=\"indicatorPos\">\n        <span>\n          <ng-content></ng-content>\n        </span>\n      </span>\n    </div>\n\n    <div class=\"slider\" [class.dragging]=\"isDragging\">\n      <div class=\"track\"></div>\n      <div\n        class=\"thumb-handle-wrapper\"\n        [class.dragging]=\"isDragging\"\n        (mousedown)=\"handleMouseDown($event)\"\n        (touchstart)=\"handleTouchStart($event)\"\n      >\n        <div #handle class=\"thumb-handle\" [style.inset-inline-start.%]=\"indicatorPos\">\n          <div\n            class=\"thumb\"\n            tabindex=\"0\"\n            role=\"slider\"\n            [attr.aria-label]=\"sliderLabel | translate\"\n            [attr.aria-valuenow]=\"value\"\n            [class.dragging]=\"isDragging\"\n            (keydown)=\"autoUpdateKeydown($event)\"\n            (keyup)=\"autoUpdateStop()\"\n          >\n            <i *ngIf=\"thumbIcon\" [ngClass]=\"thumbIcon\"></i>\n            <div *ngIf=\"!thumbIcon\" class=\"hover-circle\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <button\n    type=\"button\"\n    class=\"btn btn-sm btn-circle btn-secondary element-plus increment-button\"\n    [disabled]=\"isDisabled\"\n    [attr.aria-label]=\"incrementLabel | translate\"\n    (mousedown)=\"autoUpdateStart($event, true)\"\n    (touchstart)=\"autoUpdateStart($event, true)\"\n    (keydown.enter)=\"autoUpdateStart($event, true)\"\n    (touchend)=\"autoUpdateStop()\"\n    (mouseup)=\"autoUpdateStop()\"\n    (keyup.enter)=\"autoUpdateStop()\"\n    (mouseleave)=\"autoUpdateStop()\"\n  ></button>\n</div>\n\n<div *ngIf=\"minLabel && maxLabel\" class=\"range-indicator-wrapper\">\n  <div class=\"range-indicator\">\n    <span>{{ minLabel }}</span>\n    <span class=\"ms-auto\">{{ maxLabel }}</span>\n  </div>\n</div>\n", styles: [":host{display:flex;flex-direction:column}.slider-container{display:flex;align-items:flex-end}.decrement-button{margin-inline-end:4px}.increment-button{margin-inline-start:4px}.slider-wrapper{position:relative;flex:1 1 0;min-inline-size:0;display:flex;flex-direction:column}.value-indicator-wrapper{position:relative;margin-inline:12px;text-align:start}.value-indicator{position:relative;display:inline-block;white-space:nowrap;color:var(--element-text-secondary)}.value-indicator>span{display:inline-block;margin-inline-start:-50%}.range-indicator-wrapper{margin-block:0;margin-inline:36px}.range-indicator-wrapper .range-indicator{display:inline-flex;white-space:nowrap;inline-size:100%;color:var(--element-text-secondary)}.range-indicator-wrapper .range-indicator>span{display:inline-block}.slider{position:relative;inline-size:100%;block-size:32px;cursor:pointer}.slider.dragging{cursor:grabbing}:host.disabled .slider{cursor:default}.slider .track{position:absolute;inset-block-start:50%;border-radius:var(--element-radius-1);margin-block-start:-2px;block-size:4px;inline-size:100%;background:var(--element-ui-4);pointer-events:none}.slider .thumb-handle-wrapper{position:absolute;inset-block:0;inset-inline:12px}:host.disabled .slider .thumb-handle-wrapper{pointer-events:none}.slider .thumb-handle{display:flex;align-items:center;justify-content:center;position:absolute;inset-block-start:50%;margin-block-start:-20px;margin-inline:-20px;inline-size:40px;block-size:40px}:host.disabled .slider .thumb-handle{pointer-events:none}.slider .thumb{--thumb-state-color: var(--element-ui-0);display:flex;align-items:center;justify-content:center;block-size:24px;min-block-size:24px;inline-size:24px;min-inline-size:24px;border-radius:50%;border:1px solid var(--thumb-state-color);box-shadow:0 0 8px var(--element-box-shadow-color-1),0 8px 8px var(--element-box-shadow-color-2);background:var(--element-base-1)}.slider .thumb:hover:not(.dragging){--thumb-state-color: var(--element-ui-0-hover);background:var(--element-action-secondary-hover)}.slider .thumb:focus{box-shadow:0 0 0 var(--element-button-focus-overlay-width) var(--element-button-focus-overlay-color),0 0 0 calc(var(--element-button-focus-width) + var(--element-button-focus-overlay-width)) var(--element-focus-default)}:host.disabled .slider .thumb{--thumb-state-color: var(--element-ui-3);box-shadow:none}.slider .thumb i{font-size:1.5rem;color:var(--thumb-state-color)}.slider .thumb:hover .hover-circle,.slider .thumb:focus .hover-circle,.slider .thumb.dragging .hover-circle{display:block}.slider .hover-circle{display:none;block-size:12px;inline-size:12px;border-radius:50%;background:var(--thumb-state-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-slider', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            // eslint-disable-next-line @angular-eslint/no-forward-ref
                            useExisting: forwardRef(() => SiSliderComponent),
                            multi: true
                        }
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"slider-container\">\n  <button\n    type=\"button\"\n    class=\"btn btn-sm btn-circle btn-secondary element-minus decrement-button\"\n    [disabled]=\"isDisabled\"\n    [attr.aria-label]=\"decrementLabel | translate\"\n    (mousedown)=\"autoUpdateStart($event, false)\"\n    (touchstart)=\"autoUpdateStart($event, false)\"\n    (keydown.enter)=\"autoUpdateStart($event, false)\"\n    (touchend)=\"autoUpdateStop()\"\n    (mouseup)=\"autoUpdateStop()\"\n    (keyup.enter)=\"autoUpdateStop()\"\n    (mouseleave)=\"autoUpdateStop()\"\n  ></button>\n\n  <div class=\"slider-wrapper\">\n    <div class=\"value-indicator-wrapper\">\n      <span class=\"value-indicator\" [style.inset-inline-start.%]=\"indicatorPos\">\n        <span>\n          <ng-content></ng-content>\n        </span>\n      </span>\n    </div>\n\n    <div class=\"slider\" [class.dragging]=\"isDragging\">\n      <div class=\"track\"></div>\n      <div\n        class=\"thumb-handle-wrapper\"\n        [class.dragging]=\"isDragging\"\n        (mousedown)=\"handleMouseDown($event)\"\n        (touchstart)=\"handleTouchStart($event)\"\n      >\n        <div #handle class=\"thumb-handle\" [style.inset-inline-start.%]=\"indicatorPos\">\n          <div\n            class=\"thumb\"\n            tabindex=\"0\"\n            role=\"slider\"\n            [attr.aria-label]=\"sliderLabel | translate\"\n            [attr.aria-valuenow]=\"value\"\n            [class.dragging]=\"isDragging\"\n            (keydown)=\"autoUpdateKeydown($event)\"\n            (keyup)=\"autoUpdateStop()\"\n          >\n            <i *ngIf=\"thumbIcon\" [ngClass]=\"thumbIcon\"></i>\n            <div *ngIf=\"!thumbIcon\" class=\"hover-circle\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <button\n    type=\"button\"\n    class=\"btn btn-sm btn-circle btn-secondary element-plus increment-button\"\n    [disabled]=\"isDisabled\"\n    [attr.aria-label]=\"incrementLabel | translate\"\n    (mousedown)=\"autoUpdateStart($event, true)\"\n    (touchstart)=\"autoUpdateStart($event, true)\"\n    (keydown.enter)=\"autoUpdateStart($event, true)\"\n    (touchend)=\"autoUpdateStop()\"\n    (mouseup)=\"autoUpdateStop()\"\n    (keyup.enter)=\"autoUpdateStop()\"\n    (mouseleave)=\"autoUpdateStop()\"\n  ></button>\n</div>\n\n<div *ngIf=\"minLabel && maxLabel\" class=\"range-indicator-wrapper\">\n  <div class=\"range-indicator\">\n    <span>{{ minLabel }}</span>\n    <span class=\"ms-auto\">{{ maxLabel }}</span>\n  </div>\n</div>\n", styles: [":host{display:flex;flex-direction:column}.slider-container{display:flex;align-items:flex-end}.decrement-button{margin-inline-end:4px}.increment-button{margin-inline-start:4px}.slider-wrapper{position:relative;flex:1 1 0;min-inline-size:0;display:flex;flex-direction:column}.value-indicator-wrapper{position:relative;margin-inline:12px;text-align:start}.value-indicator{position:relative;display:inline-block;white-space:nowrap;color:var(--element-text-secondary)}.value-indicator>span{display:inline-block;margin-inline-start:-50%}.range-indicator-wrapper{margin-block:0;margin-inline:36px}.range-indicator-wrapper .range-indicator{display:inline-flex;white-space:nowrap;inline-size:100%;color:var(--element-text-secondary)}.range-indicator-wrapper .range-indicator>span{display:inline-block}.slider{position:relative;inline-size:100%;block-size:32px;cursor:pointer}.slider.dragging{cursor:grabbing}:host.disabled .slider{cursor:default}.slider .track{position:absolute;inset-block-start:50%;border-radius:var(--element-radius-1);margin-block-start:-2px;block-size:4px;inline-size:100%;background:var(--element-ui-4);pointer-events:none}.slider .thumb-handle-wrapper{position:absolute;inset-block:0;inset-inline:12px}:host.disabled .slider .thumb-handle-wrapper{pointer-events:none}.slider .thumb-handle{display:flex;align-items:center;justify-content:center;position:absolute;inset-block-start:50%;margin-block-start:-20px;margin-inline:-20px;inline-size:40px;block-size:40px}:host.disabled .slider .thumb-handle{pointer-events:none}.slider .thumb{--thumb-state-color: var(--element-ui-0);display:flex;align-items:center;justify-content:center;block-size:24px;min-block-size:24px;inline-size:24px;min-inline-size:24px;border-radius:50%;border:1px solid var(--thumb-state-color);box-shadow:0 0 8px var(--element-box-shadow-color-1),0 8px 8px var(--element-box-shadow-color-2);background:var(--element-base-1)}.slider .thumb:hover:not(.dragging){--thumb-state-color: var(--element-ui-0-hover);background:var(--element-action-secondary-hover)}.slider .thumb:focus{box-shadow:0 0 0 var(--element-button-focus-overlay-width) var(--element-button-focus-overlay-color),0 0 0 calc(var(--element-button-focus-width) + var(--element-button-focus-overlay-width)) var(--element-focus-default)}:host.disabled .slider .thumb{--thumb-state-color: var(--element-ui-3);box-shadow:none}.slider .thumb i{font-size:1.5rem;color:var(--thumb-state-color)}.slider .thumb:hover .hover-circle,.slider .thumb:focus .hover-circle,.slider .thumb.dragging .hover-circle{display:block}.slider .hover-circle{display:none;block-size:12px;inline-size:12px;border-radius:50%;background:var(--thumb-state-color)}\n"] }]
        }], propDecorators: { handleRef: [{
                type: ViewChild,
                args: ['handle', { static: true }]
            }], value: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], minLabel: [{
                type: Input
            }], maxLabel: [{
                type: Input
            }], step: [{
                type: Input
            }], disabled: [{
                type: Input
            }], thumbIcon: [{
                type: Input
            }], incrementLabel: [{
                type: Input
            }], decrementLabel: [{
                type: Input
            }], sliderLabel: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], isDisabled: [{
                type: HostBinding,
                args: ['class.disabled']
            }], handlePointerDown: [{
                type: HostListener,
                args: ['pointerdown', ['$event']]
            }, {
                type: HostListener,
                args: ['mousedown', ['$event']]
            }, {
                type: HostListener,
                args: ['touchstart', ['$event']]
            }] } });

class SiSliderModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiSliderModule, declarations: [SiSliderComponent], imports: [CommonModule, FormsModule, SiTranslateModule], exports: [SiSliderComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSliderModule, imports: [CommonModule, FormsModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SiTranslateModule],
                    declarations: [SiSliderComponent],
                    exports: [SiSliderComponent]
                }]
        }] });

class SiSortBarComponent {
    /**
     * Custom sort title.
     */
    sortTitle = $localize `:@@SI_SORT_BAR.TITLE:Sort by`;
    /**
     * List of sort criteria.
     */
    sortCriteria;
    /**
     * `key` which sortCriteria is active by default.
     */
    defaultSortCriteria;
    /**
     * Output callback event will provide you with a HttpParams object if active
     * sortCriteria change.
     */
    sortChange = new EventEmitter();
    activeSortCriteria = '';
    sortIsDescending = false;
    ngOnInit() {
        if (this.defaultSortCriteria) {
            this.setActive(this.defaultSortCriteria);
        }
    }
    trackByIndex = (index) => index;
    setActive(key) {
        if (this.activeSortCriteria === key) {
            this.sortIsDescending = !this.sortIsDescending;
        }
        this.activeSortCriteria = key;
        const searchParams = new HttpParams()
            .set('sort', this.activeSortCriteria)
            .set('order', this.sortIsDescending ? 'desc' : 'asc');
        this.sortChange.emit(searchParams);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSortBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiSortBarComponent, selector: "si-sort-bar", inputs: { sortTitle: "sortTitle", sortCriteria: "sortCriteria", defaultSortCriteria: "defaultSortCriteria" }, outputs: { sortChange: "sortChange" }, ngImport: i0, template: "<div class=\"list-header list-header-sorting\">\n  <div class=\"list-title\">{{ sortTitle | translate }}:</div>\n  <div\n    *ngFor=\"let item of sortCriteria; trackBy: trackByIndex\"\n    class=\"sort-item\"\n    tabindex=\"0\"\n    [attr.data-key]=\"item.key\"\n    (click)=\"setActive(item.key)\"\n    (keydown.enter)=\"setActive(item.key)\"\n  >\n    <span>{{ item.name | translate }}</span>\n    <span\n      class=\"icon\"\n      [class.element-sort-up]=\"item.key === activeSortCriteria && !sortIsDescending\"\n      [class.element-sort-down]=\"item.key === activeSortCriteria && sortIsDescending\"\n    ></span>\n  </div>\n</div>\n", styles: [".list-title{font-weight:500;margin-inline-end:5px}.list-header-sorting{background:var(--element-ui-4);padding:6px 12px;display:flex;align-items:center}.sort-item{padding-block:0;padding-inline:5px;cursor:pointer;display:flex;align-items:center}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSortBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-sort-bar', template: "<div class=\"list-header list-header-sorting\">\n  <div class=\"list-title\">{{ sortTitle | translate }}:</div>\n  <div\n    *ngFor=\"let item of sortCriteria; trackBy: trackByIndex\"\n    class=\"sort-item\"\n    tabindex=\"0\"\n    [attr.data-key]=\"item.key\"\n    (click)=\"setActive(item.key)\"\n    (keydown.enter)=\"setActive(item.key)\"\n  >\n    <span>{{ item.name | translate }}</span>\n    <span\n      class=\"icon\"\n      [class.element-sort-up]=\"item.key === activeSortCriteria && !sortIsDescending\"\n      [class.element-sort-down]=\"item.key === activeSortCriteria && sortIsDescending\"\n    ></span>\n  </div>\n</div>\n", styles: [".list-title{font-weight:500;margin-inline-end:5px}.list-header-sorting{background:var(--element-ui-4);padding:6px 12px;display:flex;align-items:center}.sort-item{padding-block:0;padding-inline:5px;cursor:pointer;display:flex;align-items:center}\n"] }]
        }], propDecorators: { sortTitle: [{
                type: Input
            }], sortCriteria: [{
                type: Input,
                args: [{ required: true }]
            }], defaultSortCriteria: [{
                type: Input
            }], sortChange: [{
                type: Output
            }] } });

class SiSortBarModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSortBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiSortBarModule, declarations: [SiSortBarComponent], imports: [CommonModule, SiTranslateModule], exports: [SiSortBarComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSortBarModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSortBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiTranslateModule],
                    declarations: [SiSortBarComponent],
                    exports: [SiSortBarComponent]
                }]
        }] });

class SiCircleStatusComponent {
    /**
     * The status (success, info, warning, danger) to be visualized. Success will not show.
     */
    status;
    /**
     * A custom color (e.g. `#fefefe`) for exceptional cases.
     * @deprecated use the semantic `status` input instead.
     */
    color;
    /**
     * Set a domain type icon (e.g. `element-door`) for which the status shall be shown.
     * Leave undefined for visualizing the status without an icon.
     */
    icon;
    /**
     * event direction is out
     */
    eventOut = false;
    /**
     * Whether the status should appear with a pulsing circle around the badge.
     */
    blink = false;
    /**
     * Blink pulse generator for synchronized blinking with other components
     */
    blinkPulse;
    /**
     * Aria label for icon and status combo. Needed for a11y
     */
    ariaLabel;
    backgroundClass = '';
    theAriaLabel = '';
    statusIcon;
    blinkOn = false;
    contrastFix = false;
    blinkSubs;
    bg;
    blinkService = inject(BlinkService);
    cdRef = inject(ChangeDetectorRef);
    ngOnChanges(changes) {
        if (this.blinkService && changes.blink) {
            this.blinkSubs?.unsubscribe();
            if (this.blink) {
                const pulse = this.blinkPulse ?? this.blinkService.pulse$;
                this.blinkSubs = pulse.subscribe(onOff => {
                    this.blinkOn = onOff;
                    this.cdRef.markForCheck();
                });
            }
            else {
                this.blinkOn = false;
            }
        }
        if (changes.status) {
            this.statusIcon =
                this.status && this.status !== 'success' ? STATUS_ICON[this.status] : undefined;
            this.backgroundClass = this.statusIcon?.background ?? '';
        }
        if (changes.ariaLabel || changes.status || changes.icon) {
            this.calcAriaLabel();
        }
        if (changes.color || changes.blink) {
            queueMicrotask(() => {
                this.cdRef.markForCheck();
                this.contrastFix = !!this.color && this.blink && this.calculateContrastFix();
            });
        }
    }
    ngOnDestroy() {
        this.blinkSubs?.unsubscribe();
    }
    calcAriaLabel() {
        if (this.ariaLabel) {
            this.theAriaLabel = this.ariaLabel;
        }
        else {
            const statusName = this.status && STATUS_ICON[this.status] ? this.status : 'none';
            const direction = this.eventOut ? ' out' : '';
            const iconName = this.icon?.replace('element-', '') ?? '';
            this.theAriaLabel = `${iconName}${this.status && this.icon ? ' in ' : ''}status ${statusName}${direction}`;
        }
    }
    calculateContrastFix() {
        // see https://www.w3.org/TR/AERT/#color-contrast
        const rgb = getComputedStyle(this.bg.nativeElement)
            .backgroundColor?.match(/\d+/g)
            ?.map(v => +v);
        return !!rgb && Math.round((rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000) <= 128;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCircleStatusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiCircleStatusComponent, selector: "si-circle-status", inputs: { status: "status", color: "color", icon: "icon", eventOut: "eventOut", blink: "blink", blinkPulse: "blinkPulse", ariaLabel: "ariaLabel" }, viewQueries: [{ propertyName: "bg", first: true, predicate: ["bg"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"status-indication d-flex align-items-center justify-content-center\"\n  role=\"status\"\n  [class.has-icon]=\"icon\"\n  [attr.aria-label]=\"theAriaLabel | translate\"\n>\n  <div\n    #bg\n    class=\"bg\"\n    [class.pulse]=\"blinkOn\"\n    [class.deprecated-color]=\"!status\"\n    [class.contrast-fix]=\"contrastFix\"\n    [ngClass]=\"backgroundClass\"\n    [style.background-color]=\"color\"\n  ></div>\n  <div *ngIf=\"!status\" class=\"deprecated-dot\" [style.background-color]=\"color\"></div>\n  <si-icon\n    *ngIf=\"statusIcon\"\n    size=\"status-icon\"\n    class=\"indicator\"\n    alt=\"\"\n    [icon]=\"statusIcon.icon\"\n    [color]=\"statusIcon.color\"\n    [stackedIcon]=\"statusIcon.stacked\"\n    [stackedColor]=\"statusIcon.stackedColor\"\n  ></si-icon>\n  <i\n    *ngIf=\"eventOut\"\n    class=\"icon text-body event-out element-right-4 flip-rtl\"\n    role=\"presentation\"\n  ></i>\n  <i *ngIf=\"icon\" class=\"icon position-relative text-body\" role=\"presentation\" [ngClass]=\"icon\"></i>\n</div>\n", styles: [":host{display:inline-block;vertical-align:middle}:host ::ng-deep .status-icon{font-size:24px}.status-indication{position:relative;inline-size:40px;block-size:40px;border-radius:50%;border:1px solid transparent}.status-indication.has-icon{border-color:var(--element-ui-4);background-color:var(--element-base-1);margin-block:6px;margin-inline:0 12px}.status-indication.has-icon .deprecated-dot,.status-indication.has-icon .indicator{position:absolute}.status-indication.has-icon .deprecated-dot{inset-block-start:3px;inset-inline-end:-1px}.status-indication.has-icon .indicator{inset-block-start:-9px;inset-inline-end:-13px}.status-indication>*{pointer-events:none;line-height:0}.event-out{position:absolute;inset-block-end:11px;inset-inline-end:-13px}.bg{position:absolute;inset:0;border-radius:50%;transition:opacity calc(.5s * var(--element-animations-enabled, 1));opacity:0}.pulse.deprecated-color{opacity:.5}.pulse.deprecated-color.contrast-fix{opacity:.25}.pulse:not(.deprecated-color){opacity:1}.deprecated-dot{inline-size:8px;block-size:8px;border-radius:50%}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.SiIconComponent, selector: "si-icon", inputs: ["icon", "color", "stackedIcon", "stackedColor", "alt", "size"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCircleStatusComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-circle-status', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"status-indication d-flex align-items-center justify-content-center\"\n  role=\"status\"\n  [class.has-icon]=\"icon\"\n  [attr.aria-label]=\"theAriaLabel | translate\"\n>\n  <div\n    #bg\n    class=\"bg\"\n    [class.pulse]=\"blinkOn\"\n    [class.deprecated-color]=\"!status\"\n    [class.contrast-fix]=\"contrastFix\"\n    [ngClass]=\"backgroundClass\"\n    [style.background-color]=\"color\"\n  ></div>\n  <div *ngIf=\"!status\" class=\"deprecated-dot\" [style.background-color]=\"color\"></div>\n  <si-icon\n    *ngIf=\"statusIcon\"\n    size=\"status-icon\"\n    class=\"indicator\"\n    alt=\"\"\n    [icon]=\"statusIcon.icon\"\n    [color]=\"statusIcon.color\"\n    [stackedIcon]=\"statusIcon.stacked\"\n    [stackedColor]=\"statusIcon.stackedColor\"\n  ></si-icon>\n  <i\n    *ngIf=\"eventOut\"\n    class=\"icon text-body event-out element-right-4 flip-rtl\"\n    role=\"presentation\"\n  ></i>\n  <i *ngIf=\"icon\" class=\"icon position-relative text-body\" role=\"presentation\" [ngClass]=\"icon\"></i>\n</div>\n", styles: [":host{display:inline-block;vertical-align:middle}:host ::ng-deep .status-icon{font-size:24px}.status-indication{position:relative;inline-size:40px;block-size:40px;border-radius:50%;border:1px solid transparent}.status-indication.has-icon{border-color:var(--element-ui-4);background-color:var(--element-base-1);margin-block:6px;margin-inline:0 12px}.status-indication.has-icon .deprecated-dot,.status-indication.has-icon .indicator{position:absolute}.status-indication.has-icon .deprecated-dot{inset-block-start:3px;inset-inline-end:-1px}.status-indication.has-icon .indicator{inset-block-start:-9px;inset-inline-end:-13px}.status-indication>*{pointer-events:none;line-height:0}.event-out{position:absolute;inset-block-end:11px;inset-inline-end:-13px}.bg{position:absolute;inset:0;border-radius:50%;transition:opacity calc(.5s * var(--element-animations-enabled, 1));opacity:0}.pulse.deprecated-color{opacity:.5}.pulse.deprecated-color.contrast-fix{opacity:.25}.pulse:not(.deprecated-color){opacity:1}.deprecated-dot{inline-size:8px;block-size:8px;border-radius:50%}\n"] }]
        }], propDecorators: { status: [{
                type: Input
            }], color: [{
                type: Input
            }], icon: [{
                type: Input
            }], eventOut: [{
                type: Input
            }], blink: [{
                type: Input
            }], blinkPulse: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], bg: [{
                type: ViewChild,
                args: ['bg']
            }] } });

class SiCircleStatusModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCircleStatusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiCircleStatusModule, declarations: [SiCircleStatusComponent], imports: [CommonModule, SiIconModule, SiTranslateModule], exports: [SiCircleStatusComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCircleStatusModule, imports: [CommonModule, SiIconModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCircleStatusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiIconModule, SiTranslateModule],
                    declarations: [SiCircleStatusComponent],
                    exports: [SiCircleStatusComponent]
                }]
        }] });

class SiTreeViewItemTemplateDirective {
    name;
    template = inject((TemplateRef));
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewItemTemplateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiTreeViewItemTemplateDirective, selector: "[siTreeViewItemTemplate]", inputs: { name: ["siTreeViewItemTemplate", "name"] }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewItemTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siTreeViewItemTemplate]'
                }]
        }], propDecorators: { name: [{
                type: Input,
                args: ['siTreeViewItemTemplate']
            }] } });

class FolderStateEventArgs {
    treeItem;
    oldState;
    newState;
    constructor(treeItem, oldState, newState) {
        this.treeItem = treeItem;
        this.oldState = oldState;
        this.newState = newState;
    }
}
class CheckboxClickEventArgs {
    target;
    oldState;
    newState;
    constructor(target, oldState, newState) {
        this.target = target;
        this.oldState = oldState;
        this.newState = newState;
    }
}
class ClickEventArgs {
    target;
    mouseEvent;
    constructor(target, mouseEvent) {
        this.target = target;
        this.mouseEvent = mouseEvent;
    }
}
class ClickEventArgs2 {
    target;
    itemTop;
    itemHeight;
    constructor(target, itemTop, itemHeight) {
        this.target = target;
        this.itemTop = itemTop;
        this.itemHeight = itemHeight;
    }
}
class LoadChildrenEventArgs {
    treeItem;
    callback;
    constructor(treeItem, callback) {
        this.treeItem = treeItem;
        this.callback = callback;
    }
}
class ItemsVirtualizedArgs {
    treeItems;
    virtualized;
    constructor(treeItems, virtualized) {
        this.treeItems = treeItems;
        this.virtualized = virtualized;
    }
}
const DEFAULT_TREE_ICON_SET = {
    headerHome: 'element-home',
    headerArrow: 'element-left-2 flip-rtl',
    itemMenu: 'element-options-vertical',
    itemCollapsed: 'element-down-2',
    itemCollapsedFlat: 'element-right-2 flip-rtl',
    itemCollapsedLeft: 'element-right-2 flip-rtl',
    itemExpanded: 'element-up-2',
    itemExpandedFlat: 'element-down-3',
    itemExpandedLeft: 'element-down-2'
};
const DEFAULT_CHILDREN_INDENTATION = 14;

const ROOT_LEVEL = -1;
const childrenLoaded = (item) => (item.children?.length ?? 0) > 0;
const hasChildren = (item) => item.state !== 'leaf';
const removeUndefinedState = (state) => state ?? 'collapsed';
/**
 * Collapses the tree item except for leaf items.
 */
const collapse = (item) => {
    if (item?.state !== 'leaf') {
        item.state = 'collapsed';
    }
};
/**
 * Expands the tree item except for leaf items.
 */
const expand = (item) => {
    if (item?.state !== 'leaf') {
        item.state = 'expanded';
    }
};
const expandRecursive = (item) => {
    if (item.parent) {
        expand(item.parent);
        expandRecursive(item.parent);
    }
};
const boxClicked = (treeItem, inheritChecked) => {
    if (treeItem.showCheckbox) {
        treeItem.checked = treeItem.checked === 'checked' ? 'unchecked' : 'checked';
        if (inheritChecked) {
            checkAllChildren(treeItem, treeItem.checked);
            updateCheckStateOfParents(treeItem);
        }
    }
    if (treeItem.showOptionbox && treeItem.checked === 'unchecked') {
        treeItem.parent?.children?.forEach(item => (item.checked = 'unchecked'));
        treeItem.checked = 'checked';
    }
};
/**
 * Changes the folder state to a new state based on the old state.
 * If a client calls this method, the same is responsible to load the children in case the new state is 'expanding'!!!
 *
 * @param deleteChildrenOnCollapse If set to true, the children are deleted upon collapsing the item.
 */
const doFolderStateChange = (item, deleteChildrenOnCollapse, newState) => {
    if (item?.state === 'collapsed' && (!newState || newState === 'expanded')) {
        item.state = childrenLoaded(item) ? 'expanded' : 'expanding';
    }
    else if (item?.state === 'expanding' && (!newState || newState === 'collapsed')) {
        item.state = 'collapsed';
    }
    else if (item?.state === 'expanded' && (!newState || newState === 'collapsed')) {
        if (deleteChildrenOnCollapse) {
            item.children = [];
        }
        item.state = 'collapsed';
    }
};
const enableCheckboxRecursive = (item, enable) => {
    item.showCheckbox = enable;
    if (childrenLoaded(item)) {
        item.children?.forEach(child => enableCheckboxRecursive(child, enable));
    }
};
const enableOptionboxRecursive = (item, enable) => {
    item.showOptionbox = enable;
    if (childrenLoaded(item)) {
        item.children?.forEach(child => enableOptionboxRecursive(child, enable));
    }
};
const parentCountRecursive = (item, stackLevel) => {
    if (item?.parent && item.parent.level !== ROOT_LEVEL) {
        return parentCountRecursive(item.parent, stackLevel + 1);
    }
    return stackLevel;
};
const selectItemsBetween = (roots, start, end) => {
    if (start === end) {
        return;
    }
    const foundItems = [];
    const inBetweenState = { startIsFirst: false, inBetween: false, done: false };
    for (const root of roots) {
        getItemsBetweenRecursive(foundItems, root, start, end, inBetweenState);
        if (inBetweenState.done) {
            break;
        }
    }
    foundItems.forEach(item => {
        if (item.selectable) {
            item.selected = true;
        }
    });
    return foundItems;
};
const selectRecursive = (item, select) => {
    if (item.selectable) {
        item.selected = select;
    }
    if (childrenLoaded(item)) {
        item.children?.forEach(child => selectRecursive(child, select));
    }
};
const setBoxStateRecursive = (item, state) => {
    item.checked = state;
    if (childrenLoaded(item)) {
        item.children?.forEach(child => setBoxStateRecursive(child, state));
    }
};
/**
 * Sets the item to be active or not; all other items of the tree are reset.
 */
const setActive = (item, active) => {
    const getRoot = (treeItem) => treeItem.parent ? getRoot(treeItem.parent) : treeItem;
    resetActive(getRoot(item));
    item.active = active;
};
const resetActive = (item) => {
    item.active = false;
    if (childrenLoaded(item)) {
        item.children?.forEach(childItem => resetActive(childItem));
    }
};
/**
 * Sets the treeItem as selectable or not
 */
const setSelectable = (item, selectable) => {
    item.selectable = selectable;
    if (item.selected && !item.selectable) {
        item.selected = selectable;
    }
};
const deleteItem = (item) => {
    if (item.parent) {
        const idx = item.parent.children?.indexOf(item) ?? -1;
        if (idx < 0) {
            return;
        }
        item.parent.children?.splice(idx, 1);
    }
};
const addChildItem = (parent, child, position, callback) => {
    addChildItems(parent, [child], position, callback);
};
const addChildItems = (parent, children, position, callback) => {
    const itemCount = parent.children?.length ?? 0;
    position ??= itemCount;
    // Negative position insert items counting from the last item
    if (position < 0) {
        position = itemCount + (position % itemCount);
    }
    initializeTreeItemsRecursive(children, parent, callback);
    if (!parent.children) {
        parent.children = [];
        parent.children.push(...children);
        return;
    }
    if (position >= parent.children.length) {
        parent.children.push(...children);
        return;
    }
    parent.children.splice(position, 0, ...children);
};
const initializeTreeItemsRecursive = (items, parent, callback) => {
    const level = (parent.level ?? -1) + 1;
    for (const item of items) {
        item.parent = parent;
        item.level = level;
        setTreeItemDefaults(item, callback);
        if (item.children?.length) {
            initializeTreeItemsRecursive(item.children, item, callback);
        }
    }
};
const setTreeItemDefaults = (item, callback) => {
    item.children ??= [];
    item.state ??= 'collapsed';
    item.active ??= false;
    item.checked ??= 'unchecked';
    item.selected ??= false;
    item.selectable ??= true;
    if (callback) {
        callback(item);
    }
};
const checkAllChildren = (treeItem, check) => {
    if (childrenLoaded(treeItem)) {
        treeItem.children?.forEach(item => {
            item.checked = check;
            checkAllChildren(item, check);
        });
    }
};
const getItemsBetweenRecursive = (found, current, start, end, inBetweenState) => {
    if (inBetweenState.done) {
        return;
    }
    if (current === start && !inBetweenState.inBetween) {
        // This is the first found tree item within the selection, the start tree item (the item which is clicked first) is ordered
        // before the end tree item (the item which is clicked second).
        // The recursive function is from now on handling tree node which are in between the two selections.
        // Note, we don't need to select it, as it is already selected with previous click
        inBetweenState.startIsFirst = true;
        inBetweenState.inBetween = true;
    }
    else if (current === end && !inBetweenState.inBetween) {
        // This is the first found tree item within the selection, the end tree item (the item which is clicked second) is ordered
        // before the start tree item (the item which is clicked first).
        // The recursive function is from now on handling tree node which are in between the two selections.
        inBetweenState.startIsFirst = false;
        inBetweenState.inBetween = true;
        found.push(current);
    }
    else if (current === end && inBetweenState.inBetween) {
        found.push(current);
        inBetweenState.inBetween = false;
        inBetweenState.done = true;
        return; // the end of the search
    }
    else if (current === start && inBetweenState.inBetween) {
        inBetweenState.inBetween = false;
        inBetweenState.done = true;
        return; // the end of the search
    }
    else if (inBetweenState.inBetween) {
        found.push(current);
    }
    if (current.state === 'expanded') {
        current.children?.forEach(item => getItemsBetweenRecursive(found, item, start, end, inBetweenState));
    }
};
const updateCheckStateOfParents = (treeItem) => {
    if (treeItem.parent) {
        let allChecked = true;
        let allUnchecked = true;
        for (const item of treeItem.parent?.children ?? []) {
            if (item.checked === 'indeterminate') {
                treeItem.parent.checked = 'indeterminate';
                updateCheckStateOfParents(treeItem.parent);
                return;
            }
            if (item.checked === 'checked') {
                allUnchecked = false;
            }
            if (item.checked === 'unchecked') {
                allChecked = false;
            }
            if (!allChecked && !allUnchecked) {
                treeItem.parent.checked = 'indeterminate';
                updateCheckStateOfParents(treeItem.parent);
                return;
            }
        }
        if (allChecked) {
            treeItem.parent.checked = 'checked';
        }
        else {
            treeItem.parent.checked = 'unchecked';
        }
        updateCheckStateOfParents(treeItem.parent);
    }
};

/**
 * Supports communication between the TreeViewComponent and the TreeViewItemComponent and the services.
 * Stores tree specific settings.
 * One instance per TreeViewComponent exists.
 */
class SiTreeViewService {
    clickEvent = new Subject();
    contextMenuOpenEvent = new Subject();
    folderClickEvent = new Subject();
    checkboxClickEvent = new Subject();
    loadChildrenEvent = new Subject();
    scrollIntoViewEvent = new Subject();
    inheritChecked = true;
    enableContextMenuButton = true;
    deleteChildrenOnCollapse = false;
    enableSelection = false;
    enableDataField1 = false;
    enableDataField2 = false;
    enableStateIndicator = true;
    enableIcon = true;
    enableCheckbox = false;
    enableOptionbox = false;
    expandOnClick = false;
    flatTree = false;
    singleSelectMode = false;
    childrenIndentation = 14;
    groupedList = false;
    isVirtualized = true;
    folderStateStart = true;
    contextMenuDropUp = false;
    noActionsString = 'No actions available';
    activeContextDropdown;
    triggerMarkForCheck = new Subject();
    isGroupedItem(item) {
        return (!item.parent || item.parent.level === ROOT_LEVEL) && this.groupedList;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewService, decorators: [{
            type: Injectable
        }] });

class SiTreeViewItemComponent {
    element = inject(ElementRef);
    siTreeViewService = inject(SiTreeViewService);
    cdRef = inject(ChangeDetectorRef);
    /**
     * @defaultref {@link _indentLevel}
     */
    set indentLevel(value) {
        this._indentLevel = value;
    }
    treeItem;
    scrollIntoView = new Subject();
    childrenLoaded = new Subject();
    contextMenuAriaLabel;
    templates;
    _contextMenuItems = [];
    /**
     * @defaultref {@link _contextMenuItems}
     */
    set contextMenuItemsProvider(items) {
        this._contextMenuItems = items;
    }
    _noActions = [{ title: this.siTreeViewService.noActionsString, isHeading: true }];
    _hasNoActions = false;
    _contextMenuItemsCurrent;
    get contextMenuItems() {
        if (this._contextMenuItemsCurrent) {
            return this._contextMenuItemsCurrent;
        }
        if (this._contextMenuItems) {
            if (Array.isArray(this._contextMenuItems)) {
                return this._contextMenuItems;
            }
            else {
                this._contextMenuItemsCurrent = this._contextMenuItems(this.treeItem);
                if (!this._contextMenuItemsCurrent?.length) {
                    this._contextMenuItemsCurrent = this._noActions;
                    this._hasNoActions = true;
                }
                return this._contextMenuItemsCurrent;
            }
        }
        else {
            return null;
        }
    }
    get isContextMenuButtonVisible() {
        return (this.enableContextMenuButton &&
            !!this._contextMenuItems &&
            (!Array.isArray(this._contextMenuItems) || !!this._contextMenuItems.length));
    }
    /**
     * @defaultref {@link stickyEndItems}
     * @deprecated Use `stickyEndItems` instead.
     */
    set stickyRightItems(value) {
        this.stickyEndItems = value;
    }
    get stickyRightItems() {
        return this.stickyEndItems;
    }
    stickyEndItems = false;
    displayFolderState = false;
    icons;
    savedElement;
    subscriptions = [];
    _indentLevel = 0;
    nextSiblingElement;
    contextDropdown;
    ngAfterViewInit() {
        if (this.savedElement) {
            this.siTreeViewService.scrollIntoViewEvent.next(this.savedElement);
            this.savedElement = undefined;
        }
        this.nextSiblingElement = this.element.nativeElement?.nextElementSibling;
    }
    ngOnInit() {
        this.subscriptions.push(this.scrollIntoView.subscribe(event => this.onScrollIntoViewByConsumer(event)));
        this.subscriptions.push(this.childrenLoaded.subscribe(event => this.childrenLoadingDone(event)));
        this.subscriptions.push(this.siTreeViewService.triggerMarkForCheck.subscribe(() => this.cdRef.markForCheck()));
    }
    ngOnDestroy() {
        this.subscriptions
            .filter(subscription => !!subscription)
            .forEach(subscription => subscription.unsubscribe());
    }
    get enableSelection() {
        return this.siTreeViewService.enableSelection;
    }
    get enableContextMenuButton() {
        return this.siTreeViewService.enableContextMenuButton;
    }
    get enableDataField1() {
        return this.siTreeViewService.enableDataField1;
    }
    get enableDataField2() {
        return this.siTreeViewService.enableDataField2;
    }
    get deleteChildrenOnCollapse() {
        return this.siTreeViewService.deleteChildrenOnCollapse;
    }
    get paddingStart() {
        return this.siTreeViewService.groupedList
            ? '0'
            : this._indentLevel * this.siTreeViewService.childrenIndentation + 'px';
    }
    get biggerPaddingStart() {
        const basePadding = this.showFolderStateStart ? 24 : 0;
        return ((this.siTreeViewService.groupedList
            ? basePadding
            : this._indentLevel * this.siTreeViewService.childrenIndentation + basePadding) + 'px');
    }
    get isGroupedItem() {
        return this.siTreeViewService.isGroupedItem(this.treeItem);
    }
    get showFolderState() {
        return !this.isFlatTree() && (!!this.isGroupedItem || !this.siTreeViewService.groupedList);
    }
    get showFolderStateStart() {
        return (this.displayFolderState &&
            this.siTreeViewService.folderStateStart &&
            !this.isFlatTree() &&
            (!!this.isGroupedItem || !this.siTreeViewService.groupedList));
    }
    get showFolderStateEnd() {
        return this.displayFolderState && !this.showFolderStateStart;
    }
    get isExpanding() {
        return this.treeItem.state === 'expanding';
    }
    get showStateIndicator() {
        return this.siTreeViewService.enableStateIndicator;
    }
    get showIcon() {
        return this.siTreeViewService.enableIcon && !!this.treeItem.icon;
    }
    get showCheckOrOptionBox() {
        return !!this.treeItem.showCheckbox || !!this.treeItem.showOptionbox;
    }
    getItemFolderStateClass() {
        if (this.treeItem.state === 'collapsed') {
            if (this.siTreeViewService.flatTree) {
                // flat tree mode
                return this.icons.itemCollapsedFlat;
            }
            else if (this.siTreeViewService.folderStateStart) {
                // normal tree mode; folder state icon shown on the left (in LTR) side
                return this.icons.itemCollapsedLeft; // si-tree-view-item-collapsed
            }
            else {
                // normal tree mode; folder state icon shown on the right (in LTR) side
                return this.icons.itemCollapsed; // si-tree-view-item-collapsed
            }
        }
        else if (this.treeItem.state === 'expanding') {
            return 'si-tree-view-item-expanding'; // because empty is treated as disabled
        }
        else if (this.treeItem.state === 'expanded') {
            if (this.siTreeViewService.flatTree) {
                // flat tree mode
                return this.icons.itemExpandedFlat;
            }
            else if (this.siTreeViewService.folderStateStart) {
                // normal tree mode; folder state icon shown on the left (in LTR) side
                return this.icons.itemExpandedLeft; // si-tree-view-item-expanded
            }
            else {
                // normal tree mode; folder state icon shown on the right (in LTR) side
                return this.icons.itemExpanded; // si-tree-view-item-expanded
            }
        }
        return '';
    }
    /**
     * Show filled icon if the item is selected.
     **/
    getIconClass() {
        let iconClass = this.treeItem.icon;
        if (this.treeItem.selected && this.treeItem.selectable && this.enableSelection) {
            iconClass = iconClass + ' ' + iconClass + '-filled';
        }
        return iconClass ?? '';
    }
    getStateIndicatorColor() {
        return this.treeItem ? this.treeItem.stateIndicatorColor ?? '' : '';
    }
    onItemFolderClicked(newState) {
        this.nextSiblingElement = this.element.nativeElement?.nextElementSibling;
        const oldState = removeUndefinedState(this.treeItem.state);
        doFolderStateChange(this.treeItem, this.deleteChildrenOnCollapse, newState);
        this.siTreeViewService.folderClickEvent.next(new FolderStateEventArgs(this.treeItem, oldState, removeUndefinedState(this.treeItem.state)));
        if (this.treeItem.state === 'expanding') {
            this.siTreeViewService.loadChildrenEvent.next(this.treeItem);
        }
        if (this.treeItem.state === 'expanded') {
            this.scrollChildNodeIntoViewPort();
        }
    }
    childrenLoadingDone(item) {
        if (item === this.treeItem) {
            asyncScheduler.schedule(() => this.scrollChildNodeIntoViewPort(), 0);
        }
    }
    scrollChildNodeIntoViewPort() {
        const task = () => {
            const container = this.element.nativeElement.closest('.si-tree-view');
            const first = this.element.nativeElement;
            this.nextSiblingElement =
                this.nextSiblingElement?.previousElementSibling ?? this.nextSiblingElement;
            const last = container?.contains(this.nextSiblingElement)
                ? this.nextSiblingElement
                : this.element.nativeElement.parentElement?.lastElementChild;
            const fits = container?.offsetHeight -
                (last?.offsetTop + last?.getBoundingClientRect().height - first?.offsetTop) >=
                0;
            const targetElement = fits ? last : first;
            if (targetElement) {
                const observer = new window.IntersectionObserver(([entry]) => {
                    requestAnimationFrame(() => {
                        const scrollElement = targetElement.firstChild ?? targetElement;
                        if (fits) {
                            scrollElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                        }
                        else {
                            // scrollIntoView messes up with page scroll when body also has a scroll for { block : 'start' }
                            const totalScrollTop = container?.scrollTop +
                                first?.getBoundingClientRect().top -
                                container?.getBoundingClientRect().top;
                            container?.scrollTo({ top: totalScrollTop, behavior: 'smooth' });
                        }
                    });
                    observer.disconnect();
                }, {
                    root: null,
                    threshold: 1
                });
                observer.observe(targetElement);
            }
        };
        asyncScheduler.schedule(task, 0);
    }
    onItemClicked(event) {
        const previousActive = this.treeItem.active;
        this.siTreeViewService.clickEvent.next(new ClickEventArgs(this.treeItem, event));
        if (!this.siTreeViewService.enableSelection &&
            (this.siTreeViewService.enableCheckbox || this.siTreeViewService.enableOptionbox)) {
            this.onBoxClicked();
        }
        // Toggle expand when item is collapsed, collapse only if the node is active
        const toggle = (this.treeItem.state === 'expanded' && previousActive) || this.treeItem.state === 'collapsed';
        if (this.expandOnClick() && toggle) {
            this.onItemFolderClicked();
        }
    }
    onMouseDownTreeItem(event) {
        if (event.shiftKey) {
            // let selection: Selection = window.getSelection();
            // selection.removeAllRanges();
            // we do not want the tree item text selected: thus we prevent the default behavior in this situation
            event.preventDefault();
        }
    }
    onToggleContextMenu(state) {
        if (state) {
            const elRect = this.element.nativeElement.getBoundingClientRect();
            this.siTreeViewService.contextMenuOpenEvent.next(new ClickEventArgs2(this.treeItem, elRect.top, elRect.height));
            this.siTreeViewService.activeContextDropdown = this.contextDropdown;
        }
        else {
            if (this._contextMenuItemsCurrent) {
                this._contextMenuItemsCurrent = undefined;
                this._hasNoActions = false;
            }
            this.element.nativeElement.focus();
        }
    }
    getInputType() {
        // This method will be called only when either of the showCheckbox or showOptionBox is true, thus
        // following condition can be shortened
        return this.treeItem.showCheckbox ? 'checkbox' : 'radio';
    }
    onBoxClicked() {
        if (!this.treeItem.selectable) {
            return;
        }
        const oldState = this.treeItem.checked ?? 'unchecked';
        boxClicked(this.treeItem, this.siTreeViewService.inheritChecked);
        this.siTreeViewService.checkboxClickEvent.next(new CheckboxClickEventArgs(this.treeItem, oldState, this.treeItem.checked ?? 'unchecked'));
    }
    renderMatchingTemplate(treeItem) {
        const templateDirective = this.templates.find(td => td.name === treeItem.templateName);
        return templateDirective ? templateDirective.template : this.templates.toArray()[0].template;
    }
    onContextMenu(event) {
        this.handleContextMenuEvent(event);
    }
    onKeydown(event) {
        const rtlCorrectedKey = correctKeyRTL(event.key);
        if (rtlCorrectedKey === 'Enter') {
            event.preventDefault();
            if (this.contextDropdown?.isOpen) {
                if (this._hasNoActions) {
                    this.contextDropdown?.close();
                }
            }
            else {
                this.onItemClicked(event);
            }
        }
        else if (rtlCorrectedKey === 'ContextMenu' || (rtlCorrectedKey === 'F10' && event.shiftKey)) {
            this.handleContextMenuEvent(event);
        }
        else if (rtlCorrectedKey === 'ArrowLeft' && !this.contextDropdown?.isOpen) {
            if ((!this.isFlatTree() &&
                this.showFolderStateStart &&
                (this.treeItem.state !== 'leaf' || this.isGroupedItem)) ||
                this.showFolderStateEnd) {
                event.preventDefault();
                this.onItemFolderClicked('collapsed');
            }
        }
        else if (rtlCorrectedKey === 'ArrowRight' && !this.contextDropdown?.isOpen) {
            if ((this.showFolderStateStart && (this.treeItem.state !== 'leaf' || this.isGroupedItem)) ||
                this.showFolderStateEnd) {
                event.preventDefault();
                this.onItemFolderClicked('expanded');
            }
        }
        else if (this.showCheckOrOptionBox &&
            (rtlCorrectedKey === 'Space' || rtlCorrectedKey === ' ')) {
            event.preventDefault();
            this.onBoxClicked();
        }
    }
    handleContextMenuEvent(event) {
        if (this.isContextMenuButtonVisible) {
            event.preventDefault();
            this.contextDropdown?.toggle();
            // Ensure just on context menu shall be visible at the time.
            if (this.contextDropdown !== this.siTreeViewService.activeContextDropdown) {
                this.siTreeViewService.activeContextDropdown?.close();
            }
            this.siTreeViewService.activeContextDropdown = this.contextDropdown;
            const windowContextMenuHandler = (contextMenuEvent) => {
                contextMenuEvent.preventDefault();
                window.removeEventListener('contextmenu', windowContextMenuHandler);
            };
            window.addEventListener('contextmenu', windowContextMenuHandler);
        }
    }
    isFlatTree() {
        return this.siTreeViewService.flatTree;
    }
    /**
     * Called by the consumer when they want a node to be scrolled into view.
     */
    onScrollIntoViewByConsumer(item) {
        if (item === this.treeItem) {
            this.savedElement = this.element;
            this.siTreeViewService.scrollIntoViewEvent.next(this.element);
        }
    }
    expandOnClick() {
        return (this.siTreeViewService.expandOnClick &&
            this.treeItem.state !== 'leaf' &&
            !!this.treeItem.selectable &&
            !this.siTreeViewService.flatTree);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiTreeViewItemComponent, selector: "si-tree-view-item", inputs: { indentLevel: "indentLevel", treeItem: "treeItem", scrollIntoView: "scrollIntoView", childrenLoaded: "childrenLoaded", contextMenuAriaLabel: "contextMenuAriaLabel", templates: "templates", contextMenuItemsProvider: "contextMenuItemsProvider", stickyRightItems: "stickyRightItems", stickyEndItems: "stickyEndItems", displayFolderState: "displayFolderState", icons: "icons" }, host: { listeners: { "contextmenu": "onContextMenu($event)", "keydown": "onKeydown($event)" } }, viewQueries: [{ propertyName: "contextDropdown", first: true, predicate: ["contextDropdown"], descendants: true }], ngImport: i0, template: "<div\n  *ngIf=\"!isGroupedItem\"\n  class=\"si-tree-view-li si-tree-view-li-item focus-direct-sub-inside\"\n  [class.si-tree-view-item-context-menu-visible]=\"contextDropdown?.isOpen ?? false\"\n  [class.si-tree-view-item-active]=\"treeItem.active\"\n  [class.si-tree-view-item-selected]=\"enableSelection && treeItem.selected\"\n  [class.si-tree-view-item-not-selectable]=\"!treeItem.selectable\"\n  [attr.aria-disabled]=\"!treeItem.selectable\"\n  [style.padding-inline-start]=\"biggerPaddingStart\"\n>\n  <div class=\"si-tree-view-item\" (mousedown)=\"onMouseDownTreeItem($event)\">\n    <a\n      *ngIf=\"showFolderStateStart && treeItem.state !== 'leaf'\"\n      class=\"si-tree-stretch-center si-tree-view-item-toggle\"\n      tabindex=\"-1\"\n      [style.margin-inline-start]=\"'-' + biggerPaddingStart\"\n      [style.padding-inline-start]=\"paddingStart\"\n      (click)=\"onItemFolderClicked()\"\n    >\n      <si-loading-spinner *ngIf=\"isExpanding\"></si-loading-spinner>\n      <i\n        *ngIf=\"!isExpanding\"\n        class=\"si-tree-view-item-dropdown-caret\"\n        [ngClass]=\"getItemFolderStateClass()\"\n      ></i>\n    </a>\n\n    <a *ngIf=\"showCheckOrOptionBox\" class=\"form-check input-box\" tabindex=\"-1\">\n      <input\n        class=\"form-check-input\"\n        tabindex=\"-1\"\n        [type]=\"getInputType()\"\n        [indeterminate]=\"this.treeItem.checked === 'indeterminate' ? true : null\"\n        [checked]=\"this.treeItem.checked === 'checked'\"\n        [disabled]=\"!treeItem.selectable\"\n        [attr.aria-label]=\"treeItem.label ?? '' | translate\"\n        (click)=\"onBoxClicked()\"\n      />\n    </a>\n\n    <div\n      class=\"si-tree-view-item-main d-flex flex-grow-1 align-self-stretch\"\n      (click)=\"onItemClicked($event)\"\n    >\n      <div *ngIf=\"showIcon\" class=\"si-tree-stretch-center\">\n        <span class=\"si-tree-view-item-icon\" [ngClass]=\"getIconClass()\"></span>\n      </div>\n\n      <div class=\"si-tree-view-item-object-data d-flex flex-column justify-content-center\">\n        <h5 *ngIf=\"!templates?.length\">{{ treeItem.label ?? '' | translate }}</h5>\n        <div *ngIf=\"templates?.length\">\n          <ng-container\n            *ngTemplateOutlet=\"renderMatchingTemplate(treeItem); context: { $implicit: treeItem }\"\n          ></ng-container>\n        </div>\n        <p\n          *ngIf=\"enableDataField1 && treeItem.dataField1\"\n          class=\"si-tree-view-item-object-data-field-1\"\n          >{{ treeItem.dataField1 | translate }}</p\n        >\n        <p\n          *ngIf=\"enableDataField2 && treeItem.dataField2\"\n          class=\"si-tree-view-item-object-data-field-2\"\n          >{{ treeItem.dataField2 | translate }}</p\n        >\n      </div>\n\n      <span\n        *ngIf=\"treeItem.badge\"\n        class=\"badge flex-shrink-0\"\n        [ngClass]=\"'bg-' + (treeItem.badgeColor || 'default')\"\n        >{{ treeItem.badge }}</span\n      >\n    </div>\n\n    <div\n      class=\"si-tree-view-item-end-icons d-flex ms-2 align-items-center\"\n      [class.si-tree-view-item-end-icons-sticky]=\"stickyEndItems\"\n    >\n      <div\n        *ngIf=\"showStateIndicator\"\n        class=\"si-tree-view-state-indicator\"\n        [style.background-color]=\"getStateIndicatorColor()\"\n        [class.si-tree-view-state-indicator-endmost]=\"\n          !enableContextMenuButton && !showFolderStateEnd\n        \"\n      ></div>\n      <div\n        *ngIf=\"isContextMenuButtonVisible\"\n        #contextDropdown=\"si-dropdown\"\n        siDropdown\n        dropdownContainer=\"body\"\n        dropdownDirection=\"down\"\n        dropdownAlign=\"end\"\n        class=\"si-tree-stretch-center si-tree-context-menu-btn\"\n        [dropdownResponsiveDirection]=\"true\"\n        [dropdownResponsiveDirectionToPlacement]=\"false\"\n        [dropdownIsDisabled]=\"!treeItem.selectable\"\n        [dropdownFocusOnClose]=\"false\"\n        (dropdownOnToggle)=\"onToggleContextMenu($event)\"\n      >\n        <div siDropdownToggle role=\"button\" [attr.aria-label]=\"contextMenuAriaLabel | translate\">\n          <i class=\"si-tree-view-item-icon si-tree-view-menu-btn\" [ngClass]=\"icons.itemMenu\"></i>\n        </div>\n        <si-menu\n          *ngIf=\"contextDropdown?.isOpen ?? false\"\n          siDropdownMenu\n          class=\"me-5\"\n          [items]=\"contextMenuItems!\"\n          [dropstart]=\"true\"\n          [actionParam]=\"treeItem\"\n          [focusOnLoad]=\"true\"\n        ></si-menu>\n      </div>\n      <a\n        *ngIf=\"showFolderStateEnd && treeItem.state !== 'leaf'\"\n        class=\"si-tree-stretch-center si-tree-view-item-toggle si-tree-view-item-toggle-end\"\n        tabindex=\"-1\"\n        [class.disabled]=\"!getItemFolderStateClass()\"\n        (click)=\"onItemFolderClicked()\"\n      >\n        <si-loading-spinner *ngIf=\"isExpanding\" class=\"si-tree-view-item-icon\"></si-loading-spinner>\n        <i\n          *ngIf=\"!isExpanding\"\n          class=\"si-tree-view-item-icon\"\n          [ngClass]=\"getItemFolderStateClass()\"\n        ></i>\n      </a>\n      <div\n        *ngIf=\"showFolderStateEnd && treeItem.state === 'leaf'\"\n        class=\"si-tree-stretch-center si-tree-view-item-toggle si-tree-view-item-toggle-end\"\n      >\n        <i class=\"si-tree-view-item-icon si-tree-view-item-icon-spacer\"></i>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"isGroupedItem\" class=\"si-tree-view-li focus-direct-sub-inside\">\n  <div class=\"si-tree-view-item-group\">\n    <a\n      *ngIf=\"showFolderStateStart\"\n      class=\"si-tree-stretch-center si-tree-view-item-toggle\"\n      tabindex=\"-1\"\n      (click)=\"onItemFolderClicked()\"\n    >\n      <si-loading-spinner *ngIf=\"isExpanding\"></si-loading-spinner>\n      <i\n        *ngIf=\"!isExpanding\"\n        class=\"si-tree-view-item-icon\"\n        [ngClass]=\"getItemFolderStateClass()\"\n      ></i>\n    </a>\n    <a *ngIf=\"showCheckOrOptionBox\" class=\"form-check input-box\" tabindex=\"-1\">\n      <input\n        class=\"form-check-input\"\n        tabindex=\"-1\"\n        [type]=\"getInputType()\"\n        [indeterminate]=\"this.treeItem.checked === 'indeterminate' ? true : null\"\n        [checked]=\"this.treeItem.checked === 'checked'\"\n        [attr.aria-label]=\"treeItem.label ?? '' | translate\"\n        (click)=\"onBoxClicked()\"\n      />\n    </a>\n    <p class=\"mb-0\">{{ treeItem.label ?? '' | translate }}</p>\n    <a\n      *ngIf=\"showFolderStateEnd\"\n      class=\"si-tree-stretch-center\"\n      tabindex=\"-1\"\n      [class.disabled]=\"!getItemFolderStateClass()\"\n      (click)=\"onItemFolderClicked()\"\n    >\n      <si-loading-spinner *ngIf=\"isExpanding\"></si-loading-spinner>\n      <i\n        *ngIf=\"!isExpanding\"\n        class=\"si-tree-view-item-icon\"\n        [ngClass]=\"getItemFolderStateClass()\"\n      ></i>\n    </a>\n  </div>\n</div>\n", styles: [":host.si-tree-view-top-level-item>.si-tree-view-li{margin-block:var(--si-tree-view-padding-base-vertical)}:host.si-tree-view-top-level-item+::ng-deep .si-tree-view-top-level-item>.si-tree-view-li{margin-block-start:0}.si-tree-view-li.si-tree-view-li-item{position:relative}.si-tree-view-li.si-tree-view-li-item:hover,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-context-menu-visible,.si-tree-view-li.si-tree-view-li-item:hover .si-tree-view-item-end-icons,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-context-menu-visible .si-tree-view-item-end-icons{background-color:var(--si-tree-view-item-hover-color)}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-selected,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-selected .si-tree-view-item-end-icons{background-color:var(--si-tree-view-item-select-color)}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-selected>.si-tree-view-item>.si-tree-view-item-main>.si-tree-view-item-object-data>h5{font-weight:700}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable h5,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-icon,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-object-data-field-1{color:var(--element-text-disabled)}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable:hover,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-end-icons{background-color:unset}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item:hover,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-context-menu-btn>div[role=button]:hover{background-color:unset;cursor:default}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-dropdown-caret,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-toggle-end{cursor:pointer}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-toggle-end .si-tree-view-item-icon{color:var(--element-text-primary)}.si-tree-view-li.si-tree-view-li-item .si-tree-view-item-end-icons{background-color:var(--si-tree-view-background)}.si-tree-view-item-group,.si-tree-view-item{display:flex;align-items:center}.si-tree-stretch-center{align-self:stretch;display:flex;align-items:center;justify-content:center;margin:0;text-decoration:none}.si-tree-view-item-toggle.disabled .si-tree-view-item-icon{inline-size:24px}.si-tree-stretch-center+.si-tree-view-item-toggle-end .si-tree-view-item-icon{margin-inline-start:-4px}.si-tree-view-item-icon{padding-inline-end:8px}.si-tree-view-item-icon.si-tree-view-item-icon-spacer{box-sizing:content-box;inline-size:var(--si-tree-view-icon-size)}.si-tree-view-item-object-data,.si-tree-view-item-icon{margin-block:0;margin-inline:calc(var(--si-tree-view-padding-base-horizontal) / 4)}.si-tree-view-item{justify-content:space-between;cursor:pointer;min-block-size:var(--si-tree-view-item-min-height);padding-inline:var(--si-tree-view-padding-base-horizontal) calc(var(--si-tree-view-padding-base-horizontal) / 4)}:host-context(.si-tree-view-flat) .si-tree-view-item{padding-inline-start:calc(var(--si-tree-view-padding-base-horizontal) / 2)}.si-tree-view-state-indicator{margin-block:0;margin-inline:calc(var(--si-tree-view-padding-base-horizontal) * .75);min-inline-size:6px;block-size:6px;border-radius:50%}.si-tree-view-state-indicator.si-tree-view-state-indicator-endmost{margin-inline-end:calc(var(--si-tree-view-padding-base-horizontal) * 1.75)}.si-tree-view-item-group{padding-block:calc(2 * var(--si-tree-view-padding-base-vertical));padding-inline:calc(var(--si-tree-view-padding-base-horizontal) / 2);cursor:default}.si-tree-view-item-group .si-tree-view-item-dropdown-caret:hover,.si-tree-view-item-group .si-tree-view-item-icon:hover{cursor:pointer}.si-tree-view-item-dropdown-caret,.si-tree-view-item-dropdown-caret:hover,.si-tree-view-item-icon,.si-tree-view-item-icon:hover{color:var(--element-text-primary);text-decoration:none;font-size:var(--si-tree-view-icon-size)}.si-tree-view-item-main{overflow-x:hidden}.si-tree-view-item-main>.badge{margin-block:auto}.si-tree-view-item-object-data>.si-tree-view-item-object-data-field-1{color:var(--si-tree-view-item-object-data-field-1-color)}:host.si-tree-ellipsis .si-tree-view-item-object-data{overflow-x:hidden}.si-tree-view-item-object-data>*{white-space:nowrap;margin-block:0;line-height:var(--si-tree-view-item-line-height)}:host.si-tree-ellipsis .si-tree-view-item-object-data>*{overflow:hidden;text-overflow:ellipsis}.si-tree-view-item-object-data>h5{font-size:var(--si-tree-view-item-object-data-h5-font-size);font-weight:var(--si-tree-view-item-object-data-h5-font-weight)}.si-tree-view-menu-btn{pointer-events:none}.si-tree-view-item-end-icons{block-size:calc(var(--si-tree-view-item-min-height) - 2 * (var(--element-button-focus-width) + var(--element-button-focus-overlay-width)))}.si-tree-view-item-end-icons.si-tree-view-item-end-icons-sticky{position:sticky;inset-inline-end:0}.input-box{margin-inline:2px 12px}.form-check-input{inset-block-start:2px}si-loading-spinner{--loading-spinner-size: var(--si-tree-view-icon-size)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$4.SiDropdownDirective, selector: "[siDropdown]", inputs: ["dropdownIsDisabled", "dropdownIsOpen", "dropdownOpenOnLoad", "dropdownCloseOnSelect", "dropdownCloseOnClickOut", "dropdownCloseOnEsc", "dropdownDirection", "dropdownAlign", "dropdownContainer", "dropdownResponsiveDirection", "dropdownResponsiveDirectionToPlacement", "dropdownPlacement", "dropdownPlacementReference", "dropdownItemSelector", "dropdownItemSelectorException", "dropdownFocusOnOpen", "dropdownFocusOnClose", "closeOnMenuScrollOut", "closeOnPlacementReferenceScrollOut"], outputs: ["dropdownOnToggle", "dropdownOnSelect", "dropdownResponsiveDirectionChange"], exportAs: ["si-dropdown"] }, { kind: "directive", type: i2$4.SiDropdownMenuDirective, selector: "[siDropdownMenu]", inputs: ["tabindex"], exportAs: ["si-dropdown-menu"] }, { kind: "directive", type: i2$4.SiDropdownToggleDirective, selector: "[siDropdownToggle]", exportAs: ["si-dropdown-toggle"] }, { kind: "component", type: i3$1.SiLoadingSpinnerComponent, selector: "si-loading-spinner", inputs: ["isBlockingSpinner", "isSpinnerOverlay", "ariaLabel"] }, { kind: "component", type: i3$2.SiMenuComponent, selector: "si-menu", inputs: ["items", "dropleft", "dropstart", "responsiveDropleft", "responsiveDropstart", "responsivelyDropUpwards", "actionParam", "focusOnLoad", "focus", "focusLastFromParent", "isSubList", "parentItem", "refocusAfterEnter", "position", "autofocusFromParent", "relativePositioning", "forceTitle"], outputs: ["activeChange"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-tree-view-item', template: "<div\n  *ngIf=\"!isGroupedItem\"\n  class=\"si-tree-view-li si-tree-view-li-item focus-direct-sub-inside\"\n  [class.si-tree-view-item-context-menu-visible]=\"contextDropdown?.isOpen ?? false\"\n  [class.si-tree-view-item-active]=\"treeItem.active\"\n  [class.si-tree-view-item-selected]=\"enableSelection && treeItem.selected\"\n  [class.si-tree-view-item-not-selectable]=\"!treeItem.selectable\"\n  [attr.aria-disabled]=\"!treeItem.selectable\"\n  [style.padding-inline-start]=\"biggerPaddingStart\"\n>\n  <div class=\"si-tree-view-item\" (mousedown)=\"onMouseDownTreeItem($event)\">\n    <a\n      *ngIf=\"showFolderStateStart && treeItem.state !== 'leaf'\"\n      class=\"si-tree-stretch-center si-tree-view-item-toggle\"\n      tabindex=\"-1\"\n      [style.margin-inline-start]=\"'-' + biggerPaddingStart\"\n      [style.padding-inline-start]=\"paddingStart\"\n      (click)=\"onItemFolderClicked()\"\n    >\n      <si-loading-spinner *ngIf=\"isExpanding\"></si-loading-spinner>\n      <i\n        *ngIf=\"!isExpanding\"\n        class=\"si-tree-view-item-dropdown-caret\"\n        [ngClass]=\"getItemFolderStateClass()\"\n      ></i>\n    </a>\n\n    <a *ngIf=\"showCheckOrOptionBox\" class=\"form-check input-box\" tabindex=\"-1\">\n      <input\n        class=\"form-check-input\"\n        tabindex=\"-1\"\n        [type]=\"getInputType()\"\n        [indeterminate]=\"this.treeItem.checked === 'indeterminate' ? true : null\"\n        [checked]=\"this.treeItem.checked === 'checked'\"\n        [disabled]=\"!treeItem.selectable\"\n        [attr.aria-label]=\"treeItem.label ?? '' | translate\"\n        (click)=\"onBoxClicked()\"\n      />\n    </a>\n\n    <div\n      class=\"si-tree-view-item-main d-flex flex-grow-1 align-self-stretch\"\n      (click)=\"onItemClicked($event)\"\n    >\n      <div *ngIf=\"showIcon\" class=\"si-tree-stretch-center\">\n        <span class=\"si-tree-view-item-icon\" [ngClass]=\"getIconClass()\"></span>\n      </div>\n\n      <div class=\"si-tree-view-item-object-data d-flex flex-column justify-content-center\">\n        <h5 *ngIf=\"!templates?.length\">{{ treeItem.label ?? '' | translate }}</h5>\n        <div *ngIf=\"templates?.length\">\n          <ng-container\n            *ngTemplateOutlet=\"renderMatchingTemplate(treeItem); context: { $implicit: treeItem }\"\n          ></ng-container>\n        </div>\n        <p\n          *ngIf=\"enableDataField1 && treeItem.dataField1\"\n          class=\"si-tree-view-item-object-data-field-1\"\n          >{{ treeItem.dataField1 | translate }}</p\n        >\n        <p\n          *ngIf=\"enableDataField2 && treeItem.dataField2\"\n          class=\"si-tree-view-item-object-data-field-2\"\n          >{{ treeItem.dataField2 | translate }}</p\n        >\n      </div>\n\n      <span\n        *ngIf=\"treeItem.badge\"\n        class=\"badge flex-shrink-0\"\n        [ngClass]=\"'bg-' + (treeItem.badgeColor || 'default')\"\n        >{{ treeItem.badge }}</span\n      >\n    </div>\n\n    <div\n      class=\"si-tree-view-item-end-icons d-flex ms-2 align-items-center\"\n      [class.si-tree-view-item-end-icons-sticky]=\"stickyEndItems\"\n    >\n      <div\n        *ngIf=\"showStateIndicator\"\n        class=\"si-tree-view-state-indicator\"\n        [style.background-color]=\"getStateIndicatorColor()\"\n        [class.si-tree-view-state-indicator-endmost]=\"\n          !enableContextMenuButton && !showFolderStateEnd\n        \"\n      ></div>\n      <div\n        *ngIf=\"isContextMenuButtonVisible\"\n        #contextDropdown=\"si-dropdown\"\n        siDropdown\n        dropdownContainer=\"body\"\n        dropdownDirection=\"down\"\n        dropdownAlign=\"end\"\n        class=\"si-tree-stretch-center si-tree-context-menu-btn\"\n        [dropdownResponsiveDirection]=\"true\"\n        [dropdownResponsiveDirectionToPlacement]=\"false\"\n        [dropdownIsDisabled]=\"!treeItem.selectable\"\n        [dropdownFocusOnClose]=\"false\"\n        (dropdownOnToggle)=\"onToggleContextMenu($event)\"\n      >\n        <div siDropdownToggle role=\"button\" [attr.aria-label]=\"contextMenuAriaLabel | translate\">\n          <i class=\"si-tree-view-item-icon si-tree-view-menu-btn\" [ngClass]=\"icons.itemMenu\"></i>\n        </div>\n        <si-menu\n          *ngIf=\"contextDropdown?.isOpen ?? false\"\n          siDropdownMenu\n          class=\"me-5\"\n          [items]=\"contextMenuItems!\"\n          [dropstart]=\"true\"\n          [actionParam]=\"treeItem\"\n          [focusOnLoad]=\"true\"\n        ></si-menu>\n      </div>\n      <a\n        *ngIf=\"showFolderStateEnd && treeItem.state !== 'leaf'\"\n        class=\"si-tree-stretch-center si-tree-view-item-toggle si-tree-view-item-toggle-end\"\n        tabindex=\"-1\"\n        [class.disabled]=\"!getItemFolderStateClass()\"\n        (click)=\"onItemFolderClicked()\"\n      >\n        <si-loading-spinner *ngIf=\"isExpanding\" class=\"si-tree-view-item-icon\"></si-loading-spinner>\n        <i\n          *ngIf=\"!isExpanding\"\n          class=\"si-tree-view-item-icon\"\n          [ngClass]=\"getItemFolderStateClass()\"\n        ></i>\n      </a>\n      <div\n        *ngIf=\"showFolderStateEnd && treeItem.state === 'leaf'\"\n        class=\"si-tree-stretch-center si-tree-view-item-toggle si-tree-view-item-toggle-end\"\n      >\n        <i class=\"si-tree-view-item-icon si-tree-view-item-icon-spacer\"></i>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"isGroupedItem\" class=\"si-tree-view-li focus-direct-sub-inside\">\n  <div class=\"si-tree-view-item-group\">\n    <a\n      *ngIf=\"showFolderStateStart\"\n      class=\"si-tree-stretch-center si-tree-view-item-toggle\"\n      tabindex=\"-1\"\n      (click)=\"onItemFolderClicked()\"\n    >\n      <si-loading-spinner *ngIf=\"isExpanding\"></si-loading-spinner>\n      <i\n        *ngIf=\"!isExpanding\"\n        class=\"si-tree-view-item-icon\"\n        [ngClass]=\"getItemFolderStateClass()\"\n      ></i>\n    </a>\n    <a *ngIf=\"showCheckOrOptionBox\" class=\"form-check input-box\" tabindex=\"-1\">\n      <input\n        class=\"form-check-input\"\n        tabindex=\"-1\"\n        [type]=\"getInputType()\"\n        [indeterminate]=\"this.treeItem.checked === 'indeterminate' ? true : null\"\n        [checked]=\"this.treeItem.checked === 'checked'\"\n        [attr.aria-label]=\"treeItem.label ?? '' | translate\"\n        (click)=\"onBoxClicked()\"\n      />\n    </a>\n    <p class=\"mb-0\">{{ treeItem.label ?? '' | translate }}</p>\n    <a\n      *ngIf=\"showFolderStateEnd\"\n      class=\"si-tree-stretch-center\"\n      tabindex=\"-1\"\n      [class.disabled]=\"!getItemFolderStateClass()\"\n      (click)=\"onItemFolderClicked()\"\n    >\n      <si-loading-spinner *ngIf=\"isExpanding\"></si-loading-spinner>\n      <i\n        *ngIf=\"!isExpanding\"\n        class=\"si-tree-view-item-icon\"\n        [ngClass]=\"getItemFolderStateClass()\"\n      ></i>\n    </a>\n  </div>\n</div>\n", styles: [":host.si-tree-view-top-level-item>.si-tree-view-li{margin-block:var(--si-tree-view-padding-base-vertical)}:host.si-tree-view-top-level-item+::ng-deep .si-tree-view-top-level-item>.si-tree-view-li{margin-block-start:0}.si-tree-view-li.si-tree-view-li-item{position:relative}.si-tree-view-li.si-tree-view-li-item:hover,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-context-menu-visible,.si-tree-view-li.si-tree-view-li-item:hover .si-tree-view-item-end-icons,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-context-menu-visible .si-tree-view-item-end-icons{background-color:var(--si-tree-view-item-hover-color)}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-selected,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-selected .si-tree-view-item-end-icons{background-color:var(--si-tree-view-item-select-color)}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-selected>.si-tree-view-item>.si-tree-view-item-main>.si-tree-view-item-object-data>h5{font-weight:700}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable h5,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-icon,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-object-data-field-1{color:var(--element-text-disabled)}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable:hover,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-end-icons{background-color:unset}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item:hover,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-context-menu-btn>div[role=button]:hover{background-color:unset;cursor:default}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-dropdown-caret,.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-toggle-end{cursor:pointer}.si-tree-view-li.si-tree-view-li-item.si-tree-view-item-not-selectable .si-tree-view-item-toggle-end .si-tree-view-item-icon{color:var(--element-text-primary)}.si-tree-view-li.si-tree-view-li-item .si-tree-view-item-end-icons{background-color:var(--si-tree-view-background)}.si-tree-view-item-group,.si-tree-view-item{display:flex;align-items:center}.si-tree-stretch-center{align-self:stretch;display:flex;align-items:center;justify-content:center;margin:0;text-decoration:none}.si-tree-view-item-toggle.disabled .si-tree-view-item-icon{inline-size:24px}.si-tree-stretch-center+.si-tree-view-item-toggle-end .si-tree-view-item-icon{margin-inline-start:-4px}.si-tree-view-item-icon{padding-inline-end:8px}.si-tree-view-item-icon.si-tree-view-item-icon-spacer{box-sizing:content-box;inline-size:var(--si-tree-view-icon-size)}.si-tree-view-item-object-data,.si-tree-view-item-icon{margin-block:0;margin-inline:calc(var(--si-tree-view-padding-base-horizontal) / 4)}.si-tree-view-item{justify-content:space-between;cursor:pointer;min-block-size:var(--si-tree-view-item-min-height);padding-inline:var(--si-tree-view-padding-base-horizontal) calc(var(--si-tree-view-padding-base-horizontal) / 4)}:host-context(.si-tree-view-flat) .si-tree-view-item{padding-inline-start:calc(var(--si-tree-view-padding-base-horizontal) / 2)}.si-tree-view-state-indicator{margin-block:0;margin-inline:calc(var(--si-tree-view-padding-base-horizontal) * .75);min-inline-size:6px;block-size:6px;border-radius:50%}.si-tree-view-state-indicator.si-tree-view-state-indicator-endmost{margin-inline-end:calc(var(--si-tree-view-padding-base-horizontal) * 1.75)}.si-tree-view-item-group{padding-block:calc(2 * var(--si-tree-view-padding-base-vertical));padding-inline:calc(var(--si-tree-view-padding-base-horizontal) / 2);cursor:default}.si-tree-view-item-group .si-tree-view-item-dropdown-caret:hover,.si-tree-view-item-group .si-tree-view-item-icon:hover{cursor:pointer}.si-tree-view-item-dropdown-caret,.si-tree-view-item-dropdown-caret:hover,.si-tree-view-item-icon,.si-tree-view-item-icon:hover{color:var(--element-text-primary);text-decoration:none;font-size:var(--si-tree-view-icon-size)}.si-tree-view-item-main{overflow-x:hidden}.si-tree-view-item-main>.badge{margin-block:auto}.si-tree-view-item-object-data>.si-tree-view-item-object-data-field-1{color:var(--si-tree-view-item-object-data-field-1-color)}:host.si-tree-ellipsis .si-tree-view-item-object-data{overflow-x:hidden}.si-tree-view-item-object-data>*{white-space:nowrap;margin-block:0;line-height:var(--si-tree-view-item-line-height)}:host.si-tree-ellipsis .si-tree-view-item-object-data>*{overflow:hidden;text-overflow:ellipsis}.si-tree-view-item-object-data>h5{font-size:var(--si-tree-view-item-object-data-h5-font-size);font-weight:var(--si-tree-view-item-object-data-h5-font-weight)}.si-tree-view-menu-btn{pointer-events:none}.si-tree-view-item-end-icons{block-size:calc(var(--si-tree-view-item-min-height) - 2 * (var(--element-button-focus-width) + var(--element-button-focus-overlay-width)))}.si-tree-view-item-end-icons.si-tree-view-item-end-icons-sticky{position:sticky;inset-inline-end:0}.input-box{margin-inline:2px 12px}.form-check-input{inset-block-start:2px}si-loading-spinner{--loading-spinner-size: var(--si-tree-view-icon-size)}\n"] }]
        }], propDecorators: { indentLevel: [{
                type: Input
            }], treeItem: [{
                type: Input
            }], scrollIntoView: [{
                type: Input
            }], childrenLoaded: [{
                type: Input
            }], contextMenuAriaLabel: [{
                type: Input
            }], templates: [{
                type: Input
            }], contextMenuItemsProvider: [{
                type: Input
            }], stickyRightItems: [{
                type: Input
            }], stickyEndItems: [{
                type: Input
            }], displayFolderState: [{
                type: Input
            }], icons: [{
                type: Input
            }], contextDropdown: [{
                type: ViewChild,
                args: ['contextDropdown']
            }], onContextMenu: [{
                type: HostListener,
                args: ['contextmenu', ['$event']]
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

/**
 * Provides the functionality to flatten the hierarchical tree structure into a flat one dimensional array; called flattenedTrees.
 * The TreeViewComponent uses this flattened trees (the array) to bind the contained tree/list items to the GUI into a list.
 * In addition the service provides the number of 'normal' list items and the number of group items.
 * Important:
 * The coupling to the TreeViewComponent is high, thus the service is provided only by the TreeViewComponent.
 */
class SiTreeViewConverterService {
    /**
     * The flattened tree array; filled upon calling the method 'fillFlattenedTree'
     */
    flattenedTrees = [];
    /**
     * The number of group items of the flattened tree.
     */
    groupItemsCount = 0;
    /**
     * The total items count of the flattened tree.
     */
    itemsTotal = 0;
    siTreeViewService = inject(SiTreeViewService);
    /**
     * Flattens the tree handed over as parameter.
     * Takes the mode of the tree into consideration:
     * In case of a flat tree: only the first level of the items parameter is copied into the flattenedTrees array.
     * In case of a grouped tree: only the first two levels are copied into the flattenedTrees array
     * In the other cases all tree nodes are copied into the flattenedTrees array.
     */
    fillFlattenedTree(items) {
        if (this.siTreeViewService.flatTree === false) {
            this.flattenedTrees = [];
            if (this.siTreeViewService.groupedList) {
                this.fillFlattenedTreeRecursive(items, 2, 0);
            }
            else {
                this.fillFlattenedTreeRecursive(items);
            }
        }
        else {
            this.flattenedTrees = items;
            this.groupItemsCount = 0;
        }
        this.itemsTotal = items.length;
    }
    fillFlattenedTreeRecursive(items, noOfLevels, stackLevel) {
        if (noOfLevels !== undefined && stackLevel !== undefined && noOfLevels <= stackLevel) {
            return;
        }
        stackLevel = stackLevel ?? 0;
        for (const current of items) {
            this.flattenedTrees.push(current);
            if (this.siTreeViewService.isGroupedItem(current)) {
                this.groupItemsCount++;
            }
            if (current.state === 'expanded') {
                this.fillFlattenedTreeRecursive(current.children ?? [], noOfLevels, stackLevel + 1);
            }
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewConverterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewConverterService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewConverterService, decorators: [{
            type: Injectable
        }] });

/**
 * This service provides helper functionality for the tree view to read the height of the tree/list items and
 * the group list items out of the DOM.
 *
 * Important: The coupling to the TreeViewComponent is very high as the service contains knowledge on the HTML structure!!!
 * Thus the service is provided only by the TreeViewComponent.
 *
 * Constraint: The height of the items (DOM elements) must be all the same; The height of the grouped items (DOM elements)
 * must be all the same;
 */
class SiTreeViewItemHeightService {
    /**
     * The height of a tree list item.
     * Can be undefined if the tree list has not been layout rendered yet.
     */
    itemHeight;
    /**
     * The height of a grouped list item.
     * Can be undefined if the tree list has not been layout rendered yet or if it does not contain group items.
     */
    groupItemHeight;
    /**
     * Emitter for itemHeight changes.
     */
    itemHeightChange = new EventEmitter();
    siTreeViewService = inject(SiTreeViewService);
    /**
     * Updates the height of a list item, if an appropriate item is in the DOM.
     *
     * @returns The new height of the list item; or undefined if no list item is in the DOM yet.
     */
    updateItemHeight(elementList, flattenedTrees, itemsBase, virtualizedItems) {
        let newHeight;
        let itemsTop = itemsBase + virtualizedItems;
        if (itemsTop > flattenedTrees.length) {
            itemsTop = flattenedTrees.length;
        }
        for (let i = itemsBase; i < itemsTop; i++) {
            if (this.siTreeViewService.isGroupedItem(flattenedTrees[i]) === false) {
                newHeight = this.getItemHeightOfListElement(elementList, i - itemsBase);
                break;
            }
        }
        if (newHeight !== undefined && this.itemHeight !== newHeight) {
            this.itemHeight = newHeight;
            this.itemHeightChange.emit(newHeight);
        }
        return newHeight;
    }
    /**
     * Updates the height of a group item, if an appropriate item is in the DOM.
     *
     * @returns The new height of the group item; or undefined if no group item is in the DOM yet.
     */
    updateGroupedItemHeight(elementList, flattenedTrees, itemsBase, virtualizedItems) {
        let newHeight;
        let itemsTop = itemsBase + virtualizedItems;
        if (itemsTop > flattenedTrees.length) {
            itemsTop = flattenedTrees.length;
        }
        for (let i = itemsBase; i < itemsTop; i++) {
            if (this.siTreeViewService.isGroupedItem(flattenedTrees[i])) {
                newHeight = this.getItemHeightOfListElement(elementList, i - itemsBase);
                break;
            }
        }
        if (newHeight !== undefined) {
            this.groupItemHeight = newHeight;
        }
        return newHeight;
    }
    getItemHeightOfListElement(elementList, index) {
        const items = elementList.querySelectorAll('si-tree-view-item');
        if (index < items.length) {
            return items.item(index).getBoundingClientRect().height;
        }
        return undefined;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewItemHeightService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewItemHeightService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewItemHeightService, decorators: [{
            type: Injectable
        }] });

/**
 * Provides helper functionality to virtualize a list of items.
 * The number of virtualized items is the product of the pageSize and the pagesVirtualized (no of pages virtualized);
 * The paging algorithm works as follows:
 * If scrolling down, between two and three pages are kept above the 'visible' area;
 * The trigger is therefore if more than three pages are above the visible area, one page is removed from the top and added at the bottom.
 * If scrolling up, between one and two pages are kept above the 'visible' area;
 * The trigger is therefore if less than one page is above the visible area, one page is added on top and removed from the bottom.
 * All remaining items which are not virtualized, need to be simulated with two div-elements whose height can be set with the calculated
 * properties heightBefore and heightAfter.
 * See the test client for further information on the  usage.
 * Constraint:
 * The virtualization calculation works correct only when all list items are of the same height!
 * If the 'group' mode is enabled, the corresponding group-items can have a different height, but for all group-items it must be the same.
 */
class SiTreeViewVirtualizationService {
    /**
     * The number of list items of a virtualized page.
     * Choose a value, which is roughly half of the number of items you expect to be displayed on the visible screen.
     */
    pageSize = 10;
    /**
     * The number of pages to be virtualized.
     */
    pagesVirtualized = 6;
    itemsVirtualizedChanged = new Subject();
    /**
     * The total height of the 'simulated' list items which are ordered before the virtualized list items.
     */
    _heightBefore = 0;
    /**
     * The total height of the 'simulated' list items which are ordered after the virtualized list items.
     */
    _heightAfter = 0;
    _pageBase = 0;
    scrollTopPrev = 0;
    _itemsVirtualized = [];
    groupItemsCountBefore = 0;
    listItemsCountBefore = 0;
    groupItemsCountAfter = 0;
    listItemsCountAfter = 0;
    groupItemsCountVirtualized = 0;
    listItemsCountVirtualized = 0;
    listItemsPerVirtPage = [];
    groupItemsPerVirtPage = [];
    siTreeViewService = inject(SiTreeViewService);
    siTreeViewItemHeightService = inject(SiTreeViewItemHeightService);
    /**
     * Returns the virtualized items.
     */
    get itemsVirtualized() {
        return this._itemsVirtualized;
    }
    /**
     * The total height of the 'simulated' list items which are ordered before the virtualized list items.
     */
    get heightBefore() {
        return this._heightBefore;
    }
    /**
     * The total height of the 'simulated' list items which are ordered after the virtualized list items.
     */
    get heightAfter() {
        return this._heightAfter;
    }
    /**
     * The index of the first (base) page being virtualized.
     */
    get pageBase() {
        return this._pageBase;
    }
    /**
     * The list item index of the base page.
     */
    get itemBaseIdx() {
        return this._pageBase * this.pageSize;
    }
    /**
     * Returns the number of virtualized items.
     */
    get itemsVirtualizedCount() {
        return this.itemsVirtualized.length;
    }
    /**
     * Call this method upon scroll handler notifications!
     *
     * @param scrollTop; the scrollTop value retrieved form the event target.
     * @param itemsAll; all items of the list;
     */
    handleScroll(scrollTop, itemsAll) {
        if (this.siTreeViewService.groupedList) {
            this.handleScrollGrouped(scrollTop, itemsAll);
        }
        else {
            this.handleScrollSimple(scrollTop, itemsAll);
        }
    }
    /**
     * Resets the virtualization to 'show' the items of the first page onwards.
     */
    resetVirtualizedItemList(itemsAll) {
        this._pageBase = 0;
        this.updateVirtualizedItemListIntern(itemsAll);
    }
    /**
     * Updates the virtualized items. Call this method for use cases such as:
     * - The list items array contains added or removed items which could be in the 'visible' area
     * - The item height has changed.
     */
    updateVirtualizedItemList(itemsAll) {
        this.updateVirtualizedItemListIntern(itemsAll);
    }
    /**
     * Checks if the specified item is currently virtualized.
     * If not, the virtualization is recalculated in order that the item is part of the virtualized items.
     */
    virtualizeItem(item, itemsAll) {
        if (this.checkIfItemDisplayed(item) === false) {
            this.setBasePageForItemToDisplay(item, itemsAll);
        }
    }
    /**
     * Calculates the first visible tree item based on current scroll position.
     */
    calculateFirstVisibleTreeItem() {
        let item;
        let totalItemHeight = 0;
        // Approx Y-position of the middle of the first visible (top) tree item
        const topItemPos = this.scrollTopPrev +
            (this.siTreeViewItemHeightService.itemHeight ?? 0) / 2 -
            this.heightBefore;
        for (let idx = 0; idx < this._itemsVirtualized.length && totalItemHeight < topItemPos; idx++) {
            item = this._itemsVirtualized[idx];
            totalItemHeight += this.isGroupItem(item)
                ? this.siTreeViewItemHeightService.groupItemHeight ?? 0
                : this.siTreeViewItemHeightService.itemHeight ?? 0;
        }
        return item;
    }
    get listItemsCountTotal() {
        return this.listItemsCountBefore + this.listItemsCountVirtualized + this.listItemsCountAfter;
    }
    get groupItemsCountTotal() {
        return this.groupItemsCountBefore + this.groupItemsCountVirtualized + this.groupItemsCountAfter;
    }
    get itemsCountTotal() {
        return this.listItemsCountTotal + this.groupItemsCountTotal;
    }
    get itemsCountVirtualizedMax() {
        return this.pageSize * this.pagesVirtualized;
    }
    updateVirtualizedItemListIntern(itemsAll, scrolledPages) {
        // Note!!!:
        // The order of functionality within this method must be maintained as state of this object is changed!!!
        const itemsVirtualizedOld = this._itemsVirtualized.slice();
        this._itemsVirtualized = itemsAll.slice(this.pageBase * this.pageSize, this.itemsCountVirtualizedMax + this.pageBase * this.pageSize);
        this.updateItemsTypeCount(itemsAll, scrolledPages);
        if (this.siTreeViewService.groupedList) {
            this.calculateBeforeAndAfterForGroupList();
        }
        else {
            this.calculateBeforeAndAfter();
        }
        this.maintainVirtualizationNotifies(itemsVirtualizedOld);
    }
    /**
     * Notifies a consumer about changes of virtualized tree/list items in case of a pageBase change.
     * => One notification is sent for every tree/list item which went out of the virtualized items list or came into the virtualized items.
     */
    maintainVirtualizationNotifies(itemsVirtualizedOld) {
        const itemsAdded = [];
        const itemsRemoved = [];
        for (const item of itemsVirtualizedOld) {
            if (!this._itemsVirtualized.includes(item)) {
                itemsRemoved.push(item);
            }
        }
        for (const item of this._itemsVirtualized) {
            if (!itemsVirtualizedOld.includes(item)) {
                itemsAdded.push(item);
            }
        }
        if (itemsRemoved.length > 0) {
            this.itemsVirtualizedChanged.next(new ItemsVirtualizedArgs(itemsRemoved, false));
        }
        if (itemsAdded.length > 0) {
            this.itemsVirtualizedChanged.next(new ItemsVirtualizedArgs(itemsAdded, true));
        }
    }
    calculateBasePage(idx) {
        this._pageBase = Math.floor(idx / this.pageSize - this.pagesVirtualized / 2);
        if (this.pageBase < 0) {
            this._pageBase = 0;
        }
    }
    /**
     * Calculates the height [px] for the divs before and after the tree list in case of 'grouped' mode!
     */
    calculateBeforeAndAfterForGroupList() {
        const groupItemHeight = this.siTreeViewItemHeightService.groupItemHeight ?? 0;
        const listItemHeight = this.siTreeViewItemHeightService.itemHeight ?? 0;
        const scrollHeight = this.listItemsCountTotal * listItemHeight + this.groupItemsCountTotal * groupItemHeight;
        this._heightBefore =
            this.listItemsCountBefore * listItemHeight + this.groupItemsCountBefore * groupItemHeight;
        this._heightAfter =
            scrollHeight -
                this.heightBefore -
                (this.listItemsCountVirtualized * listItemHeight +
                    this.groupItemsCountVirtualized * groupItemHeight);
    }
    /**
     * Calculates the height [px] for the divs before and after the tree list in case of 'non-grouped' mode!
     */
    calculateBeforeAndAfter() {
        if (this.siTreeViewItemHeightService.itemHeight === undefined ||
            this.siTreeViewItemHeightService.itemHeight === 0) {
            return;
        }
        const scrollHeight = this.itemsCountTotal * this.siTreeViewItemHeightService.itemHeight;
        this._heightBefore =
            this.pageBase * this.pageSize * this.siTreeViewItemHeightService.itemHeight;
        this._heightAfter =
            scrollHeight -
                this.heightBefore -
                this.itemsVirtualizedCount * this.siTreeViewItemHeightService.itemHeight;
    }
    checkIfItemDisplayed(currentItem) {
        for (const item of this._itemsVirtualized) {
            if (item === currentItem) {
                return true;
            }
        }
        return false;
    }
    setBasePageForItemToDisplay(item, itemsAll) {
        for (let i = 0; i < itemsAll.length; i++) {
            if (itemsAll[i] === item) {
                this.calculateBasePage(i);
                this.updateVirtualizedItemListIntern(itemsAll);
                return;
            }
        }
    }
    /**
     * Updates the number of grouped items and list items for the whole list for the different areas:
     * - The not virtualized items on top of the list (represented by the 'beforeHeight')
     * - The virtualized items
     * - The not virtualized items on the bottom of the list (represented by the 'afterHeight')
     */
    updateItemsTypeCount(itemsAll, scrolledPages) {
        if (this.siTreeViewService.groupedList) {
            this.updateItemsTypeCountForGroupList(itemsAll, scrolledPages);
        }
        else {
            this.groupItemsCountBefore = 0;
            this.groupItemsCountVirtualized = 0;
            this.groupItemsCountAfter = 0;
            this.listItemsCountBefore = this.itemBaseIdx;
            this.listItemsCountVirtualized = this.itemsVirtualizedCount;
            this.listItemsCountAfter =
                itemsAll.length - this.listItemsCountBefore - this.listItemsCountVirtualized;
        }
        this.updateItemsTypeCountPerVirtPage();
        if (this.itemsCountTotal !== itemsAll.length) {
            console.error('TreeListVirtualizationService: updateVirtualizedItemList().updateListItemsTypeCount() calculation error!');
        }
    }
    /**
     * Updates the number of grouped items and list items per virtualized page.
     */
    updateItemsTypeCountPerVirtPage() {
        this.listItemsPerVirtPage = [];
        this.groupItemsPerVirtPage = [];
        for (let basePgIdx = 0; basePgIdx < this.pagesVirtualized; basePgIdx++) {
            const baseIdx = basePgIdx * this.pageSize;
            let groupItemsCount = 0;
            let listItemsCount = 0;
            for (let idx = baseIdx; idx < baseIdx + this.pageSize; idx++) {
                if (idx < this.itemsVirtualized.length) {
                    const item = this.itemsVirtualized[idx];
                    if (this.isGroupItem(item)) {
                        groupItemsCount++;
                    }
                    else {
                        listItemsCount++;
                    }
                }
                else {
                    break;
                }
            }
            this.listItemsPerVirtPage.push(listItemsCount);
            this.groupItemsPerVirtPage.push(groupItemsCount);
        }
    }
    calculateVirtPageHeight(index) {
        if (index >= this.groupItemsPerVirtPage.length) {
            return 0;
        }
        if (this.siTreeViewService.groupedList) {
            if (this.siTreeViewItemHeightService.itemHeight !== undefined) {
                return (this.listItemsPerVirtPage[index] * this.siTreeViewItemHeightService.itemHeight +
                    this.groupItemsPerVirtPage[index] *
                        (this.siTreeViewItemHeightService.groupItemHeight ?? 0));
            }
            else {
                return (this.groupItemsPerVirtPage[index] *
                    (this.siTreeViewItemHeightService.groupItemHeight ?? 0));
            }
        }
        else {
            return this.listItemsPerVirtPage[index] * (this.siTreeViewItemHeightService.itemHeight ?? 0);
        }
    }
    updateItemsTypeCountForGroupList(itemsAll, scrolledPages) {
        if (scrolledPages !== undefined && scrolledPages !== 0) {
            this.updateItemsTypeCountForGroupListScrolling(itemsAll, scrolledPages);
        }
        else {
            this.updateListItemsTypeCountForGroupListFull(itemsAll);
        }
    }
    updateItemsTypeCountForGroupListScrolling(itemsAll, scrolledPages) {
        // this method optimizes the update of the type counters in regards of performance in case of scrolling
        // the method considers the difference of the pageBase for the calculation of the counters.
        scrolledPages = scrolledPages ?? 0;
        const oldBaseIndex = (this.pageBase - scrolledPages) * this.pageSize;
        const newBaseIndex = this.pageBase * this.pageSize;
        this.groupItemsCountAfter = this.groupItemsCountAfter + this.groupItemsCountVirtualized;
        this.listItemsCountAfter = this.listItemsCountAfter + this.listItemsCountVirtualized;
        this.groupItemsCountVirtualized = 0;
        this.listItemsCountVirtualized = 0;
        if (scrolledPages > 0) {
            for (let idx = oldBaseIndex; idx < newBaseIndex; idx++) {
                if (this.isGroupItem(itemsAll[idx])) {
                    this.groupItemsCountBefore++;
                    this.groupItemsCountAfter--;
                }
                else {
                    this.listItemsCountBefore++;
                    this.listItemsCountAfter--;
                }
            }
        }
        else {
            for (let idx = newBaseIndex; idx < oldBaseIndex; idx++) {
                if (this.isGroupItem(itemsAll[idx])) {
                    this.groupItemsCountBefore--;
                    this.groupItemsCountAfter++;
                }
                else {
                    this.listItemsCountBefore--;
                    this.listItemsCountAfter++;
                }
            }
        }
        const upper = newBaseIndex + this.itemsVirtualizedCount;
        for (let vi = newBaseIndex; vi < upper; vi++) {
            if (this.isGroupItem(itemsAll[vi])) {
                this.groupItemsCountVirtualized++;
            }
            else {
                this.listItemsCountVirtualized++;
            }
        }
        this.groupItemsCountAfter = this.groupItemsCountAfter - this.groupItemsCountVirtualized;
        this.listItemsCountAfter = this.listItemsCountAfter - this.listItemsCountVirtualized;
    }
    updateListItemsTypeCountForGroupListFull(itemsAll) {
        // does fully update the counters for the whole list.
        this.groupItemsCountBefore = 0;
        this.groupItemsCountVirtualized = 0;
        this.groupItemsCountAfter = 0;
        const virtTop = this.itemBaseIdx + this.itemsVirtualizedCount;
        for (let i = 0; i < itemsAll.length; i++) {
            if (this.isGroupItem(itemsAll[i])) {
                if (i < this.itemBaseIdx) {
                    this.groupItemsCountBefore++;
                }
                else if (i < virtTop) {
                    this.groupItemsCountVirtualized++;
                }
                else {
                    this.groupItemsCountAfter++;
                }
            }
        }
        this.listItemsCountBefore = this.itemBaseIdx - this.groupItemsCountBefore;
        this.listItemsCountVirtualized = this.itemsVirtualizedCount - this.groupItemsCountVirtualized;
        this.listItemsCountAfter =
            itemsAll.length -
                this.listItemsCountBefore -
                this.listItemsCountVirtualized -
                this.groupItemsCountBefore -
                this.groupItemsCountVirtualized -
                this.groupItemsCountAfter;
    }
    isGroupItem(item) {
        return !item.parent && this.siTreeViewService.groupedList;
    }
    handleScrollSimple(scrollTop, itemsAll) {
        // Notes:
        // This method is used in case all tree list items are of the same height.
        // This allows for an optimized and proper calculation of the pageBase.
        // pageBase stores the index of the first page which is virtualized.
        // totalDeltaScrollVirt corresponds to the total virtualized items height above the visible are!
        const totalDeltaScrollVirt = scrollTop - this.heightBefore;
        let updateVirtList = false;
        const pageHeight = this.pageSize * (this.siTreeViewItemHeightService.itemHeight ?? 0);
        const pageBaseOld = this.pageBase;
        const pageChangeDownTrigger = 3;
        if (this.scrollTopPrev < scrollTop) {
            // Scroll down:
            // We do keep always between two and three pages virtualized above the view, when scrolling down.
            // => We remove pages from the top only when more than three pages are 'above' the visible view
            // => It is mandatory, that the trigger points are calculated exactly in order to get a nice scrolling behavior for all situations
            if (totalDeltaScrollVirt > pageChangeDownTrigger * pageHeight) {
                const pagesOutsideView = totalDeltaScrollVirt / pageHeight;
                // Two pages shall remain 'above' the view;
                // It is important that this number is higher than the trigger when scrolling up (which is one page, see the next else statement)
                // Thus we have a hysteresis of one page in order to avoid scrollbar jitters!!
                this._pageBase = this.pageBase + Math.floor(pagesOutsideView) - (pageChangeDownTrigger - 1);
                updateVirtList = true;
            }
        }
        else if (this.scrollTopPrev > scrollTop) {
            // scroll up
            if (totalDeltaScrollVirt < pageHeight) {
                // we add pages to the top as soon as only one page (or smaller) is 'above' the visible view
                const pagesOutsideView = totalDeltaScrollVirt / pageHeight;
                this._pageBase = this.pageBase + Math.floor(pagesOutsideView) - (pageChangeDownTrigger - 2);
                if (this.pageBase < 0) {
                    this._pageBase = 0; // pageBase cannot be lower than 0; if pageBase=0 then we have no pages above the visible view.
                }
                if (this._pageBase !== pageBaseOld) {
                    updateVirtList = true;
                }
            }
        }
        this.scrollTopPrev = scrollTop;
        if (updateVirtList) {
            this.updateVirtualizedItemListIntern(itemsAll, this.pageBase - pageBaseOld);
        }
    }
    handleScrollGrouped(scrollTop, itemsAll) {
        // Notes:
        // This method is used in case the tree list is grouped => the group items have a different height than the other items.
        // This allows for an optimized and avaeraged calculation of the new pageBase.
        // pageBase stores the index of the first page which is virtualized.
        // totalDeltaScrollVirt corresponds to the total virtualized items height above the visible are!
        const totalDeltaScrollVirt = scrollTop - this.heightBefore;
        const pageHeightFirst3 = this.calculateVirtPageHeight(0) +
            this.calculateVirtPageHeight(1) +
            this.calculateVirtPageHeight(2);
        let updateVirtList = false;
        const pageHeightFirst1 = this.calculateVirtPageHeight(0);
        const pageHeightAvg = pageHeightFirst3 / 3;
        const pageBaseOld = this.pageBase;
        if (this.scrollTopPrev < scrollTop) {
            // Scroll down:
            // We do keep always between two and three pages virtualized above the view, when scrolling down.
            // => We remove pages from the top only when more than three pages are 'above' the visible view.
            // => It is mandatory, that the trigger points are calculated exactly in order to get a nice scrolling behavior for all situations.
            if (totalDeltaScrollVirt > pageHeightFirst3) {
                // Next calculation is averaged. It seems not needed to properly calculate it based on the all the real items.
                const pagesOutsideView = totalDeltaScrollVirt / pageHeightAvg;
                // Two pages shall remain 'above' the view;
                // It is important that this number is higher than the trigger when scrolling up (which is one page, see next else).
                // Thus we have a hysteresis of one page in order to avoid scrollbar jitters!!
                this._pageBase = this.pageBase + Math.floor(pagesOutsideView) - 2;
                updateVirtList = true;
            }
        }
        else if (this.scrollTopPrev > scrollTop) {
            // scroll up
            if (totalDeltaScrollVirt < pageHeightFirst1) {
                // we add pages to the top as soon as only one page (or smaller) is 'above' the visible view
                const pagesOutsideView = totalDeltaScrollVirt / pageHeightAvg;
                this._pageBase = this.pageBase + Math.floor(pagesOutsideView) - 1;
                if (this.pageBase < 0) {
                    this._pageBase = 0; // pageBase cannot be lower than 0; if pageBase=0 then we have no pages above the visible view.
                }
                if (this._pageBase !== pageBaseOld) {
                    updateVirtList = true;
                }
            }
        }
        this.scrollTopPrev = scrollTop;
        if (updateVirtList) {
            this.updateVirtualizedItemListIntern(itemsAll, this.pageBase - pageBaseOld);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewVirtualizationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewVirtualizationService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewVirtualizationService, decorators: [{
            type: Injectable
        }] });

/*
 * WARNING: Parts of this component are made to be used in conjunction with Bootstrap.
 * Bootstrap is not included with this package and has to be installed separately.
 */
const rootDefaults = {
    label: 'root',
    level: ROOT_LEVEL,
    state: 'expanded',
    selectable: false
};
/**
 * Implements a tree view with the following main capabilities:
 * Showing multiple trees. The data of the trees is set via the input property 'items'.
 * Showing the trees in a flat mode with navigation/bread/crumb on top.
 * A tree/list item is composed of a 'folder' icon, any item icon, the label, two additional datafields and a context menu button.
 * Children of parent nodes are lazy loaded upon request (in case they are not yet available in model.)
 * Context menu support via context menu item: the context menu items can be set via input properties.
 * Multi selection and focus support.
 * Checkboxes and / or option boxes per tree node.
 * Virtualization support: Input properties allow to set the page size and the number of pages to be virtualized.
 * Current limitation is roughly half a million of nodes. This is due to some 'strange' behavior with flex containers.
 * Set the input properties 'pageSize' and 'pagesVirtualized' to a reasonable amount of virtualized items.
 * The number of virtualized items is the product of the pageSize and the pagesVirtualized (no of pages virtualized).
 * Choose a value in the area of 50 virtualized items, dependent on the screen size. Check at runtime if appropriate!
 * Grouped List support: The component does also support grouped lists.
 * See the test client implementation of this package for all functionality.
 */
class SiTreeViewComponent {
    /**
     * Needs to be called by the consumer, if a tree model gets added or removed
     * items by the consumer. The tree list component needs to know, as it has to
     * update the flattened tree and the optional virtualization.
     * @deprecated Use the {@link refresh} method instead.
     */
    updateTreeDisplay = new Subject();
    /**
     * Push the tree item to be scrolled into view. Tree items will be expanded if
     * required.
     * @deprecated Use the {@link scrollItemIntoView} method instead.
     */
    scrollIntoView = new Subject();
    /**
     * The context menu items which are bound to the context menu of all tree items,
     * or a menu item provider function that is invoked for each tree item once.
     */
    contextMenuItems = [];
    /**
     * The indentation in pixel for the children in respect to its parent.
     */
    childrenIndentation = DEFAULT_CHILDREN_INDENTATION;
    /**
     * Enable horizontal scrolling. When disabled (the default), an ellipsis is used for overflowing text
     */
    horizontalScrolling = false;
    /**
     * Enable the compact mode, making it more vertically compact.
     */
    compactMode = false;
    /**
     * Enable buttons for collapse and expand all.
     * Does not work when `flatTree` is enabled.
     */
    expandCollapseAll = false;
    /**
     * Tooltip text shown for the expand all icon.
     */
    expandAllTooltip = $localize `:@@SI_TREE_VIEW.EXPAND_ALL:Expand all`;
    /**
     * Tooltip text shown for the collapse all icon.
     */
    collapseAllTooltip = $localize `:@@SI_TREE_VIEW.COLLAPSE_ALL:Collapse all`;
    /**
     * Text or translation key for aria-label of context menu dropdown. Needed for a11y.
     */
    contextMenuAriaLabel = $localize `:@@SI_TREE_VIEW.OPEN_CONTEXT_MENU:Open context menu`;
    /**
     * Customize icons for treeview.
     */
    icons;
    /**
     * Triggered upon virtualization (or unvirtualization) of a tree item.
     */
    itemsVirtualizedChanged = new EventEmitter();
    /**
     * Triggered upon clicking the folder of a tree item.
     */
    treeItemFolderClicked = new EventEmitter();
    /**
     * Triggered upon a state change of the folder of a tree item.
     */
    treeItemFolderStateChanged = new EventEmitter();
    /**
     * Triggered upon clicking the label of a tree item.
     */
    treeItemClicked = new EventEmitter();
    /**
     * Triggered upon clicking the checkbox of a tree item.
     */
    treeItemCheckboxClicked = new EventEmitter();
    /**
     * Triggered upon the request of loading the children of a tree item.
     */
    loadChildren = new EventEmitter();
    /**
     * Triggered upon the selection of a tree item (multi selection supported).
     */
    treeItemsSelected = new EventEmitter();
    /**
     * The injected content with included SiTreeViewItemTemplateDirective.
     */
    templates;
    /**
     * Track-by function for tree items. By default, items are tracked by their identity.
     */
    trackByFunction = buildTrackByIdentity();
    initialized = false;
    scrollHandlerAdded = false;
    updateTreeItemHeightRequired = true; // must be set to true so the height is initially calculated once at least
    updateGroupItemHeightRequired = true; // must be set to true so the height is initially calculated once at least
    selectedTreeItems = [];
    manuallySelectedTreeItems = false;
    _items = [];
    latestFolderChanged;
    breadCrumbTreeItems = [];
    subscriptions = [];
    multiSelectionStart;
    _multiSelectionActive = false;
    domChangeObserver;
    element = inject(ElementRef);
    siTreeViewService = inject(SiTreeViewService);
    siTreeViewConverterService = inject(SiTreeViewConverterService);
    siTreeViewVirtualizationService = inject(SiTreeViewVirtualizationService);
    siTreeViewItemHeightService = inject(SiTreeViewItemHeightService);
    cdRef = inject(ChangeDetectorRef);
    resizeObserver = inject(ResizeObserverService);
    /**
     * Create a virtual root node so there is just a single root node. This makes sure the tree
     * can be fully traversed starting from any node. This is needed e.g. for recursively
     * removing the "active" state from other nodes.
     */
    virtualRoot = { ...rootDefaults };
    updateTreeItemDefaults(item) {
        item.showCheckbox ??= this.siTreeViewService.enableCheckbox;
        item.showOptionbox ??= this.siTreeViewService.enableOptionbox;
    }
    scrollChildIntoView = new Subject();
    childrenLoaded = new Subject();
    hasAnyChildren = true;
    /**
     * Number of rows per page. Used for the virtualization of rows (number of
     * rows per page).
     * @defaultref {@link SiTreeViewVirtualizationService#pageSize}
     */
    set pageSize(value) {
        this.siTreeViewVirtualizationService.pageSize = value < 5 ? 5 : value;
        this.resetVirtualizedItemList();
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Number of pages which are virtualized.
     * @defaultref {@link SiTreeViewVirtualizationService#pagesVirtualized}
     */
    set pagesVirtualized(value) {
        this.siTreeViewVirtualizationService.pagesVirtualized = value < 5 ? 5 : value;
        this.resetVirtualizedItemList();
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets the height of the div above the virtualized rows.
     */
    get heightBefore() {
        return this.siTreeViewVirtualizationService.heightBefore + 'px';
    }
    /**
     * Gets the height of the div below the virtualized rows.
     */
    get heightAfter() {
        return this.siTreeViewVirtualizationService.heightAfter + 'px';
    }
    /**
     * Returns the virtualized items in the tree list uses virtualization, otherwise all items are returned as a flat list.
     * Bind these to the HTML.
     */
    get itemsVirtualized() {
        return this.isVirtualized
            ? this.siTreeViewVirtualizationService.itemsVirtualized
            : this.siTreeViewConverterService.flattenedTrees;
    }
    ngOnInit() {
        this.subscriptions.push(this.siTreeViewService.clickEvent.subscribe(event => this.onItemClicked(event)));
        this.subscriptions.push(this.siTreeViewService.contextMenuOpenEvent.subscribe(event => this.onContextMenuOpenClicked(event)));
        this.subscriptions.push(this.siTreeViewService.folderClickEvent.subscribe(event => this.onItemFolderClicked(event)));
        this.subscriptions.push(this.siTreeViewService.checkboxClickEvent.subscribe(event => this.onItemCheckboxClicked(event)));
        this.subscriptions.push(this.siTreeViewService.loadChildrenEvent.subscribe(event => this.onLoadChildren(event)));
        this.subscriptions.push(this.siTreeViewService.scrollIntoViewEvent.subscribe(event => this.onScrollIntoView(event)));
        this.subscriptions.push(this.updateTreeDisplay.subscribe(() => this.refresh()));
        this.subscriptions.push(this.scrollIntoView.subscribe(item => this.onScrollIntoViewByConsumer(item)));
        this.subscriptions.push(this.siTreeViewVirtualizationService.itemsVirtualizedChanged.subscribe((event) => {
            this.itemsVirtualizedChanged.next(event);
            this.cdRef.markForCheck();
        }));
        this.initialized = true;
        this.handleTreeMode();
        this.icons = {
            ...DEFAULT_TREE_ICON_SET,
            ...this.icons
        };
    }
    ngOnDestroy() {
        this.subscriptions
            .filter(subscription => !!subscription)
            .forEach(subscription => subscription.unsubscribe());
        this.removeScrollHandler();
        this.domChangeObserver?.disconnect();
    }
    ngOnChanges(changes) {
        // Compact mode change the CSS margins so it is necessary to
        // re-calc the tree item height
        if (changes.compactMode) {
            this.updateTreeItemHeightRequired = true;
        }
        if (changes.icons) {
            this.icons = {
                ...DEFAULT_TREE_ICON_SET,
                ...this.icons
            };
        }
    }
    ngAfterViewInit() {
        this.addScrollHandler();
        this.addClassObserver();
        this.subscriptions.push(this.monitorTreeSizeChanges().subscribe(d => this.updatePageSize(d)));
    }
    ngAfterViewChecked() {
        if (this.updateTreeItemHeightRequired &&
            this.siTreeViewConverterService.flattenedTrees.length > 0) {
            const oldHeight = this.siTreeViewItemHeightService.itemHeight;
            let newHeight;
            if (this.siTreeViewService.isVirtualized) {
                newHeight = this.siTreeViewItemHeightService.updateItemHeight(this.treeViewInnerElement.nativeElement, this.siTreeViewConverterService.flattenedTrees, this.siTreeViewVirtualizationService.itemBaseIdx, this.siTreeViewVirtualizationService.itemsVirtualizedCount);
            }
            else {
                newHeight = this.siTreeViewItemHeightService.updateItemHeight(this.treeViewInnerElement.nativeElement, this.siTreeViewConverterService.flattenedTrees, 0, this.siTreeViewConverterService.flattenedTrees.length);
            }
            if (newHeight !== undefined && newHeight > 0) {
                this.updateTreeItemHeightRequired = false;
                if (oldHeight !== newHeight) {
                    const task = () => {
                        this.updateVirtualizedItemList();
                        this.cdRef.markForCheck();
                    };
                    asyncScheduler.schedule(task, 0);
                }
            }
        }
        if (this.updateGroupItemHeightRequired &&
            this.siTreeViewConverterService.flattenedTrees.length > 0) {
            const oldHeight = this.siTreeViewItemHeightService.groupItemHeight;
            let newHeight;
            if (this.siTreeViewService.isVirtualized) {
                newHeight = this.siTreeViewItemHeightService.updateGroupedItemHeight(this.treeViewInnerElement.nativeElement, this.siTreeViewConverterService.flattenedTrees, this.siTreeViewVirtualizationService.itemBaseIdx, this.siTreeViewVirtualizationService.itemsVirtualizedCount);
            }
            else {
                newHeight = this.siTreeViewItemHeightService.updateGroupedItemHeight(this.treeViewInnerElement.nativeElement, this.siTreeViewConverterService.flattenedTrees, 0, this.siTreeViewConverterService.flattenedTrees.length);
            }
            if (newHeight !== undefined) {
                this.updateGroupItemHeightRequired = false;
                if (oldHeight !== newHeight) {
                    const task = () => {
                        this.updateVirtualizedItemList();
                        this.cdRef.markForCheck();
                    };
                    asyncScheduler.schedule(task, 0);
                }
            }
        }
    }
    /**
     * @defaultref {@link SiTreeViewService#folderStateStart}
     * @deprecated Use `folderStateStart` instead.
     */
    set folderStateLeft(value) {
        this.folderStateStart = value;
    }
    get folderStateLeft() {
        return this.folderStateStart;
    }
    /**
     * Sets if the folder state icon shall be shown on the left (in LTR) or on the right (in LTR) side
     * of the tree item. Per default the icon will be shown on the left (in LTR). Has no
     * effect if flatTree is enabled.
     * @defaultref {@link SiTreeViewService#folderStateStart}
     */
    set folderStateStart(value) {
        this.siTreeViewService.folderStateStart = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the folder state icon is shown on the left (in LTR) of the right (in LTR) side of the item
     */
    get folderStateStart() {
        return this.siTreeViewService.folderStateStart;
    }
    /**
     * Sets if the tree list shall virtualize the tree items.
     * This input field must be set at startup and shall not be changed afterwards.
     * @defaultref {@link SiTreeViewService#isVirtualized}
     */
    set isVirtualized(value) {
        this.siTreeViewService.isVirtualized = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree list is virtualized.
     */
    get isVirtualized() {
        return this.siTreeViewService.isVirtualized;
    }
    /**
     * Sets the root tree items of all the trees (Required).
     * @defaultref {@link _items}
     */
    set items(items) {
        this.selectedTreeItems = [];
        this._items = items;
        this.virtualRoot = { ...rootDefaults, children: items };
        setTreeItemDefaults(this.virtualRoot, item => this.updateTreeItemDefaults(item));
        initializeTreeItemsRecursive(items, this.virtualRoot, item => this.updateTreeItemDefaults(item));
        this.fillFlattenedTree(this._items, true);
        this.latestFolderChanged = this._items[0];
    }
    /**
     * Gets the root items of the tree view.
     */
    get items() {
        return this._items;
    }
    /**
     * Sets the tree item to be selected.
     */
    set selectedItem(treeItem) {
        const items = this.coerceToSelectionType(treeItem);
        const isMultipleTreeItems = Array.isArray(items);
        if ((isMultipleTreeItems && items.length) ||
            (!isMultipleTreeItems && items) ||
            this.selectedTreeItems.length) {
            this.manuallySelectedTreeItems = false;
        }
        if (!isMultipleTreeItems && items && !items.selectable) {
            return;
        }
        for (const element of this._items) {
            selectRecursive(element, false);
        }
        this.selectedTreeItems = [];
        if (!items) {
            this.siTreeViewService.triggerMarkForCheck.next();
            return;
        }
        // If this is single select or multi select with only one item
        if (!isMultipleTreeItems) {
            items.selected = true;
            this.selectedTreeItems.push(items);
            this.setFlatTreeSelectedFolder(items.parent);
            if (this.isVirtualized) {
                this.siTreeViewVirtualizationService.virtualizeItem(items, this.siTreeViewConverterService.flattenedTrees);
            }
            // wait one cycle until the new children (in case of page virtualization) are created
            const task = () => {
                this.scrollChildIntoView.next(items);
                this.cdRef.markForCheck();
                this.siTreeViewService.triggerMarkForCheck.next();
            };
            asyncScheduler.schedule(task, 0);
        }
        else {
            // Multi select with multiple items
            const task = () => {
                for (const item of items) {
                    if (item.selectable === false) {
                        continue;
                    }
                    item.selected = true;
                    this.selectedTreeItems.push(item);
                }
                this.cdRef.markForCheck();
                this.siTreeViewService.triggerMarkForCheck.next();
            };
            asyncScheduler.schedule(task, 0);
        }
    }
    /**
     * Sets if the tree shall force single tree item selection.
     * @defaultref {@link SiTreeViewService#singleSelectMode}
     */
    set singleSelectMode(value) {
        this.siTreeViewService.singleSelectMode = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree view is set to single selection only.
     */
    get singleSelectMode() {
        return this.siTreeViewService.singleSelectMode;
    }
    /**
     * Shows or hides additional information below the label.
     * @defaultref {@link SiTreeViewService#enableDataField1}
     */
    set enableDataField1(value) {
        this.siTreeViewService.enableDataField1 = value;
        // Note:
        // We need to update the tree item height not earlier than when the corresponding DOM element is rendered (the layout renderer did run).
        // Thus, we set only a flag and check if update is needed within the ngAfterViewChecked hook.
        this.updateTreeItemHeightRequired = true;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the dataField1 is shown/hidden.
     */
    get enableDataField1() {
        return this.siTreeViewService.enableDataField1;
    }
    /**
     * Shows or hides additional information below the label.
     * @defaultref {@link SiTreeViewService#enableDataField2}
     */
    set enableDataField2(value) {
        this.siTreeViewService.enableDataField2 = value;
        // Note:
        // We need to update the tree item height not earlier than when the corresponding DOM element is
        // rendered (the layout renderer did run). Thus, we set only a flag and check if update is needed
        // within the ngAfterViewChecked hook.
        this.updateTreeItemHeightRequired = true;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the dataField2 is shown/hidden.
     */
    get enableDataField2() {
        return this.siTreeViewService.enableDataField2;
    }
    /**
     * Shows or hides state pipe.
     * @defaultref {@link SiTreeViewService#enableStateIndicator}
     */
    set enableStateIndicator(value) {
        this.siTreeViewService.enableStateIndicator = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the state pipe is shown/hidden.
     */
    get enableStateIndicator() {
        return this.siTreeViewService.enableStateIndicator;
    }
    /**
     * Shows or hides icon
     * @defaultref {@link SiTreeViewService#enableIcon}
     */
    set enableIcon(value) {
        this.siTreeViewService.enableIcon = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the icon is shown/hidden.
     */
    get enableIcon() {
        return this.siTreeViewService.enableIcon;
    }
    /**
     * Shows or hides context menu button.
     * @defaultref {@link SiTreeViewService#enableContextMenuButton}
     */
    set enableContextMenuButton(value) {
        this.siTreeViewService.enableContextMenuButton = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the context menu button is shown/hidden.
     */
    get enableContextMenuButton() {
        return this.siTreeViewService.enableContextMenuButton;
    }
    /**
     * Allows / disabled selecting of tree items by clicking on them.
     * @defaultref {@link SiTreeViewService#enableSelection}
     */
    set enableSelection(value) {
        this.siTreeViewService.enableSelection = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree item selection is enabled/disabled.
     */
    get enableSelection() {
        return this.siTreeViewService.enableSelection;
    }
    /**
     * Sets if children are deleted upon collapsing tree items. This feature might
     * be used, if children shall be lazy loaded always upon expanding a tree
     * item.
     * @defaultref {@link SiTreeViewService#deleteChildrenOnCollapse}
     */
    set deleteChildrenOnCollapse(value) {
        this.siTreeViewService.deleteChildrenOnCollapse = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if children are deleted upon collapsing tree items.
     */
    get deleteChildrenOnCollapse() {
        return this.siTreeViewService.deleteChildrenOnCollapse;
    }
    /**
     * Sets if the tree view shall be displayed as flat tree list with a
     * breadcrumb. A flat tree only shows the one level at the time and lists the
     * tree items of the current level as a list.
     * @defaultref {@link SiTreeViewService#flatTree}
     */
    set flatTree(value) {
        const old = this.siTreeViewService.flatTree;
        this.siTreeViewService.flatTree = value;
        if (old !== this.siTreeViewService.flatTree) {
            this.handleTreeMode();
        }
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree view is displayed as flat tree list with a breadcrumb.
     */
    get flatTree() {
        return this.siTreeViewService.flatTree;
    }
    /**
     * Sets if the tree view is displayed as a grouped list.
     * Important: In this mode, only the first two hierarchies of the tree model
     * are considered!
     * @defaultref {@link SiTreeViewService#groupedList}
     */
    set groupedList(value) {
        const old = this.siTreeViewService.groupedList;
        this.siTreeViewService.groupedList = value;
        if (this.siTreeViewService.groupedList) {
            // Note:
            // We need to update the tree item height not earlier than when the corresponding DOM element
            // is rendered (the layout renderer did run). Thus, we set only a flag and check if update is
            // needed within the ngAfterViewChecked hook.
            this.updateGroupItemHeightRequired = true;
        }
        if (old !== this.siTreeViewService.groupedList) {
            this.fillFlattenedTree(this._items, true);
        }
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree view is displayed displayed as a grouped list.
     * Important: In this mode, only the first two hierarchies of the tree model
     * are considered!
     */
    get groupedList() {
        return this.siTreeViewService.groupedList;
    }
    /**
     * Sets if the tree items shall show a checkbox.
     * @defaultref {@link SiTreeViewService#enableCheckbox}
     */
    set enableCheckbox(value) {
        this.siTreeViewService.enableCheckbox = value;
        for (const element of this._items) {
            enableCheckboxRecursive(element, this.siTreeViewService.enableCheckbox);
        }
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree item show a checkbox.
     */
    get enableCheckbox() {
        return this.siTreeViewService.enableCheckbox;
    }
    /**
     * Sets if the tree items shall show an optionbox.
     * @defaultref {@link SiTreeViewService#enableOptionbox}
     */
    set enableOptionbox(value) {
        this.siTreeViewService.enableOptionbox = value;
        for (const element of this._items) {
            enableOptionboxRecursive(element, this.siTreeViewService.enableOptionbox);
        }
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree items shall show an optionbox.
     */
    get enableOptionbox() {
        return this.siTreeViewService.enableOptionbox;
    }
    /**
     * Sets if the tree items should expand/collapse when clicking on them.
     * Does not work when `flatTree` is enabled or the tree item is not selectable.
     * @defaultref {@link SiTreeViewService#expandOnClick}
     */
    set expandOnClick(value) {
        this.siTreeViewService.expandOnClick = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the tree items should expand/collapse when clicking on them.
     */
    get expandOnClick() {
        return this.siTreeViewService.expandOnClick;
    }
    /**
     * Sets if the checkbox state of a tree item is inherited to its children/parent.
     * @defaultref {@link SiTreeViewService#inheritChecked}
     */
    set inheritChecked(value) {
        this.siTreeViewService.inheritChecked = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets if the checkbox state of a tree item is inherited to its children/parent.
     */
    get inheritChecked() {
        return this.siTreeViewService.inheritChecked;
    }
    /**
     * Returns the last breadcrumb tree item. Can be null in case the flat tree
     * shows the root.
     */
    get lastBreadCrumbItem() {
        const item = this.breadCrumbTreeItems[this.breadCrumbTreeItems.length - 1];
        return item ? item : null;
    }
    /**
     * Returns true if the header shows the root/home of the tree.
     */
    get headerShowsRoot() {
        return this.lastBreadCrumbItem == null;
    }
    /**
     * Sets the string to be shown when there are no content actions.
     * @defaultref {@link SiTreeViewService#noActionsString}
     */
    set noActionsString(value) {
        this.siTreeViewService.noActionsString = value;
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    /**
     * Gets the string to be shown when there are no content actions.
     */
    get noActionsString() {
        return this.siTreeViewService.noActionsString;
    }
    /**
     * Called by the owner of the tree upon returning the retrieved children of a
     * 'load children' request.
     */
    childrenLoadingDone(item, children) {
        const oldState = item.state ?? 'collapsed';
        if (item?.state === 'expanding') {
            initializeTreeItemsRecursive(children, item, itemToUpdate => this.updateTreeItemDefaults(itemToUpdate));
            item.children = children;
            item.state = 'expanded';
        }
        const newState = item.state ?? 'collapsed';
        this.updateBreadCrumb(this.evalLowestBreadCrumbNode());
        if (this.flatTree) {
            this.fillFlattenedTree(children);
        }
        else {
            this.fillFlattenedTree(this._items);
        }
        if (oldState !== newState) {
            this.treeItemFolderStateChanged.emit(new FolderStateEventArgs(item, oldState, newState));
        }
        this.childrenLoaded.next(item);
        this.cdRef.markForCheck();
    }
    onFlatTreeNavigateUp() {
        if (this.lastBreadCrumbItem) {
            this.onBreadCrumbItemClicked(this.lastBreadCrumbItem.parent);
        }
    }
    onFlatTreeNavigateHome() {
        this.onBreadCrumbItemClicked();
    }
    onTreeArrowKeydown(event) {
        const rtlCorrectedKey = correctKeyRTL(event.key);
        if (rtlCorrectedKey === 'ArrowLeft' && this.flatTree) {
            if (this.lastBreadCrumbItem) {
                this.onFlatTreeNavigateUp();
            }
            else {
                this.onFlatTreeNavigateHome();
            }
            setTimeout(() => {
                if (this.treeViewInnerElement) {
                    this.treeViewInnerElement.nativeElement.focus();
                }
            });
        }
    }
    /**
     * Updates the tree to visualize the provided tree item by expanding all its parent items, collapsing all
     * other first level tree items and scroll to the provided item.
     * @param item The tree item that shall be visible.
     */
    showTreeItem(item) {
        this.doShowTreeItem(item);
        const task = () => {
            this.scrollChildIntoView.next(item);
            this.cdRef.markForCheck();
        };
        asyncScheduler.schedule(task, 0);
    }
    doShowTreeItem(item, collapseOtherNodes = true) {
        if (item.parent && item.parent.level !== ROOT_LEVEL) {
            this.expandTreeItem(item.parent);
            if (item.parent.parent && item.parent.parent.level !== ROOT_LEVEL) {
                this.doShowTreeItem(item.parent, collapseOtherNodes);
            }
            else if (collapseOtherNodes) {
                const myRoot = item.parent;
                for (const root of this.items) {
                    if (myRoot !== root) {
                        this.collapseTreeItem(root);
                    }
                }
            }
        }
    }
    /**
     * Expands all tree items.
     * @param items Optional param for recursion, will expand these items. If empty, all tree items will be expanded.
     */
    expandAll(items) {
        (items ?? this._items).forEach(item => {
            if (hasChildren(item) && childrenLoaded(item)) {
                if (item.state === 'collapsed') {
                    this.expandTreeItem(item);
                }
                this.expandAll(item.children);
            }
        });
    }
    /**
     * Expands the provided tree item.
     * @param item The tree item to be expanded.
     */
    expandTreeItem(item) {
        const oldState = removeUndefinedState(item.state);
        expand(item);
        this.latestFolderChanged = item;
        this.siTreeViewService.folderClickEvent.next(new FolderStateEventArgs(item, oldState, removeUndefinedState(item.state)));
    }
    /**
     * Collapses all tree items.
     * @param items Optional param for recursion, will collapse these items. If empty, all tree items will be collapsed.
     */
    collapseAll(items) {
        (items ?? this._items).forEach(item => {
            if (hasChildren(item)) {
                if (item.state === 'expanded' || item.state === 'expanding') {
                    this.collapseTreeItem(item);
                }
                this.collapseAll(item.children);
            }
        });
    }
    /**
     * Collapses the provided tree item.
     * @param item The tree item to be collapsed.
     */
    collapseTreeItem(item) {
        const oldState = item.state ?? 'collapsed';
        collapse(item);
        this.latestFolderChanged = item;
        this.siTreeViewService.folderClickEvent.next(new FolderStateEventArgs(item, oldState, removeUndefinedState(item.state)));
    }
    scrollFunction = (event) => this.onScroll(event);
    /**
     * Add tree items as root elements or as children of an existing tree item.
     * @param children Tree items to add.
     * @param parent Optional parent tree item to which the items shall be added.
     * @param position Optional position where to insert the tree items among their siblings.
     */
    addChildItems(children, parent, position) {
        addChildItems(parent ?? this.virtualRoot, children, position, item => this.updateTreeItemDefaults(item));
        this.refresh();
    }
    /**
     * Forces a refresh of the view considering the current tree item model. Needs
     * to be called when tree items have been added, removed, or updated via model
     * in ways that do not trigger an automatic update of the view.
     */
    refresh() {
        if (!this.flatTree) {
            this.fillFlattenedTree(this._items);
        }
        else {
            this.fillFlattenedTree(this.evalListItemsForFlatTreeMode());
        }
        this.cdRef.markForCheck();
    }
    /**
     * Scrolls the specified tree item into view. Tree items will be expanded if
     * required.
     */
    scrollItemIntoView(treeItem) {
        this.onScrollIntoViewByConsumer(treeItem);
    }
    evalListItemsForFlatTreeMode() {
        return this.lastBreadCrumbItem ? this.lastBreadCrumbItem.children ?? [] : this._items;
    }
    collapseChildrenFlatTreeModeOnly(items) {
        this.collapseChildren(items, true);
    }
    collapseChildren(items, flatModeOnly = false) {
        if (flatModeOnly && !this.flatTree) {
            return;
        }
        for (const item of items) {
            if (item.state === 'expanded' || item.state === 'expanding') {
                const oldState = item.state;
                collapse(item);
                this.latestFolderChanged = item;
                this.treeItemFolderStateChanged.next(new FolderStateEventArgs(item, oldState, item.state));
            }
        }
    }
    addScrollHandler() {
        if (!this.scrollHandlerAdded && this.isVirtualized) {
            // TODO: other solution as .addEventListener
            this.treeViewInnerElement.nativeElement.addEventListener('scroll', this.scrollFunction, false);
            this.scrollHandlerAdded = true;
        }
    }
    removeScrollHandler() {
        if (this.scrollHandlerAdded) {
            this.treeViewInnerElement.nativeElement.removeEventListener('scroll', this.scrollFunction, false);
            this.scrollHandlerAdded = false;
        }
    }
    onKeyUpShift(event) {
        if (this._multiSelectionActive) {
            this._multiSelectionActive = false;
            this.emitSelectedItems();
        }
    }
    onKeyUpCtrl(event) {
        if (this._multiSelectionActive) {
            this._multiSelectionActive = false;
            this.emitSelectedItems();
        }
    }
    onKeyUpMeta(event) {
        if (this._multiSelectionActive) {
            this._multiSelectionActive = false;
            this.emitSelectedItems();
        }
    }
    onMouseLeave(event) {
        if (this._multiSelectionActive) {
            this._multiSelectionActive = false;
            this.emitSelectedItems();
        }
    }
    onContextMenuOpenClicked(event) {
        setActive(event.target, true);
        const listRect = this.element.nativeElement.getBoundingClientRect();
        this.siTreeViewService.contextMenuDropUp =
            event.itemTop + 3 * (this.siTreeViewItemHeightService.itemHeight ?? 0) > listRect.bottom;
        this.cdRef.markForCheck();
    }
    onItemClicked(event) {
        let skipFocus = false;
        if (!event.target.selectable) {
            return;
        }
        this.manuallySelectedTreeItems = true;
        if ((event.mouseEvent.ctrlKey || (navigator.platform.match('Mac') && event.mouseEvent.metaKey)) &&
            !this.singleSelectMode) {
            this._multiSelectionActive = true;
            this.multiSelectionStart = event.target;
            if (event.target.selected) {
                skipFocus = true;
            }
            event.target.selected = !event.target.selected;
            if (event.target.selected && !this.singleSelectMode) {
                this.selectedTreeItems.push(event.target);
            }
            else {
                const idx = this.selectedTreeItems.indexOf(event.target);
                if (idx !== -1) {
                    this.selectedTreeItems.splice(idx, 1);
                }
            }
        }
        else if (event.mouseEvent.shiftKey && !this.singleSelectMode) {
            this._multiSelectionActive = true;
            // If the anchor has not been established, set it to the first item in the selected
            // items list if defined ELSE the first item in the tree
            if (!this.multiSelectionStart) {
                this.multiSelectionStart = this.selectedTreeItems?.[0] ?? this._items?.[0];
            }
            // If the tree is in flat mode, ensure the anchor is inside the currently selected folder
            if (this.flatTree) {
                const treeItems = (event.target.parent ? event.target.parent.children : this._items) ?? [];
                if (treeItems.findIndex(ti => ti === this.multiSelectionStart) < 0) {
                    // Move anchor to top-level item in current folder!
                    this.multiSelectionStart = treeItems[0];
                }
            }
            for (const element of this._items) {
                selectRecursive(element, false);
            }
            this.multiSelectionStart.selected = true;
            const selectedItems = selectItemsBetween(this._items, this.multiSelectionStart, event.target);
            this.selectedTreeItems = [this.multiSelectionStart];
            if (selectedItems) {
                this.selectedTreeItems.push(...selectedItems);
            }
        }
        else {
            this.multiSelectionStart = event.target;
            for (const element of this._items) {
                selectRecursive(element, false);
            }
            event.target.selected = true;
            this.selectedTreeItems = [event.target];
        }
        for (const element of this._items) {
            resetActive(element);
        }
        if (!skipFocus) {
            setActive(event.target, true);
        }
        this.treeItemClicked.emit(event.target);
        if (!this._multiSelectionActive) {
            this.emitSelectedItems();
            // Note, if multi selection would be active, we would emit the selected items only upon 'keyup' event for Shift and Control
            // and upon document.mouseleave event
        }
        this.cdRef.markForCheck();
        this.siTreeViewService.triggerMarkForCheck.next();
    }
    emitSelectedItems() {
        if (this.enableSelection) {
            if (this.siTreeViewService.groupedList) {
                const filtered = this.selectedTreeItems.filter(item => !this.siTreeViewService.isGroupedItem(item));
                this.treeItemsSelected.emit(filtered);
            }
            else {
                this.treeItemsSelected.emit(this.selectedTreeItems);
            }
        }
    }
    handleTreeMode() {
        let ti;
        if (this.isVirtualized) {
            ti = this.siTreeViewVirtualizationService.calculateFirstVisibleTreeItem();
        }
        if (this.flatTree) {
            this.siTreeViewService.childrenIndentation = 0;
            if (this.selectedTreeItems.length && this.manuallySelectedTreeItems) {
                // manually selected items => display the (children of) parent of the (highest or first) selected item,
                // if there is no parent display the root node
                const sorted = this.selectedTreeItems.sort((itemA, itemB) => (itemA.level ?? 0) - (itemB.level ?? 0));
                this.fillFlattenedTree(sorted[0].parent?.children ?? this._items, true);
            }
            else if (!this.latestFolderChanged) {
                // no folder state change of any tree item so far => display the root item in the list
                this.fillFlattenedTree(this._items, true);
            }
            else if (this.latestFolderChanged.state === 'expanded') {
                this.fillFlattenedTree(this.latestFolderChanged.children ?? [], true);
            }
            else if (this.latestFolderChanged.parent) {
                this.fillFlattenedTree(this.latestFolderChanged.parent?.children ?? [], true);
            }
            else {
                this.fillFlattenedTree(this._items, true);
            }
            this.updateBreadCrumb(this.evalLowestBreadCrumbNode());
            if (ti && !this.siTreeViewConverterService.flattenedTrees.includes(ti, 0)) {
                ti = this.siTreeViewConverterService.flattenedTrees[0];
            }
        }
        else {
            this.siTreeViewService.childrenIndentation = this.childrenIndentation;
            this.fillFlattenedTree(this._items, true);
        }
        this.onScrollIntoViewByConsumer(ti);
    }
    evalLowestBreadCrumbNode() {
        if (this.latestFolderChanged) {
            return this.latestFolderChanged.state === 'expanded'
                ? this.latestFolderChanged
                : this.latestFolderChanged.parent;
        }
        return undefined;
    }
    treeViewInnerElement;
    onItemFolderClicked(eventArgs) {
        this.treeItemFolderClicked.emit(eventArgs);
        this.treeItemFolderStateChanged.emit(eventArgs);
        this.latestFolderChanged = eventArgs.treeItem;
        this.updateBreadCrumb(this.evalLowestBreadCrumbNode());
        if (!this.flatTree) {
            this.fillFlattenedTree(this._items);
        }
        else if (this.latestFolderChanged.state === 'expanded') {
            this.fillFlattenedTree(this.latestFolderChanged.children ?? []);
            setTimeout(() => {
                this.treeViewInnerElement?.nativeElement.focus();
            });
        }
    }
    updateBreadCrumb(treeItem) {
        if (!treeItem || treeItem.level === ROOT_LEVEL) {
            this.breadCrumbTreeItems = [];
        }
        else {
            this.breadCrumbTreeItems = [treeItem];
            this.pushParentItemsIntoBreadCrumbRecursive(treeItem);
            this.breadCrumbTreeItems = this.breadCrumbTreeItems.reverse();
        }
    }
    pushParentItemsIntoBreadCrumbRecursive(treeItem) {
        if (treeItem?.parent && treeItem?.parent?.level !== ROOT_LEVEL) {
            this.breadCrumbTreeItems.push(treeItem.parent);
            this.pushParentItemsIntoBreadCrumbRecursive(treeItem.parent);
        }
    }
    onItemCheckboxClicked(eventArgs) {
        this.siTreeViewService.triggerMarkForCheck.next();
        this.treeItemCheckboxClicked.emit(eventArgs);
    }
    onLoadChildren(treeItem) {
        this.loadChildren.emit(new LoadChildrenEventArgs(treeItem, (item, children) => this.childrenLoadingDone(item, children)));
    }
    setFlatTreeSelectedFolder(treeItem) {
        if (this.flatTree) {
            this.latestFolderChanged = treeItem;
            if (treeItem) {
                expand(treeItem);
            }
            this.onBreadCrumbItemClicked(treeItem);
        }
    }
    onBreadCrumbItemClicked(treeItem) {
        if (treeItem && treeItem.level !== ROOT_LEVEL) {
            this.fillFlattenedTree(treeItem.children ?? [], true);
        }
        else {
            this.fillFlattenedTree(this._items, true);
        }
        this.updateBreadCrumb(treeItem);
    }
    onScroll(event) {
        if (this.siTreeViewService.isVirtualized) {
            const scrollTop = event.target.scrollTop;
            this.siTreeViewVirtualizationService.handleScroll(scrollTop, this.siTreeViewConverterService.flattenedTrees);
        }
    }
    /**
     * Called by the consumer when he wants a node to be scrolled into view.
     */
    onScrollIntoViewByConsumer(treeItem) {
        if (treeItem) {
            if (this.isVirtualized) {
                this.siTreeViewVirtualizationService.virtualizeItem(treeItem, this.siTreeViewConverterService.flattenedTrees);
            }
            // wait one cycle until the new children (in case of page virtualization) are created
            const task = () => {
                this.doShowTreeItem(treeItem, false); // keep previously opened nodes as it is
                asyncScheduler.schedule(() => {
                    this.scrollChildIntoView.next(treeItem);
                    this.cdRef.markForCheck();
                }, 0);
            };
            asyncScheduler.schedule(task, 0);
        }
    }
    onScrollIntoView(elementTreeItem) {
        const clientRectNode = elementTreeItem.nativeElement.getBoundingClientRect();
        const clientRect = this.element.nativeElement.getBoundingClientRect();
        if (clientRectNode.top < clientRect.top ||
            clientRectNode.top + this.siTreeViewItemHeightService.itemHeight > clientRect.bottom) {
            elementTreeItem.nativeElement.scrollIntoView();
        }
        this.cdRef.markForCheck();
    }
    fillFlattenedTree(items, resetVirtualization = false) {
        this.collapseChildrenFlatTreeModeOnly(items);
        this.siTreeViewConverterService.fillFlattenedTree(items);
        if (resetVirtualization) {
            this.resetVirtualizedItemList();
        }
        else {
            this.updateVirtualizedItemList();
        }
    }
    updateHasChildren() {
        this.hasAnyChildren = !!this.siTreeViewConverterService.flattenedTrees?.some(item => hasChildren(item));
    }
    updateVirtualizedItemList() {
        this.updateHasChildren();
        if (this.isVirtualized && this.initialized) {
            this.siTreeViewVirtualizationService.updateVirtualizedItemList(this.siTreeViewConverterService.flattenedTrees);
            this.cdRef.markForCheck();
        }
    }
    resetVirtualizedItemList() {
        this.updateHasChildren();
        if (this.isVirtualized && this.initialized) {
            this.siTreeViewVirtualizationService.resetVirtualizedItemList(this.siTreeViewConverterService.flattenedTrees);
        }
    }
    /**
     * Track class changes since adding classes like `.tree-sm` or `.tree-xs` change the item height.
     * Changes have to trigger the SiTreeViewItemHeightService otherwise the virtualized items are
     * calculated incorrectly which cause rendering issues.
     */
    addClassObserver() {
        this.domChangeObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                this.updateTreeItemHeightRequired = true;
                if (this.groupedList) {
                    this.updateGroupItemHeightRequired = true;
                }
                this.cdRef.markForCheck();
            });
        });
        this.domChangeObserver.observe(this.element.nativeElement, {
            attributeFilter: ['class', 'style']
        });
    }
    /**
     * Create an observable to track visible dimensions and item height of the tree view.
     * It's necessary to dynamically increase the `pageSize` to render the correct amount
     * of visible tree items.
     * @returns observable with the current tree dimensions.
     */
    monitorTreeSizeChanges() {
        const resize = this.resizeObserver.observe(this.element.nativeElement, 100, true, true);
        const merged = merge(resize, this.siTreeViewItemHeightService.itemHeightChange);
        return merged.pipe(withLatestFrom(resize), map(x => x[1]));
    }
    /**
     * Dynamically calculate and update the virtual pageSize to render the correct amount of tree items.
     * @param dimension current tree dimensions.
     */
    updatePageSize(dimension) {
        if (this.siTreeViewService.isVirtualized) {
            // Re-calc number of virtualized items based on the visible component dimensions
            const itemHeight = this.siTreeViewItemHeightService.itemHeight;
            // Issue #1331: Proceeding with itemHeight==0 leads to an error in
            // SiTreeViewVirtualizationService.updateListItemsTypeCount. It happens
            // when the component is created but not yet visible.
            if (!itemHeight) {
                return;
            }
            // Set page size to half the no. of items visible on the screen following
            // the recommendations in SiTreeViewVirtualizationService.
            const pageSize = Math.floor(dimension.height / itemHeight / 2);
            // Once the pageSize is initialized we are only allowed to increase
            // the number of virtualized items but do never reduce the size.
            // Since this would lead to a incorrect calculation of heightAfter
            // (see calculateBeforeAndAfter)
            if (pageSize > 0 && pageSize > this.siTreeViewVirtualizationService.pageSize) {
                this.pageSize = pageSize;
            }
        }
    }
    /**
     * Make sure to always have a single item for single selection or if there is only one item in the array.
     */
    coerceToSelectionType(treeItem) {
        if (Array.isArray(treeItem) && (treeItem.length <= 1 || this.singleSelectMode)) {
            // If array is empty, this will set it to undefined
            return treeItem[0];
        }
        return treeItem;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiTreeViewComponent, selector: "si-tree-view", inputs: { updateTreeDisplay: "updateTreeDisplay", scrollIntoView: "scrollIntoView", contextMenuItems: "contextMenuItems", childrenIndentation: "childrenIndentation", horizontalScrolling: "horizontalScrolling", compactMode: "compactMode", expandCollapseAll: "expandCollapseAll", expandAllTooltip: "expandAllTooltip", collapseAllTooltip: "collapseAllTooltip", contextMenuAriaLabel: "contextMenuAriaLabel", icons: "icons", trackByFunction: "trackByFunction", pageSize: "pageSize", pagesVirtualized: "pagesVirtualized", folderStateLeft: "folderStateLeft", folderStateStart: "folderStateStart", isVirtualized: "isVirtualized", items: "items", selectedItem: "selectedItem", singleSelectMode: "singleSelectMode", enableDataField1: "enableDataField1", enableDataField2: "enableDataField2", enableStateIndicator: "enableStateIndicator", enableIcon: "enableIcon", enableContextMenuButton: "enableContextMenuButton", enableSelection: "enableSelection", deleteChildrenOnCollapse: "deleteChildrenOnCollapse", flatTree: "flatTree", groupedList: "groupedList", enableCheckbox: "enableCheckbox", enableOptionbox: "enableOptionbox", expandOnClick: "expandOnClick", inheritChecked: "inheritChecked", noActionsString: "noActionsString" }, outputs: { itemsVirtualizedChanged: "itemsVirtualizedChanged", treeItemFolderClicked: "treeItemFolderClicked", treeItemFolderStateChanged: "treeItemFolderStateChanged", treeItemClicked: "treeItemClicked", treeItemCheckboxClicked: "treeItemCheckboxClicked", loadChildren: "loadChildren", treeItemsSelected: "treeItemsSelected" }, host: { listeners: { "document:keyup.shift": "onKeyUpShift($event)", "document:keyup.control": "onKeyUpCtrl($event)", "document:keyup.meta": "onKeyUpMeta($event)", "document:mouseleave": "onMouseLeave($event)" } }, providers: [
            SiTreeViewConverterService,
            SiTreeViewItemHeightService,
            SiTreeViewService,
            SiTreeViewVirtualizationService
        ], queries: [{ propertyName: "templates", predicate: SiTreeViewItemTemplateDirective }], viewQueries: [{ propertyName: "treeViewInnerElement", first: true, predicate: ["treeViewInner"], descendants: true, read: ElementRef, static: true }], usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"!flatTree && expandCollapseAll\" class=\"si-tree-view-expand-collapse-container\">\n  <button\n    class=\"btn btn-sm btn-circle btn-tertiary\"\n    type=\"button\"\n    [title]=\"expandAllTooltip | translate\"\n    (click)=\"expandAll()\"\n  >\n    <span class=\"element-expand-all\"></span>\n  </button>\n  <button\n    class=\"btn btn-sm btn-circle btn-tertiary\"\n    type=\"button\"\n    [title]=\"collapseAllTooltip | translate\"\n    (click)=\"collapseAll()\"\n  >\n    <span class=\"element-collapse-all\"></span>\n  </button>\n</div>\n<div *ngIf=\"flatTree\" class=\"si-tree-view-header\">\n  <span\n    class=\"si-tree-view-header-btn si-tree-view-header-root\"\n    tabindex=\"0\"\n    [class.disabled]=\"headerShowsRoot\"\n    [ngClass]=\"icons.headerHome\"\n    (click)=\"onFlatTreeNavigateHome()\"\n    (keydown.enter)=\"onFlatTreeNavigateHome()\"\n  ></span>\n  <span\n    *ngIf=\"lastBreadCrumbItem\"\n    class=\"si-tree-view-header-btn\"\n    tabindex=\"0\"\n    [class.disabled]=\"headerShowsRoot\"\n    [ngClass]=\"icons.headerArrow\"\n    (click)=\"onFlatTreeNavigateUp()\"\n    (keydown.enter)=\"onFlatTreeNavigateUp()\"\n  ></span>\n  <span *ngIf=\"lastBreadCrumbItem\" class=\"text-center text-truncate\">{{\n    lastBreadCrumbItem.label ?? '' | translate\n  }}</span>\n</div>\n<div\n  #treeViewInner\n  class=\"si-tree-view focus-inside\"\n  siListInteraction\n  listInteractionOrientation=\"vert\"\n  [class.si-tree-horizontal-scroll]=\"horizontalScrolling\"\n  [class.si-tree-view-flat]=\"flatTree\"\n  (keydown)=\"onTreeArrowKeydown($event)\"\n>\n  <div\n    *ngIf=\"isVirtualized\"\n    [class.w-100]=\"horizontalScrolling\"\n    [style.height]=\"heightBefore\"\n  ></div>\n  <div *ngIf=\"itemsVirtualized\" class=\"si-tree-view-root-ul\">\n    <si-tree-view-item\n      *ngFor=\"let treeItem of itemsVirtualized; trackBy: trackByFunction\"\n      class=\"focus-none\"\n      siListInteractionItem\n      [class.si-tree-ellipsis]=\"!horizontalScrolling\"\n      [class.si-tree-view-top-level-item]=\"!compactMode && (flatTree || (treeItem.level ?? 0) < 2)\"\n      [treeItem]=\"treeItem\"\n      [templates]=\"templates\"\n      [scrollIntoView]=\"scrollChildIntoView\"\n      [childrenLoaded]=\"childrenLoaded\"\n      [indentLevel]=\"treeItem.level ?? 0\"\n      [icons]=\"icons\"\n      [contextMenuItemsProvider]=\"contextMenuItems\"\n      [stickyEndItems]=\"horizontalScrolling\"\n      [displayFolderState]=\"hasAnyChildren\"\n      [contextMenuAriaLabel]=\"contextMenuAriaLabel\"\n    >\n    </si-tree-view-item>\n  </div>\n  <div *ngIf=\"isVirtualized\" [class.w-100]=\"horizontalScrolling\" [style.height]=\"heightAfter\"></div>\n</div>\n", styles: ["@keyframes si-spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}:host{--si-tree-view-background: var(--element-base-1);--si-tree-view-border-color: var(--element-ui-4);--si-tree-view-icon-size: 24px;--si-tree-view-padding-base-horizontal: 8px;--si-tree-view-padding-base-vertical: 8px;--si-tree-view-expand-collapse-height: 32px;--si-tree-view-expand-collapse-padding-horizontal: 6px;--si-tree-view-expand-collapse-padding-vertical: 4px;--si-tree-view-expand-collapse-border-radius: var(--element-radius-1);--si-tree-view-item-hover-color: var(--element-base-1-hover);--si-tree-view-item-select-color: var(--element-base-1-selected);--si-tree-view-item-line-height: 1.143;--si-tree-view-item-min-height: 40px;--si-tree-view-item-object-data-field-1-color: var(--element-text-secondary);--si-tree-view-item-object-data-h5-font-size: .875rem;--si-tree-view-item-object-data-h5-font-weight: normal;display:flex;flex-direction:column;background-color:var(--si-tree-view-background)}:host.tree-sm{--si-tree-view-item-min-height: 32px;--si-tree-view-padding-base-vertical: 0px}:host.tree-xs{--si-tree-view-item-min-height: 24px;--si-tree-view-padding-base-vertical: 0px}.si-tree-view-expand-collapse-container{margin-block:var(--si-tree-view-padding-base-vertical) calc(-.5 * var(--si-tree-view-padding-base-vertical));margin-inline:var(--si-tree-view-padding-base-horizontal)}.si-tree-view-expand-collapse-container button:not(:first-child){margin-inline-start:calc(var(--si-tree-view-padding-base-vertical) / 2)}.si-tree-view-header{padding:calc(var(--si-tree-view-padding-base-horizontal) / 2);border-block-end:1px solid var(--si-tree-view-border-color)}.si-tree-view-header>*{align-self:center}.si-tree-view-header-btn{cursor:pointer;margin-inline-end:calc(var(--si-tree-view-padding-base-horizontal) / 2);font-size:var(--si-tree-view-icon-size)}.si-tree-view-header-root{margin-inline-end:0}.si-tree-view{overflow:auto;flex:1 0 0;min-block-size:0}.si-tree-view.si-tree-horizontal-scroll{display:flex;flex-wrap:wrap;align-content:flex-start}.si-tree-view-root-ul{list-style:none;padding:0;margin:0;flex:1 1 auto}@supports (-webkit-touch-callout: none){.si-tree-horizontal-scroll{transform:translateZ(0)}}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$9.SiListInteractionDirective, selector: "[siListInteraction]", inputs: ["listInteractionSubListLeft", "listInteractionSubListStart", "listInteractionFocusOnLoad", "listInteractionFocus", "listInteractionFocusLastFromParent", "listInteractionAutofocusFromParent", "listInteractionIsSubList", "listInteractionParentItem", "listInteractionPosition", "listInteractionOrientation", "listInteractionRefocusAfterEnter", "listInteractionShowSubListOnParentFocus", "listInteractionCloseOnClickOut"], exportAs: ["si-list-interaction"] }, { kind: "directive", type: i2$9.SiListInteractionItemDirective, selector: "[siListInteractionItem]", inputs: ["listInteractionItemDisabled", "listInteractionItemDropdownToggle"], exportAs: ["si-list-interaction-item"] }, { kind: "component", type: SiTreeViewItemComponent, selector: "si-tree-view-item", inputs: ["indentLevel", "treeItem", "scrollIntoView", "childrenLoaded", "contextMenuAriaLabel", "templates", "contextMenuItemsProvider", "stickyRightItems", "stickyEndItems", "displayFolderState", "icons"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-tree-view', providers: [
                        SiTreeViewConverterService,
                        SiTreeViewItemHeightService,
                        SiTreeViewService,
                        SiTreeViewVirtualizationService
                    ], template: "<div *ngIf=\"!flatTree && expandCollapseAll\" class=\"si-tree-view-expand-collapse-container\">\n  <button\n    class=\"btn btn-sm btn-circle btn-tertiary\"\n    type=\"button\"\n    [title]=\"expandAllTooltip | translate\"\n    (click)=\"expandAll()\"\n  >\n    <span class=\"element-expand-all\"></span>\n  </button>\n  <button\n    class=\"btn btn-sm btn-circle btn-tertiary\"\n    type=\"button\"\n    [title]=\"collapseAllTooltip | translate\"\n    (click)=\"collapseAll()\"\n  >\n    <span class=\"element-collapse-all\"></span>\n  </button>\n</div>\n<div *ngIf=\"flatTree\" class=\"si-tree-view-header\">\n  <span\n    class=\"si-tree-view-header-btn si-tree-view-header-root\"\n    tabindex=\"0\"\n    [class.disabled]=\"headerShowsRoot\"\n    [ngClass]=\"icons.headerHome\"\n    (click)=\"onFlatTreeNavigateHome()\"\n    (keydown.enter)=\"onFlatTreeNavigateHome()\"\n  ></span>\n  <span\n    *ngIf=\"lastBreadCrumbItem\"\n    class=\"si-tree-view-header-btn\"\n    tabindex=\"0\"\n    [class.disabled]=\"headerShowsRoot\"\n    [ngClass]=\"icons.headerArrow\"\n    (click)=\"onFlatTreeNavigateUp()\"\n    (keydown.enter)=\"onFlatTreeNavigateUp()\"\n  ></span>\n  <span *ngIf=\"lastBreadCrumbItem\" class=\"text-center text-truncate\">{{\n    lastBreadCrumbItem.label ?? '' | translate\n  }}</span>\n</div>\n<div\n  #treeViewInner\n  class=\"si-tree-view focus-inside\"\n  siListInteraction\n  listInteractionOrientation=\"vert\"\n  [class.si-tree-horizontal-scroll]=\"horizontalScrolling\"\n  [class.si-tree-view-flat]=\"flatTree\"\n  (keydown)=\"onTreeArrowKeydown($event)\"\n>\n  <div\n    *ngIf=\"isVirtualized\"\n    [class.w-100]=\"horizontalScrolling\"\n    [style.height]=\"heightBefore\"\n  ></div>\n  <div *ngIf=\"itemsVirtualized\" class=\"si-tree-view-root-ul\">\n    <si-tree-view-item\n      *ngFor=\"let treeItem of itemsVirtualized; trackBy: trackByFunction\"\n      class=\"focus-none\"\n      siListInteractionItem\n      [class.si-tree-ellipsis]=\"!horizontalScrolling\"\n      [class.si-tree-view-top-level-item]=\"!compactMode && (flatTree || (treeItem.level ?? 0) < 2)\"\n      [treeItem]=\"treeItem\"\n      [templates]=\"templates\"\n      [scrollIntoView]=\"scrollChildIntoView\"\n      [childrenLoaded]=\"childrenLoaded\"\n      [indentLevel]=\"treeItem.level ?? 0\"\n      [icons]=\"icons\"\n      [contextMenuItemsProvider]=\"contextMenuItems\"\n      [stickyEndItems]=\"horizontalScrolling\"\n      [displayFolderState]=\"hasAnyChildren\"\n      [contextMenuAriaLabel]=\"contextMenuAriaLabel\"\n    >\n    </si-tree-view-item>\n  </div>\n  <div *ngIf=\"isVirtualized\" [class.w-100]=\"horizontalScrolling\" [style.height]=\"heightAfter\"></div>\n</div>\n", styles: ["@keyframes si-spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}:host{--si-tree-view-background: var(--element-base-1);--si-tree-view-border-color: var(--element-ui-4);--si-tree-view-icon-size: 24px;--si-tree-view-padding-base-horizontal: 8px;--si-tree-view-padding-base-vertical: 8px;--si-tree-view-expand-collapse-height: 32px;--si-tree-view-expand-collapse-padding-horizontal: 6px;--si-tree-view-expand-collapse-padding-vertical: 4px;--si-tree-view-expand-collapse-border-radius: var(--element-radius-1);--si-tree-view-item-hover-color: var(--element-base-1-hover);--si-tree-view-item-select-color: var(--element-base-1-selected);--si-tree-view-item-line-height: 1.143;--si-tree-view-item-min-height: 40px;--si-tree-view-item-object-data-field-1-color: var(--element-text-secondary);--si-tree-view-item-object-data-h5-font-size: .875rem;--si-tree-view-item-object-data-h5-font-weight: normal;display:flex;flex-direction:column;background-color:var(--si-tree-view-background)}:host.tree-sm{--si-tree-view-item-min-height: 32px;--si-tree-view-padding-base-vertical: 0px}:host.tree-xs{--si-tree-view-item-min-height: 24px;--si-tree-view-padding-base-vertical: 0px}.si-tree-view-expand-collapse-container{margin-block:var(--si-tree-view-padding-base-vertical) calc(-.5 * var(--si-tree-view-padding-base-vertical));margin-inline:var(--si-tree-view-padding-base-horizontal)}.si-tree-view-expand-collapse-container button:not(:first-child){margin-inline-start:calc(var(--si-tree-view-padding-base-vertical) / 2)}.si-tree-view-header{padding:calc(var(--si-tree-view-padding-base-horizontal) / 2);border-block-end:1px solid var(--si-tree-view-border-color)}.si-tree-view-header>*{align-self:center}.si-tree-view-header-btn{cursor:pointer;margin-inline-end:calc(var(--si-tree-view-padding-base-horizontal) / 2);font-size:var(--si-tree-view-icon-size)}.si-tree-view-header-root{margin-inline-end:0}.si-tree-view{overflow:auto;flex:1 0 0;min-block-size:0}.si-tree-view.si-tree-horizontal-scroll{display:flex;flex-wrap:wrap;align-content:flex-start}.si-tree-view-root-ul{list-style:none;padding:0;margin:0;flex:1 1 auto}@supports (-webkit-touch-callout: none){.si-tree-horizontal-scroll{transform:translateZ(0)}}\n"] }]
        }], propDecorators: { updateTreeDisplay: [{
                type: Input
            }], scrollIntoView: [{
                type: Input
            }], contextMenuItems: [{
                type: Input
            }], childrenIndentation: [{
                type: Input
            }], horizontalScrolling: [{
                type: Input
            }], compactMode: [{
                type: Input
            }], expandCollapseAll: [{
                type: Input
            }], expandAllTooltip: [{
                type: Input
            }], collapseAllTooltip: [{
                type: Input
            }], contextMenuAriaLabel: [{
                type: Input
            }], icons: [{
                type: Input
            }], itemsVirtualizedChanged: [{
                type: Output
            }], treeItemFolderClicked: [{
                type: Output
            }], treeItemFolderStateChanged: [{
                type: Output
            }], treeItemClicked: [{
                type: Output
            }], treeItemCheckboxClicked: [{
                type: Output
            }], loadChildren: [{
                type: Output
            }], treeItemsSelected: [{
                type: Output
            }], templates: [{
                type: ContentChildren,
                args: [SiTreeViewItemTemplateDirective]
            }], trackByFunction: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], pagesVirtualized: [{
                type: Input
            }], folderStateLeft: [{
                type: Input
            }], folderStateStart: [{
                type: Input
            }], isVirtualized: [{
                type: Input
            }], items: [{
                type: Input
            }], selectedItem: [{
                type: Input
            }], singleSelectMode: [{
                type: Input
            }], enableDataField1: [{
                type: Input
            }], enableDataField2: [{
                type: Input
            }], enableStateIndicator: [{
                type: Input
            }], enableIcon: [{
                type: Input
            }], enableContextMenuButton: [{
                type: Input
            }], enableSelection: [{
                type: Input
            }], deleteChildrenOnCollapse: [{
                type: Input
            }], flatTree: [{
                type: Input
            }], groupedList: [{
                type: Input
            }], enableCheckbox: [{
                type: Input
            }], enableOptionbox: [{
                type: Input
            }], expandOnClick: [{
                type: Input
            }], inheritChecked: [{
                type: Input
            }], noActionsString: [{
                type: Input
            }], onKeyUpShift: [{
                type: HostListener,
                args: ['document:keyup.shift', ['$event']]
            }], onKeyUpCtrl: [{
                type: HostListener,
                args: ['document:keyup.control', ['$event']]
            }], onKeyUpMeta: [{
                type: HostListener,
                args: ['document:keyup.meta', ['$event']]
            }], onMouseLeave: [{
                type: HostListener,
                args: ['document:mouseleave', ['$event']]
            }], treeViewInnerElement: [{
                type: ViewChild,
                args: ['treeViewInner', { read: ElementRef, static: true }]
            }] } });

class SiTreeViewModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewModule, declarations: [SiTreeViewComponent, SiTreeViewItemComponent, SiTreeViewItemTemplateDirective], imports: [CommonModule,
            SiDropdownModule,
            SiListInteractionModule,
            SiLoadingSpinnerModule,
            SiMenuModule,
            SiTranslateModule], exports: [SiTreeViewComponent, SiTreeViewItemComponent, SiTreeViewItemTemplateDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewModule, imports: [CommonModule,
            SiDropdownModule,
            SiListInteractionModule,
            SiLoadingSpinnerModule,
            SiMenuModule,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTreeViewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SiDropdownModule,
                        SiListInteractionModule,
                        SiLoadingSpinnerModule,
                        SiMenuModule,
                        SiTranslateModule
                    ],
                    declarations: [SiTreeViewComponent, SiTreeViewItemComponent, SiTreeViewItemTemplateDirective],
                    exports: [SiTreeViewComponent, SiTreeViewItemComponent, SiTreeViewItemTemplateDirective]
                }]
        }] });

class SiWizardStepComponent {
    heading = '';
    isValid = true;
    isNextNavigable = true;
    failed = false;
    next = new EventEmitter();
    back = new EventEmitter();
    save = new EventEmitter();
    cdRef = inject(ChangeDetectorRef);
    parent;
    _isActive = false;
    /**
     * Whether this step is currently active or not.
     */
    get isActive() {
        return this._isActive;
    }
    set isActive(value) {
        this._isActive = value;
        this.cdRef.markForCheck();
    }
    ngOnChanges() {
        this.parent?.notifyChildrenUpdated();
    }
    /**
     * Register this wizard step to its parent {@link SiWizardComponent}.
     * Should usually be done automatically by the {@link SiWizardComponent}.
     * @param parent The parent this belongs to.
     */
    registerParent(parent) {
        this.parent = parent;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiWizardStepComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiWizardStepComponent, selector: "si-wizard-step", inputs: { heading: "heading", isValid: "isValid", isNextNavigable: "isNextNavigable", failed: "failed" }, outputs: { next: "next", back: "back", save: "save" }, usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"isActive\">\n  <ng-content></ng-content>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiWizardStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-wizard-step', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"isActive\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { heading: [{
                type: Input
            }], isValid: [{
                type: Input
            }], isNextNavigable: [{
                type: Input
            }], failed: [{
                type: Input
            }], next: [{
                type: Output
            }], back: [{
                type: Output
            }], save: [{
                type: Output
            }] } });

class SiWizardComponent {
    wizardSteps;
    wizardContainerElement;
    wizardCancelButtonContainerElement;
    wizardButtonContainerElement;
    /**
     * Description of back button.
     */
    backText = $localize `:@@SI_WIZARD.BACK:Back`;
    /**
     * Description of next button.
     */
    nextText = $localize `:@@SI_WIZARD.NEXT:Next`;
    /**
     * Show navigation buttons previous/next.
     */
    hasNavigation = true;
    /**
     * Description of save button.
     */
    saveText = $localize `:@@SI_WIZARD.SAVE:Save`;
    /**
     * Text shown if you complete the wizard.
     */
    completionText = $localize `:@@SI_WIZARD.COMPLETED:Wizard completed!`;
    /**
     * Description of cancel button.
     */
    cancelText = $localize `:@@SI_WIZARD.CANCEL:Cancel`;
    /**
     * Show cancel bottom
     */
    hasCancel = false;
    /**
     * Display a predefined page by the end of the wizard.
     */
    enableCompletionPage = false;
    /**
     * Define how many milliseconds the completion page is visible.
     */
    completionPageVisibleTime = 3000;
    /**
     * Class name of icon shown for current and upcoming steps.
     */
    stepIcon = 'element-not-checked';
    /**
     * Class name of icon shown when a step was completed.
     */
    stepCompletedIcon = 'element-checked-filled';
    /**
     * Class name of icon shown when a step had an error.
     */
    stepFailedIcon = 'element-warning-filled';
    /**
     * Callback function triggered after the wizard has been completed.
     */
    completionAction = new EventEmitter();
    /**
     * Callback function triggered if the wizard has been canceled.
     */
    cancel = new EventEmitter();
    /**
     * Get the current step wizard step index.
     */
    get index() {
        return this._index;
    }
    /**
     * Get number of wizard steps.
     */
    get stepCount() {
        return this.steps.length;
    }
    /**
     * Get current visible wizard step.
     */
    get currentStep() {
        return this._currentStep;
    }
    steps = [];
    allStepsAreVisible = true;
    visibleSteps = 0;
    showCompletionPage = false;
    trackByIndex = (index) => index;
    isSmall = false;
    _index = 0;
    _currentStep;
    destroyer = new Subject();
    cdRef = inject(ChangeDetectorRef);
    ngAfterContentInit() {
        this.updateSteps();
        this._currentStep = this.steps[0];
        this.cdRef.markForCheck();
        queueMicrotask(() => {
            if (this.steps.length > 0) {
                this.steps[0].isActive = true;
                this.cdRef.markForCheck();
            }
        });
        this.wizardSteps.changes.pipe(takeUntil(this.destroyer)).subscribe(() => {
            this.updateSteps();
            if (!this.wizardSteps.some(step => step === this.currentStep)) {
                this._currentStep = this.wizardSteps.first;
                this._index = 0;
            }
            else {
                this._index = this.steps.indexOf(this.currentStep);
            }
            this.cdRef.markForCheck();
            queueMicrotask(() => {
                this.activate(this.currentStep);
                this.calculateNumberOfVisibleSteps();
                this.cdRef.markForCheck();
            });
        });
    }
    ngOnDestroy() {
        this.destroyer.next();
        this.destroyer.complete();
    }
    /** @internal */
    notifyChildrenUpdated() {
        this.cdRef.markForCheck();
    }
    canActivate(stepIndex) {
        if (stepIndex < 0) {
            return false;
        }
        // Can always activate previous steps
        if (stepIndex < this.index) {
            return true;
        }
        // We are already in the step. Nothing to activate.
        if (stepIndex === this.index) {
            return false;
        }
        // Fast-forward: check all steps if they are valid
        for (let i = this.index; i < stepIndex; i++) {
            const theStep = this.steps[i];
            if (!theStep.isValid) {
                return false;
            }
        }
        return true;
    }
    activateStep(event, stepIndex) {
        event.preventDefault();
        if (this.canActivate(stepIndex)) {
            if (stepIndex > this.index) {
                this.next(stepIndex - this.index);
            }
            if (stepIndex < this.index) {
                this.back(this.index - stepIndex);
            }
        }
    }
    getStateClass(stepIndex) {
        if (stepIndex === this.index) {
            return 'active';
        }
        if (!this.canActivate(stepIndex)) {
            return 'disabled';
        }
        if (stepIndex < this.index) {
            return 'completed';
        }
        return '';
    }
    getAriaDisabled(stepIndex) {
        if (!this.canActivate(stepIndex)) {
            return 'true';
        }
        return 'false';
    }
    getAriaCurrent(stepIndex) {
        if (stepIndex === this.index) {
            return 'step';
        }
        return 'false';
    }
    getStepClass(stepIndex) {
        const classes = ['step'];
        if (this.isVisibleStep(stepIndex + 1)) {
            classes.push('directly-following');
        }
        else if (stepIndex !== this.steps.length - 1) {
            classes.push('not-directly-following');
        }
        if (stepIndex !== 0 && !this.isVisibleStep(stepIndex - 1)) {
            classes.push('not-first-step');
        }
        if (this.isVisibleStep(stepIndex + 1)) {
            classes.push('line-' + this.getStateClass(stepIndex + 1));
        }
        return classes;
    }
    /**
     * Go to the next wizard step.
     * @param delta optional number of steps to move forward.
     */
    next(delta = 1) {
        if (this.index === this.steps.length) {
            return;
        }
        const stepIndex = this.index + delta;
        const nextStep = this.steps[stepIndex];
        if (this.canActivate(stepIndex)) {
            this.currentStep.next.emit();
            if (this.currentStep.isNextNavigable) {
                this.activate(nextStep);
            }
        }
        this.cdRef.markForCheck();
    }
    /**
     * Go to the previous wizard step.
     * @param delta optional number of steps to move backwards.
     */
    back(delta = 1) {
        if (this.index === 0) {
            return;
        }
        this.currentStep.back.emit();
        this.activate(this.steps[this.index - delta]);
        this.cdRef.markForCheck();
    }
    /**
     * Triggers the save action to complete the wizard
     */
    save() {
        this.currentStep.save.emit();
        if (this.enableCompletionPage && this.completionPageVisibleTime > 0) {
            this.showCompletionPage = true;
            setTimeout(() => {
                this.showCompletionPage = false;
                this.completionAction.emit();
                this.cdRef.markForCheck();
            }, this.completionPageVisibleTime);
        }
        else {
            this.completionAction.emit();
        }
    }
    getState(step, stepIndex) {
        if (step.failed === true) {
            return `title-warning ${this.stepFailedIcon}`;
        }
        else {
            const txtStyle = step.isActive ? 'wizard-active element-radio-checked' : `${this.stepIcon}`;
            return stepIndex >= this.index ? `${txtStyle}` : `text-primary ${this.stepCompletedIcon}`;
        }
    }
    isVisibleStep(stepIndex) {
        if (this.allStepsAreVisible) {
            return true;
        }
        if (this.index === stepIndex) {
            return true;
        }
        let visibleStepsDelta = (this.visibleSteps - 1) / 2;
        for (let i = visibleStepsDelta; i > 0; i--) {
            if (this.index - i < 0 || this.index + i > this.steps.length - 1) {
                visibleStepsDelta = this.visibleSteps - i;
            }
        }
        for (let i = visibleStepsDelta; i > 0; i--) {
            if (stepIndex === this.index - i || stepIndex === this.index + i) {
                return true;
            }
        }
        return false;
    }
    activate(step) {
        if (this.currentStep) {
            this.currentStep.isActive = false;
        }
        step.isActive = true;
        this._currentStep = step;
        this._index = this.steps.indexOf(step);
    }
    calculateNumberOfVisibleSteps() {
        const containerWidth = this.wizardContainerElement.nativeElement.clientWidth;
        const prevNextWidth = this.wizardButtonContainerElement.nativeElement.clientWidth;
        const cancelWidth = this.hasCancel
            ? this.wizardCancelButtonContainerElement.nativeElement.clientWidth
            : 0;
        const oneStepWidth = this.wizardContainerElement.nativeElement.querySelector('.step')?.clientWidth;
        // visible steps can be only 3, 5, 7,..
        const allButtonsWidth = 2 * prevNextWidth + cancelWidth;
        let placeableSteps = oneStepWidth
            ? Math.floor((containerWidth - allButtonsWidth) / oneStepWidth)
            : 1;
        this.allStepsAreVisible = placeableSteps >= this.steps.length;
        if (!this.allStepsAreVisible && placeableSteps % 2 === 0) {
            placeableSteps--;
        }
        if (containerWidth < 540 + allButtonsWidth) {
            this.isSmall = true;
            this.visibleSteps = 3;
        }
        else {
            this.isSmall = false;
            this.visibleSteps = placeableSteps;
        }
    }
    updateSteps() {
        this.steps = this.wizardSteps.toArray();
        this.steps.forEach(step => step.registerParent(this));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiWizardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiWizardComponent, selector: "si-wizard", inputs: { backText: "backText", nextText: "nextText", hasNavigation: "hasNavigation", saveText: "saveText", completionText: "completionText", cancelText: "cancelText", hasCancel: "hasCancel", enableCompletionPage: "enableCompletionPage", completionPageVisibleTime: "completionPageVisibleTime", stepIcon: "stepIcon", stepCompletedIcon: "stepCompletedIcon", stepFailedIcon: "stepFailedIcon" }, outputs: { completionAction: "completionAction", cancel: "cancel" }, queries: [{ propertyName: "wizardSteps", predicate: SiWizardStepComponent }], viewQueries: [{ propertyName: "wizardContainerElement", first: true, predicate: ["container"], descendants: true }, { propertyName: "wizardCancelButtonContainerElement", first: true, predicate: ["cancelButtonContainer"], descendants: true }, { propertyName: "wizardButtonContainerElement", first: true, predicate: ["buttonContainer"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"!showCompletionPage\">\n  <div\n    #container\n    class=\"container-wizard\"\n    [class.display-one-step]=\"visibleSteps === 1\"\n    (siResizeObserver)=\"calculateNumberOfVisibleSteps()\"\n  >\n    <div *ngIf=\"hasCancel\" #cancelButtonContainer class=\"me-7\">\n      <div class=\"wizard-btn-container\" (click)=\"cancel.emit()\">\n        <button type=\"button\" class=\"btn btn-circle btn-sm btn-secondary element-cancel mt-2 mb-4\">\n          <span class=\"visually-hidden\">{{ cancelText | translate }}</span>\n        </button>\n        <div class=\"si-title-2 text-primary\">{{ cancelText | translate }}</div>\n      </div>\n    </div>\n    <div #buttonContainer class=\"wizard-btn-container\">\n      <div *ngIf=\"hasNavigation\" class=\"back\" [class.invisible]=\"index === 0\" (click)=\"back(1)\">\n        <button type=\"button\" class=\"btn btn-circle btn-secondary flip-rtl element-left-4 mb-2\">\n          <span class=\"visually-hidden\">{{ backText | translate }}</span>\n        </button>\n        <div class=\"si-title-2 text-primary\">{{ backText | translate }}</div>\n      </div>\n    </div>\n    <div class=\"container-steps\" [class.small]=\"isSmall\">\n      <ng-container *ngFor=\"let step of steps; let stepIndex = index; trackBy: trackByIndex\">\n        <div\n          *ngIf=\"isVisibleStep(stepIndex)\"\n          [ngClass]=\"getStepClass(stepIndex)\"\n          [class.small]=\"isSmall\"\n        >\n          <a\n            class=\"focus-none\"\n            [ngClass]=\"getStateClass(stepIndex)\"\n            [attr.aria-current]=\"getAriaCurrent(stepIndex)\"\n            [attr.href]=\"!canActivate(stepIndex) || !currentStep?.isNextNavigable ? null : '#'\"\n            (click)=\"activateStep($event, stepIndex)\"\n          >\n            <i [ngClass]=\"[getState(step, stepIndex)]\"></i>\n            <div\n              class=\"title si-title-2 text-center\"\n              [attr.aria-disabled]=\"getAriaDisabled(stepIndex)\"\n              >{{ step.heading | translate }}</div\n            >\n          </a>\n        </div>\n      </ng-container>\n    </div>\n    <div class=\"wizard-btn-container\" [class.wizard-text-deactivate]=\"!currentStep?.isValid\">\n      <div\n        *ngIf=\"hasNavigation\"\n        class=\"next\"\n        [class.invisible]=\"index === steps.length - 1\"\n        (click)=\"next(1)\"\n      >\n        <button\n          type=\"button\"\n          class=\"btn btn-circle btn-primary flip-rtl element-right-4 mb-2\"\n          [disabled]=\"!currentStep?.isValid\"\n        >\n          <span class=\"visually-hidden\">{{ nextText | translate }}</span>\n        </button>\n        <div\n          class=\"si-title-2 text-primary\"\n          [class.disabled]=\"!currentStep?.isValid\"\n          [attr.aria-disabled]=\"!currentStep?.isValid\"\n          >{{ nextText | translate }}</div\n        >\n      </div>\n    </div>\n  </div>\n  <div>\n    <ng-content></ng-content>\n  </div>\n  <div class=\"container-wizard\">\n    <button\n      *ngIf=\"index === steps.length - 1\"\n      type=\"button\"\n      class=\"btn btn-info save\"\n      [disabled]=\"!currentStep?.isValid || !currentStep?.isNextNavigable\"\n      (click)=\"save()\"\n      >{{ saveText | translate }}</button\n    >\n  </div>\n</ng-container>\n\n<div *ngIf=\"showCompletionPage\" class=\"text-center\">\n  <i class=\"display-1 text-success element-checked\"></i>\n  <p class=\"si-title-1\"> {{ completionText | translate }}</p>\n</div>\n", styles: [".title-secondary{color:var(--element-text-secondary)}.title-warning{color:var(--element-status-warning)}.container-steps{display:flex;justify-content:center;padding-block:0;padding-inline:6px}.container-steps.small{inline-size:100%}.directly-following:not(:last-child):after{background-color:var(--element-ui-2);content:\"\";position:absolute;block-size:2px;inline-size:calc(100% - 1.5rem - 8px);inset-block-start:calc(.75rem - 1px);inset-inline-start:calc(50% + .75rem + 4px)}.not-directly-following:last-child:after,.not-first-step:first-child:before{border-block-start:2px var(--element-ui-2) dashed;content:\"\";position:absolute;block-size:2px;inline-size:1.875rem;inset-block-start:calc(.75rem - 1px);inset-inline-start:calc(50% + .75rem + 4px)}.not-first-step:first-child:before{inset-inline-start:calc(50% - 2.625rem - 4px);border-color:var(--element-ui-0)}.wizard-active{color:var(--element-ui-0)}.step{position:relative;text-align:center;margin-block-start:8px;padding-block:0;padding-inline:16px}.step i{font-size:1.5rem}.step a{color:var(--element-ui-2)}.step a:focus-visible{outline:0}.step a:focus-visible i{box-shadow:inset 0 0 0 var(--element-button-focus-width) var(--element-focus-default),inset 0 0 0 calc(var(--element-button-focus-width) + var(--element-button-focus-overlay-width)) var(--element-button-focus-overlay-color);border-radius:50%}.step a .title{color:var(--element-text-secondary)}.step a .title:hover{text-decoration:none}.step a .title{inline-size:9.75rem;margin-block-start:12px}.step .active,.step .active .title{color:var(--element-ui-0)}.step .disabled,.step .disabled:hover{opacity:.5;text-decoration:none}.step a:not(.disabled):hover,.step a:not(.disabled):hover i,.step a:not(.disabled):hover .title{color:var(--element-ui-0-hover)!important;text-decoration:none}.step .completed .title{color:var(--element-text-primary)}.step.line-completed:after{background-color:var(--element-ui-0)}.step.line-active:after{background-color:var(--element-ui-0)}.step.line-disabled:after{opacity:.5}.step.small,.step.small a .title{inline-size:100%}.container-wizard{inline-size:100%;display:flex;flex-wrap:nowrap;justify-content:center;padding-block:8px 12px;padding-inline:0}.container-wizard.display-one-step{justify-content:space-between}.wizard-btn-container{max-inline-size:50px;min-inline-size:40px;text-align:center;cursor:pointer}.wizard-btn-container.wizard-text-deactivate:hover{cursor:not-allowed;color:var(--element-text-secondary)}.wizard-btn-container .disabled{opacity:.5}.wizard-btn-container .invisible{visibility:hidden}.wizard-btn-container:hover .text-primary{color:var(--element-ui-0-hover)!important}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$8.SiResizeObserverDirective, selector: "[siResizeObserver]", inputs: ["resizeThrottle"], outputs: ["siResizeObserver"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
__decorate([
    WebComponentContentChildren(SiWizardStepComponent)
], SiWizardComponent.prototype, "wizardSteps", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiWizardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-wizard', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!showCompletionPage\">\n  <div\n    #container\n    class=\"container-wizard\"\n    [class.display-one-step]=\"visibleSteps === 1\"\n    (siResizeObserver)=\"calculateNumberOfVisibleSteps()\"\n  >\n    <div *ngIf=\"hasCancel\" #cancelButtonContainer class=\"me-7\">\n      <div class=\"wizard-btn-container\" (click)=\"cancel.emit()\">\n        <button type=\"button\" class=\"btn btn-circle btn-sm btn-secondary element-cancel mt-2 mb-4\">\n          <span class=\"visually-hidden\">{{ cancelText | translate }}</span>\n        </button>\n        <div class=\"si-title-2 text-primary\">{{ cancelText | translate }}</div>\n      </div>\n    </div>\n    <div #buttonContainer class=\"wizard-btn-container\">\n      <div *ngIf=\"hasNavigation\" class=\"back\" [class.invisible]=\"index === 0\" (click)=\"back(1)\">\n        <button type=\"button\" class=\"btn btn-circle btn-secondary flip-rtl element-left-4 mb-2\">\n          <span class=\"visually-hidden\">{{ backText | translate }}</span>\n        </button>\n        <div class=\"si-title-2 text-primary\">{{ backText | translate }}</div>\n      </div>\n    </div>\n    <div class=\"container-steps\" [class.small]=\"isSmall\">\n      <ng-container *ngFor=\"let step of steps; let stepIndex = index; trackBy: trackByIndex\">\n        <div\n          *ngIf=\"isVisibleStep(stepIndex)\"\n          [ngClass]=\"getStepClass(stepIndex)\"\n          [class.small]=\"isSmall\"\n        >\n          <a\n            class=\"focus-none\"\n            [ngClass]=\"getStateClass(stepIndex)\"\n            [attr.aria-current]=\"getAriaCurrent(stepIndex)\"\n            [attr.href]=\"!canActivate(stepIndex) || !currentStep?.isNextNavigable ? null : '#'\"\n            (click)=\"activateStep($event, stepIndex)\"\n          >\n            <i [ngClass]=\"[getState(step, stepIndex)]\"></i>\n            <div\n              class=\"title si-title-2 text-center\"\n              [attr.aria-disabled]=\"getAriaDisabled(stepIndex)\"\n              >{{ step.heading | translate }}</div\n            >\n          </a>\n        </div>\n      </ng-container>\n    </div>\n    <div class=\"wizard-btn-container\" [class.wizard-text-deactivate]=\"!currentStep?.isValid\">\n      <div\n        *ngIf=\"hasNavigation\"\n        class=\"next\"\n        [class.invisible]=\"index === steps.length - 1\"\n        (click)=\"next(1)\"\n      >\n        <button\n          type=\"button\"\n          class=\"btn btn-circle btn-primary flip-rtl element-right-4 mb-2\"\n          [disabled]=\"!currentStep?.isValid\"\n        >\n          <span class=\"visually-hidden\">{{ nextText | translate }}</span>\n        </button>\n        <div\n          class=\"si-title-2 text-primary\"\n          [class.disabled]=\"!currentStep?.isValid\"\n          [attr.aria-disabled]=\"!currentStep?.isValid\"\n          >{{ nextText | translate }}</div\n        >\n      </div>\n    </div>\n  </div>\n  <div>\n    <ng-content></ng-content>\n  </div>\n  <div class=\"container-wizard\">\n    <button\n      *ngIf=\"index === steps.length - 1\"\n      type=\"button\"\n      class=\"btn btn-info save\"\n      [disabled]=\"!currentStep?.isValid || !currentStep?.isNextNavigable\"\n      (click)=\"save()\"\n      >{{ saveText | translate }}</button\n    >\n  </div>\n</ng-container>\n\n<div *ngIf=\"showCompletionPage\" class=\"text-center\">\n  <i class=\"display-1 text-success element-checked\"></i>\n  <p class=\"si-title-1\"> {{ completionText | translate }}</p>\n</div>\n", styles: [".title-secondary{color:var(--element-text-secondary)}.title-warning{color:var(--element-status-warning)}.container-steps{display:flex;justify-content:center;padding-block:0;padding-inline:6px}.container-steps.small{inline-size:100%}.directly-following:not(:last-child):after{background-color:var(--element-ui-2);content:\"\";position:absolute;block-size:2px;inline-size:calc(100% - 1.5rem - 8px);inset-block-start:calc(.75rem - 1px);inset-inline-start:calc(50% + .75rem + 4px)}.not-directly-following:last-child:after,.not-first-step:first-child:before{border-block-start:2px var(--element-ui-2) dashed;content:\"\";position:absolute;block-size:2px;inline-size:1.875rem;inset-block-start:calc(.75rem - 1px);inset-inline-start:calc(50% + .75rem + 4px)}.not-first-step:first-child:before{inset-inline-start:calc(50% - 2.625rem - 4px);border-color:var(--element-ui-0)}.wizard-active{color:var(--element-ui-0)}.step{position:relative;text-align:center;margin-block-start:8px;padding-block:0;padding-inline:16px}.step i{font-size:1.5rem}.step a{color:var(--element-ui-2)}.step a:focus-visible{outline:0}.step a:focus-visible i{box-shadow:inset 0 0 0 var(--element-button-focus-width) var(--element-focus-default),inset 0 0 0 calc(var(--element-button-focus-width) + var(--element-button-focus-overlay-width)) var(--element-button-focus-overlay-color);border-radius:50%}.step a .title{color:var(--element-text-secondary)}.step a .title:hover{text-decoration:none}.step a .title{inline-size:9.75rem;margin-block-start:12px}.step .active,.step .active .title{color:var(--element-ui-0)}.step .disabled,.step .disabled:hover{opacity:.5;text-decoration:none}.step a:not(.disabled):hover,.step a:not(.disabled):hover i,.step a:not(.disabled):hover .title{color:var(--element-ui-0-hover)!important;text-decoration:none}.step .completed .title{color:var(--element-text-primary)}.step.line-completed:after{background-color:var(--element-ui-0)}.step.line-active:after{background-color:var(--element-ui-0)}.step.line-disabled:after{opacity:.5}.step.small,.step.small a .title{inline-size:100%}.container-wizard{inline-size:100%;display:flex;flex-wrap:nowrap;justify-content:center;padding-block:8px 12px;padding-inline:0}.container-wizard.display-one-step{justify-content:space-between}.wizard-btn-container{max-inline-size:50px;min-inline-size:40px;text-align:center;cursor:pointer}.wizard-btn-container.wizard-text-deactivate:hover{cursor:not-allowed;color:var(--element-text-secondary)}.wizard-btn-container .disabled{opacity:.5}.wizard-btn-container .invisible{visibility:hidden}.wizard-btn-container:hover .text-primary{color:var(--element-ui-0-hover)!important}\n"] }]
        }], propDecorators: { wizardSteps: [{
                type: ContentChildren,
                args: [SiWizardStepComponent]
            }], wizardContainerElement: [{
                type: ViewChild,
                args: ['container', { static: false }]
            }], wizardCancelButtonContainerElement: [{
                type: ViewChild,
                args: ['cancelButtonContainer', { static: false }]
            }], wizardButtonContainerElement: [{
                type: ViewChild,
                args: ['buttonContainer', { static: false }]
            }], backText: [{
                type: Input
            }], nextText: [{
                type: Input
            }], hasNavigation: [{
                type: Input
            }], saveText: [{
                type: Input
            }], completionText: [{
                type: Input
            }], cancelText: [{
                type: Input
            }], hasCancel: [{
                type: Input
            }], enableCompletionPage: [{
                type: Input
            }], completionPageVisibleTime: [{
                type: Input
            }], stepIcon: [{
                type: Input
            }], stepCompletedIcon: [{
                type: Input
            }], stepFailedIcon: [{
                type: Input
            }], completionAction: [{
                type: Output
            }], cancel: [{
                type: Output
            }] } });

class SiWizardModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiWizardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiWizardModule, declarations: [SiWizardComponent, SiWizardStepComponent], imports: [CommonModule, SiResizeObserverModule, SiTranslateModule], exports: [SiWizardComponent, SiWizardStepComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiWizardModule, imports: [CommonModule, SiResizeObserverModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiWizardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiResizeObserverModule, SiTranslateModule],
                    declarations: [SiWizardComponent, SiWizardStepComponent],
                    exports: [SiWizardComponent, SiWizardStepComponent]
                }]
        }] });

/**
 * The component shall be use to indicate that an authenticated
 * user does not have the required permissions.
 */
class SiUnauthorizedPageComponent {
    /** The element warning icon. */
    icon = 'element-warning-filled';
    /** The main heading indicating the problem. */
    heading;
    /** A sub heading is a sentence summarizing the problem. */
    subHeading;
    /** May be a longer description explaining the problem. */
    description;
    /**
     * Use the link object if you have one option to follow. A link object
     * has a title to be displayed and can be configured with an external link,
     * a router link, or a custom action. If you want to provide multiple options,
     * add your own content into the component.
     */
    link;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiUnauthorizedPageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiUnauthorizedPageComponent, selector: "si-unauthorized-page", inputs: { icon: "icon", heading: "heading", subHeading: "subHeading", description: "description", link: "link" }, ngImport: i0, template: "<div class=\"h-100 d-flex flex-column justify-content-center align-items-center p-6\">\n  <si-icon color=\"status-warning\" size=\"display-1\" [icon]=\"icon\"></si-icon>\n  <h1 *ngIf=\"heading\" class=\"my-9\">{{ heading | translate }}</h1>\n  <h2 *ngIf=\"subHeading\" class=\"mb-9\">{{ subHeading | translate }}</h2>\n  <p *ngIf=\"description\" class=\"text-pre-wrap text-center si-body-1 mb-9\">{{\n    description | translate\n  }}</p>\n  <a *ngIf=\"link\" class=\"btn btn-primary\" [siLink]=\"link\">{{\n    link.title ? link.title : ('Go back' | translate)\n  }}</a>\n  <ng-content></ng-content>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.SiIconComponent, selector: "si-icon", inputs: ["icon", "color", "stackedIcon", "stackedColor", "alt", "size"] }, { kind: "directive", type: i3$5.SiLinkDirective, selector: "[siLink]", inputs: ["siLink", "siLinkDefaultTarget", "actionParam", "activeClass", "exactMatch", "ariaCurrent"], outputs: ["activeChange"], exportAs: ["siLink"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiUnauthorizedPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-unauthorized-page', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"h-100 d-flex flex-column justify-content-center align-items-center p-6\">\n  <si-icon color=\"status-warning\" size=\"display-1\" [icon]=\"icon\"></si-icon>\n  <h1 *ngIf=\"heading\" class=\"my-9\">{{ heading | translate }}</h1>\n  <h2 *ngIf=\"subHeading\" class=\"mb-9\">{{ subHeading | translate }}</h2>\n  <p *ngIf=\"description\" class=\"text-pre-wrap text-center si-body-1 mb-9\">{{\n    description | translate\n  }}</p>\n  <a *ngIf=\"link\" class=\"btn btn-primary\" [siLink]=\"link\">{{\n    link.title ? link.title : ('Go back' | translate)\n  }}</a>\n  <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { icon: [{
                type: Input
            }], heading: [{
                type: Input
            }], subHeading: [{
                type: Input
            }], description: [{
                type: Input
            }], link: [{
                type: Input
            }] } });

class SiUnauthorizedPageModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiUnauthorizedPageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiUnauthorizedPageModule, declarations: [SiUnauthorizedPageComponent], imports: [CommonModule, RouterModule, SiIconModule, SiLinkModule, SiTranslateModule], exports: [SiUnauthorizedPageComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiUnauthorizedPageModule, imports: [CommonModule, RouterModule, SiIconModule, SiLinkModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiUnauthorizedPageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiUnauthorizedPageComponent],
                    imports: [CommonModule, RouterModule, SiIconModule, SiLinkModule, SiTranslateModule],
                    exports: [SiUnauthorizedPageComponent]
                }]
        }] });

class SiDatatableInteractionDirective {
    /**
     * The selection type of the datatable, will automatically be set if set for datatable.
     */
    selectionType = '';
    /**
     * Automatically select every row or cell that is navigated trough.
     * Is ignored unless `selectionType` is `single` or `cell`.
     */
    datatableInteractionAutoSelect = false;
    tabIndex = '0';
    element = inject(ElementRef).nativeElement;
    tableBody;
    autoSelectTimeout;
    isMousedown = false;
    onKeydown(event) {
        if (event.key === 'ArrowDown') {
            const first = this.selectionType === 'cell'
                ? this.element.querySelector('.datatable-row-wrapper > .datatable-body-row .datatable-body-cell')
                : this.element.querySelector('.datatable-row-wrapper > .datatable-body-row');
            if (first) {
                first.focus();
            }
        }
        else if (event.key === 'ArrowUp') {
            const last = this.selectionType === 'cell'
                ? this.element.querySelector('.datatable-row-wrapper:last-child > .datatable-body-row .datatable-body-cell')
                : this.element.querySelector('.datatable-row-wrapper:last-child > .datatable-body-row');
            if (last) {
                last.focus();
            }
        }
    }
    onMousedown(event) {
        this.isMousedown = true;
    }
    onMouseup(event) {
        this.isMousedown = false;
    }
    onFocusin(event) {
        const target = event.target;
        if (!target) {
            return;
        }
        clearTimeout(this.autoSelectTimeout);
        if (!this.isMousedown &&
            this.datatableInteractionAutoSelect &&
            (this.selectionType === 'single' || this.selectionType === 'cell')) {
            this.autoSelectTimeout = setTimeout(() => {
                const enterEvent = new KeyboardEvent('keydown', { key: 'enter' });
                Object.defineProperty(enterEvent, 'keyCode', { get: () => 13 });
                target.dispatchEvent(enterEvent);
            }, 100);
        }
        if (this.element.classList.contains('virtualized')) {
            if (this.tableBody) {
                const lastList = this.selectionType === 'cell'
                    ? this.tableBody.querySelectorAll('.datatable-row-wrapper:last-child > .datatable-body-row .datatable-body-cell')
                    : this.tableBody.querySelectorAll('.datatable-row-wrapper:last-child > .datatable-body-row');
                if (Array.from(lastList).includes(target)) {
                    this.tableBody.scrollTop = this.tableBody.scrollTop + lastList[0].clientHeight;
                }
                else {
                    const firstList = this.selectionType === 'cell'
                        ? this.tableBody.querySelectorAll('.datatable-row-wrapper:first-child > .datatable-body-row .datatable-body-cell')
                        : this.tableBody.querySelectorAll('.datatable-row-wrapper:first-child > .datatable-body-row');
                    if (Array.from(firstList).includes(target)) {
                        this.tableBody.scrollTop = this.tableBody.scrollTop - firstList[0].clientHeight;
                    }
                }
            }
        }
    }
    ngOnInit() {
        this.tableBody = this.element.querySelector('datatable-body');
        if (this.tableBody) {
            this.tableBody.tabIndex = -1;
        }
    }
    ngOnDestroy() {
        clearTimeout(this.autoSelectTimeout);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatatableInteractionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiDatatableInteractionDirective, selector: "[siDatatableInteraction]", inputs: { selectionType: "selectionType", datatableInteractionAutoSelect: "datatableInteractionAutoSelect" }, host: { listeners: { "keydown": "onKeydown($event)", "mousedown": "onMousedown($event)", "mouseup": "onMouseup($event)", "focusin": "onFocusin($event)" }, properties: { "attr.tabindex": "this.tabIndex" } }, exportAs: ["si-datatable-interaction"], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatatableInteractionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siDatatableInteraction]',
                    exportAs: 'si-datatable-interaction'
                }]
        }], propDecorators: { selectionType: [{
                type: Input
            }], datatableInteractionAutoSelect: [{
                type: Input
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onMousedown: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }], onMouseup: [{
                type: HostListener,
                args: ['mouseup', ['$event']]
            }], onFocusin: [{
                type: HostListener,
                args: ['focusin', ['$event']]
            }] } });

class SiDatatableModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatatableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiDatatableModule, declarations: [SiDatatableInteractionDirective], imports: [CommonModule], exports: [SiDatatableInteractionDirective] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatatableModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiDatatableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SiDatatableInteractionDirective],
                    exports: [SiDatatableInteractionDirective]
                }]
        }] });

const SI_DATATABLE_CONFIG = {
    cssClasses: {
        sortAscending: 'icon element-sort-up text-primary',
        sortDescending: 'icon element-sort-down text-primary',
        pagerLeftArrow: 'icon element-left-2 flip-rtl',
        pagerRightArrow: 'icon element-right-2 flip-rtl',
        pagerPrevious: 'icon element-double-left flip-rtl',
        pagerNext: 'icon element-double-right flip-rtl',
        sortUnset: ''
    },
    headerHeight: 40,
    footerHeight: 40,
    rowHeight: 64,
    rowHeightSmall: 48,
    rowHeightExtraSmall: 32,
    rowHeightTiny: 24
};

class SiSidePanelService {
    contentSubject = new BehaviorSubject(undefined);
    content$ = this.contentSubject.asObservable();
    openSubject = new BehaviorSubject(false);
    isOpen$ = this.openSubject.asObservable();
    tempContentSubject = new BehaviorSubject(undefined);
    tempContent$ = this.tempContentSubject.asObservable();
    tempContentClosed;
    enableMobile = false;
    setSidePanelContent(portal) {
        this.contentSubject.next(portal);
    }
    open() {
        this.hideTemporaryContent();
        this.openSubject.next(true);
    }
    close() {
        if (this.hideTemporaryContent()) {
            return;
        }
        this.openSubject.next(false);
    }
    toggle() {
        this.hideTemporaryContent();
        this.openSubject.next(!this.openSubject.value);
    }
    isOpen() {
        return this.openSubject.value;
    }
    isTemporaryOpen() {
        return !!this.tempContentSubject.value;
    }
    showTemporaryContent(portal) {
        this.hideTemporaryContent();
        this.tempContentSubject.next(portal);
        if (portal) {
            this.tempContentClosed = new Subject();
            return this.tempContentClosed.asObservable();
        }
        return EMPTY;
    }
    hideTemporaryContent() {
        if (!this.isTemporaryOpen()) {
            return false;
        }
        if (this.tempContentClosed) {
            const sub = this.tempContentClosed;
            this.tempContentClosed = undefined;
            sub.next();
            sub.complete();
        }
        this.tempContentSubject.next(undefined);
        return true;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class SiSidePanelComponent {
    /*
     * If true, the panel is collapsed instead of completely hidden, just like the vertical navbar
     */
    collapsible = false;
    /*
     * Default state of navigation
     */
    collapsed;
    /**
     * Header of side panel
     * @deprecated Never had any effect, should be set on {@link SiSidePanelContentComponent}.
     */
    heading = '';
    /**
     * Mode of side panel
     * (ignored below a certain width)
     */
    mode = 'over';
    /**
     * Size of side-panel
     */
    size = 'regular';
    /**
     * Aria label for close button. Needed for a11y
     * @deprecated Never had any effect, should be set on {@link SiSidePanelContentComponent}.
     */
    closeButtonLabel = $localize `:@@SI_SIDE_PANEL.CLOSE:Close`;
    /**
     * Toggle icon aria-label, required for a11y
     */
    toggleItemLabel = $localize `:@@SI_SIDE_PANEL.TOGGLE:Toggle`;
    /**
     * Specifies custom breakpoints to automatically switch mode.
     * The `smMinimum` specifies the breakpoint for the mobile view.
     * The `lgMinimum` specifies the breakpoint to allow scroll mode
     * (below automatically uses over mode).
     * The `xlMinimum` specifies the breakpoint to allow scroll mode
     * with wide size (below automatically uses over mode).
     */
    breakpoints;
    /**
     * Enable mobile drawer for small screen sizes. Should not be used in conjunction with the vertical navbar.
     */
    enableMobile = false;
    /**
     * Emits when the panel is closed
     */
    closed = new EventEmitter();
    /**
     * Emits whenever the content is resized due to opening and closing or parent resize.
     */
    contentResize = new EventEmitter();
    get isCollapsible() {
        return this.collapsible && !this.showTempContent;
    }
    get isCollapsibleTemp() {
        return this.collapsible && this.showTempContent;
    }
    get isScrollMode() {
        return this.mode === 'scroll';
    }
    get isOverMode() {
        return this.mode === 'over';
    }
    get isNormalSize() {
        return this.size === 'regular';
    }
    get isWideSize() {
        return this.size === 'wide';
    }
    isXs = false;
    isSm = false;
    isMd = true;
    isLg = false;
    isXl = false;
    isCollapsed = false;
    ready = false;
    isHidden = false;
    panelElement;
    contentElement;
    portalOutlet;
    tmpPortalOutlet;
    showTempContent = false;
    /**
     * The $rpanel-transition-duration in the style is 0.5 seconds.
     * Sending the resize event after resize need to wait until resize is done.
     */
    resizeEventDelay = 500;
    resizeEvent = new Subject();
    resizeSubs;
    subscription;
    openingOrClosing = false;
    previousContentDimensions = { width: 0, height: 0 };
    isCollapsedInternal = false; // same as the other one, except w/o timeout for animation
    isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    element = inject(ElementRef);
    resizeObserver = inject(ResizeObserverService);
    service = inject(SiSidePanelService);
    cdRef = inject(ChangeDetectorRef);
    constructor() {
        if (this.isBrowser) {
            this.subscription = this.resizeEvent
                .asObservable()
                .pipe(debounceTime(this.resizeEventDelay))
                .subscribe(() => {
                this.openingOrClosing = false;
                this.emitResizeOutputs();
                if (this.isCollapsedInternal && !this.collapsible) {
                    this.isHidden = true;
                }
                this.cdRef.markForCheck();
            });
        }
    }
    ngOnInit() {
        // handle initial state to avoid flicker
        const collapsed = this.collapsed ?? !this.service.isOpen();
        this.isCollapsedInternal = collapsed;
        this.isHidden = collapsed;
        this.isCollapsed = collapsed;
        this.resizeSubs = this.resizeObserver
            .observe(this.element.nativeElement, 100, true)
            .subscribe(dim => {
            this.setBreakpoints(dim.width, dim.height);
            if (!this.ready) {
                // delay because the initial sizing needs to settle
                setTimeout(() => {
                    this.ready = true;
                    this.cdRef.markForCheck();
                }, 100);
            }
            if (!this.openingOrClosing) {
                this.emitResizeOutputs();
            }
        });
        if (this.subscription) {
            this.subscription.add(this.service.content$.subscribe(portal => this.attachContent(portal)));
            this.subscription.add(this.service.tempContent$.subscribe(portal => this.attachTempContent(portal)));
            this.subscription.add(this.service.isOpen$.subscribe(state => this.openClose(state)));
        }
    }
    ngOnDestroy() {
        this.portalOutlet.detach();
        this.resizeSubs?.unsubscribe();
        this.subscription?.unsubscribe();
    }
    ngOnChanges(changes) {
        if (changes.collapsed) {
            if (this.collapsed) {
                this.service.close();
            }
            else {
                this.service.open();
            }
        }
        else if (changes.enableMobile) {
            this.service.enableMobile = this.enableMobile;
        }
    }
    /**
     * Toggle whether the side panel is expanded or not.
     */
    toggleSidePanel() {
        if (this.collapsible) {
            this.service.toggle();
        }
        else {
            this.service.close();
        }
    }
    emitResizeOutputs() {
        const contentDimensions = this.getContentDimensions();
        if (contentDimensions.width !== this.previousContentDimensions.width ||
            contentDimensions.height !== this.previousContentDimensions.height) {
            this.previousContentDimensions = contentDimensions;
            this.contentResize.emit(contentDimensions);
        }
    }
    getContentDimensions() {
        if (!this.isCollapsedInternal && this.isXs) {
            return { width: 0, height: 0 };
        }
        const rect = this.contentElement.nativeElement.getBoundingClientRect();
        return { width: rect.width, height: rect.height };
    }
    setBreakpoints(width, height) {
        if (!width && !height) {
            // element is not visible, no point in changing anything
            return;
        }
        const breakpoints = this.breakpoints ?? BOOTSTRAP_BREAKPOINTS;
        this.isXs = width < breakpoints.smMinimum;
        this.isSm = width >= breakpoints.smMinimum && width < breakpoints.mdMinimum;
        this.isMd = width >= breakpoints.mdMinimum && width < breakpoints.lgMinimum;
        this.isLg = width >= breakpoints.lgMinimum && width < breakpoints.xlMinimum;
        this.isXl = width >= breakpoints.xlMinimum;
        this.cdRef.markForCheck();
    }
    sendResize() {
        if (this.isScrollMode || this.element.nativeElement.style.paddingRight !== '0') {
            this.openingOrClosing = true;
            this.resizeEvent.next();
        }
    }
    attachContent(portal) {
        this.portalOutlet.detach();
        if (portal) {
            this.portalOutlet.attach(portal);
        }
        this.cdRef.markForCheck();
    }
    attachTempContent(portal) {
        this.tmpPortalOutlet.detach();
        if (portal) {
            this.tmpPortalOutlet.attach(portal);
            this.showTempContent = true;
            this.openClose(true, true);
        }
        else if (this.showTempContent) {
            this.showTempContent = false;
            this.openClose(this.service.isOpen(), true);
        }
        this.cdRef.markForCheck();
    }
    openClose(open, regainFocus = false) {
        if (open !== this.isCollapsedInternal) {
            this.moveFocusInside(open && regainFocus);
            return;
        }
        this.isCollapsedInternal = !open;
        if (open) {
            this.isHidden = false;
        }
        setTimeout(() => this.doOpenClose(open));
    }
    doOpenClose(open) {
        this.moveFocusInside(open);
        this.isCollapsed = !open;
        this.collapsed = this.isCollapsed;
        if (this.isCollapsedInternal) {
            this.closed.emit();
        }
        this.sendResize();
        this.cdRef.markForCheck();
    }
    moveFocusInside(open) {
        if (open &&
            !document.activeElement?.parentElement?.classList.contains('side-panel-collapse-toggle') &&
            !document.activeElement?.classList.contains('side-panel-collapse-toggle')) {
            // moves the keyboard focus inside the panel so that the next tab is somewhere useful
            this.panelElement.nativeElement.focus();
            queueMicrotask(() => this.panelElement.nativeElement.blur());
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiSidePanelComponent, selector: "si-side-panel", inputs: { collapsible: "collapsible", collapsed: "collapsed", heading: "heading", mode: "mode", size: "size", closeButtonLabel: "closeButtonLabel", toggleItemLabel: "toggleItemLabel", breakpoints: "breakpoints", enableMobile: "enableMobile" }, outputs: { closed: "closed", contentResize: "contentResize" }, host: { properties: { "class.enable-mobile": "this.enableMobile", "class.collapsible": "this.isCollapsible", "class.collapsible-temp": "this.isCollapsibleTemp", "class.rpanel-mode--scroll": "this.isScrollMode", "class.rpanel-mode--over": "this.isOverMode", "class.rpanel-size--regular": "this.isNormalSize", "class.rpanel-size--wide": "this.isWideSize", "class.rpanel-resize-xs": "this.isXs", "class.rpanel-resize-sm": "this.isSm", "class.rpanel-resize-md": "this.isMd", "class.rpanel-resize-lg": "this.isLg", "class.rpanel-resize-xl": "this.isXl", "class.rpanel-collapsed": "this.isCollapsed", "class.ready": "this.ready", "class.rpanel-hidden": "this.isHidden" }, classAttribute: "si-layout-inner" }, viewQueries: [{ propertyName: "panelElement", first: true, predicate: ["sidePanel"], descendants: true, static: true }, { propertyName: "contentElement", first: true, predicate: ["content"], descendants: true, static: true }, { propertyName: "portalOutlet", first: true, predicate: ["portalOutlet"], descendants: true, read: CdkPortalOutlet, static: true }, { propertyName: "tmpPortalOutlet", first: true, predicate: ["tmpPortalOutlet"], descendants: true, read: CdkPortalOutlet, static: true }], usesOnChanges: true, ngImport: i0, template: "<div #sidePanel class=\"side-panel elevation-1\" tabindex=\"-1\">\n  <div class=\"inner\" [class.d-none]=\"showTempContent\">\n    <ng-content select=\"si-side-panel-content, element-side-panel-content\"></ng-content>\n    <ng-container #portalOutlet cdkPortalOutlet></ng-container>\n  </div>\n  <div class=\"inner\" [class.d-none]=\"!showTempContent\">\n    <ng-container #tmpPortalOutlet cdkPortalOutlet></ng-container>\n  </div>\n</div>\n<div #content class=\"main-content si-layout-inner\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{--rpanel-collapsed-padding: 0;--rpanel-size: 390px;display:block;padding-inline-end:var(--rpanel-size)}:host.ready{transition:padding-inline-end calc(.5s * var(--element-animations-enabled, 1))}:host.ready .side-panel{transition:inline-size calc(.5s * var(--element-animations-enabled, 1))}:host .side-panel,:host .side-panel>.inner{inline-size:var(--rpanel-size)}:host.collapsible,:host.collapsible-temp{--rpanel-collapsed-width: 48px}:host.rpanel-size--wide{--rpanel-size: 500px}:host.rpanel-resize-sm.rpanel-mode--over,:host.rpanel-resize-md.rpanel-mode--over,:host.rpanel-resize-lg.rpanel-mode--over,:host.rpanel-resize-xl.rpanel-mode--over{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-lg.rpanel-mode--scroll.rpanel-size--wide{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-sm.rpanel-mode--scroll,:host.rpanel-resize-md.rpanel-mode--scroll{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-xs.rpanel-mode--over,:host.rpanel-resize-xs.rpanel-mode--scroll{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-xs .side-panel{z-index:1030}:host.rpanel-resize-xs:not(.rpanel-collapsed) .side-panel,:host.rpanel-resize-xs:not(.rpanel-collapsed) .side-panel>.inner{inline-size:100%}:host.rpanel-hidden:not(.collapsible) .side-panel{display:none}:host.rpanel-collapsed{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-collapsed:not(.collapsible) .side-panel{inline-size:0;overflow:hidden}:host.rpanel-collapsed.collapsible .side-panel{inline-size:var(--rpanel-collapsed-width);overflow:hidden}.side-panel{position:fixed;z-index:1029;inset-block-start:calc(48px + var(--element-titlebar-spacing, 0px));inset-block-end:0;inset-inline-end:0;overflow-x:hidden;background:var(--element-base-1);outline:0}.side-panel>.inner{display:flex;flex-direction:column;position:absolute;inset-block:0;inset-inline-start:0}@media (max-width: 575.98px){:host.enable-mobile{padding-inline-start:0!important}:host.enable-mobile.rpanel-collapsed .side-panel{inline-size:0!important}:host.enable-mobile ::ng-deep .page-top-title{margin-inline-start:40px}}\n"], dependencies: [{ kind: "directive", type: i1$3.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-side-panel', host: { class: 'si-layout-inner' }, template: "<div #sidePanel class=\"side-panel elevation-1\" tabindex=\"-1\">\n  <div class=\"inner\" [class.d-none]=\"showTempContent\">\n    <ng-content select=\"si-side-panel-content, element-side-panel-content\"></ng-content>\n    <ng-container #portalOutlet cdkPortalOutlet></ng-container>\n  </div>\n  <div class=\"inner\" [class.d-none]=\"!showTempContent\">\n    <ng-container #tmpPortalOutlet cdkPortalOutlet></ng-container>\n  </div>\n</div>\n<div #content class=\"main-content si-layout-inner\">\n  <ng-content></ng-content>\n</div>\n", styles: [":host{--rpanel-collapsed-padding: 0;--rpanel-size: 390px;display:block;padding-inline-end:var(--rpanel-size)}:host.ready{transition:padding-inline-end calc(.5s * var(--element-animations-enabled, 1))}:host.ready .side-panel{transition:inline-size calc(.5s * var(--element-animations-enabled, 1))}:host .side-panel,:host .side-panel>.inner{inline-size:var(--rpanel-size)}:host.collapsible,:host.collapsible-temp{--rpanel-collapsed-width: 48px}:host.rpanel-size--wide{--rpanel-size: 500px}:host.rpanel-resize-sm.rpanel-mode--over,:host.rpanel-resize-md.rpanel-mode--over,:host.rpanel-resize-lg.rpanel-mode--over,:host.rpanel-resize-xl.rpanel-mode--over{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-lg.rpanel-mode--scroll.rpanel-size--wide{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-sm.rpanel-mode--scroll,:host.rpanel-resize-md.rpanel-mode--scroll{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-xs.rpanel-mode--over,:host.rpanel-resize-xs.rpanel-mode--scroll{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-resize-xs .side-panel{z-index:1030}:host.rpanel-resize-xs:not(.rpanel-collapsed) .side-panel,:host.rpanel-resize-xs:not(.rpanel-collapsed) .side-panel>.inner{inline-size:100%}:host.rpanel-hidden:not(.collapsible) .side-panel{display:none}:host.rpanel-collapsed{padding-inline-end:var(--rpanel-collapsed-width)}:host.rpanel-collapsed:not(.collapsible) .side-panel{inline-size:0;overflow:hidden}:host.rpanel-collapsed.collapsible .side-panel{inline-size:var(--rpanel-collapsed-width);overflow:hidden}.side-panel{position:fixed;z-index:1029;inset-block-start:calc(48px + var(--element-titlebar-spacing, 0px));inset-block-end:0;inset-inline-end:0;overflow-x:hidden;background:var(--element-base-1);outline:0}.side-panel>.inner{display:flex;flex-direction:column;position:absolute;inset-block:0;inset-inline-start:0}@media (max-width: 575.98px){:host.enable-mobile{padding-inline-start:0!important}:host.enable-mobile.rpanel-collapsed .side-panel{inline-size:0!important}:host.enable-mobile ::ng-deep .page-top-title{margin-inline-start:40px}}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { collapsible: [{
                type: Input
            }], collapsed: [{
                type: Input
            }], heading: [{
                type: Input
            }], mode: [{
                type: Input
            }], size: [{
                type: Input
            }], closeButtonLabel: [{
                type: Input
            }], toggleItemLabel: [{
                type: Input
            }], breakpoints: [{
                type: Input
            }], enableMobile: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.enable-mobile']
            }], closed: [{
                type: Output
            }], contentResize: [{
                type: Output
            }], isCollapsible: [{
                type: HostBinding,
                args: ['class.collapsible']
            }], isCollapsibleTemp: [{
                type: HostBinding,
                args: ['class.collapsible-temp']
            }], isScrollMode: [{
                type: HostBinding,
                args: ['class.rpanel-mode--scroll']
            }], isOverMode: [{
                type: HostBinding,
                args: ['class.rpanel-mode--over']
            }], isNormalSize: [{
                type: HostBinding,
                args: ['class.rpanel-size--regular']
            }], isWideSize: [{
                type: HostBinding,
                args: ['class.rpanel-size--wide']
            }], isXs: [{
                type: HostBinding,
                args: ['class.rpanel-resize-xs']
            }], isSm: [{
                type: HostBinding,
                args: ['class.rpanel-resize-sm']
            }], isMd: [{
                type: HostBinding,
                args: ['class.rpanel-resize-md']
            }], isLg: [{
                type: HostBinding,
                args: ['class.rpanel-resize-lg']
            }], isXl: [{
                type: HostBinding,
                args: ['class.rpanel-resize-xl']
            }], isCollapsed: [{
                type: HostBinding,
                args: ['class.rpanel-collapsed']
            }], ready: [{
                type: HostBinding,
                args: ['class.ready']
            }], isHidden: [{
                type: HostBinding,
                args: ['class.rpanel-hidden']
            }], panelElement: [{
                type: ViewChild,
                args: ['sidePanel', { static: true }]
            }], contentElement: [{
                type: ViewChild,
                args: ['content', { static: true }]
            }], portalOutlet: [{
                type: ViewChild,
                args: ['portalOutlet', { read: CdkPortalOutlet, static: true }]
            }], tmpPortalOutlet: [{
                type: ViewChild,
                args: ['tmpPortalOutlet', { read: CdkPortalOutlet, static: true }]
            }] } });

class SiSidePanelContentComponent {
    /*
     * If true, the panel is collapsed instead of completely hidden, just like the vertical navbar
     */
    collapsible = false;
    /**
     * Header of side panel
     */
    heading = '';
    /**
     * Input list of primary action items
     */
    primaryActions = [];
    /**
     * Input list of secondary action items.
     */
    secondaryActions = [];
    /**
     * Status icons/actions
     */
    statusActions = [];
    /**
     * Toggles search bar
     */
    searchable = false;
    /**
     * Placeholder text for search
     */
    searchPlaceholder = $localize `:@@SI_SIDE_PANEL.SEARCH_PLACEHOLDER:Search...`;
    /**
     * Aria label for close button. Needed for a11y
     */
    closeButtonLabel = $localize `:@@SI_SIDE_PANEL.CLOSE:Close`;
    /**
     * Toggle icon aria-label, required for a11y
     */
    toggleItemLabel = $localize `:@@SI_SIDE_PANEL.TOGGLE:Toggle`;
    /**
     * Show a badge on the mobile drawer indicating a new alert or notification
     */
    showMobileDrawerBadge = false;
    /**
     * Output for search bar input
     */
    searchEvent = new EventEmitter();
    isCollapsed = false;
    isExpanded = true;
    get enableMobile() {
        return this.service?.enableMobile ?? false;
    }
    trackByIndex = (index) => index;
    mobileSize = false;
    get focusable() {
        return !this.mobileSize || !this.enableMobile || !this.isCollapsed;
    }
    /**
     * The $rpanel-transition-duration in the style is 0.5 seconds.
     * For the animation we need to wait until the resize is done.
     */
    resizeAnimationDelay = 500;
    subscription;
    service = inject(SiSidePanelService);
    breakpointObserver = inject(BreakpointObserver);
    cdRef = inject(ChangeDetectorRef);
    expandedTimeout;
    constructor() {
        const accordionHcollapse = inject(SiAccordionHCollapseService);
        this.subscription = this.service.isOpen$.subscribe(state => {
            this.isCollapsed = !state;
            clearTimeout(this.expandedTimeout);
            this.expandedTimeout = undefined;
            if (!state) {
                this.isExpanded = false;
                this.cdRef.markForCheck();
            }
            else {
                this.expandedTimeout = setTimeout(() => {
                    this.isExpanded = true;
                    this.cdRef.markForCheck();
                }, this.resizeAnimationDelay / 2);
            }
            accordionHcollapse.hcollapsed$.next(!state);
        });
        this.subscription.add(accordionHcollapse.open$.subscribe(() => this.service.open()));
    }
    ngOnInit() {
        this.subscription.add(this.breakpointObserver
            .observe('(max-width: ' + BOOTSTRAP_BREAKPOINTS.lgMinimum + 'px)')
            .subscribe(({ matches }) => {
            this.mobileSize = matches;
            this.cdRef.markForCheck();
        }));
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
    toggleSidePanel(event) {
        if (event?.detail !== 0) {
            // Blur except if triggered by keyboard
            document?.activeElement?.blur();
        }
        if (this.service.isTemporaryOpen()) {
            this.service.hideTemporaryContent();
        }
        else {
            this.service.toggle();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiSidePanelContentComponent, selector: "si-side-panel-content", inputs: { collapsible: "collapsible", heading: "heading", primaryActions: "primaryActions", secondaryActions: "secondaryActions", statusActions: "statusActions", searchable: "searchable", searchPlaceholder: "searchPlaceholder", closeButtonLabel: "closeButtonLabel", toggleItemLabel: "toggleItemLabel", showMobileDrawerBadge: "showMobileDrawerBadge" }, outputs: { searchEvent: "searchEvent" }, host: { properties: { "class.collapsed": "this.isCollapsed", "class.expanded": "this.isExpanded", "class.enable-mobile": "this.enableMobile" } }, providers: [SiAccordionHCollapseService], ngImport: i0, template: "<div class=\"rpanel-header pt-5\">\n  <p class=\"si-title-2 my-0 ms-6 auto-hide text-truncate\">{{ heading | translate }}</p>\n  <si-content-action-bar\n    *ngIf=\"(primaryActions?.length || secondaryActions?.length) && focusable\"\n    class=\"auto-hide ms-auto border-end\"\n    viewType=\"expanded\"\n    [primaryActions]=\"primaryActions\"\n    [secondaryActions]=\"secondaryActions\"\n    [toggleItemLabel]=\"toggleItemLabel\"\n  ></si-content-action-bar>\n  <button\n    type=\"button\"\n    class=\"close-button btn btn-circle btn-sm btn-ghost element-cancel me-4\"\n    [attr.aria-label]=\"closeButtonLabel | translate\"\n    [tabindex]=\"focusable ? '0' : '-1'\"\n    (click)=\"toggleSidePanel($event)\"\n  ></button>\n  <div class=\"collapse-toggle\">\n    <button\n      type=\"button\"\n      class=\"side-panel-collapse-toggle btn btn-circle btn-sm btn-ghost mx-4\"\n      [attr.aria-label]=\"toggleItemLabel | translate\"\n      (click)=\"toggleSidePanel($event)\"\n    >\n      <i\n        class=\"flip-rtl\"\n        [class.badge-dot]=\"showMobileDrawerBadge\"\n        [class.element-double-right]=\"!isCollapsed\"\n        [class.element-double-left]=\"isCollapsed\"\n      ></i>\n    </button>\n  </div>\n</div>\n<div class=\"rpanel-wrapper d-flex flex-column\">\n  <div\n    *ngIf=\"statusActions?.length && focusable\"\n    class=\"rpanel-header rpanel-statusactions px-5 pb-4\"\n  >\n    <ng-container *ngFor=\"let dp of statusActions; trackBy: trackByIndex\">\n      <a\n        *ngIf=\"!dp.disabled\"\n        class=\"rpanel-statusaction position-relative focus-inside\"\n        [attr.aria-label]=\"!isCollapsed ? '' : (dp.title! | translate)\"\n        [siLink]=\"dp\"\n      >\n        <i class=\"icon\" aria-hidden=\"true\" [ngClass]=\"dp.icon!\"></i>\n        <i\n          *ngIf=\"dp.overlayIcon\"\n          class=\"icon position-absolute\"\n          aria-hidden=\"true\"\n          [ngClass]=\"dp.overlayIcon\"\n        ></i>\n        <span class=\"ms-2 auto-hide\">{{ dp.title! | translate }}</span>\n      </a>\n      <div *ngIf=\"dp.disabled\" class=\"rpanel-statusaction dot-outer\" aria-hidden=\"true\">\n        <div class=\"dot text-muted text-center\">&bull;</div>\n      </div>\n    </ng-container>\n  </div>\n  <div *ngIf=\"searchable && focusable\" class=\"nav-search px-5 pt-2 auto-hide\">\n    <si-search-bar\n      #searchBar\n      class=\"m-0\"\n      [colorVariant]=\"'base-0'\"\n      [placeholder]=\"searchPlaceholder | translate\"\n      [debounceTime]=\"400\"\n      [showIcon]=\"true\"\n      [prohibitedCharacters]=\"'*?'\"\n      (searchChange)=\"searchEvent.emit($event)\"\n    ></si-search-bar>\n  </div>\n  <div *ngIf=\"focusable\" class=\"rpanel-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host{display:flex;flex-direction:column;flex:1}:host-context(.collapsible) .close-button{display:none}:host-context(.collapsible) .collapse-toggle{display:block}:host-context(.collapsible) :host.collapsed .auto-hide{display:none}:host-context(.collapsible) :host.collapsed .rpanel-wrapper{inline-size:var(--rpanel-collapsed-width)}:host-context(.collapsible) :host.collapsed .rpanel-content{flex:0 0 auto;margin-block-start:8px}:host-context(.collapsible) :host.collapsed .rpanel-statusactions{order:3;flex-direction:column;align-items:flex-start;padding:0!important}:host-context(.collapsible) :host.collapsed .rpanel-statusaction{padding-block:8px;padding-inline:12px}:host-context(.collapsible) :host.collapsed .rpanel-statusaction:not(.dot-outer):hover{background:var(--element-base-1-hover)}.collapse-toggle{display:none}.collapse-toggle i{vertical-align:bottom}.rpanel-header,.rpanel-statusaction{display:flex;align-items:center}.rpanel-header{justify-content:space-between}.rpanel-content{margin-block-start:12px}.rpanel-wrapper,.rpanel-content{min-block-size:0;flex:1 0 0;overflow-x:hidden;overflow-y:auto}.rpanel-statusaction{text-decoration:none}.rpanel-statusaction .dot{inline-size:24px;line-height:24px}.rpanel-statusaction span{font-size:12px;white-space:pre-wrap;color:var(--element-text-primary)}.rpanel-statusaction:hover span{color:var(--element-text-active)}@media (max-width: 575.98px){:host.enable-mobile:not(.collapsed):not(.expanded) si-content-action-bar{margin-inline-end:48px}:host.enable-mobile:not(.expanded) .collapse-toggle{position:fixed;border:0;text-align:end;padding-block:4px!important;margin-block-start:8px!important;inset-inline-end:0;inset-block-start:calc(48px + var(--element-titlebar-spacing, 0px));border-start-start-radius:var(--element-radius-2);border-end-start-radius:var(--element-radius-2);border-start-end-radius:0!important;border-end-end-radius:0!important;background:var(--element-base-1);box-shadow:0 0 4px var(--element-box-shadow-color-1),0 4px 4px var(--element-box-shadow-color-2);z-index:2}}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.SiContentActionBarComponent, selector: "si-content-action-bar", inputs: ["primaryActions", "secondaryActions", "actionParam", "viewType", "focusOnLoad", "toggleItemLabel", "preventIconsInDropdownMenus", "disabled"] }, { kind: "directive", type: i3$5.SiLinkDirective, selector: "[siLink]", inputs: ["siLink", "siLinkDefaultTarget", "actionParam", "activeClass", "exactMatch", "ariaCurrent"], outputs: ["activeChange"], exportAs: ["siLink"] }, { kind: "component", type: i5.SiSearchBarComponent, selector: "si-search-bar", inputs: ["debounceTime", "prohibitedCharacters", "placeholder", "showIcon", "tabbable", "value", "disabled", "readonly", "colorVariant"], outputs: ["searchChange"] }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-side-panel-content', providers: [SiAccordionHCollapseService], template: "<div class=\"rpanel-header pt-5\">\n  <p class=\"si-title-2 my-0 ms-6 auto-hide text-truncate\">{{ heading | translate }}</p>\n  <si-content-action-bar\n    *ngIf=\"(primaryActions?.length || secondaryActions?.length) && focusable\"\n    class=\"auto-hide ms-auto border-end\"\n    viewType=\"expanded\"\n    [primaryActions]=\"primaryActions\"\n    [secondaryActions]=\"secondaryActions\"\n    [toggleItemLabel]=\"toggleItemLabel\"\n  ></si-content-action-bar>\n  <button\n    type=\"button\"\n    class=\"close-button btn btn-circle btn-sm btn-ghost element-cancel me-4\"\n    [attr.aria-label]=\"closeButtonLabel | translate\"\n    [tabindex]=\"focusable ? '0' : '-1'\"\n    (click)=\"toggleSidePanel($event)\"\n  ></button>\n  <div class=\"collapse-toggle\">\n    <button\n      type=\"button\"\n      class=\"side-panel-collapse-toggle btn btn-circle btn-sm btn-ghost mx-4\"\n      [attr.aria-label]=\"toggleItemLabel | translate\"\n      (click)=\"toggleSidePanel($event)\"\n    >\n      <i\n        class=\"flip-rtl\"\n        [class.badge-dot]=\"showMobileDrawerBadge\"\n        [class.element-double-right]=\"!isCollapsed\"\n        [class.element-double-left]=\"isCollapsed\"\n      ></i>\n    </button>\n  </div>\n</div>\n<div class=\"rpanel-wrapper d-flex flex-column\">\n  <div\n    *ngIf=\"statusActions?.length && focusable\"\n    class=\"rpanel-header rpanel-statusactions px-5 pb-4\"\n  >\n    <ng-container *ngFor=\"let dp of statusActions; trackBy: trackByIndex\">\n      <a\n        *ngIf=\"!dp.disabled\"\n        class=\"rpanel-statusaction position-relative focus-inside\"\n        [attr.aria-label]=\"!isCollapsed ? '' : (dp.title! | translate)\"\n        [siLink]=\"dp\"\n      >\n        <i class=\"icon\" aria-hidden=\"true\" [ngClass]=\"dp.icon!\"></i>\n        <i\n          *ngIf=\"dp.overlayIcon\"\n          class=\"icon position-absolute\"\n          aria-hidden=\"true\"\n          [ngClass]=\"dp.overlayIcon\"\n        ></i>\n        <span class=\"ms-2 auto-hide\">{{ dp.title! | translate }}</span>\n      </a>\n      <div *ngIf=\"dp.disabled\" class=\"rpanel-statusaction dot-outer\" aria-hidden=\"true\">\n        <div class=\"dot text-muted text-center\">&bull;</div>\n      </div>\n    </ng-container>\n  </div>\n  <div *ngIf=\"searchable && focusable\" class=\"nav-search px-5 pt-2 auto-hide\">\n    <si-search-bar\n      #searchBar\n      class=\"m-0\"\n      [colorVariant]=\"'base-0'\"\n      [placeholder]=\"searchPlaceholder | translate\"\n      [debounceTime]=\"400\"\n      [showIcon]=\"true\"\n      [prohibitedCharacters]=\"'*?'\"\n      (searchChange)=\"searchEvent.emit($event)\"\n    ></si-search-bar>\n  </div>\n  <div *ngIf=\"focusable\" class=\"rpanel-content\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host{display:flex;flex-direction:column;flex:1}:host-context(.collapsible) .close-button{display:none}:host-context(.collapsible) .collapse-toggle{display:block}:host-context(.collapsible) :host.collapsed .auto-hide{display:none}:host-context(.collapsible) :host.collapsed .rpanel-wrapper{inline-size:var(--rpanel-collapsed-width)}:host-context(.collapsible) :host.collapsed .rpanel-content{flex:0 0 auto;margin-block-start:8px}:host-context(.collapsible) :host.collapsed .rpanel-statusactions{order:3;flex-direction:column;align-items:flex-start;padding:0!important}:host-context(.collapsible) :host.collapsed .rpanel-statusaction{padding-block:8px;padding-inline:12px}:host-context(.collapsible) :host.collapsed .rpanel-statusaction:not(.dot-outer):hover{background:var(--element-base-1-hover)}.collapse-toggle{display:none}.collapse-toggle i{vertical-align:bottom}.rpanel-header,.rpanel-statusaction{display:flex;align-items:center}.rpanel-header{justify-content:space-between}.rpanel-content{margin-block-start:12px}.rpanel-wrapper,.rpanel-content{min-block-size:0;flex:1 0 0;overflow-x:hidden;overflow-y:auto}.rpanel-statusaction{text-decoration:none}.rpanel-statusaction .dot{inline-size:24px;line-height:24px}.rpanel-statusaction span{font-size:12px;white-space:pre-wrap;color:var(--element-text-primary)}.rpanel-statusaction:hover span{color:var(--element-text-active)}@media (max-width: 575.98px){:host.enable-mobile:not(.collapsed):not(.expanded) si-content-action-bar{margin-inline-end:48px}:host.enable-mobile:not(.expanded) .collapse-toggle{position:fixed;border:0;text-align:end;padding-block:4px!important;margin-block-start:8px!important;inset-inline-end:0;inset-block-start:calc(48px + var(--element-titlebar-spacing, 0px));border-start-start-radius:var(--element-radius-2);border-end-start-radius:var(--element-radius-2);border-start-end-radius:0!important;border-end-end-radius:0!important;background:var(--element-base-1);box-shadow:0 0 4px var(--element-box-shadow-color-1),0 4px 4px var(--element-box-shadow-color-2);z-index:2}}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { collapsible: [{
                type: Input
            }], heading: [{
                type: Input
            }], primaryActions: [{
                type: Input
            }], secondaryActions: [{
                type: Input
            }], statusActions: [{
                type: Input
            }], searchable: [{
                type: Input
            }], searchPlaceholder: [{
                type: Input
            }], closeButtonLabel: [{
                type: Input
            }], toggleItemLabel: [{
                type: Input
            }], showMobileDrawerBadge: [{
                type: Input
            }], searchEvent: [{
                type: Output
            }], isCollapsed: [{
                type: HostBinding,
                args: ['class.collapsed']
            }], isExpanded: [{
                type: HostBinding,
                args: ['class.expanded']
            }], enableMobile: [{
                type: HostBinding,
                args: ['class.enable-mobile']
            }] } });

class SiSidePanelModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelModule, declarations: [SiSidePanelComponent, SiSidePanelContentComponent], imports: [CommonModule,
            PortalModule,
            SiContentActionBarModule,
            SiLinkModule,
            SiSearchBarModule,
            SiTranslateModule], exports: [SiSidePanelComponent, SiSidePanelContentComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelModule, imports: [CommonModule,
            PortalModule,
            SiContentActionBarModule,
            SiLinkModule,
            SiSearchBarModule,
            SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiSidePanelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PortalModule,
                        SiContentActionBarModule,
                        SiLinkModule,
                        SiSearchBarModule,
                        SiTranslateModule
                    ],
                    declarations: [SiSidePanelComponent, SiSidePanelContentComponent],
                    exports: [SiSidePanelComponent, SiSidePanelContentComponent]
                }]
        }] });

class SiThresholdComponent {
    /** Options to be shown in select dropdown */
    options = [];
    /** The thresholds */
    thresholdSteps = [];
    /** The unit to show */
    unit = '';
    /** The min. value for the threshold value */
    minValue = 0;
    /** The max. value for the threshold value */
    maxValue = 100;
    /** The step size for the threshold value */
    stepSize = 1;
    /** Max. number of steps, 0 for no hard limit */
    maxSteps = 0;
    /** Do validation? */
    validation = true;
    /** When disabled, steps cannot be added/removed */
    canAddRemoveSteps = true;
    /** Use horizontal layout? */
    horizontalLayout = false;
    /** Show dec/inc buttons? */
    showDecIncButtons = true;
    /** The obvious */
    readonly = false;
    /** The aria-label for delete button */
    deleteAriaLabel = $localize `:@@SI_THRESHOLD.DELETE:Delete step`;
    /** The aria-label for add button */
    addAriaLabel = $localize `:@@SI_THRESHOLD.ADD:Add step`;
    /** The aria-label for input field */
    inputAriaLabel = $localize `:@@SI_THRESHOLD.INPUT_LABEL:Threshold value`;
    /** The aria-label for status selection */
    statusAriaLabel = $localize `:@@SI_THRESHOLD.STATUS:Status`;
    /** Fired when the thresholds have changed */
    thresholdStepsChange = new EventEmitter();
    /** Fired when validation status changes */
    validChange = new EventEmitter();
    trackByItem = (index, item) => item;
    colors = [];
    _valid = true;
    /**
     * Whether the current input value is valid or not.
     */
    get valid() {
        return this._valid;
    }
    element = inject(ElementRef);
    ngOnChanges() {
        this.calcColor();
        this.validate();
    }
    deleteStep(index) {
        this.thresholdSteps.splice(index, 1);
        this.optionChanged();
    }
    addStep(index) {
        const newStep = { ...this.thresholdSteps[index], value: undefined };
        this.thresholdSteps.splice(index + 1, 0, newStep);
        this.optionChanged();
        setTimeout(() => this.element.nativeElement.querySelectorAll('input.form-control')[index]?.focus());
    }
    optionChanged() {
        this.calcColor();
        this.emitChange();
    }
    emitChange() {
        this.validate();
        this.thresholdStepsChange.emit(this.thresholdSteps);
    }
    calcColor() {
        const colorMap = new Map();
        for (const opt of this.options) {
            colorMap.set(opt.id, opt.color ?? '');
        }
        this.colors = this.thresholdSteps.map(ths => colorMap.get(ths.optionValue) ?? '');
    }
    validate() {
        const prevValid = this.valid;
        this._valid = true;
        for (let i = 1; i < this.thresholdSteps.length; i++) {
            const step = this.thresholdSteps[i];
            if (this.validation) {
                const prev = this.thresholdSteps[i - 1];
                const next = this.thresholdSteps[i + 1];
                // valid: withing min/max, each step is lower than next step with step size between
                step.valid =
                    step.value != null &&
                        step.value >= this.minValue &&
                        step.value <= this.maxValue &&
                        (prev.value == null || step.value - this.stepSize >= prev.value) &&
                        (next?.value == null || step.value + this.stepSize <= next.value);
                this._valid &&= step.valid;
            }
            else {
                step.valid = true;
            }
        }
        if (this.valid !== prevValid) {
            this.validChange.emit(this.valid);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiThresholdComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiThresholdComponent, selector: "si-threshold", inputs: { options: "options", thresholdSteps: "thresholdSteps", unit: "unit", minValue: "minValue", maxValue: "maxValue", stepSize: "stepSize", maxSteps: "maxSteps", validation: "validation", canAddRemoveSteps: "canAddRemoveSteps", horizontalLayout: "horizontalLayout", showDecIncButtons: "showDecIncButtons", readonly: "readonly", deleteAriaLabel: "deleteAriaLabel", addAriaLabel: "addAriaLabel", inputAriaLabel: "inputAriaLabel", statusAriaLabel: "statusAriaLabel" }, outputs: { thresholdStepsChange: "thresholdStepsChange", validChange: "validChange" }, host: { properties: { "class.add-remove": "this.canAddRemoveSteps", "class.horizontal": "this.horizontalLayout", "class.dec-inc-buttons": "this.showDecIncButtons" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  *ngFor=\"\n    let step of thresholdSteps;\n    first as first;\n    last as last;\n    index as index;\n    trackBy: trackByItem\n  \"\n  class=\"ths-step\"\n>\n  <div *ngIf=\"!first\" class=\"ths-value d-flex align-items-center\">\n    <button\n      *ngIf=\"canAddRemoveSteps && !readonly\"\n      type=\"button\"\n      class=\"btn btn-circle btn-sm btn-ghost element-delete m-4\"\n      [attr.aria-label]=\"deleteAriaLabel | translate\"\n      (click)=\"deleteStep(index)\"\n    ></button>\n    <div *ngIf=\"!canAddRemoveSteps || readonly\" class=\"py-4 my-4\">&#8203;</div>\n    <div class=\"line\">\n      <div class=\"segment\" [ngClass]=\"colors[index - 1]\"></div>\n      <div class=\"dot\"></div>\n      <div class=\"segment\" [ngClass]=\"colors[index]\"></div>\n    </div>\n    <div class=\"d-flex align-items-center text-nowrap m-4\">\n      <si-number-input\n        #valueInput=\"ngModel\"\n        class=\"form-control text-end\"\n        [class.is-invalid]=\"step.valid === false\"\n        [aria-label]=\"inputAriaLabel | translate\"\n        [readonly]=\"readonly\"\n        [ngModelOptions]=\"{ standalone: true }\"\n        [min]=\"minValue\"\n        [max]=\"maxValue\"\n        [step]=\"stepSize\"\n        [unit]=\"unit\"\n        [showButtons]=\"showDecIncButtons\"\n        [required]=\"true\"\n        [(ngModel)]=\"step.value\"\n        (ngModelChange)=\"emitChange()\"\n      ></si-number-input>\n    </div>\n  </div>\n  <ng-container\n    *ngIf=\"first && horizontalLayout\"\n    [ngTemplateOutlet]=\"startend\"\n    [ngTemplateOutletContext]=\"{ color: colors[index] }\"\n  >\n  </ng-container>\n  <div class=\"ths-option d-flex align-items-center\">\n    <button\n      *ngIf=\"canAddRemoveSteps && !readonly\"\n      type=\"button\"\n      class=\"btn btn-circle btn-sm btn-secondary element-plus m-4\"\n      [disabled]=\"maxSteps && thresholdSteps.length >= maxSteps\"\n      [attr.aria-label]=\"addAriaLabel | translate\"\n      (click)=\"addStep(index)\"\n    ></button>\n    <div *ngIf=\"!canAddRemoveSteps || readonly\" class=\"py-4 my-4\">&#8203;</div>\n    <div class=\"line\" [ngClass]=\"colors[index]\">\n      <div class=\"segment\"></div>\n    </div>\n    <si-select\n      class=\"my-4\"\n      [ariaLabel]=\"statusAriaLabel | translate\"\n      [readonly]=\"readonly\"\n      [options]=\"options\"\n      [(value)]=\"step.optionValue\"\n      (valueChange)=\"optionChanged()\"\n    ></si-select>\n  </div>\n  <ng-container\n    *ngIf=\"last && horizontalLayout\"\n    [ngTemplateOutlet]=\"startend\"\n    [ngTemplateOutletContext]=\"{ color: colors[index] }\"\n  >\n  </ng-container>\n</div>\n\n<ng-template #startend let-color=\"color\">\n  <div class=\"ths-value d-flex align-items-center startend\">\n    <div class=\"py-4 my-4\">&#8203;</div>\n    <div class=\"line\">\n      <div class=\"segment\" [ngClass]=\"color\"></div>\n    </div>\n  </div>\n</ng-template>\n", styles: [":host{--direction-main: column;--direction-option: row;--direction-value: row;--input-width: calc(var(--input-base-width, 90px) + var(--buttons-width, 0px))}:host.horizontal{--direction-main: row;--direction-option: column;--direction-value: column-reverse;--value-margin: -24px;padding-inline:calc(var(--value-margin) * -1)}:host.dec-inc-buttons{--buttons-width: 48px}:host,.ths-step{display:flex;flex-direction:var(--direction-main)}.ths-option{flex-direction:var(--direction-option);min-inline-size:var(--option-width, 160px)}.ths-value{flex-direction:var(--direction-value);margin-inline:var(--value-margin)}.form-control{inline-size:var(--input-width);block-size:calc(1rem + 16px)}.line{align-self:stretch;flex-basis:16px;display:flex;flex-direction:var(--direction-main);align-items:center;color:var(--element-ui-2);gap:4px}.segment{flex:1;border:1px solid currentColor}.dot{inline-size:6px;block-size:6px;border:1px solid var(--element-ui-2);border-radius:50%}.startend{inline-size:calc(var(--input-width) / 2)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$a.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$a.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$a.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$6.SiNumberInputComponent, selector: "si-number-input", inputs: ["min", "max", "step", "value", "unit", "showButtons", "aria-label", "inputId", "disabled", "readonly", "required"], outputs: ["valueChange"] }, { kind: "component", type: i3$3.SiSelectComponent, selector: "si-select", inputs: ["id", "ariaLabel", "labelledby", "filterPlaceholder", "noResultsFoundLabel", "readonly", "hasFilter"], outputs: ["dropdownClose"] }, { kind: "directive", type: i3$3.SiSelectSimpleOptionsDirective, selector: "si-select[options]", inputs: ["options"] }, { kind: "directive", type: i3$3.SiSelectSingleValueDirective, selector: "si-select:not([multi])" }, { kind: "pipe", type: i2$7.SiTranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiThresholdComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-threshold', template: "<div\n  *ngFor=\"\n    let step of thresholdSteps;\n    first as first;\n    last as last;\n    index as index;\n    trackBy: trackByItem\n  \"\n  class=\"ths-step\"\n>\n  <div *ngIf=\"!first\" class=\"ths-value d-flex align-items-center\">\n    <button\n      *ngIf=\"canAddRemoveSteps && !readonly\"\n      type=\"button\"\n      class=\"btn btn-circle btn-sm btn-ghost element-delete m-4\"\n      [attr.aria-label]=\"deleteAriaLabel | translate\"\n      (click)=\"deleteStep(index)\"\n    ></button>\n    <div *ngIf=\"!canAddRemoveSteps || readonly\" class=\"py-4 my-4\">&#8203;</div>\n    <div class=\"line\">\n      <div class=\"segment\" [ngClass]=\"colors[index - 1]\"></div>\n      <div class=\"dot\"></div>\n      <div class=\"segment\" [ngClass]=\"colors[index]\"></div>\n    </div>\n    <div class=\"d-flex align-items-center text-nowrap m-4\">\n      <si-number-input\n        #valueInput=\"ngModel\"\n        class=\"form-control text-end\"\n        [class.is-invalid]=\"step.valid === false\"\n        [aria-label]=\"inputAriaLabel | translate\"\n        [readonly]=\"readonly\"\n        [ngModelOptions]=\"{ standalone: true }\"\n        [min]=\"minValue\"\n        [max]=\"maxValue\"\n        [step]=\"stepSize\"\n        [unit]=\"unit\"\n        [showButtons]=\"showDecIncButtons\"\n        [required]=\"true\"\n        [(ngModel)]=\"step.value\"\n        (ngModelChange)=\"emitChange()\"\n      ></si-number-input>\n    </div>\n  </div>\n  <ng-container\n    *ngIf=\"first && horizontalLayout\"\n    [ngTemplateOutlet]=\"startend\"\n    [ngTemplateOutletContext]=\"{ color: colors[index] }\"\n  >\n  </ng-container>\n  <div class=\"ths-option d-flex align-items-center\">\n    <button\n      *ngIf=\"canAddRemoveSteps && !readonly\"\n      type=\"button\"\n      class=\"btn btn-circle btn-sm btn-secondary element-plus m-4\"\n      [disabled]=\"maxSteps && thresholdSteps.length >= maxSteps\"\n      [attr.aria-label]=\"addAriaLabel | translate\"\n      (click)=\"addStep(index)\"\n    ></button>\n    <div *ngIf=\"!canAddRemoveSteps || readonly\" class=\"py-4 my-4\">&#8203;</div>\n    <div class=\"line\" [ngClass]=\"colors[index]\">\n      <div class=\"segment\"></div>\n    </div>\n    <si-select\n      class=\"my-4\"\n      [ariaLabel]=\"statusAriaLabel | translate\"\n      [readonly]=\"readonly\"\n      [options]=\"options\"\n      [(value)]=\"step.optionValue\"\n      (valueChange)=\"optionChanged()\"\n    ></si-select>\n  </div>\n  <ng-container\n    *ngIf=\"last && horizontalLayout\"\n    [ngTemplateOutlet]=\"startend\"\n    [ngTemplateOutletContext]=\"{ color: colors[index] }\"\n  >\n  </ng-container>\n</div>\n\n<ng-template #startend let-color=\"color\">\n  <div class=\"ths-value d-flex align-items-center startend\">\n    <div class=\"py-4 my-4\">&#8203;</div>\n    <div class=\"line\">\n      <div class=\"segment\" [ngClass]=\"color\"></div>\n    </div>\n  </div>\n</ng-template>\n", styles: [":host{--direction-main: column;--direction-option: row;--direction-value: row;--input-width: calc(var(--input-base-width, 90px) + var(--buttons-width, 0px))}:host.horizontal{--direction-main: row;--direction-option: column;--direction-value: column-reverse;--value-margin: -24px;padding-inline:calc(var(--value-margin) * -1)}:host.dec-inc-buttons{--buttons-width: 48px}:host,.ths-step{display:flex;flex-direction:var(--direction-main)}.ths-option{flex-direction:var(--direction-option);min-inline-size:var(--option-width, 160px)}.ths-value{flex-direction:var(--direction-value);margin-inline:var(--value-margin)}.form-control{inline-size:var(--input-width);block-size:calc(1rem + 16px)}.line{align-self:stretch;flex-basis:16px;display:flex;flex-direction:var(--direction-main);align-items:center;color:var(--element-ui-2);gap:4px}.segment{flex:1;border:1px solid currentColor}.dot{inline-size:6px;block-size:6px;border:1px solid var(--element-ui-2);border-radius:50%}.startend{inline-size:calc(var(--input-width) / 2)}\n"] }]
        }], propDecorators: { options: [{
                type: Input
            }], thresholdSteps: [{
                type: Input
            }], unit: [{
                type: Input
            }], minValue: [{
                type: Input
            }], maxValue: [{
                type: Input
            }], stepSize: [{
                type: Input
            }], maxSteps: [{
                type: Input
            }], validation: [{
                type: Input
            }], canAddRemoveSteps: [{
                type: HostBinding,
                args: ['class.add-remove']
            }, {
                type: Input
            }], horizontalLayout: [{
                type: HostBinding,
                args: ['class.horizontal']
            }, {
                type: Input
            }], showDecIncButtons: [{
                type: HostBinding,
                args: ['class.dec-inc-buttons']
            }, {
                type: Input
            }], readonly: [{
                type: Input
            }], deleteAriaLabel: [{
                type: Input
            }], addAriaLabel: [{
                type: Input
            }], inputAriaLabel: [{
                type: Input
            }], statusAriaLabel: [{
                type: Input
            }], thresholdStepsChange: [{
                type: Output
            }], validChange: [{
                type: Output
            }] } });

class SiThresholdModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiThresholdModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiThresholdModule, declarations: [SiThresholdComponent], imports: [CommonModule, FormsModule, SiNumberInputModule, SiSelectModule, SiTranslateModule], exports: [SiThresholdComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiThresholdModule, imports: [CommonModule, FormsModule, SiNumberInputModule, SiSelectModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiThresholdModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SiNumberInputModule, SiSelectModule, SiTranslateModule],
                    declarations: [SiThresholdComponent],
                    exports: [SiThresholdComponent]
                }]
        }] });

class TooltipComponent {
    tooltip = '';
    anchor;
    positions;
    tooltipPositionClass = '';
    left;
    right;
    tooltipTemplate = null;
    /** @internal */
    id;
    zone = inject(NgZone);
    ngOnInit() {
        if (this.tooltip instanceof TemplateRef) {
            this.tooltipTemplate = this.tooltip;
        }
    }
    updateTooltipPosition(change) {
        const arrowClassTooltip = `tooltip-${change.connectionPair.overlayX}-${change.connectionPair.overlayY}`;
        const offsetX = change.connectionPair.offsetX;
        if (offsetX) {
            if (offsetX < 0) {
                // Need to subtract half of the width of arrow to get the center
                this.left = -1 * (offsetX + 6);
            }
            else {
                // Need to subtract half of the width of arrow to get the center
                this.right = offsetX - 6;
            }
        }
        if (arrowClassTooltip !== this.tooltipPositionClass) {
            this.zone.run(() => (this.tooltipPositionClass = arrowClassTooltip));
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: TooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: TooltipComponent, selector: "si-tooltip", inputs: { tooltip: "tooltip", anchor: "anchor", positions: "positions" }, ngImport: i0, template: "<div\n  class=\"tooltip show position-relative\"\n  role=\"tooltip\"\n  [id]=\"id\"\n  [ngClass]=\"tooltipPositionClass\"\n>\n  <div class=\"tooltip-arrow flip-rtl\" [style.left.px]=\"left\" [style.right.px]=\"right\"></div>\n  <div class=\"tooltip-inner\">\n    <div *ngIf=\"!tooltipTemplate; else templateRef\" class=\"si-body-2\">{{ tooltip }}</div>\n    <ng-template #templateRef>\n      <ng-template *ngTemplateOutlet=\"tooltipTemplate\"></ng-template>\n    </ng-template>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-tooltip', template: "<div\n  class=\"tooltip show position-relative\"\n  role=\"tooltip\"\n  [id]=\"id\"\n  [ngClass]=\"tooltipPositionClass\"\n>\n  <div class=\"tooltip-arrow flip-rtl\" [style.left.px]=\"left\" [style.right.px]=\"right\"></div>\n  <div class=\"tooltip-inner\">\n    <div *ngIf=\"!tooltipTemplate; else templateRef\" class=\"si-body-2\">{{ tooltip }}</div>\n    <ng-template #templateRef>\n      <ng-template *ngTemplateOutlet=\"tooltipTemplate\"></ng-template>\n    </ng-template>\n  </div>\n</div>\n" }]
        }], propDecorators: { tooltip: [{
                type: Input
            }], anchor: [{
                type: Input
            }], positions: [{
                type: Input
            }] } });

class SiTooltipDirective {
    static idCounter = 0;
    /**
     * The tooltip text to be displayed
     */
    siTooltip = '';
    _placement;
    /**
     * The placement of the tooltip. One of 'top', 'start', end', 'bottom'
     */
    set placement(value) {
        const deprecatedMessage = '@simpl/element-ng - SiTooltipDirective: \
Setting placement to "left" or "right" is deprecated, use "start" or "end" instead';
        if (value === 'left') {
            console.warn(deprecatedMessage);
            this._placement = 'start';
        }
        else if (value === 'right') {
            console.warn(deprecatedMessage);
            this._placement = 'end';
        }
        else {
            this._placement = value;
        }
    }
    get placement() {
        return this._placement;
    }
    /**
     * The trigger event on which the tooltip shall be displayed
     */
    triggers;
    /**
     * Allows the tooltip to be disabled
     */
    isDisabled = false;
    describedBy = `__tooltip_${SiTooltipDirective.idCounter++}`;
    overlayref;
    overlay = inject(Overlay);
    elementRef = inject(ElementRef);
    ngOnInit() {
        if (!this.placement || !positions[this.placement]) {
            this.placement = 'auto';
        }
    }
    ngOnDestroy() {
        this.overlayref?.dispose();
    }
    showTooltip() {
        if (this.isDisabled || !this.siTooltip) {
            return;
        }
        if (!this.overlayref?.hasAttached()) {
            this.overlayref = getOverlay(this.elementRef, this.overlay, false, this.placement);
            this.overlayref.addPanelClass('pe-none');
        }
        if (this.overlayref.hasAttached()) {
            return;
        }
        const toolTipPortal = new ComponentPortal(TooltipComponent);
        const tooltipRef = this.overlayref.attach(toolTipPortal);
        tooltipRef.instance.tooltip = this.siTooltip;
        tooltipRef.instance.anchor = new CdkOverlayOrigin(this.elementRef);
        tooltipRef.instance.positions = positions[this.placement];
        tooltipRef.instance.id = this.describedBy;
        const positionStrategy = getPositionStrategy(this.overlayref);
        positionStrategy?.positionChanges.subscribe(change => tooltipRef.instance.updateTooltipPosition(change));
        tooltipRef.changeDetectorRef.detectChanges();
    }
    focusIn() {
        this.showTooltip();
    }
    show() {
        if (this.triggers === 'focus') {
            return;
        }
        this.showTooltip();
    }
    hide() {
        this.overlayref?.detach();
    }
    mouseOut() {
        if (this.triggers === 'focus') {
            return;
        }
        this.hide();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTooltipDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.1.5", type: SiTooltipDirective, selector: "[siTooltip]", inputs: { siTooltip: "siTooltip", placement: "placement", triggers: "triggers", isDisabled: "isDisabled" }, host: { listeners: { "focus": "focusIn()", "mouseenter": "show()", "touchstart": "hide()", "focusout": "hide()", "mouseleave": "mouseOut()" }, properties: { "attr.aria-describedby": "this.describedBy" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siTooltip]'
                }]
        }], propDecorators: { siTooltip: [{
                type: Input
            }], placement: [{
                type: Input
            }], triggers: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], describedBy: [{
                type: HostBinding,
                args: ['attr.aria-describedby']
            }], focusIn: [{
                type: HostListener,
                args: ['focus']
            }], show: [{
                type: HostListener,
                args: ['mouseenter']
            }], hide: [{
                type: HostListener,
                args: ['touchstart']
            }, {
                type: HostListener,
                args: ['focusout']
            }], mouseOut: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class SiTooltipModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiTooltipModule, declarations: [SiTooltipDirective, TooltipComponent], imports: [CommonModule, OverlayModule], exports: [SiTooltipDirective, TooltipComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTooltipModule, imports: [CommonModule, OverlayModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, OverlayModule],
                    declarations: [SiTooltipDirective, TooltipComponent],
                    exports: [SiTooltipDirective, TooltipComponent]
                }]
        }] });

class SimplElementNgModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SimplElementNgModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SimplElementNgModule, imports: [SiCalendarButtonComponent], exports: [SiAboutModule,
            SiAccordionModule,
            SiActionDialogModule,
            SiBreadcrumbModule,
            SiBreadcrumbRouterModule,
            SiCalendarButtonComponent,
            SiCardModule,
            SiCircleStatusModule,
            SiColumnSelectionModalModule,
            SiComfortScoreModule,
            SiCommissioningStatusModule,
            SiConnectionStrengthModule,
            SiContentActionBarModule,
            SiCopyrightNoticeModule,
            SiDatatableModule,
            SiDatepickerModule,
            SiDateRangeFilterModule,
            SiDropdownModule,
            SiElectrontitlebarModule,
            SiEmptyStateModule,
            SiFileUploaderModule,
            SiFilterBarModule,
            SiFilteredSearchModule,
            SiFooterModule,
            SiFormModule,
            SiIconModule,
            SiIconStatusModule,
            SiInlineNotificationModule,
            SiLandingPageModule,
            SiLanguageSwitcherModule,
            SiLinkModule,
            SiListInteractionModule,
            SiLoadingSpinnerModule,
            SiLocalizationModule,
            SiMainDetailContainerModule,
            SiMasterDetailContainerModule,
            SiMenuModule,
            SiModalModule,
            SiNavbarModule,
            SiNavbarSecondaryModule,
            SiNavbarVerticalModule,
            SiNumberInputModule,
            SiPaginationModule,
            SiPasswordStrengthModule,
            SiPopoverModule,
            SiProgressbarModule,
            SiPromptDialogButtonsModule,
            SiResizeObserverModule,
            SiResultDetailsListModule,
            SiSearchBarModule,
            SiSelectModule,
            SiSidePanelModule,
            SiSliderModule,
            SiSortBarModule,
            SiSplitModule,
            SiStatusBarModule,
            SiTabsModule,
            SiThresholdModule,
            SiTooltipModule,
            SiTreeViewModule,
            SiTypeaheadModule,
            SiUnauthorizedPageModule,
            SiWizardModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SimplElementNgModule, imports: [SiCalendarButtonComponent, SiAboutModule,
            SiAccordionModule,
            SiActionDialogModule,
            SiBreadcrumbModule,
            SiBreadcrumbRouterModule,
            SiCardModule,
            SiCircleStatusModule,
            SiColumnSelectionModalModule,
            SiComfortScoreModule,
            SiCommissioningStatusModule,
            SiConnectionStrengthModule,
            SiContentActionBarModule,
            SiCopyrightNoticeModule,
            SiDatatableModule,
            SiDatepickerModule,
            SiDateRangeFilterModule,
            SiDropdownModule,
            SiElectrontitlebarModule,
            SiEmptyStateModule,
            SiFileUploaderModule,
            SiFilterBarModule,
            SiFilteredSearchModule,
            SiFooterModule,
            SiFormModule,
            SiIconModule,
            SiIconStatusModule,
            SiInlineNotificationModule,
            SiLandingPageModule,
            SiLanguageSwitcherModule,
            SiLinkModule,
            SiListInteractionModule,
            SiLoadingSpinnerModule,
            SiLocalizationModule,
            SiMainDetailContainerModule,
            SiMasterDetailContainerModule,
            SiMenuModule,
            SiModalModule,
            SiNavbarModule,
            SiNavbarSecondaryModule,
            SiNavbarVerticalModule,
            SiNumberInputModule,
            SiPaginationModule,
            SiPasswordStrengthModule,
            SiPopoverModule,
            SiProgressbarModule,
            SiPromptDialogButtonsModule,
            SiResizeObserverModule,
            SiResultDetailsListModule,
            SiSearchBarModule,
            SiSelectModule,
            SiSidePanelModule,
            SiSliderModule,
            SiSortBarModule,
            SiSplitModule,
            SiStatusBarModule,
            SiTabsModule,
            SiThresholdModule,
            SiTooltipModule,
            SiTreeViewModule,
            SiTypeaheadModule,
            SiUnauthorizedPageModule,
            SiWizardModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SimplElementNgModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [SiCalendarButtonComponent],
                    // Since this a library, which does not have any pages, imports are not needed
                    exports: [
                        SiAboutModule,
                        SiAccordionModule,
                        SiActionDialogModule,
                        SiBreadcrumbModule,
                        SiBreadcrumbRouterModule,
                        SiCalendarButtonComponent,
                        SiCardModule,
                        SiCircleStatusModule,
                        SiColumnSelectionModalModule,
                        SiComfortScoreModule,
                        SiCommissioningStatusModule,
                        SiConnectionStrengthModule,
                        SiContentActionBarModule,
                        SiCopyrightNoticeModule,
                        SiDatatableModule,
                        SiDatepickerModule,
                        SiDateRangeFilterModule,
                        SiDropdownModule,
                        SiElectrontitlebarModule,
                        SiEmptyStateModule,
                        SiFileUploaderModule,
                        SiFilterBarModule,
                        SiFilteredSearchModule,
                        SiFooterModule,
                        SiFormModule,
                        SiIconModule,
                        SiIconStatusModule,
                        SiInlineNotificationModule,
                        SiLandingPageModule,
                        SiLanguageSwitcherModule,
                        SiLinkModule,
                        SiListInteractionModule,
                        SiLoadingSpinnerModule,
                        SiLocalizationModule,
                        SiMainDetailContainerModule,
                        SiMasterDetailContainerModule,
                        SiMenuModule,
                        SiModalModule,
                        SiNavbarModule,
                        SiNavbarSecondaryModule,
                        SiNavbarVerticalModule,
                        SiNumberInputModule,
                        SiPaginationModule,
                        SiPasswordStrengthModule,
                        SiPopoverModule,
                        SiProgressbarModule,
                        SiPromptDialogButtonsModule,
                        SiResizeObserverModule,
                        SiResultDetailsListModule,
                        SiSearchBarModule,
                        SiSelectModule,
                        SiSidePanelModule,
                        SiSliderModule,
                        SiSortBarModule,
                        SiSplitModule,
                        SiStatusBarModule,
                        SiTabsModule,
                        SiThresholdModule,
                        SiTooltipModule,
                        SiTreeViewModule,
                        SiTypeaheadModule,
                        SiUnauthorizedPageModule,
                        SiWizardModule
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AlertDialogResult, CheckboxClickEventArgs, ClickEventArgs, ClickEventArgs2, CloseCause, ConfirmationDialogResult, DEFAULT_CHILDREN_INDENTATION, DEFAULT_TREE_ICON_SET, DeleteConfirmationDialogResult, EditAbortDialogResult, EditDiscardDialogResult, FolderStateEventArgs, ItemsVirtualizedArgs, LoadChildrenEventArgs, ONE_DAY, ONE_MINUTE, ROOT_LEVEL, ResultDetailStepState, SI_DATATABLE_CONFIG, SI_TOAST_AUTO_HIDE_DELAY, SiAboutComponent, SiAboutModule, SiActionDialogModule, SiActionDialogService, SiAlertDialogComponent, SiCalendarButtonComponent, SiCircleStatusComponent, SiCircleStatusModule, SiColumnSelectionDialogComponent, SiColumnSelectionDialogService, SiColumnSelectionModalModule, SiComfortScoreComponent, SiComfortScoreModule, SiComfortScoreStatusComponent, SiCommissioningStatusComponent, SiCommissioningStatusModule, SiConfirmationDialogComponent, SiConnectionStrengthComponent, SiConnectionStrengthModule, SiDatatableInteractionDirective, SiDatatableModule, SiDateInputDirective, SiDateRangeCalculationService, SiDateRangeComponent, SiDateRangeFilterComponent, SiDateRangeFilterModule, SiDatepickerComponent, SiDatepickerDirective, SiDatepickerModule, SiDatepickerOverlayComponent, SiDatepickerOverlayDirective, SiDeleteConfirmationDialogComponent, SiEditDiscardDialogComponent, SiElectrontitlebarComponent, SiElectrontitlebarModule, SiEmptyStateComponent, SiEmptyStateModule, SiFileDropzoneComponent, SiFileUploaderComponent, SiFileUploaderModule, SiFilterBarComponent, SiFilterBarModule, SiFilterPillComponent, SiFilteredSearchComponent, SiFilteredSearchModule, SiFooterComponent, SiFooterModule, SiIconStatusComponent, SiIconStatusModule, SiLandingPageComponent, SiLandingPageModule, SiMainDetailContainerComponent, SiMainDetailContainerModule, SiMasterDetailContainerComponent, SiMasterDetailContainerModule, SiPaginationComponent, SiPaginationModule, SiPasswordStrengthComponent, SiPasswordStrengthDirective, SiPasswordStrengthModule, SiPromptDialogButtonsComponent, SiPromptDialogButtonsModule, SiResultDetailsListComponent, SiResultDetailsListModule, SiSidePanelComponent, SiSidePanelContentComponent, SiSidePanelModule, SiSidePanelService, SiSliderComponent, SiSliderModule, SiSortBarComponent, SiSortBarModule, SiThresholdComponent, SiThresholdModule, SiTimepickerComponent, SiToastNotificationService, SiTooltipDirective, SiTooltipModule, SiTreeViewComponent, SiTreeViewConverterService, SiTreeViewItemComponent, SiTreeViewItemHeightService, SiTreeViewItemTemplateDirective, SiTreeViewModule, SiTreeViewService, SiTreeViewVirtualizationService, SiUnauthorizedPageComponent, SiUnauthorizedPageModule, SiWizardComponent, SiWizardModule, SiWizardStepComponent, SimplElementNgModule, TooltipComponent, addChildItem, addChildItems, boxClicked, childrenLoaded, collapse, deleteItem, doFolderStateChange, enableCheckboxRecursive, enableOptionboxRecursive, expand, expandRecursive, getDatepickerFormat, hasChildren, initializeTreeItemsRecursive, parentCountRecursive, removeUndefinedState, resetActive, runsInElectron, selectItemsBetween, selectRecursive, setActive, setBoxStateRecursive, setSelectable, setTreeItemDefaults };
